import React, { useEffect, useState, useCallback, useRef, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import sessionManager from './auth/SessionManager';
import { toggleDebugFakePremium } from './web3/debugContractOverrides';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import { WatchlistProvider, useWatchlist } from './watchlist/WatchlistContext';
import PremiumBanner from './PremiumBanner';
import GoogleAdsBanner from './GoogleAdsBanner';
import E3DHeader from './E3DHeader';
// UpgradeDialog has been removed
//import Slider from 'react-slider';

//import { useLocation, useNavigate } from 'react-router-dom';
import { GraphLayoutManager, GraphLayoutPanel } from './GraphLayoutManager';
import Papa from 'papaparse';
import { buildPcapConversationsFromRows } from './pcap/pcapCsvConversations';
import { getField, toNumber, toPortString } from './pcap/pcapCsvFields';
import { useAppRouteEffects } from './hooks/useAppRouteEffects';
import { CircularProgress, IconButton, Tooltip, Slider, Switch, FormControlLabel, Dialog, DialogTitle, DialogContent, Popover } from '@material-ui/core';
//import Divider from '@material-ui/core/Divider';
import { Button, TextField } from '@material-ui/core';
import { Menu, MenuItem } from '@material-ui/core';
import NameTableDialog from './NameTableDialog';
import InputAdornment from '@material-ui/core/InputAdornment';
import ClearIcon from '@material-ui/icons/Clear'; 
import SearchIcon from '@material-ui/icons/Search';
import { GraphComponent } from './GraphComponent';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import GraphViewModeSelector from './GraphViewModeSelector';
import { filterGraphDataByViewMode } from './GraphDataFilter';
import { jsPDF } from 'jspdf';
import axios from 'axios';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { SearchDialog, AboutDialog, LoginDialog, VerifyEmailCodeDialog, LogoutConfirmDialog, MembersOnlyDialog, CookieConsentDialog } from './AuthDialogs';
import SignupDialog from './SignupDialog';
import { SaveMapDialog } from './MapDialogs';
import { LoadMapDialog } from './MapDialogs';
import { NodeList, LinkList, LinkListPCAP, formatPrice } from './NodeLists';
import useStyles from './sharedStyles'; 
import { SERVER_NAME, ETHERSCAN, BSCSCAN, SOLANA, ALL_CHAINS, PCAP, etherscanLogo } from './config';
import DateRangePickerPopover from './DateRangePickerPopover';
import { FaCog, FaChevronRight, FaArrowsAltH, FaArrowsAltV, FaBook } from 'react-icons/fa';
import { FaSync, FaBars, FaRedo, FaNewspaper, FaTimes, FaHourglassHalf, FaPaste } from 'react-icons/fa';
import { FaUsers, FaClock, FaCertificate, FaBitcoin, FaFilter, FaSearch, FaFont, FaHeart, FaCoins, FaSignature, FaCircle, FaStar, FaCircleNotch, FaMinus } from 'react-icons/fa';
import { FaSave, FaFileExport, FaDollarSign, FaChartBar, FaQuestionCircle, FaBus, FaEye, FaTools, FaNetworkWired } from 'react-icons/fa';
import { genericTokenIcon, genericUserIcon, futLogoIcon200, genericNodeIcon } from './config';
import TokenInfoComponent from './TokenInfoComponent';
//import FutcoChart from './FutcoChart';
import WalletConnect from './WalletConnect';
import { initGA, logPageView } from './analytics';
import { TokenContainer } from './TokenContainer'; 
import { OptionsPopup } from './OptionsPopup';
import { Newsletter } from './Newsletter';
import NewsletterContent from './NewsletterContent';
import BubblesView from './BubblesView';
import { buildPcapCollapsedGraph as buildPcapCollapsedGraphPure, buildPcapGroupedGraph as buildPcapGroupedGraphPure, applyPcapLinkStyle as applyPcapLinkStylePure } from './pcap/pcapTransforms';
//import { set } from 'react-ga';
//import Cookies from 'js-cookie';
import HomePage from './HomePage';
import MintNFTDialog from './MintNFTDialog';
import CustomNFTDialog from './CustomNFTDialog';
import MintPcapNFTDialog from './MintPcapNFTDialog';
import { downloadImagePNG, downloadImageJPG, downloadPDF, downloadCsv, downloadCsvWithHash, graphDataToCsv, exportGraphPngDataUrl } from './GraphExportUtils';
import E3DMarketplace from './E3DMarketplace';
import CustomNFTMarketplace from './CustomNFTMarketplace';
import SwapPage from './SwapPage';
import StakePage from './StakePage';
import ShortcutPage from './ShortcutPage';
import DocPage from './DocPage';
import PcapView from './PcapView';
import Dashboard from './Dashboard';
import WhatsNewPage from './WhatsNewPage';
import StoriesPage from './StoriesPage';
import StoriesPageRoute from './StoriesPageRoute';
import StoryGuidePage from './StoryGuidePage';
import StoryReferencePage from './StoryReferencePage';
import StoryUseCasePage from './StoryUseCasePage';
import MethodologyPage from './MethodologyPage';
import ActionsPage from './ActionsPage';
import AgentVerdictsPage from './AgentVerdictsPage';
import ThesisPage from './ThesisPage';
import ThesisGuidePage from './ThesisGuidePage';
import ThesisUseCasePage from './ThesisUseCasePage';
import PriceReferencePage from './PriceReferencePage';
import PriceGuidePage from './PriceGuidePage';
import PriceUseCasePage from './PriceUseCasePage';
import StoryEmbedPage from './StoryEmbedPage';
import PayPage from './PayPage';
import MintReportPage from './MintReportPage';
import CategoriesFilterDialog from './CategoriesFilterDialog';
import PcapGallery from './PcapGallery';
import FlowView from './FlowView';
import TimeseriesGallery from './TimeseriesGallery';
import AgentsDirectoryPage from './AgentsDirectoryPage';
import AgentDashboardPage from './AgentDashboardPage';
import AgentsGuidePage from './AgentsGuidePage';
import AgentsUseCasePage from './AgentsUseCasePage';
import TransactionsGuidePage from './TransactionsGuidePage';
import TransactionsUseCasePage from './TransactionsUseCasePage';
import ApiKeysPage from './ApiKeysPage';
import ApiGuidePage from './ApiGuidePage';
import PcapUploadsPage from './PcapUploadsPage';
import PcapUploadDetailPage from './PcapUploadDetailPage';
import PcapDetailsPage from './PcapDetailsPage';
import TokenIntelligencePage from './token/TokenIntelligencePage';
import TokenClaimPage from './token/TokenClaimPage';
import ProjectClaimReviewPage from './admin/ProjectClaimReviewPage';
import ProjectDiscoveryReviewPage from './admin/ProjectDiscoveryReviewPage';
import ProjectOutreachManagerPage from './admin/ProjectOutreachManagerPage';
import IntelligencePage from './IntelligencePage';
import MacroIntelligencePage from './MacroIntelligencePage';
import MapsPage from './MapsPage';
import TokenomicsPage from './TokenomicsPage';

function QuickPriceChart({ token, selectedPriceTrendInterval = '30D' }) {
  const [hovered, setHovered] = useState(null);
  useEffect(() => {
    try {
      console.debug('[QuickPriceChart] trend debug', {
        tokenId: token && (token.id || token.address || token.symbol || token.name || ''),
        selectedTrend: String(selectedPriceTrendInterval || '30D').trim().toUpperCase(),
        trendType: token && token.priceTrend && Array.isArray(token.priceTrend.points) ? 'flat_points' : 'per_range_map',
        trendKeys: token && token.priceTrend && typeof token.priceTrend === 'object' ? Object.keys(token.priceTrend).slice(0, 12) : [],
      });
    } catch (e) {
    }
  }, [token, selectedPriceTrendInterval]);
  if (!token) return null;
  const currentPrice = Number(token.priceUSD || token.price || 0);
  const changes = token.changes || {};
  const selectedTrend = String(selectedPriceTrendInterval || '30D').trim().toUpperCase();
  const trend = token.priceTrend || {};
  const selectedTrendSeries = trend && typeof trend === 'object' ? trend[selectedTrend] : null;
  const trendPoints = Array.isArray(trend.points)
    ? trend.points
    : (selectedTrendSeries && Array.isArray(selectedTrendSeries.points))
      ? selectedTrendSeries.points
      : [];
  const allIntervals = ['30D', '7D', '24H', '12H', '6H', '30M'];
  const startIndex = allIntervals.indexOf(selectedTrend);
  const intervals = startIndex >= 0 ? allIntervals.slice(startIndex) : allIntervals;
  const rawPts = trendPoints.length
    ? trendPoints.filter((pt) => {
      const interval = String(pt && pt.interval || '').trim().toUpperCase();
      if (!interval) return false;
      if (interval === 'NOW') return true;
      if (String(pt.kind || '').toLowerCase() === 'interpolated') {
        return intervals.some((k) => interval.includes(k));
      }
      return intervals.includes(interval);
    }).map((pt) => ({
      price: Number(pt.price),
      label: String(pt.label || pt.interval || ''),
    }))
    : intervals.map((k) => {
      const e = changes[k];
      if (!e || e.percent == null) return null;
      const pct = parseFloat(e.percent);
      return Number.isFinite(pct) ? { price: currentPrice / (1 + pct / 100), label: k } : null;
    }).filter(Boolean).concat([{ price: currentPrice, label: 'now' }]);
  if (!rawPts.length) {
    return <div style={{ color: '#555', fontSize: 12, padding: 16 }}>No multi-interval price data available.</div>;
  }
  const ptPairs = rawPts.filter((pt) => Number.isFinite(pt.price) && pt.price > 0);
  if (ptPairs.length < 2) {
    return <div style={{ color: '#555', fontSize: 12, padding: 16 }}>No multi-interval price data available.</div>;
  }
  const pts = ptPairs.map((p) => p.price);
  const ptLabels = ptPairs.map((p) => p.label);
  const w = 500; const pad = { top: 12, right: 12, bottom: 22, left: 60 };
  const h = 160;
  const innerW = w - pad.left - pad.right;
  const innerH = h - pad.top - pad.bottom;
  const minP = Math.min(...pts); const maxP = Math.max(...pts);
  const rng = maxP - minP || 1;
  const xs = pts.map((_, i) => pad.left + (i / (pts.length - 1)) * innerW);
  const ys = pts.map((v) => pad.top + innerH - ((v - minP) / rng) * innerH);
  const d = xs.map((x, i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${ys[i].toFixed(1)}`).join(' ');
  const up = pts[pts.length - 1] >= pts[0];
  const lineColor = up ? '#00e676' : '#ff5252';
  const fmtPrice = (v) => v < 0.0001 ? v.toExponential(2) : v < 1 ? v.toFixed(5) : v.toFixed(4);
  const chg24 = changes['24H'] && changes['24H'].percent != null ? parseFloat(changes['24H'].percent) : null;
  return (
    <div style={{ position: 'relative' }}>
      <svg width={w} height={h} style={{ display: 'block' }} onMouseLeave={() => setHovered(null)}>
        {[0, 0.25, 0.5, 0.75, 1].map((v) => {
          const yg = pad.top + innerH - v * innerH;
          const priceLabel = fmtPrice(minP + v * rng);
          return (
            <g key={v}>
              <line x1={pad.left} y1={yg} x2={w - pad.right} y2={yg} stroke="rgba(255,255,255,0.06)" strokeWidth={1} />
              <text x={pad.left - 4} y={yg + 4} textAnchor="end" fill="#555" fontSize={9}>{priceLabel}</text>
            </g>
          );
        })}
        {xs.map((x, i) => (
          <text key={i} x={x} y={h - 4} textAnchor="middle" fill="#555" fontSize={9}>{ptLabels[i]}</text>
        ))}
        <path d={d} fill="none" stroke={lineColor} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
        {pts.map((price, i) => (
          <circle key={i} cx={xs[i]} cy={ys[i]} r={hovered && hovered.idx === i ? 5 : 3} fill={lineColor}
            style={{ cursor: 'default' }}
            onMouseEnter={() => setHovered({ idx: i, x: xs[i], y: ys[i], price })}
          />
        ))}
        <text x={w - pad.right} y={pad.top + 4} textAnchor="end" fill="#e5e7ff" fontSize={11} fontWeight="bold">
          ${fmtPrice(currentPrice)}{chg24 != null ? `  ${chg24 > 0 ? '+' : ''}${chg24.toFixed(1)}%` : ''}
        </text>
      </svg>
      {hovered && (
        <div style={{
          position: 'absolute', left: Math.min(hovered.x + 10, w - 120), top: hovered.y < 60 ? hovered.y + 12 : hovered.y - 44,
          background: 'rgba(20,24,40,0.95)', border: '1px solid rgba(100,120,200,0.4)',
          borderRadius: 6, padding: '4px 8px', pointerEvents: 'none', fontSize: 11, color: '#d0d4f0',
        }}>
          <div style={{ fontWeight: 700 }}>${fmtPrice(hovered.price)}</div>
          <div style={{ color: '#888' }}>{ptLabels[hovered.idx]}</div>
        </div>
      )}
    </div>
  );
}

 const PRICE_CHANGE_INTERVAL_OPTIONS = ['1H', '6H', '12H', '24H', '7D', '30D'];
const normalizePriceChangeIntervalKey = (value) => {
  const raw = String(value || '').trim().toUpperCase();
  if (raw === '30M') return '1H';
  return raw;
};

const HIDE_GOOGLE_ADS_BANNER = true;

// peermap.e3d.ai serves this same build (see nginx) but as a bare, chrome-free
// view of the pcap feature: no e3d nav header, no premium banner.
const IS_PEERMAP_HOST = typeof window !== 'undefined' && window.location.hostname === 'peermap.e3d.ai';

axios.defaults.withCredentials = true;

// Note: We're using direct function references instead of global handlers
// The handleSignup function is defined in the AppContent component

// Outside your component
let showAdvanced = true;
let isLoaded = false;
let sparkLength = 24;
let isMobile = false;
// Ensure we only load initial price history once per page load
let hasLoadedInitialPriceHistory = false;

// Global function for login dialog access across components
window.globalShowLogin = null; // Will be initialized in AppContent
window.globalShowMembersOnly = null; // Will be initialized in AppContent

function AppContent(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const { watchlistOnly, setWatchlistOnly, watchedKeys, items } = useWatchlist();

  const openUpgradeDialog = useCallback(() => {
    try {
      if (window && typeof window.openUpgradeDialog === 'function') {
        window.openUpgradeDialog();
        return;
      }
    } catch (e) {
    }

    try {
      if (window && typeof window.navigateToSignup === 'function') {
        window.navigateToSignup();
        return;
      }
    } catch (e) {
    }

    navigate('/signup');
  }, [navigate]);
  
  // Define goTo function early to avoid access before initialization
  const goTo = (path) => {
    // Add timestamp to force re-render even if path is the same
    const url = new URL(path, window.location.origin);
    url.searchParams.append('_t', Date.now());
    
    // Reset view states based on the path
    if (path === '/home') {
      // These will be defined later in the component, but we need to check if they exist first
      if (typeof setShowNewsletter === 'function') {
        setShowNewsletter(false);
      }
      if (typeof setShowHomePage === 'function') {
        setShowHomePage(true);
      }
    } else {
      if (typeof setShowHomePage === 'function') {
        setShowHomePage(false);
      }
    }
    
    // Use navigate instead of direct window.location change
    navigate(url.pathname + url.search, {
      replace: true,
      state: { from: location.pathname }
    });
    
    console.log(`Navigation to ${path} complete`);
  };

  const handlePcapMintClick = async () => {
    if (!userAddress) {
      setShowConnectWalletToMintDialog(true);
      return;
    }
    setShowMintPcapNFTDialog(true);
  };

  const refreshAddressMeta = async (address) => {
    const addr = normalizeAddress(address);
    if (!addr) return;
    addressMetaCacheRef.current.delete(addr);
    await resolveAddresses([addr]);
    const applied = applyResolvedLabels();
    if (applied && applied.changed) {
      setGraphData(applied.next);
    }
  };

  const isIpv4 = (s) => {
    if (!s) return false;
    const m = String(s).trim().match(/^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/);
    if (!m) return false;
    for (let i = 1; i <= 4; i += 1) {
      const n = Number(m[i]);
      if (!Number.isInteger(n) || n < 0 || n > 255) return false;
    }
    return true;
  };

  const extractIpv4 = (s) => {
    if (!s) return '';
    const raw = String(s);
    const m = raw.match(/(\d{1,3}(?:\.\d{1,3}){3})/);
    if (!m || !m[1]) return '';
    return isIpv4(m[1]) ? m[1] : '';
  };

  const openNameTableDialogForNode = (node) => {
    const raw = node ? (node.id || node.address || node.addr || null) : null;
    let addr = normalizeAddress(raw);
    let chain = 'ETH';
    if (!addr && raw) {
      try {
        const m = String(raw).match(/0x[0-9a-fA-F]{40}/);
        if (m && m[0]) {
          addr = normalizeAddress(m[0]);
        }
      } catch (e) {
      }
    }

    if (!addr && raw && isIpv4(raw) && location && typeof location.pathname === 'string' && location.pathname.startsWith('/pcap')) {
      addr = String(raw).trim();
      chain = 'PCAP';
    }
    try {
      console.log('[nametable] openNameTableDialogForNode', { raw, addr, chain });
    } catch (e) {
    }
    if (!addr) {
      try {
        console.warn('[nametable] cannot open dialog: invalid address for node', { id: node && node.id, address: node && node.address });
      } catch (e) {
      }
      return;
    }
    setNameTableNode(node);
    setNameTableChain(chain);

    let preLabel = '';
    let preIcon = '';
    if (chain === 'PCAP') {
      const meta = pcapNameTableCacheRef.current.get(String(addr).toLowerCase());
      preLabel = meta && meta.label ? String(meta.label) : '';
      preIcon = meta && meta.iconUrl ? iconFilenameForDialog(String(meta.iconUrl)) : '';
    } else {
      const meta = addressMetaCacheRef.current.get(addr);
      preLabel = (meta && (meta.personalLabel || meta.name || meta['n.name'])) ? (meta.personalLabel || meta.name || meta['n.name']) : '';
      preIcon = (meta && (meta.personalIconUrl || meta.icon || meta['n.icon'])) ? (meta.personalIconUrl || meta.icon || meta['n.icon']) : '';
    }

    setNameTableLabel(String(preLabel || ''));
    setNameTableIconUrl(String(preIcon || ''));
    setNameTableUploadFile(null);
    setNameTableError('');
    try {
      console.log('[nametable] setting showNameTableDialog=true');
    } catch (e) {
    }
    setShowNameTableDialog(true);
  };

  useEffect(() => {
    if (typeof window === 'undefined') return;
    window.openNameTableDialogForNode = openNameTableDialogForNode;

    const onOpen = (evt) => {
      try {
        const node = evt && evt.detail ? evt.detail.node : null;
        console.log('[nametable] open-nametable-dialog event received', { id: node && node.id, address: node && node.address });
        if (node) openNameTableDialogForNode(node);
      } catch (e) {
      }
    };

    try {
      window.addEventListener('open-nametable-dialog', onOpen);
    } catch (e) {
    }

    return () => {
      try {
        if (window.openNameTableDialogForNode === openNameTableDialogForNode) {
          delete window.openNameTableDialogForNode;
        }
      } catch (e) {
      }

      try {
        window.removeEventListener('open-nametable-dialog', onOpen);
      } catch (e) {
      }
    };
  }, [openNameTableDialogForNode]);

  const handleEditNameTableFromContextMenu = async () => {
    if (!nodeContextMenu || !nodeContextMenu.node) return;
    const node = nodeContextMenu.node;
    setNodeContextMenu(null);
    openNameTableDialogForNode(node);
  };

  const normalizeIconUrl = (u) => {
    const raw = String(u || '').trim();
    if (!raw) return '';
    const lower = raw.toLowerCase();

    const ICONS_ORIGIN = 'https://e3d.ai';

    // If we ever get an API-prefixed icon path (e.g. /apitest/icons/... or /api/icons/...),
    // rewrite it to a same-origin /icons/... path.
    try {
      const m = raw.match(/^(https?:\/\/[^/]+)?\/(?:apitest|api)\/(icons\/.*)$/i);
      if (m && m[2]) {
        return `/${m[2]}`;
      }
    } catch (e) {
    }

    // Icons are always served from the canonical origin at https://e3d.ai/icons/...
    // (even during local dev), so avoid using window.location.origin here.
    try {
      const abs = raw.match(/^(https?:\/\/[^/]+)(\/icons\/.*)$/i);
      if (abs && abs[2]) {
        return `${ICONS_ORIGIN}${abs[2]}`;
      }
    } catch (e) {
    }

    if (lower.startsWith('/icons/')) {
      return `${ICONS_ORIGIN}${raw}`;
    }

    if (lower.startsWith('http://') || lower.startsWith('https://')) return raw;
    if (raw.startsWith('/')) return `${SERVER_NAME}${raw}`;
    if (lower.startsWith('uploads/')) return `${SERVER_NAME}/${raw}`;
    return raw;
  };

  const iconFilenameForDialog = (iconUrlOrPath) => {
    const raw = String(iconUrlOrPath || '').trim();
    if (!raw) return '';
    const normalized = normalizeIconUrl(raw);
    try {
      if (typeof normalized === 'string' && normalized.startsWith('/icons/')) {
        return normalized.slice('/icons/'.length);
      }
      const m = normalized.match(/\/icons\/([^/?#]+)(?:[?#].*)?$/i);
      if (m && m[1]) return m[1];
    } catch (e) {
    }
    return raw;
  };

  const handleSaveNameTable = async () => {
    try {
      setNameTableSaving(true);
      setNameTableError('');

      const chain = String(nameTableChain || 'ETH').toUpperCase();
      const raw = nameTableNode ? (nameTableNode.id || nameTableNode.address || nameTableNode.addr || '') : '';
      const addr = (chain === 'PCAP')
        ? (isIpv4(raw) ? String(raw).trim() : '')
        : normalizeAddress(raw);
      if (!addr) {
        setNameTableError('Invalid address');
        return;
      }

      let finalIconUrl = String(nameTableIconUrl || '').trim();
      if (nameTableUploadFile) {
        const fd = new FormData();
        fd.append('image', nameTableUploadFile);
        fd.append('address', addr);
        fd.append('chain', chain);
        const resp = await axios.post(`${SERVER_NAME}/user/uploadAddressIcon`, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
          withCredentials: true,
        });
        finalIconUrl = resp && resp.data && resp.data.url ? String(resp.data.url) : '';
      }

      // For PCAP nametable, allow the dialog to store/display just the icon filename.
      // Convert "foo.png" into "/icons/foo.png" before saving.
      if (String(chain || '').toUpperCase() === 'PCAP') {
        const s = String(finalIconUrl || '').trim();
        const sLower = s.toLowerCase();
        const looksLikeFilename = s && !s.includes('/') && !s.includes('\\') && !sLower.startsWith('http://') && !sLower.startsWith('https://');
        if (looksLikeFilename) {
          finalIconUrl = `/icons/${s}`;
        }
      }

      finalIconUrl = normalizeIconUrl(finalIconUrl);

      await axios.post(`${SERVER_NAME}/nametable`, {
        chain,
        address: addr,
        label: String(nameTableLabel || ''),
        iconUrl: finalIconUrl,
      }, {
        withCredentials: true,
      });

      setShowNameTableDialog(false);
      if (chain === 'PCAP') {
        pcapNameTableCacheRef.current.set(String(addr).toLowerCase(), {
          address: String(addr).toLowerCase(),
          chain: 'PCAP',
          label: String(nameTableLabel || ''),
          iconUrl: finalIconUrl,
        });
        setGraphData((prev) => {
          if (!prev || !Array.isArray(prev.nodes)) return prev;
          const nextNodes = prev.nodes.map((n) => {
            if (!n || !n.id) return n;
            const id = String(n.id).trim();
            if (id !== String(addr).trim()) return n;
            return {
              ...n,
              label: String(nameTableLabel || '') || n.label,
              symbol: String(nameTableLabel || '') || n.symbol,
              icon: finalIconUrl || n.icon || null,
            };
          });
          const normalizeEndpointId = (v) => {
            const raw = (v && typeof v === 'object') ? (v.id ?? v._id ?? v.address) : v;
            if (raw == null) return '';
            return String(raw);
          };
          const nextLinks = Array.isArray(prev.links) ? prev.links.map((l) => {
            if (!l || typeof l !== 'object') return l;
            const s = normalizeEndpointId(l.source);
            const t = normalizeEndpointId(l.target);
            return { ...l, source: s, target: t };
          }) : prev.links;
          try {
            if (typeof window !== 'undefined' && window.__DEBUG_PCAP_ICONS__) {
              const hit = nextNodes.find((n) => n && String(n.id || '').trim() === String(addr).trim());
              if (hit && hit.icon) {
                console.log('[PCAP][icon][save] graph node', {
                  id: hit.id,
                  label: hit.label,
                  icon: hit.icon,
                });
              } else {
                console.log('[PCAP][icon][save] graph node missing icon after save', {
                  addr,
                  finalIconUrl,
                  hit: hit ? { id: hit.id, label: hit.label, icon: hit.icon } : null,
                });
              }
            }
          } catch (e) {
          }
          return { ...prev, nodes: nextNodes, links: nextLinks };
        });

        setTokenList((prev) => {
          const rows = Array.isArray(prev) ? prev : [];
          const addrLc = String(addr).trim().toLowerCase();
          let changed = false;
          const next = rows.map((row) => {
            const id = row && (row.id || row.address) ? String(row.id || row.address).trim().toLowerCase() : '';
            if (!id || id !== addrLc) return row;
            const nextLabel = String(nameTableLabel || '') || row.label || row.name || '';
            const nextIcon = finalIconUrl || row.icon || null;
            if (nextLabel !== (row.label || '') || nextIcon !== (row.icon || null)) {
              changed = true;
              return { ...row, label: nextLabel, icon: nextIcon };
            }
            return row;
          });
          try {
            if (typeof window !== 'undefined' && window.__DEBUG_PCAP_ICONS__) {
              const hit = next.find((r) => r && String(r.id || r.address || '').trim().toLowerCase() === addrLc);
              if (hit && hit.icon) {
                console.log('[PCAP][icon][save] list row', {
                  id: hit.id,
                  label: hit.label,
                  icon: hit.icon,
                });
              } else {
                console.log('[PCAP][icon][save] list row missing icon after save', {
                  addr: addrLc,
                  finalIconUrl,
                  hit: hit ? { id: hit.id, label: hit.label, icon: hit.icon } : null,
                });
              }
            }
          } catch (e) {
          }
          return changed ? next : prev;
        });
      } else {
        await refreshAddressMeta(addr);
      }
    } catch (e) {
      if (e && e.response && e.response.status === 401) {
        try {
          setSnackbarSeverity('info');
          setSnackbarMessage('Saving nametable entries requires an account. Please create an account or log in.');
          setSnackbarOpen(true);
        } catch (e2) {
        }
        setNameTableError('Please create an account or log in to save nametable entries');
        return;
      }
      const msg = (e && e.response && e.response.data && e.response.data.message)
        ? String(e.response.data.message)
        : 'Failed to save';
      setNameTableError(msg);
    } finally {
      setNameTableSaving(false);
    }
  };

  const handleToggleWatchlistOnly = () => {
    const next = !watchlistOnly;
    setWatchlistOnly(next);
    if (next) {
      try {
        if (String(SERVER_NAME || '').includes('apitest')) {
          const rows = (items || []).map((it) => `${it.address || ''} ${it.label || ''}`.trim());
          console.log('[watchlist] entries:', rows.length);
          rows.forEach((r) => console.log(r));
        }
      } catch (e) {
      }
    }
  };

  const toggleLiveMode = () => {
    setIsLiveMode((prev) => !prev);
  };
  const currentView = (location && typeof location.pathname === 'string') ? location.pathname : '';

  const handleNodeRightClick = (node, event) => {
    event.preventDefault();
    setShowTopSubmenu(false);
    setNodeContextMenu({
      mouseX: event.clientX,
      mouseY: event.clientY,
      node,
      graphDataOverride: (graphDataRef && graphDataRef.current) ? graphDataRef.current : graphData,
    });
  };

  const linksFollowDepthRef = useRef(0);

  useEffect(() => {
    try {
      // Reset follow depth when navigating to a new route so a fresh /graphs
      // session starts at depth 0.
      linksFollowDepthRef.current = 0;
    } catch (e) {
    }
  }, [location && location.pathname]);

  useEffect(() => {
    const handleOpenNodeContextMenu = (e) => {
      try {
        const d = e && e.detail ? e.detail : null;
        if (!d) return;
        const x = d.mouseX != null ? d.mouseX : d.clientX;
        const y = d.mouseY != null ? d.mouseY : d.clientY;
        if (x == null || y == null) return;
        const node = d.node || (d.id != null ? { id: d.id } : null);
        if (!node) return;
        setShowTopSubmenu(false);
        setNodeContextMenu({
          mouseX: x,
          mouseY: y,
          node,
          graphDataOverride: d.graphDataOverride,
        });
      } catch (err) {
      }
    };

    window.addEventListener('open-node-context-menu', handleOpenNodeContextMenu);
    return () => window.removeEventListener('open-node-context-menu', handleOpenNodeContextMenu);
  }, []);

  const followTokenById = async (tokenId) => {
    if (!tokenId) return;

    try {
      if (location.pathname.startsWith('/graphs')) {
        // Enforce follow depth for /graphs.
        const maxDepth = 1;
        const used = Number(linksFollowDepthRef.current) || 0;
        if (used >= maxDepth) {
          if (!isAuthenticated) {
            if (window.navigateToSignup) {
              window.navigateToSignup();
            } else {
              navigate('/signup');
            }
          } else {
            openUpgradeDialog();
          }
          return;
        }
      }
    } catch (e) {
    }

    try {
      setIsCounterpartyLoading(true);

      // Request counterparties over the last week so the server can
      // constrain by timestamp instead of relying on a generic LIMIT.
      const nowSec = Math.floor(Date.now() / 1000);
      const weekAgoSec = nowSec - 7 * 24 * 60 * 60;

      const resp = await axios.get(SERVER_NAME + '/tokenCounterparties', {
        params: {
          token: tokenId,
          startTime: weekAgoSec,
          endTime: nowSec,
        },
      });
      const raw = resp.data || [];

      if (!graphData || !graphData.nodes) return;

      const existingIds = new Set(graphData.nodes.map(n => n.id));

      // Preserve existing node positions; we'll only arrange the *new*
      // counterparties in an arc around the followed token.
      const newNodes = [...graphData.nodes];
      const newLinks = graphData.links ? [...graphData.links] : [];
      const newTokens = [];

      // Apply node caps for /graphs view. Discovery should show about half as
      // many nodes as a logged-in free subscriber.
      const isLinks = location.pathname.startsWith('/graphs');
      const maxNodesFree = 1200;
      const maxNodesDiscovery = 600;
      const maxNodes = !isLinks ? null : (isAuthenticated ? maxNodesFree : maxNodesDiscovery);
      const remainingCapacity = (maxNodes && Number.isFinite(maxNodes)) ? Math.max(0, maxNodes - newNodes.length) : Infinity;

      // Anchor = followed token's current position; fallback to origin.
      const anchorNode = graphData.nodes.find(n => n.id === tokenId);
      const anchorX = typeof anchorNode?.x === 'number' ? anchorNode.x : 0;
      const anchorY = typeof anchorNode?.y === 'number' ? anchorNode.y : 0;
      const anchorZ = typeof anchorNode?.z === 'number' ? anchorNode.z : 0;

      // Classify which new addresses are users (no icon) vs tokens (icon).
      const classified = raw
        .filter(({ address }) => !!address)
        .map(({ address, name, symbol, icon, icon2 }) => ({
          address: address.toLowerCase(),
          name,
          symbol,
          icon,
          icon2,
          isToken: !!(icon || icon2),
        }))
        .filter(({ address }) => !existingIds.has(address));

      const userNew = classified.filter(c => !c.isToken);
      const tokenNew = classified.filter(c => c.isToken);
      const totalUser = userNew.length || 1;
      const totalToken = tokenNew.length || 1;

      let userIndex = 0;
      let tokenIndex = 0;

      // Determine the outward direction of the followed node from the origin
      // in the XZ plane, and place new nodes on half-circles further out in
      // that direction.
      const anchorRadius = Math.sqrt(anchorX * anchorX + anchorZ * anchorZ);
      const baseAngle = Math.atan2(anchorZ, anchorX); // outward from center

      // Use a narrower arc so nodes extend outward more than around.
      const arcSpan = Math.PI * 0.7; // 126-degree arc
      const angleStart = baseAngle - arcSpan / 2;
      const userAngleStep = totalUser > 1 ? arcSpan / (totalUser - 1) : 0;
      const tokenAngleStep = totalToken > 1 ? arcSpan / (totalToken - 1) : 0;

      // Base radius for the inner (user) arc and outer (token) arc, scaling
      // with group size so larger sets are pushed further out.
      const baseOffsetUsers = 150;
      const perUserOffset = 2;
      const userRadius = (anchorRadius || 0) + baseOffsetUsers + perUserOffset * totalUser;

      const gapBetweenArcs = 360; // push token arc even further beyond users
      const baseOffsetTokens = baseOffsetUsers + gapBetweenArcs;
      const perTokenOffset = 10;  // additional spacing per token
      const tokenRadius = (anchorRadius || 0) + baseOffsetTokens + perTokenOffset * totalToken;

      const cappedRaw = remainingCapacity !== Infinity ? raw.slice(0, remainingCapacity) : raw;

      cappedRaw.forEach(({ address, name, symbol, icon, icon2 }) => {
        if (!address) return;
        const id = address.toLowerCase();

        if (!existingIds.has(id)) {
          existingIds.add(id);

          const vol = new Array(sparkLength).fill(0);
          vol[vol.length - 1] = 1;

          const isToken = !!(icon || icon2);
          let angle;
          let radius;
          if (isToken) {
            angle = angleStart + tokenIndex * tokenAngleStep;
            tokenIndex += 1;
            radius = tokenRadius;
          } else {
            angle = angleStart + userIndex * userAngleStep;
            userIndex += 1;
            radius = userRadius;
          }

          const nx = radius * Math.cos(angle);
          const nz = radius * Math.sin(angle);
          const ny = anchorY; // keep same height for clarity

          newNodes.push({
            id,
            label: name || symbol || id,
            symbol: symbol || '',
            icon: icon || icon2 || null,
            nodeType: 'connected_user',
            volume: vol,
            x: nx,
            y: ny,
            z: nz,
            // Pin new nodes to the ring so they stay distributed around
            // the followed token instead of collapsing inward.
            fx: nx,
            fy: ny,
            fz: nz,
          });

          newTokens.push({
            id,
            label: name || symbol || id,
            symbol: symbol || '',
            icon: icon || icon2 || null,
            likes: 0,
          });
        }

        newLinks.push({
          source: tokenId,
          target: id,
          value: 1,
        });
      });

      const updated = { nodes: newNodes, links: newLinks };
      setGraphData(updated);

      // Gently reheat the force simulation so new nodes can expand
      // into place without forcing a full redistribute.
      if (graphRef.current && typeof graphRef.current.d3ReheatSimulation === 'function') {
        graphRef.current.d3ReheatSimulation();
      }

      if (newTokens.length) {
        setTokenList(prev => {
          const byId = new Map(prev.map(t => [t.id, t]));
          newTokens.forEach(t => {
            if (!byId.has(t.id)) {
              byId.set(t.id, t);
            }
          });
          return Array.from(byId.values());
        });
      }

      setLinkCount(prev => {
        const map = new Map(prev);
        cappedRaw.forEach(({ address }) => {
          if (!address) return;
          const id = address.toLowerCase();
          map.set(id, (map.get(id) || 0) + 1);
        });
        map.set(tokenId, (map.get(tokenId) || 0) + cappedRaw.length);
        return map;
      });

      // We intentionally avoid layoutManager.handleDistributeAll(updated) here
      // so the existing layout is preserved and only the simulation is reheated.
      try {
        if (location.pathname.startsWith('/graphs')) {
          linksFollowDepthRef.current = (Number(linksFollowDepthRef.current) || 0) + 1;
        }
      } catch (e2) {
      }
    } catch (e) {
      console.error('Error following token from category view:', e);
    } finally {
      setIsCounterpartyLoading(false);
    }
  };

  const handleFollowFromContextMenu = async () => {
    if (!nodeContextMenu || !nodeContextMenu.node) return;
    const tokenId = nodeContextMenu.node.id;
    setNodeContextMenu(null);
    await followTokenById(tokenId);
  };

  const handleFollowNewFromContextMenu = () => {
    if (!nodeContextMenu || !nodeContextMenu.node) return;
    const tokenId = nodeContextMenu.node.id;
    setNodeContextMenu(null);

    if (typeof tokenId === 'string' && tokenId.startsWith('0x')) {
      goTo(`/graphs/${encodeURIComponent(tokenId)}`);
    }
  };

  const handleNodeDoubleClick = async (node) => {
    if (!node || !node.id) return;
    await followTokenById(node.id);
  };

  const handleCopyAddressFromContextMenu = async () => {
    if (!nodeContextMenu || !nodeContextMenu.node) return;
    const tokenId = nodeContextMenu.node.id;
    setNodeContextMenu(null);

    // Update the global search text so the address appears in the search UI
    setSearchText(tokenId);

    // Copy to clipboard if available
    try {
      if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(tokenId);
      }
    } catch (err) {
      console.error('Failed to copy address to clipboard:', err);
    }
  };

  const handleHideFromContextMenu = () => {
    if (!nodeContextMenu || !nodeContextMenu.node) return;
    const id = nodeContextMenu.node.id;
    const gd = nodeContextMenu.graphDataOverride;
    setNodeContextMenu(null);
    toggleHiddenNodeId(id, gd);
  };

  const handleHideNeighborsFromContextMenu = () => {
    if (!nodeContextMenu || !nodeContextMenu.node) return;
    const id = nodeContextMenu.node.id;
    const gd = nodeContextMenu.graphDataOverride;
    setNodeContextMenu(null);
    forceToggleHiddenNodeIdWithNeighbors(id, gd);
  };

  const handleHideNonNeighborsFromContextMenu = () => {
    if (!nodeContextMenu || !nodeContextMenu.node) return;
    const key = nodeContextMenu.node.id != null ? String(nodeContextMenu.node.id) : '';
    if (!key) {
      setNodeContextMenu(null);
      return;
    }
    const gd = nodeContextMenu.graphDataOverride;
    setNodeContextMenu(null);

    const normalizeEndpointId = (v) => {
      const raw = (v && typeof v === 'object') ? (v.id ?? v._id ?? v.address) : v;
      if (raw == null) return '';
      return String(raw);
    };

    const sourceGraph = (gd && typeof gd === 'object') ? gd : (graphDataRef && graphDataRef.current ? graphDataRef.current : graphData);
    const nodes = sourceGraph && Array.isArray(sourceGraph.nodes) ? sourceGraph.nodes : [];
    const links = sourceGraph && Array.isArray(sourceGraph.links) ? sourceGraph.links : [];

    const keep = new Set([key]);
    for (let i = 0; i < links.length; i += 1) {
      const l = links[i];
      if (!l) continue;
      const s = normalizeEndpointId(l.source);
      const t = normalizeEndpointId(l.target);
      if (!s || !t) continue;
      if (s === key) keep.add(t);
      else if (t === key) keep.add(s);
    }

    setHiddenNodeIds(() => {
      const next = new Set();
      for (let i = 0; i < nodes.length; i += 1) {
        const n = nodes[i];
        if (!n || n.id == null) continue;
        const id = String(n.id);
        if (!id) continue;
        if (!keep.has(id)) next.add(id);
      }
      return next;
    });
  };

  const handleUnhideAllFromContextMenu = () => {
    setNodeContextMenu(null);
    unhideAllNodes();
  };

  const handleShowNeighborsFromContextMenu = () => {
    if (!nodeContextMenu || !nodeContextMenu.node) return;
    const key = nodeContextMenu.node.id != null ? String(nodeContextMenu.node.id) : '';
    if (!key) {
      setNodeContextMenu(null);
      return;
    }
    const gd = nodeContextMenu.graphDataOverride;
    setNodeContextMenu(null);

    const normalizeEndpointId = (v) => {
      const raw = (v && typeof v === 'object') ? (v.id ?? v._id ?? v.address) : v;
      if (raw == null) return '';
      return String(raw);
    };

    const sourceGraph = (gd && typeof gd === 'object') ? gd : (graphDataRef && graphDataRef.current ? graphDataRef.current : graphData);
    const links = sourceGraph && Array.isArray(sourceGraph.links) ? sourceGraph.links : [];
    const neighbors = new Set();
    for (let i = 0; i < links.length; i += 1) {
      const l = links[i];
      if (!l) continue;
      const s = normalizeEndpointId(l.source);
      const t = normalizeEndpointId(l.target);
      if (!s || !t) continue;
      if (s === key) neighbors.add(t);
      else if (t === key) neighbors.add(s);
    }

    if (!neighbors.size) return;
    setHiddenNodeIds((prev) => {
      const next = new Set(prev);
      neighbors.forEach((nid) => next.delete(String(nid)));
      return next;
    });
  };

  const handleUnselectAllFromContextMenu = () => {
    setNodeContextMenu(null);
    setPcapSelectedLinkKeysManual(() => new Set());
    setPcapSelectedLinkKeysNeighbors(() => new Set());
    setActiveLinkId(null);

    // Also clear any neighbor-highlighted links for non-PCAP graphs.
    setGraphData((prev) => {
      if (!prev || !Array.isArray(prev.links) || !prev.links.length) return prev;
      let changed = false;
      const nextLinks = prev.links.map((l) => {
        if (!l || typeof l !== 'object') return l;
        if (!l.__neighborSelected) return l;
        changed = true;
        const { __neighborSelected, ...rest } = l;
        // Only clear color if it was set by neighbor selection.
        return { ...rest, color: undefined };
      });
      return changed ? { ...prev, links: nextLinks } : prev;
    });
  };

  const handleSelectNeighborsFromContextMenu = () => {
    if (!nodeContextMenu || !nodeContextMenu.node) return;
    const key = nodeContextMenu.node.id != null ? String(nodeContextMenu.node.id) : '';
    if (!key) {
      setNodeContextMenu(null);
      return;
    }
    const gd = nodeContextMenu.graphDataOverride;
    setNodeContextMenu(null);

    const isPcapView = !!(location && typeof location.pathname === 'string' && location.pathname.startsWith('/pcap'));
    if (!isPcapView && dataSource !== PCAP) {
      // Non-PCAP: apply highlight by setting per-link color (GraphComponent respects link.color).
      setGraphData((prev) => {
        const sourceGraph = (gd && typeof gd === 'object') ? gd : (prev || (graphDataRef && graphDataRef.current ? graphDataRef.current : graphData));
        const links = sourceGraph && Array.isArray(sourceGraph.links) ? sourceGraph.links : [];
        if (!links.length) return prev;

        const normalizeEndpointId = (v) => {
          const raw = (v && typeof v === 'object') ? (v.id ?? v._id ?? v.address) : v;
          if (raw == null) return '';
          return String(raw);
        };

        let changed = false;
        const nextLinks = (prev && Array.isArray(prev.links) ? prev.links : []).map((l) => {
          if (!l || typeof l !== 'object') return l;
          const s = normalizeEndpointId(l.source);
          const t = normalizeEndpointId(l.target);
          if (!s || !t) return l;
          if (!(s === key || t === key)) return l;
          if (l.__neighborSelected && l.color) return l;
          changed = true;
          return { ...l, color: 'rgba(33, 150, 243, 0.95)', __neighborSelected: true };
        });
        return changed ? { ...prev, links: nextLinks } : prev;
      });
      return;
    }

    const normalizeEndpointId = (v) => {
      const raw = (v && typeof v === 'object') ? (v.id ?? v._id ?? v.address) : v;
      if (raw == null) return '';
      return String(raw);
    };

    const makePairKey = (a, b) => {
      const ordered = [String(a || ''), String(b || '')].sort();
      return `${ordered[0]}↔${ordered[1]}`;
    };

    const sourceGraph = (gd && typeof gd === 'object') ? gd : (graphDataRef && graphDataRef.current ? graphDataRef.current : graphData);
    const links = sourceGraph && Array.isArray(sourceGraph.links) ? sourceGraph.links : [];
    const add = new Set();
    for (let i = 0; i < links.length; i += 1) {
      const l = links[i];
      if (!l) continue;
      const s = normalizeEndpointId(l.source);
      const t = normalizeEndpointId(l.target);
      if (!s || !t) continue;
      if (s === key) add.add(makePairKey(s, t));
      else if (t === key) add.add(makePairKey(s, t));
    }

    if (!add.size) return;
    setPcapSelectedLinkKeysNeighbors((prev) => {
      const next = new Set(prev);
      add.forEach((k) => next.add(k));
      return next;
    });
  };

  const handleUnselectNeighborsFromContextMenu = () => {
    if (!nodeContextMenu || !nodeContextMenu.node) return;
    const key = nodeContextMenu.node.id != null ? String(nodeContextMenu.node.id) : '';
    if (!key) {
      setNodeContextMenu(null);
      return;
    }
    const gd = nodeContextMenu.graphDataOverride;
    setNodeContextMenu(null);

    const isPcapView = !!(location && typeof location.pathname === 'string' && location.pathname.startsWith('/pcap'));
    if (!isPcapView && dataSource !== PCAP) {
      // Non-PCAP: remove neighbor selection highlight.
      setGraphData((prev) => {
        if (!prev || !Array.isArray(prev.links) || !prev.links.length) return prev;
        const normalizeEndpointId = (v) => {
          const raw = (v && typeof v === 'object') ? (v.id ?? v._id ?? v.address) : v;
          if (raw == null) return '';
          return String(raw);
        };

        let changed = false;
        const nextLinks = prev.links.map((l) => {
          if (!l || typeof l !== 'object') return l;
          if (!l.__neighborSelected) return l;
          const s = normalizeEndpointId(l.source);
          const t = normalizeEndpointId(l.target);
          if (!s || !t) return l;
          if (!(s === key || t === key)) return l;
          changed = true;
          const { __neighborSelected, ...rest } = l;
          return { ...rest, color: undefined };
        });
        return changed ? { ...prev, links: nextLinks } : prev;
      });
      return;
    }

    const normalizeEndpointId = (v) => {
      const raw = (v && typeof v === 'object') ? (v.id ?? v._id ?? v.address) : v;
      if (raw == null) return '';
      return String(raw);
    };

    const makePairKey = (a, b) => {
      const ordered = [String(a || ''), String(b || '')].sort();
      return `${ordered[0]}↔${ordered[1]}`;
    };

    const sourceGraph = (gd && typeof gd === 'object') ? gd : (graphDataRef && graphDataRef.current ? graphDataRef.current : graphData);
    const links = sourceGraph && Array.isArray(sourceGraph.links) ? sourceGraph.links : [];
    const remove = new Set();
    for (let i = 0; i < links.length; i += 1) {
      const l = links[i];
      if (!l) continue;
      const s = normalizeEndpointId(l.source);
      const t = normalizeEndpointId(l.target);
      if (!s || !t) continue;
      if (s === key) remove.add(makePairKey(s, t));
      else if (t === key) remove.add(makePairKey(s, t));
    }

    if (!remove.size) return;
    setPcapSelectedLinkKeysNeighbors((prev) => {
      const next = new Set(prev);
      remove.forEach((k) => next.delete(k));
      return next;
    });
  };
  
  const [graphData, setGraphData] = useState(() => {
    // On mount, check if there's preserved graph data from a previous instance (e.g., gallery → pcap navigation)
    try {
      if (typeof window !== 'undefined' && window.__E3D_PCAP_GRAPH_DATA__) {
        return window.__E3D_PCAP_GRAPH_DATA__;
      }
    } catch (e) {}
    return { nodes: [], links: [] };
  });

  const [pcapConversations, setPcapConversations] = useState([]);
  const pcapCsvTextRef = useRef('');

  const graphDataRef = useRef(graphData);

  const [hiddenNodeIds, setHiddenNodeIds] = useState(() => new Set());
  const [hideNeighborsMode, setHideNeighborsMode] = useState(false);

  const toggleHiddenNodeIdInternal = useCallback((id, graphDataOverride, forceNeighbors) => {
    const key = id != null ? String(id) : '';
    if (!key) return;

    const normalizeEndpointId = (v) => {
      const raw = (v && typeof v === 'object') ? (v.id ?? v._id ?? v.address) : v;
      if (raw == null) return '';
      return String(raw);
    };

    const getNeighborIds = () => {
      const out = new Set();
      try {
        const sourceGraph = (graphDataOverride && typeof graphDataOverride === 'object')
          ? graphDataOverride
          : (graphDataRef && graphDataRef.current ? graphDataRef.current : graphData);
        const links = sourceGraph && Array.isArray(sourceGraph.links) ? sourceGraph.links : [];
        for (let i = 0; i < links.length; i += 1) {
          const l = links[i];
          if (!l) continue;
          const s = normalizeEndpointId(l.source);
          const t = normalizeEndpointId(l.target);
          if (!s || !t) continue;
          if (s === key) out.add(t);
          else if (t === key) out.add(s);
        }
      } catch (e) {
      }
      return out;
    };

    setHiddenNodeIds((prev) => {
      const next = new Set(prev);
      const isHidden = next.has(key);
      const idsToToggle = new Set([key]);

      if (forceNeighbors || hideNeighborsMode) {
        const neighbors = getNeighborIds();
        neighbors.forEach((n) => idsToToggle.add(n));
      }

      idsToToggle.forEach((nid) => {
        if (!nid) return;
        if (isHidden) next.delete(nid);
        else next.add(nid);
      });

      return next;
    });
  }, [graphData, hideNeighborsMode, graphDataRef]);

  const toggleHiddenNodeId = useCallback((id, graphDataOverride) => {
    toggleHiddenNodeIdInternal(id, graphDataOverride, false);
  }, [toggleHiddenNodeIdInternal]);

  const forceToggleHiddenNodeIdWithNeighbors = useCallback((id, graphDataOverride) => {
    toggleHiddenNodeIdInternal(id, graphDataOverride, true);
  }, [toggleHiddenNodeIdInternal]);

  const unhideAllNodes = useCallback(() => {
    setHiddenNodeIds(new Set());
  }, []);
  const [pcapLinkStyle, setPcapLinkStyle] = useState('collapsed_straight');
  const [pcapShowLabels, setPcapShowLabels] = useState(true);
  const [pcapLabelSize, setPcapLabelSize] = useState(4);
  const pcapBaseGraphRef = useRef(null);
  const pcapEffectiveBaseGraphRef = useRef(null);
  const nodeContextMenuRef = useRef(null);
  const dragSelectedGroupRef = useRef({ anchorId: null, members: null });
  const [showNames, setShowNames] = useState(true);
  const [dataSource, setDataSource] = useState(() => {
    // Check if we're loading from PCAP gallery to avoid flashing ETH view
    try {
      if (typeof window !== 'undefined' && window.__E3D_PCAP_IS_LOADING_FROM_GALLERY__) {
        return 0; // PCAP
      }
    } catch (e) {}
    return 1; // Default to ETH, 0 = PCAP, 1 = ETH, 2 = BSC
  });
  const [priceDataSource, setPriceDataSource] = useState(ALL_CHAINS);
  const [pcapShowMac, setPcapShowMac] = useState(() => {
    try {
      const raw = localStorage.getItem('pcapShowMac');
      if (raw == null) {
        try {
          localStorage.setItem('pcapShowMac', 'false');
        } catch (e2) {
        }
        return false;
      }
      return raw === 'true';
    } catch (e) {
      return false;
    }
  });
  const [pcapShowOui, setPcapShowOui] = useState(() => {
    try {
      const raw = localStorage.getItem('pcapShowOui');
      if (raw == null) {
        try {
          localStorage.setItem('pcapShowOui', 'true');
        } catch (e2) {
        }
        return true;
      }
      return raw === 'true';
    } catch (e) {
      return true;
    }
  });
  const [pcapGroupNamesEnabled, setPcapGroupNamesEnabled] = useState(false);
  const [pcapGroupIpsEnabled, setPcapGroupIpsEnabled] = useState(false);
  const [pcapManualGroupNameKeys, setPcapManualGroupNameKeys] = useState(() => new Set());
  const [pcapManualGroupIpFirstOctets, setPcapManualGroupIpFirstOctets] = useState(() => new Set());
  const pcapManualGroupNameKeysRef = useRef(new Set());
  const pcapManualGroupIpFirstOctetsRef = useRef(new Set());
  const [pcapShowTopN, setPcapShowTopN] = useState('All');
  const [showTopSubmenu, setShowTopSubmenu] = useState(false);
  const [priceListTotal, setPriceListTotal] = useState(0);
  const [priceListSortBy, setPriceListSortBy] = useState(() => {
    try {
      const raw = (typeof window !== 'undefined' && window.localStorage)
        ? String(window.localStorage.getItem('e3d_price_sort_by') || '').trim()
        : '';
      // Default /price sorting should be Stories (desc).
      // Keep the stored value if present, but fall back to storyCount.
      // Legacy/default 'price' should not win here, but marketCap should persist.
      if (!raw || raw === 'price') return 'storyCount';
      return raw;
    } catch (e) {
      return 'storyCount';
    }
  });
  const [priceListSortDir, setPriceListSortDir] = useState(() => {
    try {
      const raw = (typeof window !== 'undefined' && window.localStorage)
        ? String(window.localStorage.getItem('e3d_price_sort_dir') || '').trim().toLowerCase()
        : '';
      return raw === 'asc' ? 'asc' : 'desc';
    } catch (e) {
      return 'desc';
    }
  });
  const priceSortStorageKeyBy = 'e3d_price_sort_by';
  const priceSortStorageKeyDir = 'e3d_price_sort_dir';
  const PRICE_HIDDEN_COLUMNS_STORAGE_KEY = 'e3d_price_hidden_columns_v3';
  const PRICE_HIDDEN_COLUMNS_DEFAULT = useMemo(() => (['address', 'fdvUSD', 'liquidityUSD', 'volume24hUSD', 'effectiveLiquidityUSD']), []);
  const PRICE_COLUMN_VISIBILITY_OPTIONS = useMemo(() => ([
    { id: 'chain', label: 'Chain' },
    { id: 'address', label: 'Address' },
    { id: 'liquidityUSD', label: 'Liquidity' },
    { id: 'volume24hUSD', label: 'Uniswap 24H Vol' },
    { id: 'fdvUSD', label: 'FDV' },
    { id: 'effectiveLiquidityUSD', label: 'Eff. Liq' },
    { id: 'trend_sparkline', label: 'Price Trend' },
    { id: 'volume_trend_sparkline', label: 'Volume Trend' },
    { id: 'fragilityScore', label: 'Fragility' },
    { id: 'storyCount', label: 'Stories' },
    { id: 'thesisCount', label: 'Theses' },
  ]), []);
  const [priceHiddenColumns, setPriceHiddenColumns] = useState(() => {
    const parseHiddenColumns = (rawValue) => {
      const raw = String(rawValue || '').trim();
      return raw ? raw.split(',').map((s) => String(s || '').trim()).filter(Boolean) : [];
    };
    try {
      const stored = (typeof window !== 'undefined' && window.localStorage)
        ? parseHiddenColumns(window.localStorage.getItem(PRICE_HIDDEN_COLUMNS_STORAGE_KEY))
        : [];
      if (stored.length) {
        return Array.from(new Set(stored));
      }
      const legacy = (typeof window !== 'undefined' && window.localStorage)
        ? parseHiddenColumns(window.localStorage.getItem('e3d_price_hidden_columns'))
        : [];
      if (legacy.length) {
        return Array.from(new Set(legacy.concat(PRICE_HIDDEN_COLUMNS_DEFAULT)));
      }
      return PRICE_HIDDEN_COLUMNS_DEFAULT;
    } catch (e) {
      return PRICE_HIDDEN_COLUMNS_DEFAULT;
    }
  });
  const [showPriceDetails, setShowPriceDetails] = useState(false);
  const priceVisibleColumnCount = useMemo(
    () => PRICE_COLUMN_VISIBILITY_OPTIONS.filter((opt) => !priceHiddenColumns.includes(opt.id)).length,
    [PRICE_COLUMN_VISIBILITY_OPTIONS, priceHiddenColumns]
  );
  const [priceListOffset, setPriceListOffset] = useState(0);
  const priceListPageSize = 300;
  const priceListLoadingRef = useRef(false);
  const priceListPendingResetRef = useRef(null);
  const [priceListBusy, setPriceListBusy] = useState(false);
  const [priceSearchText, setPriceSearchText] = useState('');
  const priceSearchDebounceRef = useRef(null);
  const [priceScreenerOpen, setPriceScreenerOpen] = useState(false);
  const [priceScreener, setPriceScreener] = useState(() => {
    try {
      const raw = typeof window !== 'undefined' && window.localStorage
        ? window.localStorage.getItem('e3d_price_screener') : null;
      return raw ? JSON.parse(raw) : {};
    } catch (e) { return {}; }
  });
  const [screenerPresets, setScreenerPresets] = useState(() => {
    try {
      const raw = typeof window !== 'undefined' && window.localStorage
        ? window.localStorage.getItem('e3d_screener_presets') : null;
      return raw ? JSON.parse(raw) : [];
    } catch (e) { return []; }
  });
  const [screenerPresetName, setScreenerPresetName] = useState('');
  const [screenerPresetSaving, setScreenerPresetSaving] = useState(false);
  useEffect(() => {
    try { window.localStorage.setItem('e3d_screener_presets', JSON.stringify(screenerPresets)); } catch (e) {}
  }, [screenerPresets]);
  const parseScreenerVal = (v) => {
    if (v === '' || v == null) return null;
    const s = String(v).trim().replace(/,/g, '');
    const mult = s.endsWith('B') || s.endsWith('b') ? 1e9
      : s.endsWith('M') || s.endsWith('m') ? 1e6
      : s.endsWith('K') || s.endsWith('k') ? 1e3 : 1;
    const n = Number(s.replace(/[BbMmKk]$/, ''));
    return Number.isFinite(n) ? n * mult : null;
  };
  const [priceSelectedCategories, setPriceSelectedCategories] = useState([]);
  const [priceCategoryAnchorEl, setPriceCategoryAnchorEl] = useState(null);
  const priceFavoriteAddresses = useMemo(() => {
    try {
      const out = [];
      (watchedKeys || new Set()).forEach((key) => {
        const parts = String(key || '').split(':');
        const addr = parts.length >= 2 ? String(parts[1] || '').trim().toLowerCase() : '';
        if (addr && /^0x[0-9a-f]{40}$/.test(addr)) out.push(addr);
      });
      return Array.from(new Set(out));
    } catch (e) {
      return [];
    }
  }, [watchedKeys]);
  const priceFavoriteAddressesCsv = useMemo(() => priceFavoriteAddresses.join(','), [priceFavoriteAddresses]);
  const [priceChangeIntervalSelected, setPriceChangeIntervalSelected] = useState(() => {
    try {
      const raw = (typeof window !== 'undefined' && window.localStorage)
        ? normalizePriceChangeIntervalKey(window.localStorage.getItem('e3d_price_change_interval_selected'))
        : '';
      return PRICE_CHANGE_INTERVAL_OPTIONS.includes(raw) ? raw : '12H';
    } catch (e) {
      return '12H';
    }
  });
  const [priceSelectedChangeIntervals, setPriceSelectedChangeIntervals] = useState(() => {
    try {
      const raw = (typeof window !== 'undefined' && window.localStorage)
        ? String(window.localStorage.getItem('e3d_price_change_intervals') || '').trim()
        : '';
      const parsed = raw
        .split(',')
        .map((s) => normalizePriceChangeIntervalKey(s))
        .filter((s) => PRICE_CHANGE_INTERVAL_OPTIONS.includes(s));
      const uniq = Array.from(new Set(parsed));
      return uniq.length ? uniq : ['6H', '12H'];
    } catch (e) {
      return ['6H', '12H'];
    }
  });
  const [priceChangeAnchorEl, setPriceChangeAnchorEl] = useState(null);
  const priceSelectedCategoriesCsv = useMemo(() => priceSelectedCategories.join(','), [priceSelectedCategories]);
  const priceCategoryButtonLabel = useMemo(() => {
    if (!priceSelectedCategories.length) return 'All Categories';
    if (priceSelectedCategories.length === 1) return priceSelectedCategories[0];
    return `Categories (${priceSelectedCategories.length})`;
  }, [priceSelectedCategories]);
  const [priceTrendAnchorEl, setPriceTrendAnchorEl] = useState(null);
  const [priceColumnsAnchorEl, setPriceColumnsAnchorEl] = useState(null);
  const priceMenuPaperProps = useMemo(() => ({
    style: {
      backgroundColor: '#242424',
      border: '1px solid rgba(111, 135, 255, 0.22)',
      borderRadius: 10,
      boxShadow: '0 18px 50px rgba(0, 0, 0, 0.72)',
      marginTop: 28,
      color: '#e9edff',
      minWidth: 190,
    },
  }), []);
  const priceMenuListProps = useMemo(() => ({
    style: {
      paddingTop: 0,
      paddingBottom: 0,
    },
  }), []);
  const priceMenuItemStyle = useMemo(() => ({
    fontSize: 11.5,
    lineHeight: '14px',
    minHeight: 24,
    paddingTop: 2,
    paddingBottom: 2,
    color: '#e9edff',
  }), []);
  const [priceTrendIntervalSelected, setPriceTrendIntervalSelected] = useState(() => {
    try {
      const raw = (typeof window !== 'undefined' && window.localStorage)
        ? String(window.localStorage.getItem('e3d_price_trend_interval_selected') || '').trim().toUpperCase()
        : '';
      return PRICE_CHANGE_INTERVAL_OPTIONS.includes(raw) ? raw : '24H';
    } catch (e) {
      return '24H';
    }
  });
  const priceTrendIntervalRef = useRef(priceTrendIntervalSelected);
  useEffect(() => { priceTrendIntervalRef.current = priceTrendIntervalSelected; }, [priceTrendIntervalSelected]);
  const priceChangeButtonLabel = useMemo(() => {
    if (priceSelectedChangeIntervals.length === PRICE_CHANGE_INTERVAL_OPTIONS.length) return 'All %';
    if (!priceSelectedChangeIntervals.length) return 'No %';
    if (priceSelectedChangeIntervals.length === 1) return `${priceSelectedChangeIntervals[0]} %`;
    return `% (${priceSelectedChangeIntervals.length})`;
  }, [priceSelectedChangeIntervals]);
  const priceTrendButtonLabel = useMemo(() => {
    return `${priceTrendIntervalSelected || '24H'} Trend`;
  }, [priceTrendIntervalSelected]);

  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(PRICE_HIDDEN_COLUMNS_STORAGE_KEY, priceHiddenColumns.join(','));
      }
    } catch (e) {
    }
  }, [priceHiddenColumns, PRICE_HIDDEN_COLUMNS_STORAGE_KEY]);
  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem('e3d_price_change_intervals', priceSelectedChangeIntervals.join(','));
      }
    } catch (e) {
    }
  }, [priceSelectedChangeIntervals]);
  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem('e3d_price_trend_interval_selected', String(priceTrendIntervalSelected || '24H'));
      }
    } catch (e) {
    }
  }, [priceTrendIntervalSelected]);
  useEffect(() => {
    try {
      console.debug('[PriceTrendMenu] selected interval changed', {
        priceTrendIntervalSelected,
        priceTrendButtonLabel,
      });
    } catch (e) {
    }
  }, [priceTrendIntervalSelected, priceTrendButtonLabel]);

  const screenerActiveFilterCount = useMemo(() => {
    try {
      return Object.values(priceScreener || {}).filter((v) => v !== '' && v != null && v !== false).length;
    } catch (e) {
      return 0;
    }
  }, [priceScreener]);
  const screenerHasActiveFilters = screenerActiveFilterCount > 0;

  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem('e3d_price_change_interval_selected', String(priceChangeIntervalSelected || '12H'));
      }
    } catch (e) {
    }
  }, [priceChangeIntervalSelected]);

  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem('e3d_price_screener', JSON.stringify(priceScreener));
      }
    } catch (e) {}
  }, [priceScreener]);

  useEffect(() => {
    if (!priceSelectedChangeIntervals.length) {
      setPriceSelectedChangeIntervals(['6H', '12H']);
      setPriceChangeIntervalSelected('12H');
      return;
    }
    if (!priceSelectedChangeIntervals.includes(priceChangeIntervalSelected)) {
      setPriceChangeIntervalSelected(priceSelectedChangeIntervals.includes('12H') ? '12H' : priceSelectedChangeIntervals[priceSelectedChangeIntervals.length - 1]);
    }
  }, [priceSelectedChangeIntervals, priceChangeIntervalSelected]);
  useEffect(() => {
    if (!PRICE_CHANGE_INTERVAL_OPTIONS.includes(priceTrendIntervalSelected)) {
      setPriceTrendIntervalSelected('24H');
    }
  }, [priceTrendIntervalSelected]);
  const [tokenList, setTokenList] = useState(() => {
    // Restore tokenList from window object if available (for PCAP gallery navigation)
    try {
      if (typeof window !== 'undefined' && window.__E3D_PCAP_TOKEN_LIST__) {
        return window.__E3D_PCAP_TOKEN_LIST__;
      }
    } catch (e) {}
    return [];
  });
  const [filterUser, setFilterUser] = useState(false);
  const [showNewTokens, setShowNewTokens] = useState(false);

  const addressMetaCacheRef = useRef(new Map());

  const pcapMacOuiByMac = React.useMemo(() => {
    try {
      if (dataSource !== PCAP) return new Map();
      const base = pcapBaseGraphRef.current;
      const nodes = base && Array.isArray(base.nodes) ? base.nodes : [];
      const macRegex = /^([0-9A-Fa-f]{2}([:-])){5}[0-9A-Fa-f]{2}$/;
      const out = new Map();
      for (let i = 0; i < nodes.length; i += 1) {
        const n = nodes[i];
        if (!n || n.id == null) continue;
        const id = String(n.id).trim();
        if (!macRegex.test(id)) continue;
        const org = n.label != null ? String(n.label).trim() : '';
        if (org) out.set(id, org);
      }
      return out;
    } catch (e) {
      return new Map();
    }
  }, [dataSource, graphData]);

  useEffect(() => {
    try {
      pcapManualGroupNameKeysRef.current = new Set(pcapManualGroupNameKeys || []);
    } catch (e) {
      pcapManualGroupNameKeysRef.current = new Set();
    }
  }, [pcapManualGroupNameKeys]);

  useEffect(() => {
    try {
      pcapManualGroupIpFirstOctetsRef.current = new Set(pcapManualGroupIpFirstOctets || []);
    } catch (e) {
      pcapManualGroupIpFirstOctetsRef.current = new Set();
    }
  }, [pcapManualGroupIpFirstOctets]);

  const normalizeAddress = (addr) => {
    if (!addr) return '';
    const s = String(addr).trim().toLowerCase();
    if (!s) return '';
    const base = s.includes('.') ? s.split('.')[0] : s;
    if (!base.startsWith('0x')) return '';
    if (!/^0x[0-9a-f]+$/.test(base)) return '';
    return base;
  };

  const looksLikeAddress = (s) => {
    if (!s) return false;
    const v = String(s);
    return v.startsWith('0x') && v.length >= 10;
  };

  const resolveAddresses = async (addresses) => {
    const cleaned = Array.from(
      new Set(
        (addresses || [])
          .map((a) => normalizeAddress(a))
          .filter((a) => a && looksLikeAddress(a))
      )
    );

    if (!cleaned.length) return;

    const missing = cleaned.filter((a) => !addressMetaCacheRef.current.has(a));
    if (!missing.length) return;

    const chunks = [];
    const MAX = 500;
    for (let i = 0; i < missing.length; i += MAX) {
      chunks.push(missing.slice(i, i + MAX));
    }

    for (const chunk of chunks) {
      try {
        const resp = await axios.post(`${SERVER_NAME}/addressMetaBatch`, { addresses: chunk });
        const payload = resp ? resp.data : null;
        const rows = Array.isArray(payload)
          ? payload
          : (payload && Array.isArray(payload.data)
            ? payload.data
            : (payload && payload.data && Array.isArray(payload.data.data)
              ? payload.data.data
              : []));
        rows.forEach((row, idx) => {
          const reqAddr = chunk[idx];
          const addr = normalizeAddress((row && (row.address || row.addr)) || reqAddr);
          if (!addr) return;
          addressMetaCacheRef.current.set(addr, row || null);
        });
      } catch (e) {
        // Important: do NOT mark these addresses as "known null" on request
        // failure. Otherwise a transient server/network issue permanently
        // prevents name/symbol lookups for the rest of the session.
      }
    }
  };

  const applyResolvedLabels = (maybeGraph) => {
    const g = maybeGraph || graphData;
    if (!g || !Array.isArray(g.nodes) || !g.nodes.length) return { changed: false, next: g };

    let changed = false;
    const nextNodes = g.nodes.map((n) => {
      if (!n || !n.id) return n;
      const addr = normalizeAddress(n.id);
      if (!addr) return n;
      const meta = addressMetaCacheRef.current.get(addr);
      if (!meta) return n;
      const nextLabel = meta.name || meta['n.name'] || meta.symbol || meta['n.symbol'] || n.label;
      const nextIcon = meta.icon || meta['n.icon'] || meta.icon2 || meta['n.icon2'] || n.icon || null;
      if (nextLabel && nextLabel !== n.label) {
        changed = true;
        return { ...n, label: nextLabel, icon: nextIcon };
      }
      if (nextIcon && nextIcon !== n.icon) {
        changed = true;
        return { ...n, icon: nextIcon };
      }
      return n;
    });

    return {
      changed,
      next: {
        ...g,
        nodes: nextNodes,
      },
    };
  };

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        if (typeof location !== 'undefined' && location && typeof location.pathname === 'string') {
          if (location.pathname.startsWith('/graphs')) {
            return;
          }
        }
        if (!graphData || !Array.isArray(graphData.nodes) || !graphData.nodes.length) return;
        const ids = graphData.nodes
          .map((n) => (n && n.id ? String(n.id) : ''))
          .filter(Boolean);

        await resolveAddresses(ids);
        if (cancelled) return;

        setGraphData((prev) => {
          const { changed, next } = applyResolvedLabels(prev);
          return changed ? next : prev;
        });

        if (Array.isArray(tokenList) && tokenList.length) {
          setTokenList((prev) => {
            let changed = false;
            const next = prev.map((row) => {
              const addr = normalizeAddress(row && (row.address || row.id));
              if (!addr) return row;
              const meta = addressMetaCacheRef.current.get(addr);
              if (!meta) return row;
              const nextLabel = meta.name || meta['n.name'] || meta.symbol || meta['n.symbol'] || row.label;
              const nextIcon = meta.icon || meta['n.icon'] || meta.icon2 || meta['n.icon2'] || row.icon || null;
              if (nextLabel && nextLabel !== row.label) {
                changed = true;
                return { ...row, label: nextLabel, icon: nextIcon };
              }
              if (nextIcon && nextIcon !== row.icon) {
                changed = true;
                return { ...row, icon: nextIcon };
              }
              return row;
            });
            return changed ? next : prev;
          });
        }
      } catch (e) {
        if (cancelled) return;
      }
    };

    run();
    return () => {
      cancelled = true;
    };
  }, [graphData, tokenList]);

  const buildPcapCollapsedGraph = useCallback((baseGraph) => buildPcapCollapsedGraphPure(baseGraph), []);

  const buildPcapGroupedGraph = useCallback((baseGraph, groupOpts) => buildPcapGroupedGraphPure(baseGraph, groupOpts), []);

  const applyPcapLinkStyle = useCallback((style, baseGraph) => applyPcapLinkStylePure(style, baseGraph), []);

  const pcapMobileForceGroupNames = !!(dataSource === PCAP && isMobile);
  const pcapGroupNamesEffective = pcapMobileForceGroupNames ? true : !!pcapGroupNamesEnabled;
  const pcapGroupIpsEffective = !!pcapGroupIpsEnabled;
  const pcapManualGroupingEnabled = !!((pcapManualGroupNameKeys && pcapManualGroupNameKeys.size) || (pcapManualGroupIpFirstOctets && pcapManualGroupIpFirstOctets.size));
  const pcapGroupEnabled = !!(pcapGroupNamesEffective || pcapGroupIpsEffective || pcapManualGroupingEnabled);

  const recomputePcapGraphAndTokens = useCallback((baseGraph, opts) => {
    const o = opts || {};
    const base = baseGraph || pcapBaseGraphRef.current;
    if (!base) return;
    const groupNamesOn = pcapMobileForceGroupNames ? true : (o.groupNamesOn != null ? !!o.groupNamesOn : !!pcapGroupNamesEnabled);
    const groupIpsOn = o.groupIpsOn != null ? !!o.groupIpsOn : !!pcapGroupIpsEnabled;
    const manualNameKeys = Array.isArray(o.manualNameKeys) ? o.manualNameKeys : Array.from(pcapManualGroupNameKeys || []);
    const manualIpFirstOctets = Array.isArray(o.manualIpFirstOctets) ? o.manualIpFirstOctets : Array.from(pcapManualGroupIpFirstOctets || []);
    const groupOn = !!(groupNamesOn || groupIpsOn || (manualNameKeys && manualNameKeys.length) || (manualIpFirstOctets && manualIpFirstOctets.length));

    const isMacAddress = (s) => {
      const raw = String(s || '').trim();
      if (!raw) return false;
      // Match aa:bb:cc:dd:ee:ff (or AA-BB-CC-DD-EE-FF)
      return /^([0-9A-Fa-f]{2}([:-])){5}[0-9A-Fa-f]{2}$/.test(raw);
    };

    const macOn = o.macOn != null ? !!o.macOn : !!pcapShowMac;
    const ouiOn = o.ouiOn != null ? !!o.ouiOn : !!pcapShowOui;
    let filteredBase = base;
    if (!macOn) {
      const allNodes = Array.isArray(base.nodes) ? base.nodes : [];
      const allowed = new Set(
        allNodes
          .filter((n) => {
            if (!n) return false;
            const id = String(n.id || '').trim();
            const label = String(n.label || '').trim();
            return !(isMacAddress(id) || isMacAddress(label));
          })
          .map((n) => String(n.id))
      );
      filteredBase = {
        nodes: allNodes.filter((n) => n && allowed.has(String(n.id))),
        links: (Array.isArray(base.links) ? base.links : []).filter((l) => {
          if (!l) return false;
          const s = typeof l.source === 'object' ? l.source.id : l.source;
          const t = typeof l.target === 'object' ? l.target.id : l.target;
          return allowed.has(String(s)) && allowed.has(String(t));
        }),
      };
    }

    const effectiveBase = groupOn
      ? buildPcapGroupedGraph(filteredBase, {
        groupNames: groupNamesOn,
        groupIps: groupIpsOn,
        manualNameKeys,
        manualIpFirstOctets,
      })
      : filteredBase;

    // Force-graph mutates node objects (x/y/z/vx/vy/vz) and may preserve
    // layout between updates by id. When switching between grouped/ungrouped
    // views we want a fresh layout so the clusters can spread out.
    const sanitizeNodes = (arr) => (Array.isArray(arr) ? arr.map((n) => {
      if (!n || typeof n !== 'object') return n;
      const { x, y, z, vx, vy, vz, fx, fy, fz, ...rest } = n;
      return { ...rest };
    }) : []);
    const sanitizeLinks = (arr) => (Array.isArray(arr) ? arr.map((l) => {
      if (!l || typeof l !== 'object') return l;
      const s = typeof l.source === 'object' ? l.source.id : l.source;
      const t = typeof l.target === 'object' ? l.target.id : l.target;
      // Important: force source/target to ids so links always attach to the
      // current node objects (avoids stale refs bundling at the origin).
      return { ...l, source: s, target: t };
    }) : []);

    const sanitizedBase = {
      nodes: sanitizeNodes(effectiveBase.nodes),
      links: sanitizeLinks(effectiveBase.links),
    };

    // If any links reference missing node ids, ForceGraph will effectively
    // render them against a "ghost" node at the origin, which looks like a
    // bundled hairball not touching real nodes.
    const nodeIdsArr = (sanitizedBase.nodes || []).map((n) => (n && n.id != null ? String(n.id) : '')).filter(Boolean);
    const nodeIdSet = new Set(nodeIdsArr);
    const originalLinks = Array.isArray(sanitizedBase.links) ? sanitizedBase.links : [];

    const invalidLinks = [];
    for (let i = 0; i < originalLinks.length; i += 1) {
      const l = originalLinks[i];
      if (!l) continue;
      const s = l.source != null ? String(l.source) : '';
      const t = l.target != null ? String(l.target) : '';
      if (!s || !t || !nodeIdSet.has(s) || !nodeIdSet.has(t)) {
        if (invalidLinks.length < 12) invalidLinks.push({ id: l.id, source: s, target: t, pcapDir: l.pcapDir });
      }
    }

    let filteredLinks = originalLinks.filter((l) => {
      if (!l) return false;
      const s = l.source != null ? String(l.source) : '';
      const t = l.target != null ? String(l.target) : '';
      if (!s || !t) return false;
      return nodeIdSet.has(s) && nodeIdSet.has(t);
    });

    // "Show Top N": cap the rendered node set to the N heaviest talkers (by
    // total bytes, falling back to link/degree count for zero-byte nodes
    // like MAC helper nodes), applied after grouping so a grouped cluster's
    // combined traffic is what gets ranked, not its individual members.
    const topN = o.topN !== undefined ? o.topN : pcapShowTopN;
    if (topN !== 'All' && topN != null && Number.isFinite(Number(topN)) && Number(topN) > 0) {
      const limit = Number(topN);
      const rankedNodes = Array.isArray(sanitizedBase.nodes) ? sanitizedBase.nodes : [];
      if (rankedNodes.length > limit) {
        const sortedNodes = rankedNodes.slice().sort((a, b) => {
          const aBytes = Number(a && a.totalBytes) || 0;
          const bBytes = Number(b && b.totalBytes) || 0;
          if (bBytes !== aBytes) return bBytes - aBytes;
          const aLinks = Number(a && a.linkCount) || 0;
          const bLinks = Number(b && b.linkCount) || 0;
          return bLinks - aLinks;
        });
        sanitizedBase.nodes = sortedNodes.slice(0, limit);
        const keepIds = new Set(sanitizedBase.nodes.map((n) => String(n && n.id)));
        filteredLinks = filteredLinks.filter((l) => {
          const s = l && l.source != null ? String(l.source) : '';
          const t = l && l.target != null ? String(l.target) : '';
          return keepIds.has(s) && keepIds.has(t);
        });
      }
    }

    if (dataSource === PCAP && groupOn) {
      try {
        console.log(
          'PCAP grouped link debug:',
          'nodes=',
          nodeIdsArr.length,
          'links=',
          originalLinks.length,
          'invalid=',
          invalidLinks.length,
          'after=',
          filteredLinks.length
        );
        if (invalidLinks.length) {
          console.log('PCAP grouped invalid link samples:', invalidLinks);
          console.log('PCAP grouped node id samples:', nodeIdsArr.slice(0, 12));
        }
      } catch (e) {
      }
    }

    sanitizedBase.links = filteredLinks;

    pcapEffectiveBaseGraphRef.current = sanitizedBase;

    const styledGraph = applyPcapLinkStyle(pcapLinkStyle, sanitizedBase);
    const styledNodesRaw = Array.isArray(styledGraph && styledGraph.nodes) ? styledGraph.nodes : [];
    const pcapMeta = pcapNameTableCacheRef && pcapNameTableCacheRef.current ? pcapNameTableCacheRef.current : null;
    const styledNodes = (pcapMeta && pcapMeta.size)
      ? styledNodesRaw.map((n) => {
        if (!n || !n.id) return n;
        const id = String(n.id).trim().toLowerCase();
        const meta = pcapMeta.get(id);
        if (!meta) return n;
        const nextLabel = meta && meta.label ? String(meta.label) : (n.label || '');
        const nextIcon = meta && meta.iconUrl ? normalizeIconUrl(String(meta.iconUrl)) : (n.icon || null);
        if (nextLabel === n.label && nextIcon === n.icon) return n;
        return { ...n, label: nextLabel, symbol: nextLabel || n.symbol, icon: nextIcon || null };
      })
      : styledNodesRaw;

    // When MAC view is enabled, prefer displaying MAC + OUI org in the graph and lists.
    // We do this by populating node.displayId, and then using displayId everywhere we render a node.
    const macRegex = /^([0-9A-Fa-f]{2}([:-])){5}[0-9A-Fa-f]{2}$/;
    const displayIdByNodeId = new Map();
    if (macOn) {
      try {
        // Build IP -> MAC map from the MAC↔IP helper links.
        const ipToMac = new Map();
        const baseLinks = Array.isArray(sanitizedBase && sanitizedBase.links) ? sanitizedBase.links : [];
        for (let i = 0; i < baseLinks.length; i += 1) {
          const l = baseLinks[i];
          if (!l || l.metaType !== 'pcap_mac') continue;
          const s = l && (typeof l.source === 'object' ? l.source.id : l.source);
          const t = l && (typeof l.target === 'object' ? l.target.id : l.target);
          const sId = s != null ? String(s).trim() : '';
          const tId = t != null ? String(t).trim() : '';
          if (macRegex.test(sId) && tId && !macRegex.test(tId) && !ipToMac.has(tId)) {
            ipToMac.set(tId, sId);
          } else if (macRegex.test(tId) && sId && !macRegex.test(sId) && !ipToMac.has(sId)) {
            ipToMac.set(sId, tId);
          }
        }

        // Build MAC -> display string map from MAC nodes (label is org after OUI enrichment).
        const macDisplayByMac = new Map();
        for (let i = 0; i < styledNodes.length; i += 1) {
          const n = styledNodes[i];
          if (!n || n.id == null) continue;
          const id = String(n.id).trim();
          if (!macRegex.test(id)) continue;
          const org = (n.label != null ? String(n.label).trim() : '');
          const disp = (ouiOn && org && org !== id) ? `${org} (${id})` : id;
          macDisplayByMac.set(id, disp);
        }

        // MAC nodes: display MAC+org; IP nodes: display mapped MAC if available.
        for (let i = 0; i < styledNodes.length; i += 1) {
          const n = styledNodes[i];
          if (!n || n.id == null) continue;
          const id = String(n.id).trim();
          if (macRegex.test(id)) {
            const disp = macDisplayByMac.get(id) || id;
            displayIdByNodeId.set(id, disp);
          } else {
            const mac = ipToMac.get(id);
            if (mac && macDisplayByMac.has(mac)) {
              displayIdByNodeId.set(id, macDisplayByMac.get(mac));
            }
          }
        }
      } catch (e) {
      }
    }

    const styledNodesWithDisplay = (macOn && displayIdByNodeId.size)
      ? styledNodes.map((n) => {
        if (!n || n.id == null) return n;
        const id = String(n.id).trim();
        const disp = displayIdByNodeId.get(id);
        if (!disp) return { ...n, displayId: null };
        if (n.displayId === disp) return n;
        return { ...n, displayId: disp };
      })
      : styledNodes.map((n) => {
        if (!n || typeof n !== 'object') return n;
        if (!('displayId' in n)) return n;
        if (n.displayId == null) return n;
        const { displayId, ...rest } = n;
        return rest;
      });

    // Some grouped PCAP nodes can end up with an icon but an empty label.
    // Ensure the label always has a meaningful fallback so both the graph
    // and list render text.
    const styledNodesWithDisplayAndLabel = (Array.isArray(styledNodesWithDisplay) ? styledNodesWithDisplay : []).map((n) => {
      if (!n || typeof n !== 'object') return n;
      const id = n.id != null ? String(n.id) : '';
      const disp = n.displayId != null ? String(n.displayId).trim() : '';
      const lbl = n.label != null ? String(n.label).trim() : '';
      if (lbl) return n;
      const nextLabel = disp || id;
      if (!nextLabel) return n;
      return { ...n, label: nextLabel, symbol: nextLabel };
    });
    const styledNodeIdsArr = styledNodesWithDisplayAndLabel.map((n) => (n && n.id != null ? String(n.id) : '')).filter(Boolean);
    const styledNodeIdSet = new Set(styledNodeIdsArr);
    const styledLinksRaw = Array.isArray(styledGraph && styledGraph.links) ? styledGraph.links : [];

    // Normalize styled link endpoints to ids again because applyPcapLinkStyle and/or
    // force-graph can mutate endpoints into node objects.
    const styledLinksNormalized = styledLinksRaw.map((l) => {
      if (!l || typeof l !== 'object') return l;
      const s = typeof l.source === 'object' ? l.source.id : l.source;
      const t = typeof l.target === 'object' ? l.target.id : l.target;
      return { ...l, source: s, target: t };
    });

    const styledInvalid = [];
    for (let i = 0; i < styledLinksNormalized.length; i += 1) {
      const l = styledLinksNormalized[i];
      if (!l) continue;
      const s = l.source != null ? String(l.source) : '';
      const t = l.target != null ? String(l.target) : '';
      if (!s || !t || !styledNodeIdSet.has(s) || !styledNodeIdSet.has(t)) {
        if (styledInvalid.length < 12) styledInvalid.push({ id: l.id, source: s, target: t, pcapDir: l.pcapDir });
      }
    }

    const styledLinksFiltered = styledLinksNormalized.filter((l) => {
      if (!l) return false;
      const s = l.source != null ? String(l.source) : '';
      const t = l.target != null ? String(l.target) : '';
      if (!s || !t) return false;
      return styledNodeIdSet.has(s) && styledNodeIdSet.has(t);
    });

    if (dataSource === PCAP && groupOn) {
      try {
        console.log(
          'PCAP grouped styled link debug:',
          'nodes=',
          styledNodeIdsArr.length,
          'links=',
          styledLinksRaw.length,
          'invalid=',
          styledInvalid.length,
          'after=',
          styledLinksFiltered.length,
          'style=',
          pcapLinkStyle
        );
        if (styledInvalid.length) console.log('PCAP grouped styled invalid samples:', styledInvalid);
      } catch (e) {
      }
    }

    // ForceGraph mutates link endpoints (source/target) into node objects.
    // If we later replace nodes with new objects but reuse those mutated link
    // objects, links can end up pointing at stale node objects and appear as a
    // "fixed" hairball that doesn't follow dragged/simulated nodes.
    // Rematerialize nodes/links and force endpoints back to ids each update.
    // In Stories mode on /graphs, highlight story-address nodes amber.
    const isStoriesMode = location.pathname.startsWith('/graphs') && linksDataModeRef.current === 'stories';
    const storyAddrSet = isStoriesMode && storyAddressesRef.current.length
      ? new Set(storyAddressesRef.current.map((a) => String(a).toLowerCase()))
      : null;
    const finalNodes = (styledNodesWithDisplayAndLabel || []).map((n) => {
      if (!n || typeof n !== 'object') return n;
      if (storyAddrSet) {
        const nid = n.id != null ? String(n.id).toLowerCase() : '';
        if (nid && storyAddrSet.has(nid)) {
          return { ...n, storyNode: true, color: 0xFFA500 };
        }
        return { ...n, storyNode: false };
      }
      return { ...n };
    });
    const finalLinks = (styledLinksFiltered || []).map((l) => {
      if (!l || typeof l !== 'object') return l;
      const s = typeof l.source === 'object' ? l.source.id : l.source;
      const t = typeof l.target === 'object' ? l.target.id : l.target;
      return { ...l, source: s, target: t };
    });

    const newGraphData = { nodes: finalNodes, links: finalLinks };
    setGraphData(newGraphData);

    // Preserve graph data across component remounts (e.g., when navigating from gallery to pcap)
    try {
      if (typeof window !== 'undefined') {
        window.__E3D_PCAP_GRAPH_DATA__ = newGraphData;
      }
    } catch (e) {}

    // In grouped PCAP we have seen cases where three-forcegraph holds onto
    // stale internal node instances for link endpoints. Remounting the graph
    // forces a clean rebuild of internal caches.
    if (dataSource === PCAP && groupOn) {
      setGraphInstanceKey((prev) => prev + 1);
    }
    try {
      const tokenType = 'Token';
      const baseNodesRaw = sanitizedBase.nodes || [];
      const baseNodes = (pcapMeta && pcapMeta.size)
        ? baseNodesRaw.map((n) => {
          if (!n || !n.id) return n;
          const id = String(n.id).trim().toLowerCase();
          const meta = pcapMeta.get(id);
          if (!meta) return n;
          const nextLabel = meta && meta.label ? String(meta.label) : (n.label || '');
          const nextIcon = meta && meta.iconUrl ? normalizeIconUrl(String(meta.iconUrl)) : (n.icon || null);
          if (nextLabel === n.label && nextIcon === n.icon) return n;
          return { ...n, label: nextLabel, symbol: nextLabel || n.symbol, icon: nextIcon || null };
        })
        : baseNodesRaw;

      const baseNodesWithDisplay = (macOn && displayIdByNodeId.size)
        ? baseNodes.map((n) => {
          if (!n || n.id == null) return n;
          const id = String(n.id).trim();
          const disp = displayIdByNodeId.get(id);
          if (!disp) return { ...n, displayId: null };
          if (n.displayId === disp) return n;
          return { ...n, displayId: disp };
        })
        : baseNodes;

      const tokensRaw = createTokenList(baseNodesWithDisplay, tokenType, PCAP);
      const tokens = (pcapMeta && pcapMeta.size)
        ? (Array.isArray(tokensRaw) ? tokensRaw.map((row) => {
          const id = row && (row.id || row.address) ? String(row.id || row.address).trim().toLowerCase() : '';
          if (!id) return row;
          const meta = pcapMeta.get(id);
          if (!meta) return row;
          const nextLabel = meta && meta.label ? String(meta.label) : (row.label || row.name || '');
          const nextIcon = meta && meta.iconUrl ? normalizeIconUrl(String(meta.iconUrl)) : (row.icon || null);
          if (nextLabel === (row.label || '') && nextIcon === (row.icon || null)) return row;
          return { ...row, label: nextLabel, icon: nextIcon || null };
        }) : tokensRaw)
        : tokensRaw;
      setTokenList(tokens);

      // Preserve tokenList across component remounts (for PCAP gallery navigation)
      try {
        if (typeof window !== 'undefined') {
          window.__E3D_PCAP_TOKEN_LIST__ = tokens;
        }
      } catch (e) {}
    } catch (e) {
    }
  }, [applyPcapLinkStyle, buildPcapGroupedGraph, dataSource, isMobile, pcapGroupNamesEnabled, pcapGroupIpsEnabled, pcapLinkStyle, pcapManualGroupIpFirstOctets, pcapManualGroupNameKeys, pcapMobileForceGroupNames, pcapShowMac, pcapShowOui, pcapShowTopN]);

  const handleGroupThisFromContextMenu = useCallback(() => {
    try {
      const isPcapView = !!(location && typeof location.pathname === 'string' && location.pathname.startsWith('/pcap'));
      if (!isPcapView) return;
      const ctx = nodeContextMenuRef.current;
      if (!ctx || !ctx.node) return;

      const n = ctx.node;
      const id = n && n.id != null ? String(n.id).trim() : '';
      const label = n && n.label != null ? String(n.label).trim() : '';
      if (!id) return;

      const macRegex = /^([0-9A-Fa-f]{2}([:-])){5}[0-9A-Fa-f]{2}$/;
      const isMacOnly = macRegex.test(id) || macRegex.test(label);
      if (isMacOnly) {
        setNodeContextMenu(null);
        return;
      }

      const normalizeTextKey = (s) => String(s || '').trim().toLowerCase();
      const labelKey = normalizeTextKey(label);
      const rawIdForGrouping = (id && typeof id === 'string' && id.startsWith('ip:'))
        ? id.slice('ip:'.length)
        : ((id && typeof id === 'string' && id.startsWith('name:')) ? id.slice('name:'.length) : id);
      const rawIpForGrouping = extractIpv4(rawIdForGrouping) || extractIpv4(label);
      const rawIdKey = normalizeTextKey(rawIdForGrouping);
      const isEffectivelyUnnamedLabel = (lk, ik) => {
        const v = String(lk || '').trim();
        if (!v) return true;
        if (v === String(ik || '').trim()) return true;
        if (v === '-') return true;
        if (v === 'n/a') return true;
        if (v === 'na') return true;
        if (v === 'unknown') return true;
        return false;
      };

      const nextNameKeys = new Set(pcapManualGroupNameKeysRef.current || []);
      const nextIpFirstOctets = new Set(pcapManualGroupIpFirstOctetsRef.current || []);

      const hasMeaningfulName = !!(
        labelKey &&
        !isEffectivelyUnnamedLabel(labelKey, rawIdKey) &&
        labelKey !== rawIdKey &&
        !isIpv4(label)
      );

      // If the node has a meaningful name, group by that name even when id is an IP.
      if (hasMeaningfulName) {
        if (id && typeof id === 'string' && id.startsWith('name:')) {
          setNodeContextMenu(null);
          return;
        }
        if (nextNameKeys.has(labelKey)) {
          setNodeContextMenu(null);
          return;
        }
        nextNameKeys.add(labelKey);
        setPcapManualGroupNameKeys(nextNameKeys);
      } else if (rawIpForGrouping) {
        // Otherwise, if the node is an IP address, group by /8.
        const firstOctet = String(rawIpForGrouping).split('.')[0] || '';
        if (firstOctet) {
          if (id && typeof id === 'string' && id.startsWith('ip:') && String(rawIdForGrouping).includes('/8')) {
            setNodeContextMenu(null);
            return;
          }
          if (nextIpFirstOctets.has(firstOctet)) {
            setNodeContextMenu(null);
            return;
          }
          nextIpFirstOctets.add(firstOctet);
          setPcapManualGroupIpFirstOctets(nextIpFirstOctets);
        }
      }

      setNodeContextMenu(null);
      if (pcapBaseGraphRef.current) {
        recomputePcapGraphAndTokens(pcapBaseGraphRef.current, {
          groupNamesOn: (dataSource === PCAP && isMobile) ? true : !!pcapGroupNamesEnabled,
          groupIpsOn: !!pcapGroupIpsEnabled,
          manualNameKeys: Array.from(nextNameKeys || []),
          manualIpFirstOctets: Array.from(nextIpFirstOctets || []),
        });
      }
      setGraphInstanceKey((prev) => prev + 1);
    } catch (e) {
      try { setNodeContextMenu(null); } catch (e2) {}
    }
  }, [dataSource, isMobile, location, pcapGroupIpsEnabled, pcapGroupNamesEnabled, recomputePcapGraphAndTokens]);

  const handleGroupAllFromContextMenu = useCallback(() => {
    try {
      const isPcapView = !!(location && typeof location.pathname === 'string' && location.pathname.startsWith('/pcap'));
      if (!isPcapView) return;

      const macRegex = /^([0-9A-Fa-f]{2}([:-])){5}[0-9A-Fa-f]{2}$/;
      const normalizeTextKey = (s) => String(s || '').trim().toLowerCase();
      const isEffectivelyUnnamedLabel = (lk, ik) => {
        const v = String(lk || '').trim();
        if (!v) return true;
        if (v === String(ik || '').trim()) return true;
        if (v === '-') return true;
        if (v === 'n/a') return true;
        if (v === 'na') return true;
        if (v === 'unknown') return true;
        return false;
      };

      // Scan the ungrouped base graph (not the currently-displayed, possibly
      // already-grouped one) so every distinct name present gets its own
      // manual group key, the same way clicking "Group X Addresses" once
      // per name would.
      const baseNodes = (pcapBaseGraphRef.current && Array.isArray(pcapBaseGraphRef.current.nodes))
        ? pcapBaseGraphRef.current.nodes
        : [];
      const nextNameKeys = new Set(pcapManualGroupNameKeysRef.current || []);

      baseNodes.forEach((n) => {
        const id = n && n.id != null ? String(n.id).trim() : '';
        const label = n && n.label != null ? String(n.label).trim() : '';
        if (!id) return;
        if (macRegex.test(id) || macRegex.test(label)) return;

        const rawIdForGrouping = (id.startsWith('ip:')) ? id.slice('ip:'.length)
          : (id.startsWith('name:')) ? id.slice('name:'.length) : id;
        const labelKey = normalizeTextKey(label);
        const rawIdKey = normalizeTextKey(rawIdForGrouping);

        const hasMeaningfulName = !!(
          labelKey &&
          !isEffectivelyUnnamedLabel(labelKey, rawIdKey) &&
          labelKey !== rawIdKey &&
          !isIpv4(label)
        );

        if (hasMeaningfulName) {
          nextNameKeys.add(labelKey);
        }
      });

      setPcapManualGroupNameKeys(nextNameKeys);
      setNodeContextMenu(null);
      if (pcapBaseGraphRef.current) {
        recomputePcapGraphAndTokens(pcapBaseGraphRef.current, {
          groupNamesOn: (dataSource === PCAP && isMobile) ? true : !!pcapGroupNamesEnabled,
          groupIpsOn: !!pcapGroupIpsEnabled,
          manualNameKeys: Array.from(nextNameKeys || []),
          manualIpFirstOctets: Array.from(pcapManualGroupIpFirstOctetsRef.current || []),
        });
      }
      setGraphInstanceKey((prev) => prev + 1);
    } catch (e) {
      try { setNodeContextMenu(null); } catch (e2) {}
    }
  }, [dataSource, isMobile, location, pcapGroupIpsEnabled, pcapGroupNamesEnabled, recomputePcapGraphAndTokens]);

  const handleSetPcapShowTopN = useCallback((value) => {
    try {
      const isPcapView = !!(location && typeof location.pathname === 'string' && location.pathname.startsWith('/pcap'));
      if (!isPcapView) return;
      setPcapShowTopN(value);
      setNodeContextMenu(null);
      setShowTopSubmenu(false);
      if (pcapBaseGraphRef.current) {
        recomputePcapGraphAndTokens(pcapBaseGraphRef.current, { topN: value });
      }
      setGraphInstanceKey((prev) => prev + 1);
    } catch (e) {
      try { setNodeContextMenu(null); } catch (e2) {}
    }
  }, [location, recomputePcapGraphAndTokens]);

  const handleUngroupAllFromContextMenu = useCallback(() => {
    try {
      const isPcapView = !!(location && typeof location.pathname === 'string' && location.pathname.startsWith('/pcap'));
      if (!isPcapView) return;
      setPcapManualGroupNameKeys(() => new Set());
      setPcapManualGroupIpFirstOctets(() => new Set());
      setNodeContextMenu(null);
      if (pcapBaseGraphRef.current) {
        recomputePcapGraphAndTokens(pcapBaseGraphRef.current, {
          groupNamesOn: (dataSource === PCAP && isMobile) ? true : !!pcapGroupNamesEnabled,
          groupIpsOn: !!pcapGroupIpsEnabled,
          manualNameKeys: [],
          manualIpFirstOctets: [],
        });
      }
      setGraphInstanceKey((prev) => prev + 1);
    } catch (e) {
      try { setNodeContextMenu(null); } catch (e2) {}
    }
  }, [dataSource, isMobile, location, pcapGroupIpsEnabled, pcapGroupNamesEnabled, recomputePcapGraphAndTokens]);

  const handleUngroupThisFromContextMenu = useCallback(() => {
    try {
      const isPcapView = !!(location && typeof location.pathname === 'string' && location.pathname.startsWith('/pcap'));
      if (!isPcapView) return;
      const ctx = nodeContextMenuRef.current;
      if (!ctx || !ctx.node) return;
      const n = ctx.node;
      const id = n && n.id != null ? String(n.id).trim() : '';
      if (!id) return;

      const raw = id;
      const nextNameKeys = new Set(pcapManualGroupNameKeysRef.current || []);
      const nextIpFirstOctets = new Set(pcapManualGroupIpFirstOctetsRef.current || []);
      let changed = false;
      if (raw.startsWith('name:')) {
        const key = raw.slice('name:'.length).trim().toLowerCase();
        if (key && nextNameKeys.delete(key)) {
          changed = true;
          setPcapManualGroupNameKeys(nextNameKeys);
        }
      } else if (raw.startsWith('ip:')) {
        const rest = raw.slice('ip:'.length).trim().toLowerCase();
        const m = rest.match(/^(\d{1,3})\.0\.0\.0\/8$/);
        const oct = m && m[1] ? String(m[1]).trim() : '';
        if (oct && nextIpFirstOctets.delete(oct)) {
          changed = true;
          setPcapManualGroupIpFirstOctets(nextIpFirstOctets);
        }
      }

      setNodeContextMenu(null);
      if (pcapBaseGraphRef.current) {
        recomputePcapGraphAndTokens(pcapBaseGraphRef.current, {
          groupNamesOn: (dataSource === PCAP && isMobile) ? true : !!pcapGroupNamesEnabled,
          groupIpsOn: !!pcapGroupIpsEnabled,
          manualNameKeys: Array.from(nextNameKeys || []),
          manualIpFirstOctets: Array.from(nextIpFirstOctets || []),
        });
      }
      if (changed) setGraphInstanceKey((prev) => prev + 1);
    } catch (e) {
      try { setNodeContextMenu(null); } catch (e2) {}
    }
  }, [dataSource, isMobile, location, pcapGroupIpsEnabled, pcapGroupNamesEnabled, recomputePcapGraphAndTokens]);

  const setPcapLinkStyleAndApply = useCallback((nextStyle) => {
    setPcapLinkStyle(nextStyle);
    const base = pcapEffectiveBaseGraphRef.current || pcapBaseGraphRef.current || graphData;
    const nextGraph = applyPcapLinkStyle(nextStyle, base);
    try {
      const ns = nextGraph && Array.isArray(nextGraph.nodes) ? nextGraph.nodes : [];
      const ls = nextGraph && Array.isArray(nextGraph.links) ? nextGraph.links : [];
      const finalNodes = ns.map((n) => (n && typeof n === 'object' ? { ...n } : n));
      const finalLinks = ls.map((l) => {
        if (!l || typeof l !== 'object') return l;
        const s = typeof l.source === 'object' ? l.source.id : l.source;
        const t = typeof l.target === 'object' ? l.target.id : l.target;
        return { ...l, source: s, target: t };
      });
      setGraphData({ nodes: finalNodes, links: finalLinks });
      const pcapGroupEnabledNow = !!((pcapMobileForceGroupNames ? true : !!pcapGroupNamesEnabled) || !!pcapGroupIpsEnabled);
      if (dataSource === PCAP && pcapGroupEnabledNow) {
        setGraphInstanceKey((prev) => prev + 1);
      }
    } catch (e) {
      setGraphData(nextGraph);
    }
  }, [applyPcapLinkStyle, dataSource, graphData, isMobile, pcapGroupNamesEnabled, pcapGroupIpsEnabled, pcapMobileForceGroupNames]);

  const setPcapGroupNamesEnabledAndApply = useCallback((next) => {
    if (dataSource === PCAP && isMobile) return;
    const v = !!next;
    setPcapGroupNamesEnabled(v);
    try {
      localStorage.setItem('pcapGroupNamesEnabled', v ? 'true' : 'false');
    } catch (e) {
    }
    if (pcapBaseGraphRef.current) {
      recomputePcapGraphAndTokens(pcapBaseGraphRef.current, { groupNamesOn: v, groupIpsOn: !!pcapGroupIpsEnabled });
    }
    setGraphInstanceKey((prev) => prev + 1);
  }, [dataSource, isMobile, pcapGroupIpsEnabled, recomputePcapGraphAndTokens]);

  const setPcapGroupIpsEnabledAndApply = useCallback((next) => {
    const v = !!next;
    setPcapGroupIpsEnabled(v);
    try {
      localStorage.setItem('pcapGroupIpsEnabled', v ? 'true' : 'false');
    } catch (e) {
    }
    if (pcapBaseGraphRef.current) {
      recomputePcapGraphAndTokens(pcapBaseGraphRef.current, { groupNamesOn: !!pcapGroupNamesEnabled, groupIpsOn: v });
    }
    setGraphInstanceKey((prev) => prev + 1);
  }, [pcapGroupNamesEnabled, recomputePcapGraphAndTokens]);

  const setPcapShowMacAndApply = useCallback((next) => {
    const v = !!next;
    setPcapShowMac(v);
    try {
      localStorage.setItem('pcapShowMac', v ? 'true' : 'false');
    } catch (e) {
    }
    if (pcapBaseGraphRef.current) {
      recomputePcapGraphAndTokens(pcapBaseGraphRef.current, { macOn: v, ouiOn: !!pcapShowOui });
    }
    setGraphInstanceKey((prev) => prev + 1);
  }, [pcapShowOui, recomputePcapGraphAndTokens]);

  const setPcapShowOuiAndApply = useCallback((next) => {
    const v = !!next;
    setPcapShowOui(v);
    try {
      localStorage.setItem('pcapShowOui', v ? 'true' : 'false');
    } catch (e) {
    }
    if (pcapBaseGraphRef.current) {
      recomputePcapGraphAndTokens(pcapBaseGraphRef.current, { macOn: !!pcapShowMac, ouiOn: v });
    }
    setGraphInstanceKey((prev) => prev + 1);
  }, [pcapShowMac, recomputePcapGraphAndTokens]);

  useEffect(() => {
    if (dataSource !== PCAP) return;
    if (!pcapBaseGraphRef.current) return;
    recomputePcapGraphAndTokens(pcapBaseGraphRef.current, {
      groupNamesOn: pcapMobileForceGroupNames ? true : !!pcapGroupNamesEnabled,
      groupIpsOn: !!pcapGroupIpsEnabled,
      macOn: !!pcapShowMac,
      ouiOn: !!pcapShowOui,
    });
  }, [dataSource, isMobile, pcapGroupNamesEnabled, pcapGroupIpsEnabled, pcapShowMac, pcapShowOui, pcapMobileForceGroupNames, recomputePcapGraphAndTokens]);

  useEffect(() => {
    // PCAP on mobile: keep the conversation/node list panel closed by default.
    // Rendering the virtualized table + images can be expensive on iOS Safari.
    if (dataSource === PCAP && isMobile) {
      setShowPanel(false);
    }
  }, [dataSource, isMobile]);

  useEffect(() => {
    // PCAP mobile portrait: the bottom node list should be open by default.
    // Avoid referencing isPortrait here because it is initialized later in this file.
    // Instead, infer portrait mode directly from window dimensions.
    if (dataSource !== PCAP || !isMobile) return;
    try {
      const portraitNow = (typeof window !== 'undefined') && (window.innerWidth < window.innerHeight);
      if (portraitNow) {
        setShowBottom(true);
        setShowPanel(false);
      }
    } catch (e) {
    }
  }, [dataSource, isMobile]);
  const [graphViewMode, setGraphViewMode] = useState('all'); // Options: 'all', 'token_connected', 'users_only', 'tokens_only'
  
  // Use a ref to track if we're currently classifying to avoid infinite loops
  const isClassifying = useRef(false);
  
  // Classify nodes whenever graph data changes
  useEffect(() => {

    if (!isClassifying.current && graphData && graphData.nodes && graphData.nodes.length > 0) {
      isClassifying.current = true;
      
      // Apply classification without triggering a re-render if possible
      const needsUpdate = graphData.nodes.some(node => !node.nodeType);
      
      if (needsUpdate) {
        // Only update if nodes haven't been classified yet
        const classifiedData = classifyGraphNodes({...graphData});
        setGraphData(classifiedData);
      }
      
      isClassifying.current = false;
    }
  }, [graphData.nodes.length]);
  
  // Fix token icons in graph display - addresses the issue with generic Ethereum icons
  const fixTokenGraphIcons = () => {
    if (tokenList && tokenList.length > 0 && graphData && graphData.nodes && graphData.nodes.length > 0) {
      console.log("Fixing token icons in graph");
      
      // Create a deep copy of the graph data to avoid direct mutation
      const updatedGraphData = JSON.parse(JSON.stringify(graphData));
      let iconsFixed = false;
      
      // For each node in graph data, try to match it with tokenList
      updatedGraphData.nodes.forEach(node => {
        if (!node.icon || node.icon === genericTokenIcon) {
          // Try to find a matching token in tokenList
          const tokenMatch = tokenList.find(token => token.id === node.id);
          if (tokenMatch && tokenMatch.icon && tokenMatch.icon !== genericTokenIcon) {
            console.log(`Updating icon for ${node.id} from tokenList`);
            node.icon = tokenMatch.icon;
            node.originalIcon = tokenMatch.icon;
            iconsFixed = true;
          }
        }
      });
      
      // Only update if we actually fixed icons
      if (iconsFixed) {
        // Update the graph with fixed icons
        setGraphData(updatedGraphData);
      }
    }
  };
  const [linkCount, setLinkCount] = useState( new Map() );
  const [nodeListVisibleCount, setNodeListVisibleCount] = useState(null);
  const [transactions, setTransactions] = useState(null);
  const [originalGraphData, setOriginalGraphData] = useState(null);
  const [fileUrl, setFileUrl] = useState(null);
  const [searchText, setSearchText] = useState('');
  const classes = useStyles();
  const graphRef = useRef(null);
  const engineStopSeqRef = useRef(0);
  const engineStopWaitersRef = useRef([]);
  const suppressAutoFitUntilRef = useRef(0);
  const [mapData, setMapData] = useState(new Map());
  const [showText, setShowText] = useState(true);
  const [showAddressLabels, setShowAddressLabels] = useState(false);
  const [showGraphToolbar, setShowGraphToolbar] = useState(false);
  const [graphToolbarOrientation, setGraphToolbarOrientation] = useState('horizontal');
  const [labelSize, setLabelSize] = useState(() => {
    // Check URL parameter first, then default to middle of slider range (2-20)
    try {
      const params = new URLSearchParams(window.location.search);
      const urlSize = params.get('labelSize');
      if (urlSize != null) {
        const n = Number(urlSize);
        if (!Number.isNaN(n) && n >= 2 && n <= 20) return n;
      }
    } catch (e) {}
    return 11;
  });
  const [intervalEthId, setIntervalEthId] = useState(null);
  const [intervalBscId, setIntervalBscId] = useState(null);
  const simulationRef = useRef();
  const [PauseSimulation, setPauseSimulation] = useState(false);
  const [showPanel, setShowPanel] = useState(() => {
    try {
      // Default to closed on small screens so we don't mount the heavy list UI
      // on mobile Safari during initial load.
      return window.innerWidth >= 800;
    } catch (e) {
      return true;
    }
  });
  const [showBottom, setShowBottom] = useState(true);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isFirstEngineStop, setIsFirstEngineStop] = useState(true);
  const [is3DMode, setIs3DMode] = useState(true); // Default to 3D view mode (controls whether we see 2D or 3D graph)
  const [progressVisible, setProgressVisible] = useState(() => {
    // Restore progress visibility state for PCAP gallery navigation
    try {
      if (typeof window !== 'undefined' && window.__E3D_PCAP_PROGRESS_VISIBLE__ != null) {
        return window.__E3D_PCAP_PROGRESS_VISIBLE__;
      }
    } catch (e) {}
    return false;
  });
  const [progress, setProgress] = useState(() => {
    // Restore progress value for PCAP gallery navigation
    try {
      if (typeof window !== 'undefined' && window.__E3D_PCAP_PROGRESS__ != null) {
        return window.__E3D_PCAP_PROGRESS__;
      }
    } catch (e) {}
    return 0;
  });
  const [maxValue, setMaxValue] = useState(0);
  const [dateRange, setDateRange] = useState({ startDate: 0, endDate: 0 });
  const [dateRange2, setDateRange2] = useState({ startDate: 0, endDate: 0 });
  const [linksIsoDateRange, setLinksIsoDateRange] = useState(null);
  const [earliestEthTxIso, setEarliestEthTxIso] = useState(null);
  const [linksDateRangeAnchorEl, setLinksDateRangeAnchorEl] = useState(null);
  const [linksSignInAnchorEl, setLinksSignInAnchorEl] = useState(null);
  const [linksRangeUpgradeMsg, setLinksRangeUpgradeMsg] = useState('');
  // Replace direct auth state with context hook
  const [showLogin, setShowLogin] = useState(false);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [nodeContextMenu, setNodeContextMenu] = useState(null); // { mouseX, mouseY, node }
  const [showSignup, setShowSignup] = useState(false);
  const [showMembersOnly, setShowMembersOnly] = useState(false);
  const [showVerifyEmailCode, setShowVerifyEmailCode] = useState(false);

  useEffect(() => {
    nodeContextMenuRef.current = nodeContextMenu;
  }, [nodeContextMenu]);

  useEffect(() => {
    try {
      if (typeof window === 'undefined') return;

      const notifyEngineStop = () => {
        try {
          engineStopSeqRef.current = (engineStopSeqRef.current || 0) + 1;
          const seq = engineStopSeqRef.current;
          const waiters = Array.isArray(engineStopWaitersRef.current) ? engineStopWaitersRef.current : [];
          engineStopWaitersRef.current = [];
          for (let i = 0; i < waiters.length; i += 1) {
            const w = waiters[i];
            if (!w || typeof w.resolve !== 'function') continue;
            try { if (w.timer) clearTimeout(w.timer); } catch (e) {}
            try { w.resolve({ seq, ts: Date.now() }); } catch (e) {}
          }
        } catch (e) {
        }
      };

      window.__E3D_NOTIFY_ENGINE_STOP__ = notifyEngineStop;
      window.__E3D_WAIT_FOR_ENGINE_STOP__ = (timeoutMs = 60000) => {
        try {
          const t = Number(timeoutMs);
          const timeout = Number.isFinite(t) && t > 0 ? Math.min(t, 5 * 60 * 1000) : 60000;
          return new Promise((resolve, reject) => {
            const timer = setTimeout(() => {
              try {
                engineStopWaitersRef.current = (engineStopWaitersRef.current || []).filter((x) => x && x.resolve !== resolve);
              } catch (e) {
              }
              try { reject(new Error('Timed out waiting for engine stop')); } catch (e) {}
            }, timeout);
            engineStopWaitersRef.current = Array.isArray(engineStopWaitersRef.current) ? engineStopWaitersRef.current : [];
            engineStopWaitersRef.current.push({ resolve, reject, timer });
          });
        } catch (e) {
          return Promise.reject(e);
        }
      };

      window.__E3D_EXPORT_GRAPH_PNG__ = (filename) => {
        try {
          if (!graphRef || !graphRef.current) return false;
          const name = filename ? String(filename) : 'e3d_graph.png';
          downloadImagePNG(graphRef, name);
          return true;
        } catch (e) {
          return false;
        }
      };

      window.__E3D_EXPORT_GRAPH_PNG_DATA_URL__ = () => {
        try {
          if (!graphRef || !graphRef.current) return '';
          return exportGraphPngDataUrl(graphRef);
        } catch (e) {
          return '';
        }
      };

      window.__E3D_EXPORT_GRAPH_SNAPSHOT_JSON__ = () => {
        try {
          const normalizeEndpointId = (v) => {
            try {
              if (v == null) return '';
              if (typeof v === 'object') {
                const raw = v.id ?? v._id ?? v.address;
                return raw != null ? String(raw) : '';
              }
              return String(v);
            } catch (e) {
              return '';
            }
          };

          const src = (graphDataRef && graphDataRef.current)
            ? graphDataRef.current
            : (graphRef && graphRef.current && typeof graphRef.current.graphData === 'function' ? graphRef.current.graphData() : null);

          const nodesIn = src && Array.isArray(src.nodes) ? src.nodes : [];
          const linksIn = src && Array.isArray(src.links) ? src.links : [];

          const nodes = nodesIn.map((n) => {
            if (!n || typeof n !== 'object') return n;
            const out = { ...n };
            if (out.id != null) out.id = String(out.id);
            if (out.label != null) out.label = String(out.label);
            if (out.x != null) out.x = Number(out.x);
            if (out.y != null) out.y = Number(out.y);
            if (out.z != null) out.z = Number(out.z);
            return out;
          });

          const links = linksIn.map((l) => {
            if (!l || typeof l !== 'object') return l;
            const out = { ...l };
            out.source = normalizeEndpointId(out.source);
            out.target = normalizeEndpointId(out.target);
            return out;
          });

          const rangeMinutes = 10;
          const snap = {
            version: 1,
            created_at: new Date().toISOString(),
            range_minutes: rangeMinutes,
            graphData: { nodes, links },
          };
          return JSON.stringify(snap);
        } catch (e) {
          return '';
        }
      };

      window.__E3D_ZOOM_OUT__ = (times = 1) => {
        try {
          // Try layoutManagerRef first, then fallback to global window reference
          let lm = layoutManagerRef && layoutManagerRef.current ? layoutManagerRef.current : null;
          if (!lm && typeof window !== 'undefined' && window.__E3D_LAYOUT_MANAGER__) {
            console.log('[__E3D_ZOOM_OUT__] Using fallback window.__E3D_LAYOUT_MANAGER__');
            lm = window.__E3D_LAYOUT_MANAGER__;
          }
          if (!lm) {
            console.log('[__E3D_ZOOM_OUT__] No layoutManager (neither ref nor window)');
            return false;
          }
          if (typeof lm.handleZoomOut !== 'function') {
            console.log('[__E3D_ZOOM_OUT__] layoutManager has no handleZoomOut function');
            return false;
          }
          const gd = graphDataRef && graphDataRef.current ? graphDataRef.current : graphData;
          const n = Math.max(1, Number(times) || 1);
          console.log(`[__E3D_ZOOM_OUT__] Calling handleZoomOut ${n} times`);
          for (let i = 0; i < n; i += 1) {
            lm.handleZoomOut(gd);
          }
          console.log(`[__E3D_ZOOM_OUT__] Successfully called handleZoomOut ${n} times`);
          return true;
        } catch (e) {
          console.log('[__E3D_ZOOM_OUT__] Error:', e);
          return false;
        }
      };

      window.__E3D_STOP_CAMERA_SPIN__ = () => {
        try {
          if (typeof stopCameraSpin === 'function') {
            stopCameraSpin();
            return true;
          }
          return false;
        } catch (e) {
          return false;
        }
      };

      window.__E3D_START_CAMERA_SPIN__ = () => {
        try {
          if (typeof startCameraSpin === 'function') {
            startCameraSpin();
            return true;
          }
          return false;
        } catch (e) {
          return false;
        }
      };

      window.__E3D_SUPPRESS_AUTO_FIT__ = (durationMs = 60000) => {
        try {
          const duration = Math.max(0, Number(durationMs) || 0);
          suppressAutoFitUntilRef.current = Date.now() + duration;
          console.log(`[__E3D_SUPPRESS_AUTO_FIT__] Auto-fit suppressed for ${duration}ms`);
          return true;
        } catch (e) {
          console.log('[__E3D_SUPPRESS_AUTO_FIT__] Error:', e);
          return false;
        }
      };

      window.__E3D_ZOOM_TO_FIT__ = (transitionDuration = 1000, padding = 80) => {
        try {
          if (!graphRef || !graphRef.current) {
            console.log('[__E3D_ZOOM_TO_FIT__] No graphRef');
            return false;
          }
          if (typeof graphRef.current.zoomToFit !== 'function') {
            console.log('[__E3D_ZOOM_TO_FIT__] graphRef has no zoomToFit function');
            return false;
          }
          const duration = Math.max(0, Number(transitionDuration) || 0);
          const pad = Math.max(0, Number(padding) || 0);
          console.log(`[__E3D_ZOOM_TO_FIT__] Calling zoomToFit(${duration}, ${pad})`);
          graphRef.current.zoomToFit(duration, pad);
          console.log('[__E3D_ZOOM_TO_FIT__] Successfully called zoomToFit');
          return true;
        } catch (e) {
          console.log('[__E3D_ZOOM_TO_FIT__] Error:', e);
          return false;
        }
      };

      window.__E3D_PCAP_EXPAND_GRAPH__ = (times = 1) => {
        try {
          const lm = layoutManagerRef && layoutManagerRef.current ? layoutManagerRef.current : null;
          if (!lm || typeof lm.handleExpandGraph !== 'function') return false;
          const gd = graphDataRef && graphDataRef.current ? graphDataRef.current : graphData;
          lm.handleExpandGraph(gd, Number(times) || 1);
          return true;
        } catch (e) {
          return false;
        }
      };

      window.__E3D_PCAP_ZOOM_IN__ = (times = 1) => {
        try {
          const lm = layoutManagerRef && layoutManagerRef.current ? layoutManagerRef.current : null;
          if (!lm || typeof lm.zoomIn !== 'function') return false;
          const n = Math.max(1, Number(times) || 1);
          for (let i = 0; i < n; i += 1) {
            lm.zoomIn();
          }
          return true;
        } catch (e) {
          return false;
        }
      };
    } catch (e) {
    }
  }, []);
  const [showAdvancedToolbar, setShowAdvancedToolbar] = useState(true);
  const [isTourRunning, setIsTourRunning] = useState(false);
  const [showNameTableDialog, setShowNameTableDialog] = useState(false);
  const [nameTableNode, setNameTableNode] = useState(null);
  const membersOnlyEnabled = false;
  const [nameTableChain, setNameTableChain] = useState('ETH');
  const [nameTableLabel, setNameTableLabel] = useState('');
  const [nameTableIconUrl, setNameTableIconUrl] = useState('');
  const [nameTableUploadFile, setNameTableUploadFile] = useState(null);
  const [nameTableSaving, setNameTableSaving] = useState(false);
  const [nameTableError, setNameTableError] = useState('');

  // Use authentication context (shared across the app)
  const { isAuthenticated, authChecked, userID, userAddress, roles, login, logout, updateUserInfo, connectWallet } = useAuth();
  const [username, setUsername] = useState(localStorage.getItem('username') || '');

  useEffect(() => {
    let isMounted = true;

    const loadCached = () => {
      try {
        if (typeof window === 'undefined' || !window.sessionStorage) return null;
        const cached = String(window.sessionStorage.getItem('e3d_earliest_eth_tx_iso') || '').trim();
        return cached || null;
      } catch (e) {
        return null;
      }
    };

    const fetchEarliest = async () => {
      try {
        const cachedIso = loadCached();
        if (cachedIso) {
          if (isMounted) setEarliestEthTxIso(cachedIso);
          return;
        }

        const tryUrl = async (suffix) => {
          const url = `${SERVER_NAME}${suffix}`;
          const res = await axios.get(url);
          return res && res.data ? res.data : null;
        };

        let data = null;
        try {
          data = await tryUrl('/ethTransactions/earliestTimestamp');
        } catch (e) {
        }
        if (!data) {
          try {
            data = await tryUrl('/ethTransactions/earliestTimestamp');
          } catch (e) {
          }
        }

        const iso = data && data.earliestTimestampIso ? String(data.earliestTimestampIso) : '';
        if (!iso) return;

        try {
          if (typeof window !== 'undefined' && window.sessionStorage) {
            window.sessionStorage.setItem('e3d_earliest_eth_tx_iso', iso);
            if (data && data.earliestTimestampSec != null) {
              window.sessionStorage.setItem('e3d_earliest_eth_tx_sec', String(data.earliestTimestampSec));
            }
          }
        } catch (e) {
        }

        if (isMounted) setEarliestEthTxIso(iso);
      } catch (e) {
      }
    };

    fetchEarliest();

    return () => {
      isMounted = false;
    };
  }, []);

  const isLinksHistoricalRangeActive = useMemo(() => {
    try {
      return !!(linksIsoDateRange && linksIsoDateRange.start && linksIsoDateRange.end);
    } catch (e) {
      return false;
    }
  }, [linksIsoDateRange]);

  const linksMaxLookbackDays = useMemo(() => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        const cachedDays = String(window.sessionStorage.getItem('e3d_max_lookback_days') || '').trim();
        if (cachedDays) {
          const n = Number(cachedDays);
          if (Number.isFinite(n) && n > 0) return Math.floor(n);
        }
      }
    } catch (e) {
    }

    try {
      const r = Array.isArray(roles) ? roles : [];
      if (r.includes('enterprise')) return 90;
      if (r.includes('premium')) return 30;
      if (isAuthenticated) return 7;
    } catch (e) {
    }
    return 7;
  }, [roles, isAuthenticated]);

  const isPremiumPlus = useMemo(() => {
    try {
      const r = Array.isArray(roles) ? roles : [];
      return r.includes('premium') || r.includes('enterprise');
    } catch (e) {
      return false;
    }
  }, [roles]);

  const clearLinksDateRange = useCallback(() => {
    try {
      if (typeof window !== 'undefined' && window.sessionStorage) {
        window.sessionStorage.removeItem('e3d_date_range');
      }
    } catch (e) {
    }
    setLinksRangeUpgradeMsg('');
    setLinksIsoDateRange(null);
    setDateRange2({ startDate: 0, endDate: 0 });
  }, []);

  const formatRangeLabel = useCallback((isoStart, isoEnd) => {
    try {
      if (!isoStart || !isoEnd) return '';
      const s = new Date(String(isoStart));
      const e = new Date(String(isoEnd));
      if (isNaN(s.getTime()) || isNaN(e.getTime())) return '';
      const fmt = (d) => d.toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' });
      return `${fmt(s)} – ${fmt(e)}`;
    } catch (e) {
      return '';
    }
  }, []);

  useEffect(() => {
    try {
      if (!location.pathname.startsWith('/graphs')) return;
      if (typeof window === 'undefined' || !window.sessionStorage) return;
      const raw = String(window.sessionStorage.getItem('e3d_date_range') || '').trim();
      if (!raw) {
        setLinksIsoDateRange(null);
        setDateRange2({ startDate: 0, endDate: 0 });
        return;
      }
      const parsed = JSON.parse(raw);
      if (!parsed || !parsed.start || !parsed.end) return;
      const sIso = String(parsed.start);
      const eIso = String(parsed.end);
      const sSec = Math.floor(Date.parse(sIso) / 1000);
      const eSec = Math.floor(Date.parse(eIso) / 1000);
      if (!Number.isFinite(sSec) || !Number.isFinite(eSec) || sSec <= 0 || eSec <= 0) return;
      setLinksIsoDateRange({ start: sIso, end: eIso });
      setDateRange2({ startDate: sSec, endDate: eSec });
    } catch (e) {
    }
  }, [location.pathname]);

  useEffect(() => {
    if (!location.pathname.startsWith('/graphs')) return;
    if (!isLinksHistoricalRangeActive) return;

    const endIso = linksIsoDateRange && linksIsoDateRange.end ? String(linksIsoDateRange.end) : '';
    const endMs = endIso ? Date.parse(endIso) : NaN;
    if (!Number.isFinite(endMs) || endMs <= 0) return;

    const nowMs = Date.now();
    const delayMs = endMs - nowMs;

    // Only auto-unlock when the user selected a future end time.
    // For normal historical ranges (end in the past), keep the range active.
    if (!(delayMs > 0)) return;

    const timer = setTimeout(() => {
      try {
        // End reached: unlock interval buttons by clearing the custom range.
        clearLinksDateRange();

        // Refresh /links data after unlocking.
        setIsLiveMode(false);
        clearNodePositions();
        resetGraph();
        fetchEthTransactions().catch(() => {});
      } catch (e) {
      }
    }, Math.min(delayMs, 2 ** 31 - 1));

    return () => {
      try { clearTimeout(timer); } catch (e) {}
    };
  }, [location.pathname, isLinksHistoricalRangeActive, linksIsoDateRange && linksIsoDateRange.end, clearLinksDateRange]);

  const linksAccessLevel = useMemo(() => {
    try {
      if (!isAuthenticated) return 'non_subscriber';
      const r = Array.isArray(roles) ? roles : [];
      if (r.includes('enterprise') || r.includes('premium')) return 'premium_plus';
      return 'free_subscriber';
    } catch (e) {
      return 'non_subscriber';
    }
  }, [isAuthenticated, roles]);

  const allowedLinksInterval = useMemo(() => {
    if (linksAccessLevel === 'premium_plus') return '2M';
    if (linksAccessLevel === 'free_subscriber') return '2M';
    return '1M';
  }, [linksAccessLevel]);

  const hasLinksAddress = useMemo(() => {
    const path = location.pathname || '';
    if (!path.startsWith('/graphs/')) return false;
    const parts = path.split('/');
    const addr = parts[2] || '';
    return /^0x[0-9a-fA-F]{8,}$/.test(addr);
  }, [location.pathname]);

  const allowedLinksIntervals = useMemo(() => {
    // Allow narrower windows within a tier (so users can reduce node counts).
    // Premium+ default remains 10M via allowedLinksInterval, but 1M/5M are allowed.
    try {
      if (linksAccessLevel === 'premium_plus') {
        return ['1M', '2M', '5M', '10M'];
      }
      if (linksAccessLevel === 'free_subscriber') {
        return ['1M', '2M', '5M'];
      }
      return ['1M'];
    } catch (e) {
      return ['1M'];
    }
  }, [linksAccessLevel]);

  const pcapNameTableCacheRef = useRef(new Map());

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      if (!isAuthenticated) return;
      try {
        const resp = await axios.get(`${SERVER_NAME}/nametable`, { withCredentials: true });
        const payload = resp && resp.data ? resp.data : null;
        const items = payload && Array.isArray(payload.items) ? payload.items : [];

        const nextPcap = new Map();
        (items || []).forEach((it) => {
          const chain = it && it.chain ? String(it.chain).toUpperCase() : '';
          if (chain !== 'PCAP') return;
          const addr = it && it.address ? String(it.address).toLowerCase() : '';
          if (!addr) return;
          nextPcap.set(addr, {
            chain: 'PCAP',
            address: addr,
            label: it && it.label ? String(it.label) : '',
            iconUrl: normalizeIconUrl(it && it.iconUrl ? String(it.iconUrl) : ''),
          });
        });

        if (cancelled) return;
        pcapNameTableCacheRef.current = nextPcap;

        if (location && typeof location.pathname === 'string' && location.pathname.startsWith('/pcap')) {
          setGraphData((prev) => {
            if (!prev || !Array.isArray(prev.nodes)) return prev;
            let changed = false;
            const nextNodes = prev.nodes.map((n) => {
              if (!n || !n.id) return n;
              const id = String(n.id).trim().toLowerCase();
              const meta = nextPcap.get(id);
              if (!meta) return n;
              const nextLabel = meta.label ? meta.label : n.label;
              const nextIcon = meta.iconUrl ? normalizeIconUrl(meta.iconUrl) : n.icon;
              if (nextLabel !== n.label || nextIcon !== n.icon) {
                changed = true;
                return { ...n, label: nextLabel, icon: nextIcon || null };
              }
              return n;
            });
            const normalizeEndpointId = (v) => {
              const raw = (v && typeof v === 'object') ? (v.id ?? v._id ?? v.address) : v;
              if (raw == null) return '';
              return String(raw);
            };
            const nextLinks = Array.isArray(prev.links) ? prev.links.map((l) => {
              if (!l || typeof l !== 'object') return l;
              const s = normalizeEndpointId(l.source);
              const t = normalizeEndpointId(l.target);
              return { ...l, source: s, target: t };
            }) : prev.links;
            try {
              if (typeof window !== 'undefined' && window.__DEBUG_PCAP_ICONS__) {
                const shown = nextNodes.filter((n) => n && n.icon).slice(0, 12).map((n) => ({ id: n.id, label: n.label, icon: n.icon }));
                console.log('[PCAP][icon][load] graph nodes with icons sample', {
                  count: nextNodes.filter((n) => n && n.icon).length,
                  sample: shown,
                });
              }
            } catch (e) {
            }
            return changed ? { ...prev, nodes: nextNodes, links: nextLinks } : prev;
          });

          setTokenList((prev) => {
            const rows = Array.isArray(prev) ? prev : [];
            let changed = false;
            const next = rows.map((row) => {
              const id = row && (row.id || row.address) ? String(row.id || row.address).trim().toLowerCase() : '';
              if (!id) return row;
              const meta = nextPcap.get(id);
              if (!meta) return row;
              const nextLabel = meta.label ? meta.label : (row.label || row.name || '');
              const nextIcon = meta.iconUrl ? normalizeIconUrl(meta.iconUrl) : (row.icon || null);
              if (nextLabel !== (row.label || '') || nextIcon !== (row.icon || null)) {
                changed = true;
                return { ...row, label: nextLabel, icon: nextIcon };
              }
              return row;
            });
            try {
              if (typeof window !== 'undefined' && window.__DEBUG_PCAP_ICONS__) {
                const shown = next.filter((r) => r && r.icon).slice(0, 12).map((r) => ({ id: r.id, label: r.label, icon: r.icon }));
                console.log('[PCAP][icon][load] list rows with icons sample', {
                  count: next.filter((r) => r && r.icon).length,
                  sample: shown,
                });
              }
            } catch (e) {
            }
            return changed ? next : prev;
          });
        }
      } catch (e) {
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, location && location.pathname]);
  
  // Force sync authentication state across all components
  const syncAuthState = () => {
    const storedIsAuth = localStorage.getItem('isAuthenticated') === 'true';
    const storedUsername = localStorage.getItem('username');
    const storedUserID = localStorage.getItem('userID');
    const storedUserAddress = localStorage.getItem('userAddress');
    
    if (process.env.NODE_ENV === 'development') {
      console.log('Syncing auth state:', {
        storedIsAuth,
        storedUsername,
        storedUserID,
        storedUserAddress
      });
    }
    
    // Update local state
    if (storedIsAuth && storedUsername) {
      setUsername(storedUsername);
    } else if (!storedIsAuth) {
      setUsername('');
    }
    
    // Force sync with auth context if there's a mismatch
    if (storedIsAuth && !isAuthenticated && storedUserID) {
      console.log('🚨 Authentication mismatch detected - forcing sync');
      login({
        username: storedUsername || '',
        userID: storedUserID || '',
        userAddress: storedUserAddress || ''
      });
    }
  };
  
  // Run auth state sync on mount
  useEffect(() => {
    syncAuthState();
  }, []);

  useEffect(() => {
    const onToggle = () => {
      setShowGraphToolbar((prev) => !prev);
    };

    window.toggleGraphToolbar = onToggle;

    window.addEventListener('toggle-graph-toolbar', onToggle);
    return () => {
      window.removeEventListener('toggle-graph-toolbar', onToggle);
      delete window.toggleGraphToolbar;
    };
  }, []);

  // Listen for specific events that might indicate auth state changes
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'isAuthenticated' || e.key === 'username' || e.key === 'userID') {
        console.log('Storage changed for:', e.key);
        syncAuthState();
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  // Initialize global navigate function for components outside React Router
  useEffect(() => {
    if (navigate) {
      window.goToE3DPage = (path) => {
        goTo(path);
      };
      
      // Add global navigateToSignup function for use in dialogs
      window.navigateToSignup = () => {
        navigate('/signup', { replace: true });
      };
      
      // Clean up on unmount
      return () => {
        delete window.goToE3DPage;
        delete window.navigateToSignup;
      };
    }
  }, [navigate, goTo]);

  // Initialize global login/signup functions for cross-component access
  useEffect(() => {
    // Make both naming conventions available for backward compatibility
    window.globalShowLogin = (value) => {
      setShowLogin(value);
    };

    window.globalShowMembersOnly = (value) => {
      if (!membersOnlyEnabled) return;
      try {
        if (value) {
          const p = (typeof window !== 'undefined' && window.location && window.location.pathname)
            ? String(window.location.pathname)
            : '';
          if (p.startsWith('/pcap')) return;
        }
      } catch (e) {
      }
      setShowMembersOnly(value);
    };
    
    // This is the name other components are expecting
    window.setGlobalShowLogin = (value) => {
      setShowLogin(value);
    };
    
    // Add global signup function for access from LoginDialog
    window.setGlobalShowSignup = (value) => {
      setShowSignup(value);
    };
    
    return () => {
      delete window.globalShowLogin;
      delete window.setGlobalShowLogin;
      delete window.globalShowMembersOnly;
      delete window.setGlobalShowSignup;
    };
  }, []);

  // Initialize global login function for cross-component access
  useEffect(() => {
    // Listen for the custom event that forces login dialog to render
    const forceLoginDialogListener = () => {
      console.log('🔵 Force login dialog render event received');
      setShowLogin(true);
    };

    const forceMembersOnlyDialogListener = () => {
      if (!membersOnlyEnabled) return;
      console.log('🟣 Force members-only dialog render event received');
      try {
        const p = (typeof window !== 'undefined' && window.location && window.location.pathname)
          ? String(window.location.pathname)
          : '';
        if (p.startsWith('/pcap')) return;
      } catch (e) {
      }
      setShowMembersOnly(true);
    };
    
    document.addEventListener('force-login-dialog-render', forceLoginDialogListener);
    document.addEventListener('force-members-only-dialog-render', forceMembersOnlyDialogListener);
    
    // For debugging - log auth state on mount
    console.log('AppContent: Initial auth state', { isAuthenticated, username, userID });
    
    // Clean up event listener on unmount
    return () => {
      document.removeEventListener('force-login-dialog-render', forceLoginDialogListener);
      document.removeEventListener('force-members-only-dialog-render', forceMembersOnlyDialogListener);
    };
  }, [isAuthenticated, username, userID]);
  
  const [password, setPassword] = useState('');
  const cookieSuppressed = (() => {
    try {
      const s = (typeof window !== 'undefined' && window.location && window.location.search)
        ? String(window.location.search)
        : '';
      const params = new URLSearchParams(s);
      const v = params.get('noCookie') || params.get('nocookie') || params.get('no_cookie');
      if (v == null) return false;
      const sv = String(v).trim().toLowerCase();
      return sv === '1' || sv === 'true' || sv === 'yes';
    } catch (e) {
      return false;
    }
  })();
  const [showCookieDialog, setShowCookieDialog] = useState(() => {
    if (cookieSuppressed) return false;
    // Check localStorage immediately to avoid showing dialog if already consented
    try {
      const consent = localStorage.getItem('cookieConsent');
      if (consent) return false;
    } catch (e) {}
    return true;
  });
  const [cookieConsent, setCookieConsent] = useState(() => {
    // Initialize from localStorage to avoid delay
    try {
      const consent = localStorage.getItem('cookieConsent');
      return consent === 'accepted';
    } catch (e) {}
    return false;
  });
  const [resetCookieConsent, setResetCookieConsent] = useState(false);
  const [rate, setRate] = useState(null);
  const [showAboutDialog, setShowAboutDialog] = useState(false);
  const [showSearchDialog, setShowSearchDialog] = useState(false);
  const [showSwapDialog, setShowSwapDialog] = useState(false);
  const [showStakeDialog, setShowStakeDialog] = useState(false);
  const [isProcessingUrl, setIsProcessingUrl] = useState(false);

  // Debug logging for dialog state changes
  const debugSetShowSwapDialog = (value) => {
    console.log('App: Setting showSwapDialog to', value);
    setShowSwapDialog(value);
  };
  
  const debugSetShowStakeDialog = (value) => {
    console.log('App: Setting showStakeDialog to', value);
    setShowStakeDialog(value);
  };
  const [showSaveMapDialog, setShowSaveMapDialog] = useState(false);
  const [showLoadMapDialog, setShowLoadMapDialog] = useState(false);
  const [dimensions, setDimensions] = useState({ width: window.innerWidth, height: window.innerHeight });
  const [currentNodeIndex, setCurrentNodeIndex] = useState(0);
  const [spinCamera, setSpinCamera] = useState(true);
  // Initialize the global state tracker
  React.useEffect(() => {
    window._tempSpinState = spinCamera;
  }, []);
  const [tokenData, setTokenData] = useState(null);
  const [activeNodeId, setActiveNodeId] = useState(null);
  const [defaultNodeId, setDefaultNodeId] = useState(null);
  const [updateCoordinatesIntervalId, setUpdateCoordinatesIntervalId] = useState(null);
  const [activeNodeName, setActiveNodeName] = useState(null);
  const [activeLinkId, setActiveLinkId] = useState(null);
  const [pcapSelectedLinkKeysManual, setPcapSelectedLinkKeysManual] = useState(() => new Set());
  const [pcapSelectedLinkKeysNeighbors, setPcapSelectedLinkKeysNeighbors] = useState(() => new Set());
  const pcapSelectedLinkKeys = useMemo(() => {
    const next = new Set();
    try {
      if (pcapSelectedLinkKeysManual && typeof pcapSelectedLinkKeysManual.forEach === 'function') {
        pcapSelectedLinkKeysManual.forEach((k) => next.add(k));
      }
      if (pcapSelectedLinkKeysNeighbors && typeof pcapSelectedLinkKeysNeighbors.forEach === 'function') {
        pcapSelectedLinkKeysNeighbors.forEach((k) => next.add(k));
      }
    } catch (e) {
    }
    return next;
  }, [pcapSelectedLinkKeysManual, pcapSelectedLinkKeysNeighbors]);
  const [mode3D, setMode3D] = useState(true); // Default to 3D layout mode
  const [globalDistance, setGlobalDistance] = useState(1000);
  const [globalSize, setGlobalSize] = useState(2000);
  const [userTransactions, setUserTransactions] = useState(false);
  // Do not show the HomePage by default when landing on '/' or '/token'. For
  // those routes we want the token view as the default. Other routes (like
  // '/home') keep the existing HomePage behavior.
  // Also check if we're loading from PCAP gallery to avoid flashing home page.
  const [showHomePage, setShowHomePage] = useState(() => {
    // Check if we're loading from PCAP gallery
    try {
      if (typeof window !== 'undefined' && window.__E3D_PCAP_IS_LOADING_FROM_GALLERY__) {
        return false;
      }
    } catch (e) {}
    const path = location.pathname;
    return path === '/home';
  });
  const [showShortcutPage, setShowShortcutPage] = useState(false);
  const [subscribeNewsletter, setSubscribeNewsletter] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('success');
  const [showPicker, setShowPicker] = useState(false);
  const [allLikesFilter, setAllLikesFilter] = useState(false);
  const [myLikesFilter, setMyLikesFilter] = useState(false);
  const [portfolioFilter, setPortfolioFilter] = useState("");
  const [showMintNFTDialog, setShowMintNFTDialog] = useState(false);
  const [showCustomNFTDialog, setShowCustomNFTDialog] = useState(false);
  const [showMintPcapNFTDialog, setShowMintPcapNFTDialog] = useState(false);
  const [showConnectWalletToMintDialog, setShowConnectWalletToMintDialog] = useState(false);
  // userAddress now comes from useAuth() context
  const [showE3DMarketplace, setShowE3DMarketplace] = useState(false);
  const [showCustomNFTMarketplace, setShowCustomNFTMarketplace] = useState(false);
  const [useTime, setUseTime] = useState(true);
  const [viewGraph, setViewGraph] = useState(() => {
    // Check if we're loading from PCAP gallery to avoid flashing home page
    try {
      if (typeof window !== 'undefined' && window.__E3D_PCAP_IS_LOADING_FROM_GALLERY__) {
        return true;
      }
    } catch (e) {}
    return false;
  });
  const [viewTransaction, setViewTransaction] = useState(false);
  const [filterNewOnly, setFilterNewOnly] = useState(false);
  // Debug mode to test layout without Premium Banner
  const [debugHideBanner, setDebugHideBanner] = useState(false);

  const [hasInitialLayoutApplied, setHasInitialLayoutApplied] = useState(false);

  // Adjust container heights based on whether the ad banner is displayed
  useEffect(() => {
    // Set a CSS variable that can be used in all container calculations
    const root = document.documentElement;
    // When ad banner is visible, we need to adjust heights
    // Always use exactly 60px for desktop (not 55px) to match standard AdSense format
    const adBannerHeight = (!debugHideBanner && !isAuthenticated && localStorage.getItem('isAuthenticated') !== 'true') ? '60px' : '0px';
    root.style.setProperty('--ad-banner-height', adBannerHeight);
    console.log('Setting --ad-banner-height to', adBannerHeight);
  }, [debugHideBanner, isAuthenticated]);
  
  const [filterNFTOnly, setFilterNFTOnly] = useState(false);
  const [filterNFT, setFilterNFT] = useState(false);
  const [filterToken, setFilterToken] = useState(false);
  const [newPositions, setNewPositions] = useState(null);
  const [rangeSelected, setRangeSelected] = useState('12H');
  const [minLinks, setMinLinks] = useState(2);
  const [maps, setMaps] = useState(60);
  const [chartData, setChartData] = useState(null);
  const [showChart, setShowChart] = useState(true);
  const [isPortrait, setIsPortrait] = useState(false);
  const [maxLinks, setMaxLinks] = useState(0);
  const [rangeInterval, setRangeInterval] = useState(300);
  const [filterValue, setFilterValue] = useState(false);
  const [isFirstOrient, setIsFirstOrient] = useState(true);
  const [maxTransactions, setMaxTransactions] = useState('30000');
  const [maxNodes, setMaxNodes] = useState(-1);
  const [tokenPrice, setTokenPrice] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [pcapNamesLoading, setPcapNamesLoading] = useState(false);
  const [isCounterpartyLoading, setIsCounterpartyLoading] = useState(false);
  const [isConfigured, setIsConfigured] = useState(false);
  const [tokenUniswapVersion, setTokenUniswapVersion] = useState(0);
  const [e3dPrice, setE3dPrice] = useState(0);
  const [reload, setReload] = useState(false);
  const [showBubblesMode, setShowBubblesMode] = useState(false);
  const [showSectorView, setShowSectorView] = useState(false);
  const [quickChartToken, setQuickChartToken] = useState(null);
  const [imageKey, setImageKey] = useState(Date.now());
  const cameraSpinIntervalRef = useRef(null);
  const [imgRefs, setImgRefs] = useState([]);
  const [isDataReady, setIsDataReady] = useState(false);
  const [hasPriceHistoryData, setHasPriceHistoryData] = useState(false); // Track when price history data is available
  const [graphKey, setGraphKey] = useState(0);
  const [parseURL, setParseURL] = useState(true);
  const hasRun = useRef(false);
  const rangeSelectedOverrideRef = useRef(null);
  const linksIntervalTouchedRef = useRef(false);
  const [showOptionsPopup, setShowOptionsPopup] = useState(false);
  const [showNewsletter, setShowNewsletter] = useState(false);

  useEffect(() => {
    try {
      const isGraphRoute = location.pathname.startsWith('/graphs');
      if (!isGraphRoute) {
        linksIntervalTouchedRef.current = false;
        return;
      }
    } catch (e) {
    }
  }, [location.pathname]);
  const [newsDate, setNewsDate] = useState(null);
  const [tourSpeedGraph, setTourSpeedGraph] = useState(6000);
  const [tourSpeedList, setTourSpeedList] = useState(2000);
  const [spinSpeed, setSpinSpeed] = useState(60);
  const [useAspectRatio, setUseAspectRatio] = useState(false);
  const [imageSize, setImageSize] = useState(100);
  const [graphInstanceKey, setGraphInstanceKey] = useState(0);
  const [organicLayout, setOrganicLayout] = useState(false);
  const hasLoadedOrganicGraphRef = useRef(false);
  // Holds the currently in-flight fetchEthTransactions promise so duplicate
  // callers get the same result rather than firing a second parallel request.
  const fetchEthTransactionsPromiseRef = useRef(null);
  const getTransactionsRunIdRef = useRef(0);
  const nodeListRef = useRef();

  const showAllAddressesInLinksDetail = useMemo(() => {
    const path = location.pathname || '';
    if (!path.startsWith('/graphs/')) return false;
    const parts = path.split('/');
    const addr = parts[2] || '';
    return /^0x[0-9a-fA-F]{8,}$/.test(addr);
  }, [location.pathname]);
  // Apply a minimum-links filter in /links views so we can downsample
  // very dense graphs by node degree. Always keep token nodes and any
  // non-token nodes that are directly connected to a token.
  const memoizedGraphData = useMemo(() => {
    if (!graphData || !graphData.nodes || !graphData.links) return graphData;

    if (!location.pathname.startsWith('/graphs') || minLinks <= 1) {
      return graphData;
    }

    const degree = new Map();
    const tokenIds = new Set();

    // Token classification: a node is a "token" only if it has a symbol OR a
    // display name that is NOT just its own address.  Wallet nodes whose only
    // label is "0x…" would pass a plain truthy check but should still be
    // subject to the min-links threshold.
    graphData.nodes.forEach((n) => {
      if (!n) return;
      const name   = typeof n.name   === 'string' ? n.name.trim()   : '';
      const label  = typeof n.label  === 'string' ? n.label.trim()  : '';
      const symbol = typeof n.symbol === 'string' ? n.symbol.trim() : '';
      const isToken = Boolean(
        symbol ||
        (name  && !name.startsWith('0x'))  ||
        (label && !label.startsWith('0x'))
      );
      if (isToken) tokenIds.add(n.id);
    });

    const connectedToToken = new Set();

    graphData.links.forEach((link) => {
      if (!link) return;
      const src = typeof link.source === 'object' ? link.source.id : link.source;
      const tgt = typeof link.target === 'object' ? link.target.id : link.target;
      if (!src || !tgt) return;

      degree.set(src, (degree.get(src) || 0) + 1);
      degree.set(tgt, (degree.get(tgt) || 0) + 1);

      // Track non-token nodes that are directly connected to a token.
      const srcIsToken = tokenIds.has(src);
      const tgtIsToken = tokenIds.has(tgt);
      if (srcIsToken && !tgtIsToken) {
        connectedToToken.add(tgt);
      } else if (tgtIsToken && !srcIsToken) {
        connectedToToken.add(src);
      }
    });

    const keepIds = new Set(
      graphData.nodes
        .filter((n) => {
          if (!n) return false;
          const id = n.id;
          if (tokenIds.has(id)) return true;                 // always keep tokens
          if (connectedToToken.has(id)) return true;         // always keep neighbors of tokens
          return (degree.get(id) || 0) >= minLinks;          // apply min-links threshold
        })
        .map((n) => n.id)
    );

    // If filter would drop everything, fall back to the original graph.
    if (!keepIds.size) return graphData;

    let nodes = graphData.nodes.filter((n) => keepIds.has(n.id));
    let links = graphData.links.filter((link) => {
      if (!link) return false;
      const src = typeof link.source === 'object' ? link.source.id : link.source;
      const tgt = typeof link.target === 'object' ? link.target.id : link.target;
      return keepIds.has(src) && keepIds.has(tgt);
    });

    // Final cleanup: drop any non-token nodes that have no incident links in
    // the filtered graph so we don't show isolated wallets that no longer have
    // visible connections.
    const connectedIds = new Set();
    links.forEach((link) => {
      if (!link) return;
      const src = typeof link.source === 'object' ? link.source.id : link.source;
      const tgt = typeof link.target === 'object' ? link.target.id : link.target;
      if (src) connectedIds.add(src);
      if (tgt) connectedIds.add(tgt);
    });

    const finalKeep = new Set();
    nodes.forEach((n) => {
      if (!n) return;
      const id = n.id;
      if (tokenIds.has(id) || connectedIds.has(id)) {
        finalKeep.add(id);
      }
    });

    nodes = nodes.filter((n) => finalKeep.has(n.id));
    links = links.filter((link) => {
      if (!link) return false;
      const src = typeof link.source === 'object' ? link.source.id : link.source;
      const tgt = typeof link.target === 'object' ? link.target.id : link.target;
      return finalKeep.has(src) && finalKeep.has(tgt);
    });

    // If the final cleanup removed all nodes (e.g. organic wallet graph where
    // all high-degree nodes lost their neighbours during filtering), fall back
    // to the unfiltered graph so we never show a blank canvas.
    if (nodes.length === 0 && graphData.nodes.length > 0) return graphData;

    return { nodes, links };
  }, [graphData, location.pathname, minLinks]);
  const memoizedGraphRef = useMemo(() => graphRef, [graphRef]);
  const memoizedDataSource = useMemo(() => dataSource, [dataSource]);
  const memoizedTokenList = useMemo(() => tokenList, [tokenList]);

  // Controls how the token view orders and sources data:
  // 'transactions' - current behavior, driven by fetchEthTransactions()
  // 'price'        - use price-list meta cache and sort by highest price
  // 'volatility'   - use price-list meta cache and sort by largest % change
  // 'marketcap'    - use price-list meta cache and sort by largest market cap
  // Default to 'links' on /graphs so the token view starts in Txs mode.
  const [tokenView, setTokenView] = useState(() => {
    try {
      const path = typeof window !== 'undefined' && window.location ? String(window.location.pathname || '') : '';
      if (path.startsWith('/graphs')) return 'links';
    } catch (e) {
    }
    return 'chain';
  });
  const [layoutMode, setLayoutMode] = useState('sphere');
  const [isLiveMode, setIsLiveMode] = useState(false);
  const liveIntervalRef = useRef(null);

  // 'all' = full transaction graph (default), 'stories' = story-addresses-only graph
  const [linksDataMode, setLinksDataMode] = useState('all');
  const linksDataModeRef = useRef('all');
  const [storyAddresses, setStoryAddresses] = useState([]);
  const storyAddressesRef = useRef([]);
  const storiesLiveIntervalRef = useRef(null);

  useEffect(() => {
    try {
      if (!location.pathname.startsWith('/graphs')) return;
      if (tokenView !== 'links') {
        setTokenView('links');
      }
    } catch (e) {
    }
  }, [location.pathname]);

  const [linksStoryOverlayEnabled, setLinksStoryOverlayEnabled] = useState(() => {
    try {
      const raw = (typeof window !== 'undefined' && window.localStorage)
        ? String(window.localStorage.getItem('e3d_links_story_overlay') || '')
        : '';
      if (raw === 'true') return true;
      if (raw === 'false') return false;
      return true;
    } catch (e) {
      return true;
    }
  });
  const [storyOverlayMap, setStoryOverlayMap] = useState(new Map()); // Map<address_lc, Story[]>
  const storyOverlayMapRef = useRef(new Map());
  // Addresses currently in the user's watchlist (used for Watchlist graph mode).
  const watchlistAddressesRef = useRef([]);
  // Always-current ref for watchedKeys so async functions don't capture stale closures.
  const watchedKeysRef = useRef(watchedKeys);
  // Map<address_lc, Story[]> built when Stories mode is activated.
  // Used for hover tooltips and click popovers on story-address nodes.
  const storyNodeMapRef = useRef(new Map());
  // Popover state for story-address node clicks in Stories mode.
  const [storyPopover, setStoryPopover] = useState(null); // { nodeId, stories, x, y }
  // Cache of the last transaction-derived tokenList so we can restore it instantly
  // when switching back to Transactions mode from Price/Volatility/MktCap on /links.
  const linksTransactionTokenListRef = useRef([]);

  // Keep linksDataModeRef in sync with linksDataMode state.
  useEffect(() => {
    linksDataModeRef.current = linksDataMode;
  }, [linksDataMode]);

  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem('e3d_links_story_overlay', linksStoryOverlayEnabled ? 'true' : 'false');
      }
    } catch (e) {
    }
  }, [linksStoryOverlayEnabled]);

  // Reset Stories-mode state when leaving /graphs.
  useEffect(() => {
    if (!location.pathname.startsWith('/graphs')) {
      setLinksDataMode('all');
      linksDataModeRef.current = 'all';
      setStoryAddresses([]);
      storyAddressesRef.current = [];
      storyNodeMapRef.current = new Map();
      setStoryPopover(null);
      watchlistAddressesRef.current = [];
      if (storiesLiveIntervalRef.current) {
        clearInterval(storiesLiveIntervalRef.current);
        storiesLiveIntervalRef.current = null;
      }
    }
  }, [location.pathname]);

  const fetchPriceListPage = useCallback(async ({
    dataSourceParam,
    offset,
    limit,
    sortBy,
    sortDir,
    search,
    hideNoCirc,
    category,
    favoritesOnly,
    favoriteAddresses,
    minMktCap,
    maxMktCap,
    minLiquidity,
    maxLiquidity,
    minFdv,
    minPrice,
    maxPrice,
    minChange24h,
    maxChange24h,
    minVolume24h,
    maxVolume24h,
  }) => {
    const debugPricePaging = (typeof window !== 'undefined') && !!window.__DEBUG_PRICE_PAGING__;
    const url = SERVER_NAME + '/fetchTokenPricesWithHistoryAllRanges';

    if (debugPricePaging) {
      console.log('[price:paging] fetchPriceListPage request', {
        dataSource: dataSourceParam,
        offset,
        limit,
        sortBy,
        sortDir,
        search,
      });
    }

    const screenerEntries = Object.entries({
      minMktCap, maxMktCap, minLiquidity, maxLiquidity, minFdv,
      minPrice, maxPrice, minChange24h, maxChange24h, minVolume24h, maxVolume24h,
    }).filter(([, v]) => v != null);
 
    const response = await axios.get(url, {
      params: {
        dataSource: dataSourceParam,
        offset,
        limit,
        sortBy,
        sortDir,
        search,
        hideNoCirc,
        category,
        favoritesOnly,
        favoriteAddresses,
        trendInterval: priceTrendIntervalRef.current || '12H',
        ...Object.fromEntries(screenerEntries),
      },
      withCredentials: true,
    });
 
    const payload = response.data;
    let rows = [];
    let total = 0;

    if (payload && Array.isArray(payload.rows)) {
      rows = payload.rows;
      const parsedTotal = Number(payload.total);
      total = Number.isFinite(parsedTotal) && parsedTotal > 0 ? parsedTotal : 0;
      if (!total && Number.isFinite(Number(limit)) && Number(limit) > 0 && rows.length < Number(limit)) {
        total = Number(offset) + rows.length;
      }
    } else if (Array.isArray(payload)) {
      // Backward-compatible server responses.
      rows = payload;
      total = payload.length;
    }

    // Preserve the per-interval changes from the raw response, keyed by address.
    const changesByAddress = new Map();
    rows.forEach((t) => {
      const addr = (t.address || t.id || '').toLowerCase();
      if (!addr) return;
      if (t.changes) {
        changesByAddress.set(addr, t.changes);
      }
    });

    const normalized = createTokenList(rows, 'Token', dataSourceParam);
    const merged = normalized.map((t) => {
      const addr = (t.id || '').toLowerCase();
      const changes = changesByAddress.get(addr);
      return changes ? { ...t, changes } : t;
    });

    if (debugPricePaging) {
      console.log('[price:paging] fetchPriceListPage response', {
        offset,
        limit,
        rows: merged.length,
        total,
        payloadShape: payload && Array.isArray(payload.rows) ? '{rows,total}' : (Array.isArray(payload) ? 'array' : typeof payload),
      });
    }

    return { rows: merged, total };
  }, []);

  const resetAndLoadPriceList = useCallback(async ({ sortBy, sortDir, searchOverride }) => {
    if (priceListLoadingRef.current) {
      priceListPendingResetRef.current = { sortBy, sortDir, searchOverride };
      return;
    }
    priceListLoadingRef.current = true;
    setPriceListBusy(true);
    try {
      setIsDataReady(false);
      setTokenView('price');
      setTokenList([]);
      setPriceListOffset(0);
      setPriceListTotal(0);
      setPriceListSortBy(sortBy);
      setPriceListSortDir(sortDir);

      const searchValue = typeof searchOverride === 'string' ? searchOverride : priceSearchText;
      const hasActiveSearch = !!String(searchValue || '').trim();

      const { rows, total } = await fetchPriceListPage({
        dataSourceParam: priceDataSource,
        offset: 0,
        limit: priceListPageSize,
        sortBy,
        sortDir,
        search: searchValue,
        hideNoCirc: ((!!priceScreener.includeNoCirc) || hasActiveSearch) ? 0 : 1,
        emptyFdv: priceScreener.emptyFdv ? 1 : 0,
        emptyLiquidity: priceScreener.emptyLiquidity ? 1 : 0,
        emptyVolume24h: priceScreener.emptyVolume24h ? 1 : 0,
        emptyEffectiveLiquidity: priceScreener.emptyEffectiveLiquidity ? 1 : 0,
        category: priceSelectedCategoriesCsv,
        favoritesOnly: watchlistOnly ? 1 : 0,
        favoriteAddresses: priceFavoriteAddressesCsv,
        ...Object.fromEntries(
          Object.entries({
            minMktCap: parseScreenerVal(priceScreener.minMktCap),
            maxMktCap: parseScreenerVal(priceScreener.maxMktCap),
            minLiquidity: parseScreenerVal(priceScreener.minLiquidity),
            maxLiquidity: parseScreenerVal(priceScreener.maxLiquidity),
            minFdv: parseScreenerVal(priceScreener.minFdv),
            minPrice: parseScreenerVal(priceScreener.minPrice),
            maxPrice: parseScreenerVal(priceScreener.maxPrice),
            minChange24h: parseScreenerVal(priceScreener.minChange24h),
            maxChange24h: parseScreenerVal(priceScreener.maxChange24h),
            minVolume24h: parseScreenerVal(priceScreener.minVolume24h),
            maxVolume24h: parseScreenerVal(priceScreener.maxVolume24h),
          }).filter(([, v]) => v != null)
        ),
      });

      setTokenList(rows);
      setPriceListOffset(rows.length);
      setPriceListTotal(total);
      setIsDataReady(true);
    } catch (e) {
      console.error('Error loading /price list page:', e);
      setIsDataReady(true);
    } finally {
      priceListLoadingRef.current = false;
      setPriceListBusy(false);
      const pending = priceListPendingResetRef.current;
      if (pending) {
        priceListPendingResetRef.current = null;
        // Skip the queued request if it has the same params as what we just loaded
        // (React Strict Mode fires the effect twice, queuing an identical request).
        const sameSort = pending.sortBy === sortBy && pending.sortDir === sortDir;
        const sameSearch = (pending.searchOverride == null && searchOverride == null) ||
            pending.searchOverride === searchOverride;
        if (!sameSort || !sameSearch) {
          resetAndLoadPriceList(pending);
        }
      }
    }
  }, [priceDataSource, fetchPriceListPage, priceFavoriteAddressesCsv, priceScreener, priceSearchText, priceSelectedCategoriesCsv, watchlistOnly]);

  const loadMorePriceList = useCallback(async () => {
    const debugPricePaging = (typeof window !== 'undefined') && !!window.__DEBUG_PRICE_PAGING__;
    if (!location.pathname.startsWith('/price')) return;
    if (priceListLoadingRef.current) return;
    if (priceListTotal && tokenList.length >= priceListTotal) return;

    if (debugPricePaging) {
      console.log('[price:paging] loadMorePriceList start', {
        offset: priceListOffset,
        tokenListLen: tokenList.length,
        total: priceListTotal,
        sortBy: priceListSortBy,
        sortDir: priceListSortDir,
      });
    }

    priceListLoadingRef.current = true;
    setPriceListBusy(true);
    try {
      const hasActiveSearch = !!String(priceSearchText || '').trim();
      const { rows, total } = await fetchPriceListPage({
        dataSourceParam: priceDataSource,
        offset: priceListOffset,
        limit: priceListPageSize,
        sortBy: priceListSortBy,
        sortDir: priceListSortDir,
        search: priceSearchText,
        hideNoCirc: ((!!priceScreener.includeNoCirc) || hasActiveSearch) ? 0 : 1,
        emptyFdv: priceScreener.emptyFdv ? 1 : 0,
        emptyLiquidity: priceScreener.emptyLiquidity ? 1 : 0,
        emptyVolume24h: priceScreener.emptyVolume24h ? 1 : 0,
        emptyEffectiveLiquidity: priceScreener.emptyEffectiveLiquidity ? 1 : 0,
        category: priceSelectedCategoriesCsv,
        favoritesOnly: watchlistOnly ? 1 : 0,
        favoriteAddresses: priceFavoriteAddressesCsv,
        ...Object.fromEntries(
          Object.entries({
            minMktCap: parseScreenerVal(priceScreener.minMktCap),
            maxMktCap: parseScreenerVal(priceScreener.maxMktCap),
            minLiquidity: parseScreenerVal(priceScreener.minLiquidity),
            maxLiquidity: parseScreenerVal(priceScreener.maxLiquidity),
            minFdv: parseScreenerVal(priceScreener.minFdv),
            minPrice: parseScreenerVal(priceScreener.minPrice),
            maxPrice: parseScreenerVal(priceScreener.maxPrice),
            minChange24h: parseScreenerVal(priceScreener.minChange24h),
            maxChange24h: parseScreenerVal(priceScreener.maxChange24h),
            minVolume24h: parseScreenerVal(priceScreener.minVolume24h),
            maxVolume24h: parseScreenerVal(priceScreener.maxVolume24h),
          }).filter(([, v]) => v != null)
        ),
      });

      if (debugPricePaging) {
        console.log('[price:paging] loadMorePriceList fetched', {
          requestedOffset: priceListOffset,
          fetched: rows ? rows.length : 0,
          reportedTotal: total,
        });
      }

      setTokenList((prev) => (prev || []).concat(rows || []));
      setPriceListOffset((prev) => prev + (rows ? rows.length : 0));
      setPriceListTotal(total || priceListTotal);
    } catch (e) {
      console.error('Error loading more /price rows:', e);
    } finally {
      priceListLoadingRef.current = false;
      setPriceListBusy(false);
    }
  }, [priceDataSource, fetchPriceListPage, location.pathname, priceFavoriteAddressesCsv, priceListOffset, priceListSortBy, priceListSortDir, priceListTotal, priceScreener, priceSearchText, priceSelectedCategoriesCsv, tokenList.length, watchlistOnly]);

  const [priceExportBusy, setPriceExportBusy] = useState(false);
  const exportPriceListCsv = useCallback(async () => {
    if (priceExportBusy) return;
    setPriceExportBusy(true);
    try {
      const hasActiveSearch = !!String(priceSearchText || '').trim();
      const { rows } = await fetchPriceListPage({
        dataSourceParam: priceDataSource,
        offset: 0,
        limit: Math.max(priceListTotal || 0, tokenList.length || 0) || priceListPageSize,
        sortBy: priceListSortBy,
        sortDir: priceListSortDir,
        search: priceSearchText,
        hideNoCirc: ((!!priceScreener.includeNoCirc) || hasActiveSearch) ? 0 : 1,
        emptyFdv: priceScreener.emptyFdv ? 1 : 0,
        emptyLiquidity: priceScreener.emptyLiquidity ? 1 : 0,
        emptyVolume24h: priceScreener.emptyVolume24h ? 1 : 0,
        emptyEffectiveLiquidity: priceScreener.emptyEffectiveLiquidity ? 1 : 0,
        category: priceSelectedCategoriesCsv,
        favoritesOnly: watchlistOnly,
        favoriteAddresses: priceFavoriteAddressesCsv,
      });

      const headers = ['Name', 'Symbol', 'Address', 'Price', 'Market Cap', 'FDV', 'Liquidity', 'Uniswap 24H Vol', 'Eff. Liquidity', 'Circ Supply', 'Total Supply', 'Fragility', '1H%', '6H%', '12H%', '24H%', 'Price Confidence', 'Anomaly Flags'];
      const escape = (v) => {
        const s = v == null ? '' : String(v);
        return s.includes(',') || s.includes('"') || s.includes('\n') ? `"${s.replace(/"/g, '""')}"` : s;
      };
      const getChange = (token, interval) => {
        try {
          const entry = token.changes && token.changes[interval];
          return entry && entry.percent != null ? Number(entry.percent).toFixed(4) : '';
        } catch (e) { return ''; }
      };
      const csvRows = rows.map((t) => [
        escape(t.label || t.name || ''),
        escape(t.symbol || ''),
        `"${String(t.id || t.address || '')}"`,
        t.price != null ? t.price : '',
        t.marketCap != null ? Math.round(t.marketCap) : '',
        t.fdvUSD != null ? Math.round(t.fdvUSD) : '',
        t.liquidityUSD != null ? Math.round(t.liquidityUSD) : '',
        t.volume24hUSD != null ? Math.round(t.volume24hUSD) : '',
        t.effectiveLiquidityUSD != null ? Math.round(t.effectiveLiquidityUSD) : '',
        t.circulatingSupply != null ? Math.round(t.circulatingSupply) : '',
        t.totalSupply != null ? Math.round(t.totalSupply) : '',
        t.fragilityScore != null ? t.fragilityScore : '',
        getChange(t, '1H'),
        getChange(t, '6H'),
        getChange(t, '12H'),
        getChange(t, '24H'),
        t.priceConfidence != null ? t.priceConfidence : '',
        escape(Array.isArray(t.anomalyFlags) ? t.anomalyFlags.join(';') : (t.anomalyFlags || '')),
      ].join(','));

      const csv = [headers.join(','), ...csvRows].join('\n');
      const blob = new Blob([csv], { type: 'text/csv' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      const dateStr = new Date().toISOString().slice(0, 10);
      a.href = url;
      a.download = `e3d-price-${dateStr}.csv`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('CSV export failed:', err);
    } finally {
      setPriceExportBusy(false);
    }
  }, [priceExportBusy, fetchPriceListPage, priceDataSource, priceListSortBy, priceListSortDir, priceSearchText, priceSelectedCategoriesCsv, watchlistOnly, priceFavoriteAddressesCsv, priceScreener]);

  const resetPriceToolbarSettings = useCallback(() => {
    setWatchlistOnly(false);
    setPriceSelectedCategories([]);
    setPriceSelectedChangeIntervals(['12H', '24H']);
    setPriceChangeIntervalSelected('24H');
    setPriceTrendIntervalSelected('24H');
    setPriceHiddenColumns(PRICE_HIDDEN_COLUMNS_DEFAULT);
    setPriceSearchText('');
    setPriceScreener({});
    resetAndLoadPriceList({ sortBy: 'storyCount', sortDir: 'desc', searchOverride: '' });
  }, [resetAndLoadPriceList, PRICE_HIDDEN_COLUMNS_DEFAULT]);

  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && window.localStorage) {
        window.localStorage.setItem(priceSortStorageKeyBy, String(priceListSortBy || 'storyCount'));
        window.localStorage.setItem(priceSortStorageKeyDir, String(priceListSortDir || 'desc'));
      }
    } catch (e) {
    }
  }, [priceListSortBy, priceListSortDir]);

  useEffect(() => {
    if (!location.pathname.startsWith('/price')) return;
    resetAndLoadPriceList({ sortBy: priceListSortBy, sortDir: priceListSortDir });
  }, [location.pathname, priceScreener, priceSelectedCategoriesCsv, priceTrendIntervalSelected, priceDataSource]);

  useEffect(() => {
    if (!location.pathname.startsWith('/price')) return;
    if (!watchlistOnly) return;
    resetAndLoadPriceList({ sortBy: priceListSortBy, sortDir: priceListSortDir });
  }, [location.pathname, watchlistOnly, priceFavoriteAddressesCsv, priceListSortBy, priceListSortDir]);

  const handlePriceServerSortChange = useCallback((nextSortBy, nextSortDir) => {
    if (!nextSortBy) return;
    const dir = (String(nextSortDir || '').toLowerCase() === 'asc') ? 'asc' : 'desc';
    resetAndLoadPriceList({ sortBy: nextSortBy, sortDir: dir });
  }, [resetAndLoadPriceList]);
  const [liveLastEndTime, setLiveLastEndTime] = useState(null);
  // Track when Live mode started and when we last performed a full refresh.
  const liveStartRef = useRef(null);
  const liveLastRefreshRef = useRef(null);
  const [allCategories, setAllCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [categoriesOpen, setCategoriesOpen] = useState(false);

  // Ensure synthetic chain label nodes are only present in chain view. When
  // the token view switches away from 'chain', remove any chain_label nodes
  // from the current graphData so they don't appear in other layouts.
  useEffect(() => {
    if (tokenView !== 'chain' && graphData && graphData.nodes && graphData.nodes.length) {
      const hasChainLabels = graphData.nodes.some(n => n.nodeType === 'chain_label');
      if (!hasChainLabels) return;
      const cleaned = {
        ...graphData,
        nodes: graphData.nodes.filter(n => n.nodeType !== 'chain_label'),
      };
      setGraphData(cleaned);
    }
  }, [tokenView, graphData]);

  // Keep an always-up-to-date ref to the latest graphData so long-lived
  // callbacks (like camera spin) can read current nodes without closing
  // over a stale snapshot of state.
  useEffect(() => {
    graphDataRef.current = graphData;
  }, [graphData]);

// Save options to localStorage when they are updated
useEffect(() => {
  if (cookieConsent && isLoaded) { // Check if the user has accepted the cookie consent
    localStorage.setItem('tourSpeedGraph', tourSpeedGraph);
    localStorage.setItem('tourSpeedList', tourSpeedList);
    localStorage.setItem('spinSpeed', spinSpeed);
    localStorage.setItem('showGraphToolbar', showGraphToolbar ? 'true' : 'false');
    localStorage.setItem('graphToolbarOrientation', graphToolbarOrientation);
    localStorage.setItem('showNames', showNames ? 'true' : 'false');
    localStorage.setItem('showAddressLabels', showAddressLabels ? 'true' : 'false');
    if (labelSize !== null && labelSize !== undefined) {
      localStorage.setItem('labelSize', String(labelSize));
    }
    localStorage.setItem('useAspectRatio', useAspectRatio.toString());
    localStorage.setItem('imageSize', imageSize);
    localStorage.setItem('filterNFT', filterNFT);
    localStorage.setItem('filterToken', filterToken);
    localStorage.setItem('userAddress', userAddress);
  }
}, [tourSpeedGraph, tourSpeedList, spinSpeed, showGraphToolbar, graphToolbarOrientation, showNames, showAddressLabels, labelSize, useAspectRatio, imageSize, cookieConsent, userID, viewGraph, filterNFT, filterToken]);

  // Load token categories from the backend for chain view filtering and /price filters.
  useEffect(() => {
    if (!location.pathname.startsWith('/token') && !location.pathname.startsWith('/price')) return;
    if (allCategories && allCategories.length) return;

    const loadCategories = async () => {
      try {
        const res = await axios.get(SERVER_NAME + '/getCategories');
        if (res && Array.isArray(res.data)) {
          setAllCategories(res.data.map((row) => row.category));
        }
      } catch (e) {
        console.error('Failed to load categories', e);
      }
    };

    loadCategories();
  }, [location.pathname, allCategories]);

  // Add effect to fix token icons in token graph view
  useEffect(() => {
    // Only run for token view (not organic layout) and when data is available
    if (filterToken && !filterNFT && !organicLayout && tokenList.length > 0 && graphData && graphData.nodes && graphData.nodes.length > 0) {
      console.log('Initializing token icons for all graph nodes');
      // Update all nodes in the graph with the corresponding icon from tokenList
      setGraphData(prevGraphData => {
        const updatedNodes = [...prevGraphData.nodes].map(node => {
          // For each node, try to find matching token in tokenList
          const tokenMatch = tokenList.find(token => token.id === node.id);
          if (tokenMatch && tokenMatch.icon && tokenMatch.icon !== genericTokenIcon) {
            // Use the icon from tokenList
            return { ...node, icon: tokenMatch.icon };
          }
          return node;
        });
        return { ...prevGraphData, nodes: updatedNodes };
      });
    }
  }, [tokenList.length, filterToken, filterNFT, organicLayout]);

  // Restore options from localStorage when the component mounts
  useEffect(() => {
  if (cookieConsent) { // Check if the user has accepted the cookie consent
    const savedTourSpeedGraph = localStorage.getItem('tourSpeedGraph');
    const savedTourSpeedList = localStorage.getItem('tourSpeedList');
    const savedSpinSpeed = localStorage.getItem('spinSpeed');
    const savedShowGraphToolbar = localStorage.getItem('showGraphToolbar');
    const savedGraphToolbarOrientation = localStorage.getItem('graphToolbarOrientation');
    const savedShowNames = localStorage.getItem('showNames');
    const savedShowAddressLabels = localStorage.getItem('showAddressLabels');
    const savedLabelSize = localStorage.getItem('labelSize');
    const savedUseAspectRatio = localStorage.getItem('useAspectRatio');
    const savedImageSize = localStorage.getItem('imageSize');
    const savedUserID = localStorage.getItem('userID');
    const savedUserAddress = localStorage.getItem('userAddress');
    const savedViewGraph = localStorage.getItem('viewGraph');
    const savedFilterNFT = localStorage.getItem('filterNFT');
    const savedFilterToken = localStorage.getItem('filterToken');

    if (savedTourSpeedGraph) setTourSpeedGraph(savedTourSpeedGraph);
    if (savedTourSpeedList) setTourSpeedList(savedTourSpeedList);
    // check spinSpeed, it may have been to 0 using nospin in params
    if (savedSpinSpeed && spinSpeed) setSpinSpeed(savedSpinSpeed);
    if (savedShowGraphToolbar) setShowGraphToolbar(savedShowGraphToolbar === 'true');
    if (savedGraphToolbarOrientation === 'horizontal' || savedGraphToolbarOrientation === 'vertical') {
      setGraphToolbarOrientation(savedGraphToolbarOrientation);
    }
    if (savedShowNames) setShowNames(savedShowNames === 'true');
    if (savedShowAddressLabels) setShowAddressLabels(savedShowAddressLabels === 'true');
    // Only restore labelSize from localStorage if no URL parameter is present
    if (savedLabelSize) {
      try {
        const params = new URLSearchParams(window.location.search);
        if (!params.has('labelSize')) {
          const n = Number(savedLabelSize);
          if (!Number.isNaN(n)) setLabelSize(n);
        }
      } catch (e) {
        const n = Number(savedLabelSize);
        if (!Number.isNaN(n)) setLabelSize(n);
      }
    }
    if (savedUseAspectRatio) setUseAspectRatio(savedUseAspectRatio === 'true');
    if (savedImageSize) setImageSize(savedImageSize);
    // Auth state is now managed by AuthContext - no need to set these here
    // if (savedUserID) setUserID(savedUserID);
    // if (savedUserAddress) setUserAddress(savedUserAddress);
   //if (savedViewGraph) setViewGraph(savedViewGraph);
   //if (savedFilterNFT) setFilterNFT(savedFilterNFT);
   //if (savedFilterToken) setFilterToken(savedFilterToken);
  }
}, [cookieConsent]);

function resetLocalStorage() {
  localStorage.removeItem('tourSpeedGraph');
  localStorage.removeItem('tourSpeedList');
  localStorage.removeItem('spinSpeed');
  localStorage.removeItem('useAspectRatio');
  localStorage.removeItem('imageSize');
  localStorage.removeItem('userID');
  localStorage.removeItem('userAddress');
  localStorage.removeItem('subscribeNewsletter');
  localStorage.removeItem('isAuthenticated');

  localStorage.removeItem('viewGraph');
  localStorage.removeItem('filterNFT');
  localStorage.removeItem('filterToken');
}
 
const [showOpenPcapButton, setShowOpenPcapButton] = useState(() => {
  // Don't show Open PCAP button when navigating from gallery
  try {
    if (typeof window !== 'undefined' && window.__E3D_PCAP_SHOW_OPEN_BUTTON__ != null) {
      return window.__E3D_PCAP_SHOW_OPEN_BUTTON__;
    }
  } catch (e) {}
  return false;
});
const [demoPcapLoading, setDemoPcapLoading] = useState(false);

const [showOpenFlowButton, setShowOpenFlowButton] = useState(false);
const [flowLoading, setFlowLoading] = useState(false);

  // Preserve progress state for PCAP gallery navigation (must be after showOpenPcapButton declaration)
  useEffect(() => {
    try {
      if (typeof window !== 'undefined' && dataSource === PCAP) {
        window.__E3D_PCAP_PROGRESS_VISIBLE__ = progressVisible;
        window.__E3D_PCAP_PROGRESS__ = progress;
        window.__E3D_PCAP_SHOW_OPEN_BUTTON__ = showOpenPcapButton;
      }
    } catch (e) {}
  }, [progressVisible, progress, dataSource, showOpenPcapButton]);

  // Poll window progress values to update local state (fixes progress bar updates during component remounts)
  useEffect(() => {
    if (dataSource !== PCAP) return;

    const pollInterval = setInterval(() => {
      try {
        if (typeof window !== 'undefined') {
          // Check if window has newer progress values than local state
          const windowProgress = window.__E3D_PCAP_PROGRESS__;
          const windowProgressVisible = window.__E3D_PCAP_PROGRESS_VISIBLE__;
          const windowShowButton = window.__E3D_PCAP_SHOW_OPEN_BUTTON__;

          if (windowProgress != null && windowProgress !== progress) {
            console.log('[ProgressPoll] Updating progress from window:', windowProgress);
            setProgress(windowProgress);
          }
          if (windowProgressVisible != null && windowProgressVisible !== progressVisible) {
            console.log('[ProgressPoll] Updating progressVisible from window:', windowProgressVisible);
            setProgressVisible(windowProgressVisible);
          }
          if (windowShowButton != null && windowShowButton !== showOpenPcapButton) {
            console.log('[ProgressPoll] Updating showOpenPcapButton from window:', windowShowButton);
            setShowOpenPcapButton(windowShowButton);
          }
        }
      } catch (e) {
        console.error('[ProgressPoll] Error:', e);
      }
    }, 100); // Poll every 100ms

    return () => clearInterval(pollInterval);
  }, [dataSource, progress, progressVisible, showOpenPcapButton]);

  // Update the ref whenever graphData changes
  useEffect(() => {
    graphDataRef.current = graphData;
  }, [graphData]);


  
  // Expose navigation function globally for components that can't easily access props
  useEffect(() => {
    // Expose goTo function globally for components that don't have direct access
    window.goToHome = () => {
      console.log('Global goToHome called');
      goTo('/home');
    };
    
    return () => {
      // Cleanup on unmount
      delete window.goToHome;
    };
  }, []);


  const clearAllViews = () => {
    // Reset graph data first
    // If we're navigating into a /links/<address> view and have a matching
    // prefetched snapshot ready to hydrate, don't wipe the graph state.
    let preservePrefetchedLinksGraph = false;
    try {
      if (location && location.pathname) {
        const parts = String(location.pathname).split('/');
        const addr = (parts[2] || '').toLowerCase();
        if (parts[1] === 'links' && addr) {
          if (
            typeof window !== 'undefined' &&
            window.prefetchedForensics &&
            window.prefetchedForensics.token &&
            String(window.prefetchedForensics.token).toLowerCase() === addr
          ) {
            preservePrefetchedLinksGraph = true;
          } else if (typeof window !== 'undefined' && window.prefetchedForensicsWasUsed) {
            // Snapshot was already consumed; still preserve state during
            // subsequent clearAllViews passes (e.g. remounts).
            preservePrefetchedLinksGraph = true;
          }
        }
      }
    } catch (e) {
      preservePrefetchedLinksGraph = false;
    }

    if (location && location.pathname && location.pathname.startsWith('/graphs')) {
      // eslint-disable-next-line no-console
      console.log('clearAllViews(/graphs) preservePrefetchedLinksGraph=', preservePrefetchedLinksGraph);
    }

    if (!preservePrefetchedLinksGraph) {
      setGraphData({ nodes: [], links: [] });
    }
    
    // Reset force graph instance
    if (graphRef.current) {
      const forceGraphInstance = graphRef.current;
      // Only call methods that exist in both 2D and 3D modes
      if (typeof forceGraphInstance.d3Force === 'function') {
        // Make sure link force exists
        const linkForce = forceGraphInstance.d3Force('link');
        if (linkForce && typeof linkForce.distance === 'function') {
          linkForce.distance(0);
        }
        
        // Make sure charge force exists
        const chargeForce = forceGraphInstance.d3Force('charge');
        if (chargeForce && typeof chargeForce.strength === 'function') {
          chargeForce.strength(0);
        }
        
        // Only call reheat if it exists
        if (typeof forceGraphInstance.d3ReheatSimulation === 'function') {
          forceGraphInstance.d3ReheatSimulation();
        }
      }
      // refresh() only exists in 3D mode
      if (is3DMode && typeof forceGraphInstance.refresh === 'function') {
        forceGraphInstance.refresh();
      }
    }

    // Reset all view states BUT preserve authentication and wallet state
    setShowHomePage(false);
    setShowShortcutPage(false);
    setShowE3DMarketplace(false);
    setShowCustomNFTMarketplace(false);
    setShowCustomNFTDialog(false);
    setViewTransaction(false);
    setFilterNFT(false);
    if (!preservePrefetchedLinksGraph) {
      setFilterToken(false);
      setViewGraph(false);
    }
    setFilterNFTOnly(false);
    setFilterNewOnly(false);
    setShowBottom(false);
    if (!preservePrefetchedLinksGraph) {
      setUserTransactions(false); 
      setOrganicLayout(false);
    }
    hasLoadedOrganicGraphRef.current = false;
    isLoaded = false;
  }; // End of clearAllViews
  
  // Function to load NFT visualization
  const loadNFTVisualization = async (nftTokenId) => {
    try {
      console.log(`Loading visualization for NFT: ${nftTokenId}`);
      setIsLoading(true);
      
      try {
        // Primary Method: Use the dedicated endpoint
        const response = await axios.get(`${SERVER_NAME}/getNFTTokens/${nftTokenId}`);
        const { tokens } = response.data;
        
        if (tokens && tokens.length > 0) {
          console.log(`Found ${tokens.length} tokens for NFT ${nftTokenId} using primary method`);
          processTokensForVisualization(tokens);
          return;
        }
      } catch (primaryError) {
        console.log(`Primary NFT data fetch failed, trying fallback: ${primaryError.message}`);
      }
      
      // Fallback Method 1: Get NFT metadata to get timestamp
      console.log(`Using fallback method for NFT ${nftTokenId}...`);
      try {
        const nftResponse = await axios.get(`${SERVER_NAME}/fetchNFTById/${nftTokenId}`);
        if (nftResponse.data && nftResponse.data.timestamp) {
          const nftTimestamp = nftResponse.data.timestamp;
          const endTimestamp = nftTimestamp + (10 * 60); // Add 10 minutes
          
          console.log(`Found timestamp ${nftTimestamp} for NFT ${nftTokenId}, fetching transactions...`);
          
          // Fetch transactions in that time window
          const transactionsResponse = await axios.get(`${SERVER_NAME}/fetchTransactionsDB`, {
            params: {
              dataSource: dataSource,
              startTime: nftTimestamp,
              endTime: endTimestamp
            }
          });
          
          if (transactionsResponse.data && transactionsResponse.data.length > 0) {
            // Create token list from transactions
            const tokens = createTokenList(transactionsResponse.data, 'ERC20', dataSource);
            console.log(`Found ${tokens.length} tokens from transactions for NFT ${nftTokenId}`);
            processTokensForVisualization(tokens);
            return;
          }
        }
      } catch (fallbackError) {
        console.error(`Fallback method failed: ${fallbackError.message}`);
      }
      
      // If we got here, both methods failed
      console.log(`No tokens found for NFT ${nftTokenId} using any method`);
      setIsLoading(false);
    } catch (error) {
      console.error('Error loading NFT visualization:', error);
      setIsLoading(false);
    }
  };
  
  // Helper function to process tokens for visualization
  const processTokensForVisualization = (tokens) => {
    // Format nodes for the graph
    const nodes = tokens.map(token => ({
      id: token.id || token.address,
      x: token.x || (Math.random() * 100 - 50),
      y: token.y || (Math.random() * 100 - 50),
      z: token.z || (Math.random() * 100 - 50),
      label: token.label || token.name || token.id?.substring(0, 8) || token.address?.substring(0, 8),
      symbol: token.symbol || '',
      icon: token.icon || '',
      type: token.type || 'ERC20'
    }));
    
    // Create a simple set of links between nodes
    const links = [];
    if (nodes.length > 1) {
      for (let i = 1; i < nodes.length; i++) {
        links.push({
          source: nodes[0].id,
          target: nodes[i].id,
          value: 1
        });
      }
    }
    
    // Set the graph data and classify nodes
    setGraphData(classifyGraphNodes({ nodes, links }));
    
    // Set the first node as active
    if (nodes.length > 0) {
      setActiveNodeId(nodes[0].id);
    }
    
    // Enable graph view
    setViewGraph(true);
    setIsLoading(false);
  };

  const stopCameraSpinRef = useRef(null);
  const stopCameraSpinImplRef = useRef(null);
  const layoutManagerRef = useRef(null);

  function stopCameraSpin() {
    try {
      const fn = stopCameraSpinImplRef.current;
      if (typeof fn === 'function') return fn();
    } catch (e) {
    }
  }

  useEffect(() => {
    stopCameraSpinRef.current = stopCameraSpin;
  }, [stopCameraSpin]);
  
  function parseAndLoadPcapCsvData(csvData) {
    return parseAndLoadPcapCsvDataImpl(csvData);
  }

  function getTokenListWithHistoryAllRanges(dataSourceParam, options) {
    return getTokenListWithHistoryAllRangesImpl(dataSourceParam, options);
  }

  useAppRouteEffects({
    location,
    isProcessingUrl,
    setIsProcessingUrl,
    clearAllViews,
    SERVER_NAME,
    parseAndLoadPcapCsvData,
    setShowOpenPcapButton,
    setShowOpenFlowButton,
    setViewGraph,
    setShowBottom,
    setShowPanel,
    setIsDataReady,
    setSnackbarSeverity,
    setSnackbarMessage,
    setSnackbarOpen,
    loadNFTVisualization,
    setShowHomePage,
    setShowShortcutPage,
    setTokenView,
    setFilterToken,
    setFilterNFT,
    stopCameraSpinRef,
    setMyLikesFilter,
    setAllLikesFilter,
    setDefaultNodeId,
    setViewTransaction,
    setShowCustomNFTMarketplace,
    setShowE3DMarketplace,
    setShowCustomNFTDialog,
    setDataSource,
    ETHERSCAN,
    PCAP,
    setOrganicLayout,
    setUserTransactions,
    setHasPriceHistoryData,
    setRangeSelected,
    setSearchText,
    classifyGraphNodes,
    setGraphData,
    setTokenList,
    setGraphViewMode,
    setMinLinks,
    setIsLoading,
    setIsTourRunning,
    setDateRange2,
    setShowNewsletter,
    setNewsDate,
    dateRange2,
    setFilterNewOnly,
    setFilterNFTOnly,
    createTokenList,
    layoutManagerRef,
    getTokenListWithHistoryAllRanges,
    axios,
    genericTokenIcon,
    setMaxNodes,
    setSpinSpeed,
    setSpinCamera,
    setIsConfigured,
    setProgress,
    setProgressVisible,
  });


  useEffect(() => {
    setImgRefs(graphData.nodes.map(() => React.createRef()));
  }, [graphData.nodes]);

  useEffect(() => {
    initGA();
  }, []);

  // GTM Ticket 1: log a GA pageview on every SPA route change so /token/:address
  // navigations are captured. Previously logPageView fired only on initial mount,
  // so client-side navigations to token pages never registered in Analytics.
  useEffect(() => {
    logPageView();
  }, [location && location.pathname]);

  const handleOrientationChange = () => {
    const pathname = location && location.pathname ? String(location.pathname) : '';
    const pathParts = pathname.split('/');

    if (isMobileDevice()) {
      isMobile = true;
      showAdvanced = false;
      setShowChart(true);

      const portrait = window.innerWidth < window.innerHeight;
      if (portrait) {
        setShowBottom(true);
        setShowPanel(false);
        setIsPortrait(true);
      } else {
        setShowBottom(false);
        setShowPanel(true);
        setIsPortrait(false);      
      }
    } else if (pathParts[1] === 'price') {
      setViewGraph(false);
      setShowHomePage(false);
      setShowShortcutPage(false);
      setShowBottom(false);
      setFilterToken(true);
      setFilterNFT(false);
      setTokenView('price');

      if (pathParts[2]) {
        const address = pathParts[2];
        setShowPanel(true);
        setIsPortrait(false);      
      }
    } else if (pathParts[1] === 'graphs') {
      setShowBottom(false);
      setMinLinks(2);
      // Show nodelist panel by default; hide it only when drilling into a specific address
      if (pathParts[2] && /^0x[a-fA-F0-9]{40}$/.test(pathParts[2])) {
        setShowPanel(false);
      } else {
        setShowPanel(true);
      }
    }
  };

  useEffect(() => {
    handleOrientationChange();
    window.addEventListener('resize', handleOrientationChange);
    return () => window.removeEventListener('resize', handleOrientationChange);
  }, []);

  function isMobileDevice() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  }

  const uploadNFTImage = async (name, description) => {
    if (!graphRef.current) return;
    
    const renderer = graphRef.current.renderer();
    const scene = graphRef.current.scene();
    const camera = graphRef.current.camera();

    // Render the scene to the WebGL renderer
    renderer.render(scene, camera);

    // Extract NFT contract addresses and positions from graphData
    const tokenListMap = graphData.nodes.map(node => ({
        address: node.id, 
        x: node.x,
        y: node.y,
        z: node.z
    }));

    // Define NFT metadata with the new timestamp
    const timestamp = dateRange.startTime;
    const nftName = (name) ? name : "FutCo NFT";
    const nftDescription = (description) ? description : "The Ethereum blockchain is also art";
    const nftMetadata = {
        name: nftName,
        description: nftDescription,
        properties: {
          authors: [{ name: "FutCo" }],
          timestamp: timestamp, // Adding the timestamp to properties
          tokenList: tokenListMap,
     
        }
    };

    // Use the WebGL context to capture the current frame
    const gl = renderer.getContext();
    const width = gl.drawingBufferWidth;
    const height = gl.drawingBufferHeight;

    // Create a new ArrayBuffer and read pixel data into it
    const pixels = new Uint8Array(width * height * 4);
    gl.readPixels(0, 0, width, height, gl.RGBA, gl.UNSIGNED_BYTE, pixels);

    // Create a 2D canvas to assemble the image
    const canvas = document.createElement('canvas');
    canvas.width = width;
    canvas.height = height;
    const context = canvas.getContext('2d');

    // Flip the image data and put it onto the canvas
    const imageData = new ImageData(new Uint8ClampedArray(pixels), width, height);
    context.putImageData(imageData, 0, 0);
    context.translate(0, canvas.height);
    context.scale(1, -1);
    context.drawImage(canvas, 0, 0);

    // Convert the canvas to a PNG blob
    canvas.toBlob(async (blob) => {
        // Add the image blob to the NFT metadata
        nftMetadata.image = blob;

        // Prepare the form data
        const formData = new FormData();
        formData.append('image', blob, 'nft-image.png');
        formData.append('nft', JSON.stringify(nftMetadata));

        // Send the form data to your endpoint
        try {
            const response = await fetch('/store-nft', {
                method: 'POST',
                body: formData,
            });

            const result = await response.json();
            if (response.ok) {
                console.log('NFT stored successfully!', result);
                saveMap(result.data.metadata);
                // Handle success, such as showing a message to the user or redirecting
            } else {
                console.error('Error storing NFT:', result);
                // Handle error, such as showing an error message to the user
            }
        } catch (error) {
            console.error('Network error:', error);
            // Handle network error
        }
    }, 'image/png');
  };

  function isLoggedIn() {
      return !!(isAuthenticated || localStorage.getItem('isAuthenticated') === 'true');
  }


  async function saveMap(name) {
    // Check if user is logged in
    if (!await isLoggedIn()) {
      alert('Please log in to save the map');
      return;
    }
  
    // Limit the original array to the first 10 nodes before mapping
    const nodeList = graphData.nodes.map(node => ({
      id: node.id,
      x: node.x,
      y: node.y,
      z: node.z
    }));

    //console.log(nodeList);

    const timestamp = dateRange.startDate;

    // Prepare the map data
    const mapData = {
      name: name,
      timestamp: timestamp,
      nodes: nodeList
    };
  
    const jsonString = JSON.stringify(mapData);
    const sizeInBytes = new TextEncoder().encode(jsonString).length;
    console.log(`Size of JSON: ${sizeInBytes} bytes`);

    try {
      const response = await axios.post(`${SERVER_NAME}/maps/save`, mapData, {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true // Important for including cookies in cross-origin requests, equivalent to credentials: 'include' in fetch
      });
      // Further processing...
      if (response.status === 200) {
        // Handle success
       // alert('Map saved successfully');
        setShowSaveMapDialog(false);
      } else {
        // Handle any errors that occurred during the request
        alert('Failed to save the map');
      }
    } catch (error) {
      console.error('Error sending map data:', error);
      alert('Error sending map data');
    }
  }
  

  async function selectMap() {
    // Check if user is logged in
    if (!isLoggedIn()) {
      alert('Please log in to load a map');
      return;
    }
  
    try {
      const response = await axios.get(`${SERVER_NAME}/maps/list`,  {
        withCredentials: true // Important for including cookies in cross-origin requests, equivalent to credentials: 'include' in fetch
      });
      // Further processing...
      if (response.status === 200) {
        setMaps(response.data.mapNames);
        setShowLoadMapDialog(true);
        console.log('Map name list loaded successfully');
      } else {
        // Handle any errors that occurred during the request
        console.log('Failed to save the map');
      }
    } catch (error) {
      console.error('Error loading map data:', error);
      alert('Error loading map list');
    }
  }
  
  async function openMap(mapName) {
    // Check if user is logged in
    if (!await isLoggedIn()) { // Ensure this is awaited to correctly check the login status asynchronously
        alert('Please log in to open a map');
        return;
    }

    try {
        // The mapName should be part of the URL or the configuration object, not a separate argument
        const response = await axios.get(`${SERVER_NAME}/maps/open/${encodeURIComponent(mapName)}`, {
            withCredentials: true // Important for including cookies in cross-origin requests, equivalent to credentials: 'include' in fetch
        });

        // Further processing...
        if (response.status === 200 && response.data) {
            const map = response.data.map;
            //console.log(map);
            setShowLoadMapDialog(false); // Presumably closes the dialog for loading maps
            console.log('Map opened successfully');

            // Assuming setDateRange and getTransactions are functions you have for handling the map data
            // Uncomment setDateRange if it needs to be set here
            // setDateRange(map.timestamp); // Update the date range based on the map's timestamp
            resetGraph();
            await getTransactions(dataSource, null, false, map.timestamp);
            setNewPositions(map.nodes);
 
        } else {
            // Handle any errors that occurred during the request
            console.log('Failed to open the map');
        }
    } catch (error) {
        console.error('Error loading map data:', error);
        alert('Error loading map data');
    }
  } 

  function updateCoordinates() {
    if (showAdvanced && graphRef.current && graphRef.current.cameraPosition) {
      const position = graphRef.current.cameraPosition();
      const x = document.getElementById('X');
      const y = document.getElementById('Y');
      const z = document.getElementById('Z');
  
      if (x && y && z) {
        x.innerHTML = parseInt(position.x, 10).toString();
        y.innerHTML = parseInt(position.y, 10).toString();
        z.innerHTML = parseInt(position.z, 10).toString();
      }
    }
  }

  useEffect(() => {
    if (newPositions) {
      // Create a new array for nodes to ensure React detects the change
      const updatedNodes = graphData.nodes.map(node => {
        const mapNode = newPositions.find(mapNode => mapNode.id === node.id);
        if (mapNode) {
          //console.log(mapNode);
          // Return a new object for the updated node to ensure React detects the change
          return {
            ...node,
            x: mapNode.x,
            y: mapNode.y,
            z: mapNode.z,
            fx: mapNode.x, // Fixed positions in the force-directed graph
            fy: mapNode.y,
            fz: mapNode.z
          };
        }
        return node; // Return the original node if no updates are necessary
      });
  
      // Update the graph data state with the new nodes array
      setGraphData(prevData => ({
        ...prevData, // Spread the previous data to maintain other state properties
        nodes: updatedNodes // Set the new nodes array
      }));
  
      setNewPositions(null); // Reset newPositions now that we've processed them
    }
  }, [newPositions, graphData, setGraphData]); // Add setGraphData if it's from useState
  


  function logHeight() {
    const topContainer = document.getElementById('topContainer');
    const linkContainer = document.getElementById('linkContainer');
    const bottomContainer = document.getElementById('bottomContainer');
    const graphContainer = document.getElementById('graphContainer');
    const container = document.getElementById('container');

    console.log("topContainer: " + topContainer.clientHeight);
    console.log("linkContainer: " + linkContainer.clientHeight);
    console.log("botttomContainer: " + bottomContainer.clientHeight);
    console.log("graphContainer: " + graphContainer.clientHeight);
    console.log("container: " + container.clientHeight);
  }

  useEffect(() => {
    if (updateCoordinatesIntervalId === null) {
      const id = setInterval( updateCoordinates, 500);
      setUpdateCoordinatesIntervalId(id);
    }

    const handleResize = () => {
      const pathname = location.pathname;
      if (pathname == '/' || pathname == '/home') return;

      // Check if we're on special routes to apply custom handling
      const isPricePage = pathname.startsWith('/price');
      const isStoriesPage = pathname.startsWith('/stories');

      // For non-stories routes, bail out early if core filters are not ready
      if ((filterNFT === null || filterToken === null)) { return; }

      const e3dHeader = document.getElementById('e3dHeader');
      const e3dHeaderHeight = e3dHeader ? e3dHeader.clientHeight : 0;
      const adBannerContainer = document.getElementById('adBannerContainer');
      const adBannerContainerHeight = adBannerContainer ? adBannerContainer.clientHeight : 0;
      const premiumBannerContainer = document.getElementById('premiumBannerContainer');
      const premiumBannerContainerHeight = premiumBannerContainer ? premiumBannerContainer.clientHeight : 0;
      const linksHeroBanner = document.getElementById('linksHeroBanner');
      const linksHeroBannerHeight = linksHeroBanner ? linksHeroBanner.clientHeight : 0;
      const otherHeight = e3dHeaderHeight + adBannerContainerHeight + premiumBannerContainerHeight + linksHeroBannerHeight;

      const topContainer = document.getElementById('topContainer');
      const linkContainer = document.getElementById('linkContainer');
      const infoContainer = document.getElementById('infoContainer');
      const bottomContainer = document.getElementById('bottomContainer');
      const mainContainer = document.getElementById( viewTransaction ? 'linkContainer' : ((viewGraph) ? 'graphContainer' : 'tokenContainer' ));
      const panelContainer = document.getElementById('panelContainer');
      const container = document.getElementById('container');
      const nodeListContainer = (isMobile) ? document.getElementById('nodeListContainerMobile') : document.getElementById('nodeListContainer');

      const appContainer = document.getElementById('appContainer');
      const appSize = appContainer.getBoundingClientRect();
      console.log(`App container width and height: ${appSize.width} x ${appSize.height}`);

      let width = appSize.width;
      let height = appSize.height;

      const topHeight = topContainer ? topContainer.clientHeight : 0;
      const bottomHeight = bottomContainer ? bottomContainer.clientHeight : 0;
      let linkHeight = 0;
      let mainHeight = 0;
      
      if (!viewGraph && filterToken) {
        // Price view layout (token list)
        //linkHeight = linkContainer ? height - effectiveTopHeight - bottomHeight : 0;
        linkHeight = linkContainer ? (height - topHeight - bottomHeight - otherHeight) : 0;
        mainHeight = 0; // No main container needed for price view
        if (infoContainer) {
          linkHeight = linkHeight - infoContainer.clientHeight;
          mainHeight = linkHeight;
        }
      } else {
        // Normal layout for desktop and landscape
        linkHeight = linkContainer ? ((height - topHeight - bottomHeight - otherHeight) * 0.40) : 0;
        mainHeight = mainContainer ? height - topHeight - bottomHeight - otherHeight - linkHeight : 0;
      }

      const panelHeight = mainHeight;
      
      if (mainContainer) {
        setDimensions({
          width: mainContainer.clientWidth,
          height: mainHeight
        });
      }
      
      if (linkContainer) {
        const LinkContainerHeight = linkHeight ? linkHeight : mainHeight;
        linkContainer.style.height = `${LinkContainerHeight}px`; 
        linkContainer.style.maxHeight = `${LinkContainerHeight}px`; 
        linkContainer.style.scrollHeight = `${LinkContainerHeight}px`;
      }

      if (nodeListContainer) {
        const NodeListContainerHeight = ((isMobile && !isPortrait) || infoContainer) ? mainHeight : (linkHeight) ? linkHeight : mainHeight;
        nodeListContainer.style.width = '100%';
        nodeListContainer.style.height = `${NodeListContainerHeight}px`; 
        nodeListContainer.style.maxHeight = `${NodeListContainerHeight}px`; 
        nodeListContainer.style.scrollHeight = `${NodeListContainerHeight}px`; 
        nodeListContainer.style.padding = '0';
        nodeListContainer.style.margin = '0';
      }
    
      if (container && !isPricePage) {
        container.style.height = `${mainHeight}px`; 
        container.style.maxHeight = `${mainHeight}px`; 
        container.style.scrollHeight = `${mainHeight}px`; 
      }

      if (mainContainer) {
        mainContainer.style.height = `${mainHeight}px`; // Set the height using style.height
        mainContainer.style.maxHeight = `${mainHeight}px`; // Set the height using style.height
        mainContainer.style.scrollHeight = `${mainHeight}px`; // Set the height using style.height
      }
 
      if (panelContainer) {
        panelContainer.style.height = `${mainHeight}px`; 
        panelContainer.style.maxHeight = `${mainHeight}px`; 
        panelContainer.style.scrollHeight = `${mainHeight}px`; 
      }

    };

    window.addEventListener('resize', handleResize);

    handleResize();
  
    // Remove event listener on cleanup
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [showPanel, showBottom, isMobile, isPortrait, viewGraph, filterToken, filterNFT, isDataReady, memoizedGraphData.nodes, isAuthenticated, location.pathname]);

  useEffect(() => {
    try {
      if (typeof window === 'undefined' || typeof document === 'undefined') return;
      const params = new URLSearchParams(window.location.search || '');
      const enable = params.get('print') === '1' || params.get('print') === 'true';
      if (enable) {
        document.body.classList.add('print-mode');
      } else {
        document.body.classList.remove('print-mode');
      }
    } catch (e) {
    }

    return () => {
      try {
        if (typeof document !== 'undefined') document.body.classList.remove('print-mode');
      } catch (e) {
      }
    };
  }, [location.search]);

  // Initialize rates and adjust panel for mobile
  useEffect(() => {
    updateRate();

    if (window.innerWidth < 800) {
      setShowPanel(false);
    }
  }, []);

  // Function to update exchange rate
  const updateRate = async () => {
    try {
      const response = await axios.get(`${SERVER_NAME}/rate`);
      if (response.data) {
        setRate(response.data);
      }
    } catch (error) {
      console.error("Error fetching rate:", error);
    }
  };

  const checkCookieConsent = () => {
    try {
      if (cookieSuppressed) {
        setShowCookieDialog(false);
        return;
      }
    } catch (e) {
    }
    const consent = localStorage.getItem('cookieConsent');
    if (consent) {
      setCookieConsent(consent === 'accepted');
      setShowCookieDialog(false);
    }
  };

  const handleAcceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setCookieConsent(true);
    setShowCookieDialog(false);
  };

  const handleDeclineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setCookieConsent(false);
    setShowCookieDialog(false);
  };


  const handleCloseTokenInfo = () => {
    setTokenData(null);
  };

  const handleCloseChart = () => {
    setShowChart(false);
  };

  // Check the user's cookie consent preference on component mount
  React.useEffect(() => {
    checkCookieConsent();
  }, []);

  useEffect(() => {
    if (resetCookieConsent) {
      setShowCookieDialog(true);
      setCookieConsent(false);
      setResetCookieConsent(false);
    }
  }, [resetCookieConsent]);


  
  const Modal = ({ children, onClose }) => {
    return (
      <div className="modalBackdrop">
        <div className="modalContent">
          <button className="closeButton" onClick={onClose}>X</button>
          {children}
        </div>
      </div>
    );
  };

  // This function handles user registration
  const handleSignup = async (username, password, subscribeNewsletterParam) => {
    let response = null;
    try {
      if (password === "deleteme") {
        axios.delete(`${SERVER_NAME}/deleteUser`, { data: { username: username } })
        .then(function (response) {
          // Handle success
          console.log(response.data);
          alert('User deleted successfully!');
        })
        .catch(function (error) {
          // Handle error
          console.log(error);
          alert('Error deleting user');
        });
        return;
      }

      // Always use /signup for all environments
      response = await axios.post(`${SERVER_NAME}/signup`, {
        username: username,
        password: password,
        subscribeNewsletter: subscribeNewsletterParam,
      });
    } catch (error) {
      console.error('Registration error:', error);
      const message = (error.response && error.response.data) ? error.response.data.message : error;
      console.error(message);
      alert(message);
      return;
    }

    // Handle response here. For example:
    if (response && response.data.success) {
      console.log('Registration successful');
      
      // Important: Do NOT log the user in immediately!
      // The email verification flow needs to complete first
      // Only set minimal user info
      // Full login will happen after email verification
      
      return response.data;
    } else if (response) {
      console.error('Registration failed with response:', response.data);
      return null;
    }
  }
 
  useEffect(() => {
    updateRate();

    if (window.innerWidth < 800) {
      setShowPanel(false)
    }
  }, []);

  const handleVerifyEmailCode = async (username, code) => {
    try {
      // Replace with your actual server name
      const response = await axios.post(`${SERVER_NAME}/verifyEmailCode`, {
        username: username,
        code: code,
      });

      // Handle response here. For example:
      if (response.data.success) {
        //alert('Verification successful');

        if (subscribeNewsletter) {
          // Replace with your actual server name
          const response2 = await axios.post(`${SERVER_NAME}/subscribeNewsletter`, {
            username: username,
            subscribeNewsletter: subscribeNewsletter,
          });   
          
          setShowVerifyEmailCode(false);
          handleLogin(username, password);
          //setShowLogin(true);
        }
      } else {
        alert('Registration failed'); // Inform the user if registration failed
        setShowSignup(true);
      }
    } catch (error) {
      console.error('Registration error:', error);
      // Handle errors here, such as showing a message to the user
    }
  };


  const handleLogin = async (username, passwordParam, setErrorMessage = null) => {
    try {
      console.log('Attempting login with POST:', { email: username, SERVER_NAME });
      
      // Standard POST request with enhanced error logging
      const loginUrl = `${SERVER_NAME}/login`;
      
      // Prepare login data
      const loginData = {
        email: username,
        password: passwordParam
      };
      
      // Standard axios configuration
      const axiosConfig = {
        headers: {
          'Content-Type': 'application/json'
        },
        withCredentials: true
      };
      
      console.log('Sending POST request to:', loginUrl);
      
      // Make the POST request with detailed error handling
      const response = await axios.post(loginUrl, loginData, axiosConfig)
        .catch(error => {
          console.error('Login error details:', {
            message: error.message,
            code: error.code,
            response: error.response ? {
              status: error.response.status, 
              data: error.response.data,
              headers: error.response.headers
            } : 'No response',
            request: error.request ? 'Request sent but no response' : 'No request sent'
          });
          
          // Handle case where email is not verified
          if (error.response && error.response.status === 403 && 
              error.response.data.needsVerification && 
              error.response.data.email) {
            
            console.log('User account needs verification:', error.response.data.email);
            
            // Close login dialog first
            setShowLogin(false);
            
            // Send verification code to the email
            handleSendVerificationCode(error.response.data.email, passwordParam);
            
            // The error is handled, so we're not throwing it further
            return { handled: true, error };
          }
          
          throw error;
        });
      
      // If we get a handled error object, just return - verification flow is already triggered
      if (response && response.handled) {
        return;
      }
      
      console.log('Login response received:', response);
      
      setPassword("");
      
      // Process response
      if (response.status === 200 && response.data.message === 'Login successful') {
        // Use AuthContext login instead of direct state setters
        login({
          username: response.data.user.username,
          userID: response.data.user.userid,
          userAddress: response.data.user.userAddress || response.data.user.address || '',
          roles: Array.isArray(response.data.user.roles) ? response.data.user.roles : [],
          subscribeNewsletter: response.data.user.subscribeNewsletter
        });
        setShowLogin(false);
        
        // Properly handle the newsletter subscription status
        console.log('Newsletter status from server:', response.data.user.subscribeNewsletter);
        console.log('Newsletter status type:', typeof response.data.user.subscribeNewsletter);
        
        // Ensure we convert to a proper boolean value
        const subscriptionStatus = response.data.user.subscribeNewsletter === true || 
                                  response.data.user.subscribeNewsletter === 'true';
        console.log('Setting newsletter subscription to:', subscriptionStatus);
        
        setSubscribeNewsletter(subscriptionStatus);
      } else {
        // Handle the case where authentication was not successful
        console.error('Authentication failed:', response.data);
        if (setErrorMessage) {
          setErrorMessage('Authentication failed: ' + (response.data.message || 'Unknown error'));
        } else {
          console.error('Authentication failed: ' + (response.data.message || 'Unknown error'));
        }
      }
    } catch (error) {
      console.error('Overall login error:', error);
      let errorMsg = error.message;
      
      // Enhanced error message based on common issues
      if (errorMsg.includes('Network Error')) {
        errorMsg = 'Network error: Please check your connection and try again.';
      } else if (error.response) {
        if (error.response.status === 401) {
          errorMsg = 'Invalid username or password.';
        } else if (error.response.status === 403 && error.response.data?.needsVerification) {
          errorMsg = 'Please verify your email before logging in.';
        } else if (error.response.status === 429) {
          errorMsg = 'Too many login attempts. Please try again later.';
        } else if (error.response.data?.message) {
          errorMsg = error.response.data.message;
        }
      }
      
      if (setErrorMessage) {
        setErrorMessage('Login error: ' + errorMsg);
      } else {
        console.error('Login error: ' + errorMsg);
      }
    }
  };
  
  // Function to send verification code to email
  const handleSendVerificationCode = async (email, passwordToRetry = '') => {
    try {
      // Send verification code to the email
      await axios.post(`${SERVER_NAME}/sendEmailCode`, { userId: email });
      console.log('Verification code sent to:', email);
      
      // Show the email verification dialog
      const verifyEmailRoot = document.createElement('div');
      verifyEmailRoot.id = 'verify-email-root';
      document.body.appendChild(verifyEmailRoot);
      
      // Import the required components
      const { VerifyEmailCodeDialog } = require('./AuthDialogs');
      const ReactDOM = require('react-dom');
      
      ReactDOM.render(
        <VerifyEmailCodeDialog 
          username={email} 
          onClose={(verified) => {
            ReactDOM.unmountComponentAtNode(verifyEmailRoot);
            document.body.removeChild(verifyEmailRoot);
            
            if (verified) {
              // If verification was successful, automatically log the user in.
              // Use the same credentials they just provided.
              setTimeout(() => {
                try {
                  handleLogin(email, passwordToRetry);
                } catch (e) {
                }
              }, 250);
            }
          }} 
        />,
        verifyEmailRoot
      );
    } catch (error) {
      console.error('Error sending verification code:', error);
      alert('Failed to send verification code. Please try again later.');
    }
  };
  
  const handleLogout = async () => {
    try {
        resetLocalStorage();
        // Use AuthContext logout instead of direct state setters
        logout();
        setShowLogoutConfirm(false);
        setSubscribeNewsletter(false);
        setCookieConsent(false);

        // Call server to logout
        const response = await axios.get(`${SERVER_NAME}/logout`);

        if (response.status === 200) {
            console.log('Logout successful:', response.data);
        } else {
            console.error('Authentication failed:', response.data);
            alert('Authentication failed: ' + (response.data.message || 'Unknown error'));
        }
    } catch (error) {
        console.error('Logout error:', error);
    }
  };

  const handleLogoutConfirm = () => {
    console.log('handleLogoutConfirm called');
    console.log('Before setShowLogoutConfirm, current value:', showLogoutConfirm);
    // Show the logout confirmation dialog
    setShowLogoutConfirm(true);
    console.log('After setShowLogoutConfirm, value should be true');
  };

  function convertUTCToLocalAsTimestamp(utcDateString) {
    // Parse the UTC date string into a Date object
    const date = new Date(utcDateString);
    
    // The getTime method gets the time in milliseconds since the epoch in UTC,
    // and getTimezoneOffset returns the difference in minutes between UTC and
    // the local time. So we adjust the time by this offset to get the local time.
    const localTimeAsTimestamp = date.getTime() - (date.getTimezoneOffset() * 60000);
  
    // Convert milliseconds to seconds to get the Unix timestamp
    return Math.floor(localTimeAsTimestamp / 1000);
  }
  
  function convertUTCToLocalAsTimestampString(utcDateString) {
    // Append 'Z' to the date string to indicate that it's in UTC time
    const utcDateWithZ = utcDateString + 'Z';
    // Create a date object using the updated string
    const date = new Date(utcDateWithZ);
    // Convert to local time string in Pacific Time
    const options = {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false, // Use 24-hour format
        timeZone: 'America/Los_Angeles' // Specify timezone
    };
    const localTimeString = date.toLocaleString('en-US', options);

    // Format the string to 'YYYY-MM-DD HH:MM:SS' format
    const formattedString = localTimeString.replace(/(\d+)\/(\d+)\/(\d+), (\d+:\d+:\d+)/, '$3-$1-$2 $4');

    return formattedString;
  }

  function convertToUnixTimestamp(dateInput) {
    // If the input is already a Date object, use it directly.
    // If it's a string or number, try converting it to a Date object.
    const date = dateInput instanceof Date ? dateInput : new Date(dateInput);
    
    // Now check if the conversion was successful by checking if the date is valid.
    if (!isNaN(date.getTime())) {
      // Convert the date to a Unix timestamp
      const unixTimestamp = Math.floor(date.getTime() / 1000);
      return unixTimestamp;
    } else {
      // Handle the error case where date is not valid
      console.error('Invalid date input:', dateInput);
      return null; // or throw an error, or return a default timestamp
    }
  }
  
  function formatDuration(startDate, endDate) {
    // Ensure that startDate and endDate are numbers and not null or undefined
    const start = Number(startDate);
    const end = Number(endDate);
  
    // Calculate the difference in seconds
    const durationInSeconds = end - start;
  
    // Don't calculate if start or end is not a valid timestamp
    if (isNaN(durationInSeconds)) {
      return 'Invalid date range';
    }
  
    // Calculate hours, minutes, and seconds
    const hours = Math.floor(durationInSeconds / 3600);
    const minutes = Math.floor((durationInSeconds % 3600) / 60);
    const seconds = durationInSeconds % 60;
  
    // Format the duration as HH:mm:ss
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
  }
  
  const handleDateKeyDown = (event) => {
    if (event.key === 'Delete') {
      // Prevent the delete key from finalizing the edit
      event.preventDefault();
    }
  };

  const handleDateChange = (start, end) => {
    setDateRange({ startDate: start, endDate: end });
  };
  
  useEffect(() => {
    console.log(`Start: ${dateRange.startDate}, End: ${dateRange.endDate}`);
  }, [dateRange]);
  
  useEffect(() => {
    console.log(`Start: ${dateRange2.startDate}, End: ${dateRange2.endDate}`);
  }, [dateRange2]);
  

  function Spinner() {
    const classes = useStyles();
  
    return (
      <div className={classes.spinnerWrapper}>
        <CircularProgress />
      </div>
    );
  }

  const DateTimeRangePicker = ({ startDate, endDate, onDateChange }) => {
    // Safeguard against invalid dates
    const getValidDate = (timestamp) => {
      const date = new Date(timestamp * 1000);
      if (isNaN(date.getTime())) {
        return new Date(); // Return current date if invalid
      } else {
        return date; // This will be in local time
      }
    };
  
    const [localStartDate, setLocalStartDate] = useState(getValidDate(startDate));
    const [localEndDate, setLocalEndDate] = useState(getValidDate(endDate));
  
    useEffect(() => {
      setLocalStartDate(getValidDate(startDate));
      setLocalEndDate(getValidDate(endDate));
    }, [startDate, endDate]);
  
    
    const handleStartDateChange = (date) => {
      const startDate = date.getTime() / 1000;
      const endDate = Math.floor(Date.now() / 1000) ;
      setLocalStartDate(startDate);  // one day
      setLocalEndDate(endDate);
      onDateChange(startDate, endDate);
    };

    return (
        <DatePicker
          selected={localStartDate}
          onChange={handleStartDateChange}
          showTimeSelect
          timeFormat="HH:mm:ss"
          timeIntervals={15}
          timeCaption="time"
          dateFormat="yyyy-MM-dd HH:mm:ss"
        />
    );
  };

  useEffect(() => {
    const max = Math.max(...Array.from(linkCount.values()));
    setMaxLinks(max);
  }, [linkCount]); // Only recompute when linkCount changes


  useEffect(() => {
    // If this /links view was hydrated from a prefetched forensics snapshot
    // (Stories inline forensics), skip the automatic organic user-graph
    // fetch. The snapshot already provided the initial graph the user
    // expects to see.
    if (
      typeof window !== 'undefined' &&
      window.prefetchedForensicsWasUsed &&
      typeof location !== 'undefined' &&
      typeof location.pathname === 'string' &&
      location.pathname.startsWith('/graphs')
    ) {
      return;
    }

    // If we’re no longer in organic user-graph mode, clear the guard
    if (
      !organicLayout ||
      !userTransactions ||
      !viewGraph ||
      dataSource !== ETHERSCAN
    ) {
      hasLoadedOrganicGraphRef.current = false;
      return;
    }

    // Only apply to the ETH user graph with graph view on
    if (hasLoadedOrganicGraphRef.current) {
      // Already loaded once for this mode; skip
      return;
    }

    // If a fetch is already in flight (e.g. React StrictMode double-invoke),
    // don't fire a second parallel request.
    if (fetchEthTransactionsPromiseRef.current) {
      return;
    }

    const isLinksRoute = typeof location !== 'undefined' && location && typeof location.pathname === 'string' && location.pathname.startsWith('/graphs');
    const hasExistingNodes = !!(graphData && graphData.nodes && graphData.nodes.length > 0);
    const hasExistingLinks = !!(graphData && graphData.links && graphData.links.length > 0);

    // If we already have graph data, treat as loaded and skip. On /links,
    // require actual links so stale node-only graphs from routes like /price
    // do not block the initial transaction fetch.
    if (hasExistingNodes && (!isLinksRoute || hasExistingLinks)) {
      hasLoadedOrganicGraphRef.current = true;
      return;
    }

    console.log('Organic user graph: calling fetchEthTransactions()');
    hasLoadedOrganicGraphRef.current = true;   // set guard before calling
    fetchEthTransactions();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organicLayout, userTransactions, viewGraph, dataSource]);

  const [tokenViewTrigger, setTokenViewTrigger] = useState(0);

  useEffect(() => {
    // For the /token route, automatically load data according to the current
    // the current tokenView. Transactions mode uses the original
    // transaction-driven sphere; the price-based modes rely on the price-list
    // meta cache, and the 'chain' mode uses the simpler fetchTokensDB-backed
    // list via getTokenList.
    const isTokenRoute = location.pathname.startsWith('/token');
    if (!isTokenRoute) return;

    // If a category filter is present (coming from a CATEGORY story), we
    // already set tokenList and graphData explicitly. Skip the auto-loader to
    // avoid overwriting the category-specific state a few seconds later.
    const searchParams = new URLSearchParams(location.search);
    if (searchParams.has('category')) return;

    stopCameraSpin();
    isLoaded = false;
    setViewGraph(true);
    resetGraph();
    setHasInitialLayoutApplied(false);

    if (tokenView === 'links') {
      loadTransactionMode(tokenView);
    } else if (tokenView === 'price' || tokenView === 'volatility' || tokenView === 'marketcap') {
      loadPriceMode(tokenView);
    } else if (tokenView === 'chain') {
      loadChainMode();
    }

  }, [location.pathname, location.search, tokenView, tokenViewTrigger]);

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const path = location && location.pathname ? String(location.pathname) : '';
        if (path !== '/pcap') return;

        const params = new URLSearchParams(location && location.search ? String(location.search) : '');
        const uploadId = String(params.get('upload_id') || '').trim();
        const uploadIdsRaw = String(params.get('upload_ids') || '').trim();
        const uploadIds = uploadIdsRaw
          ? uploadIdsRaw.split(',').map((s) => String(s || '').trim()).filter(Boolean)
          : (uploadId ? [uploadId] : []);
        const uniqueIds = Array.from(new Set(uploadIds));
        if (!uniqueIds.length) return;

        setIsLoading(true);
        setProgressVisible(true);
        setProgress(10);
        setShowOpenPcapButton(false);

        let merged = '';
        for (let i = 0; i < uniqueIds.length; i += 1) {
          const id = uniqueIds[i];
          setProgress(10 + Math.min(45, Math.floor((i / Math.max(1, uniqueIds.length)) * 45)));
          const resp = await axios.get(`${SERVER_NAME}/pcap/uploads/${encodeURIComponent(id)}/graphCsv`, {
            withCredentials: true,
            responseType: 'text',
            timeout: 60000,
          });
          if (cancelled) return;
          const csvText = resp && typeof resp.data === 'string' ? resp.data : '';
          try {
            const ct = resp && resp.headers ? (resp.headers['content-type'] || resp.headers['Content-Type']) : '';
            const head = String(csvText || '').slice(0, 200).toLowerCase();
            const looksHtml = head.includes('<!doctype html') || head.includes('<html') || head.includes('<head');
            const looksJson = head.trim().startsWith('{') || head.trim().startsWith('[');
            const looksCsv = head.includes('client addr') || head.includes('server addr') || head.includes(',');
            if (looksHtml || (ct && String(ct).toLowerCase().includes('text/html'))) {
              throw new Error('PCAP graph CSV request returned HTML (likely auth/session issue)');
            }
            if (looksJson && !(ct && String(ct).toLowerCase().includes('text/csv'))) {
              throw new Error('PCAP graph CSV request returned JSON (likely an error response)');
            }
            if (!looksCsv) {
              throw new Error('PCAP graph CSV request returned an unexpected payload');
            }
          } catch (e) {
            throw e;
          }
          if (!csvText) continue;
          if (!merged) {
            merged = csvText;
          } else {
            const lines = String(csvText).split(/\r?\n/);
            const body = lines.slice(1).filter((l) => String(l || '').trim() !== '').join('\n');
            if (body) {
              merged = `${merged.replace(/\s*$/g, '')}\n${body}\n`;
            }
          }
        }

        if (!merged) throw new Error('Empty graph CSV');

        try {
          const lines = String(merged || '').split(/\r?\n/).filter((l) => String(l || '').trim() !== '');
          if (lines.length <= 1) {
            throw new Error('No flows found for this upload (CSV has header only)');
          }
        } catch (e) {
          throw e;
        }

        setProgress(60);
        await parseAndLoadPcapCsvData(merged);
        if (cancelled) return;
        setProgress(100);

        try { setDataSource(PCAP); } catch (e) {}
        try { setViewGraph(true); } catch (e) {}
        try { setIsDataReady(true); } catch (e) {}
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message)
          ? String(e.response.data.message)
          : (e && e.message ? String(e.message) : 'Failed to load upload graph');
        try {
          setSnackbarSeverity('error');
          setSnackbarMessage(msg);
          setSnackbarOpen(true);
        } catch (e2) {
        }
      } finally {
        try {
          setProgressVisible(false);
          setIsLoading(false);
          setIsDataReady(true);
        } catch (e3) {
        }
      }
    };

    run();
    return () => { cancelled = true; };
  }, [location.pathname, location.search]);

  useEffect(() => {
    try {
      if (showOpenPcapButton) {
        setShowGraphToolbar(false);
      }
    } catch (e) {
    }
  }, [showOpenPcapButton]);

  function resetGraph() {
    setLinkCount(new Map());
    setChartData(null);
    setGraphData({ nodes: [], links: [] });
  }


  async function fetchEthTransactions(rangeOverride) {
    // Deduplicate concurrent calls: if a fetch is already in flight (and we
    // aren't overriding the range), reuse the same promise so we don't fire
    // two parallel requests to the backend.
    if (!rangeOverride && fetchEthTransactionsPromiseRef.current) {
      return fetchEthTransactionsPromiseRef.current;
    }

    const doFetch = async () => {
      try {
        setGraphData({ ...graphData });
        setDataSource(ETHERSCAN);
        const effectiveRange = rangeOverride && typeof rangeOverride === 'object' ? rangeOverride : dateRange2;
        let latest = true;
        let startDate = 0;
        let endDate = 0;
        if (effectiveRange && effectiveRange.startDate) {
          latest = false;
          startDate = effectiveRange.startDate;
          endDate = effectiveRange.endDate;
        }

        const newGraphData = await getTransactions(ETHERSCAN, '', latest, startDate, endDate, userID);
        return newGraphData;
      } finally {
        fetchEthTransactionsPromiseRef.current = null;
      }
    };

    const promise = doFetch();
    if (!rangeOverride) {
      fetchEthTransactionsPromiseRef.current = promise;
    }
    return promise;
  }

  // transaction history. This is used for the "Transactions" tokenView
  // option on the /token route.
  async function loadTransactionMode(sortMode) {
    try {
      // Default interval for transaction mode.
      // Use the same logged-in default as /links to reduce node counts.
      setRangeSelected(isAuthenticated ? '2M' : '1M');
      const newGraphData = await fetchEthTransactions();
      layoutManager.handleDistributeAll(newGraphData);
   } catch (error) {
      console.error('Error loading token view from meta cache:', error);
      setIsDataReady(true);
    }
  }

  // Helper: load token-view data from the price-list meta cache instead of
  // transaction history. This is used for the "Highest Price",
  // "Highest Changes", and "Market Cap" tokenView options on the /token
  // route.
  async function loadPriceMode(sortMode) {
    try {
      console.log('Token view meta load: mode =', sortMode);
      setIsDataReady(false);
      setHasPriceHistoryData(true);

      const tokens = await getTokenListWithHistoryAllRanges(dataSource);
      if (!tokens || tokens.length === 0) {
        console.warn('Token view meta load: no tokens returned');
        setIsDataReady(true);
        return;
      }

      // Always cap the meta-based list to a maximum of 500 tokens to keep the
      // token view manageable.
      let sorted = [...tokens];

      if (sortMode === 'price') {
        // Sort by highest current price first
        sorted.sort((a, b) => {
          const pa = parseFloat(a.price) || 0;
          const pb = parseFloat(b.price) || 0;
          return pb - pa;
        });
      } else if (sortMode === 'volatility') {
        // Sort by largest absolute percent change for the selected range
        sorted.sort((a, b) => {
          const ca = a.changes && a.changes[rangeSelected];
          const cb = b.changes && b.changes[rangeSelected];
          const pa = ca ? Math.abs(Number(ca.percent) || 0) : 0;
          const pb = cb ? Math.abs(Number(cb.percent) || 0) : 0;
          return pb - pa;
        });
      } else if (sortMode === 'marketcap') {
        // Sort by largest market cap first. Prefer marketCap field, but fall
        // back to common variants if needed.
        sorted.sort((a, b) => {
          const ma = Number(a.marketCap || a.marketcap || a.market_cap || 0) || 0;
          const mb = Number(b.marketCap || b.marketcap || b.market_cap || 0) || 0;
          return mb - ma;
        });
      }

      // Apply the 500-token cap after sorting.
      sorted = sorted.slice(0, 500);

      setTokenList(sorted);

      // Synthesize a minimal graphData so NodeList and other consumers have
      // nodes to work with, even though there is no transaction sphere.
      const metaNodes = sorted.map(t => {
        const rawIcon = (t && (t.icon || t.icon2)) ? String(t.icon || t.icon2).trim() : '';
        const v = rawIcon.toLowerCase ? rawIcon.toLowerCase() : rawIcon;
        const safeIcon = (!rawIcon || v === 'null' || v === 'undefined' || v === '""') ? genericTokenIcon : rawIcon;
        return {
          id: t.id,
          label: t.label || t.name || (t.id && t.id.substring(0, 8)) || '',
          symbol: t.symbol || '',
          icon: safeIcon,
          type: 'token',
        };
      });

      const newGraphData = { nodes: metaNodes, links: [] };
      setGraphData(newGraphData);
      layoutManager.handleDistributeAll(newGraphData);
      setIsDataReady(true);
    } catch (error) {
      console.error('Error loading token view from meta cache:', error);
      setIsDataReady(true);
    }
  }

  // Helper: load token-view data for chain-only mode using fetchTokensDB via
  // getTokenList. Unlike the meta-based helper, this does not apply the
  // 500-token cap and instead builds graphData from the full token set so the
  // chain layout can operate over all available tokens.
  async function loadChainMode(categoriesOverride) {
    try {
      // Force the layout/zoom effect to rerun when chain mode loads.
      isLoaded = false;
      setIsDataReady(false);

      const rawTokens = await getTokenList(dataSource, '', false, 'Token', userID, categoriesOverride);
      if (!rawTokens || rawTokens.length === 0) {
        setTokenList([]);
        setGraphData({ nodes: [], links: [] });
        setIsDataReady(true);
        return;
      }

      // Normalize tokens to ensure a 'symbol' field is always present for the
      // NodeList, even if the backend sends token_symbol instead.
      const tokens = rawTokens.map((t) => ({
        ...t,
        symbol: t.symbol || t.token_symbol || '',
      }));

      // Keep the full token list for the table
      setTokenList(tokens);

      // For the graph, limit to the first N tokens per chain so React Force
      // Graph remains responsive even when the underlying token set is large.
      // Use a lower cap on mobile devices to keep performance smooth.
      const MAX_PER_CHAIN = isMobile ? 75 : 200;
      const tokensByChain = new Map();

      tokens.forEach((t) => {
        const key = (t.chain || 'UNKNOWN').toUpperCase();
        if (!tokensByChain.has(key)) {
          tokensByChain.set(key, []);
        }
        const list = tokensByChain.get(key);
        if (list.length < MAX_PER_CHAIN) {
          list.push(t);
        }
      });

      const graphTokens = Array.from(tokensByChain.values()).flat();

      const chainNodes = graphTokens.map((t) => {
        const rawIcon = (t && (t.icon || t.icon2)) ? String(t.icon || t.icon2).trim() : '';
        const v = rawIcon.toLowerCase ? rawIcon.toLowerCase() : rawIcon;
        const safeIcon = (!rawIcon || v === 'null' || v === 'undefined' || v === '""') ? genericTokenIcon : rawIcon;
        return {
          id: t.id,
          label: t.label || t.name || (t.id && t.id.substring(0, 8)) || '',
          symbol: t.symbol || t.token_symbol || '',
          icon: safeIcon,
          nodeType: t.nodeType || 'token',
          chain: t.chain,
        };
      });

      const newGraphData = { nodes: chainNodes, links: [] };
      setGraphData(newGraphData);

      // Run the chain layout immediately on the freshly built graph so we
      // don't depend on the async state update for graphData.
      layoutManager.handleDistributeAll(newGraphData);

      setIsDataReady(true);
    } catch (error) {
      console.error('Error loading token view for chain mode:', error);
      setIsDataReady(true);
    }
  }

  const handleCategoriesApply = (nextCategories) => {
    setSelectedCategories(nextCategories || []);
    if (tokenView === 'chain' && location.pathname.startsWith('/token')) {
      loadChainMode(nextCategories || []);
    }
  };

  // Load the /links graph from the /stories/transactions endpoint.
  // Fetches story transactions from the backend cache, builds graph nodes/links
  // directly (same format as /fetchTransactionsDB), and marks story addresses
  // for amber highlighting.
  // When true, the next setGraphData call in getTransactions will strip x/y/z
  // positions from all nodes so the force simulation starts fresh. This prevents
  // the "stretched" layout caused by react-force-graph reusing old node positions
  // when switching modes or time ranges.
  const stripNodePositionsNextRenderRef = useRef(false);

  function clearNodePositions() {
    stripNodePositionsNextRenderRef.current = true;
  }

  // Fetch story addresses from the backend and store them. Also fetches the
  // full stories list to build storyNodeMapRef (address_lc → Story[]) for
  // hover tooltips and click popovers in Stories mode.
  async function fetchStoryAddresses() {
    try {
      const [addrResp, storiesResp] = await Promise.all([
        axios.get(`${SERVER_NAME}/stories/addresses`, { withCredentials: true }),
        axios.get(`${SERVER_NAME}/stories`, { withCredentials: true }),
      ]);
      const payload = addrResp && addrResp.data ? addrResp.data : {};
      const addrs = Array.isArray(payload.addresses) ? payload.addresses : [];
      storyAddressesRef.current = addrs;
      setStoryAddresses(addrs);

      // Build address → Story[] map from the stories list + their meta addresses.
      const stories = Array.isArray(storiesResp && storiesResp.data) ? storiesResp.data : [];
      const nodeMap = new Map();
      const addToMap = (addr, story) => {
        const key = String(addr || '').toLowerCase();
        if (!key || !/^0x[0-9a-f]{40}$/.test(key)) return;
        if (!nodeMap.has(key)) nodeMap.set(key, []);
        nodeMap.get(key).push(story);
      };
      stories.forEach(story => {
        if (story.primary_token) addToMap(story.primary_token, story);
        // Also map any addresses embedded in meta_json
        const meta = story.meta || {};
        const extractFromMeta = (obj) => {
          if (!obj || typeof obj !== 'object') return;
          Object.values(obj).forEach(v => {
            if (typeof v === 'string' && /^0x[0-9a-fA-F]{40}$/.test(v.trim())) {
              addToMap(v.trim(), story);
            } else if (typeof v === 'object') {
              extractFromMeta(v);
            }
          });
        };
        extractFromMeta(meta);
      });
      storyNodeMapRef.current = nodeMap;

      // Also update the story overlay map (primary_token only) for the optional
      // graph annotation overlay in /links.
      try {
        const overlay = new Map();
        stories.forEach((s) => {
          const addr = String(s && s.primary_token ? s.primary_token : '').toLowerCase();
          if (!addr) return;
          if (!overlay.has(addr)) overlay.set(addr, []);
          overlay.get(addr).push(s);
        });
        storyOverlayMapRef.current = overlay;
        setStoryOverlayMap(overlay);
      } catch (e) {
      }

      return addrs;
    } catch (error) {
      console.error('Error fetching story addresses:', error);
      return [];
    }
  }

  useEffect(() => {
    if (!location.pathname.startsWith('/graphs')) return;
    if (!linksStoryOverlayEnabled) return;

    let cancelled = false;

    const fetchOverlayStories = async () => {
      try {
        const resp = await axios.get(`${SERVER_NAME}/stories`, { withCredentials: true });
        const stories = Array.isArray(resp && resp.data) ? resp.data : [];
        const overlay = new Map();
        stories.forEach((s) => {
          const addr = String(s && s.primary_token ? s.primary_token : '').toLowerCase();
          if (!addr) return;
          if (!overlay.has(addr)) overlay.set(addr, []);
          overlay.get(addr).push(s);
        });
        if (cancelled) return;
        storyOverlayMapRef.current = overlay;
        setStoryOverlayMap(overlay);
      } catch (e) {
        // ignore overlay fetch errors
      }
    };

    fetchOverlayStories();
    const id = setInterval(fetchOverlayStories, 60000);
    return () => {
      cancelled = true;
      clearInterval(id);
    };
  }, [location.pathname, linksStoryOverlayEnabled]);

  // Keep watchedKeysRef and watchlistAddressesRef in sync with watchedKeys.
  useEffect(() => {
    watchedKeysRef.current = watchedKeys;
    const addrs = [];
    (watchedKeys || new Set()).forEach(key => {
      const addr = key.split(':')[1];
      if (addr && /^0x[0-9a-f]{40}$/.test(addr)) addrs.push(addr);
    });
    watchlistAddressesRef.current = addrs;
  }, [watchedKeys]);

  // Populate watchlistAddressesRef from watchedKeys/items and then reload the
  // graph via the normal fetchEthTransactions path (same pattern as Stories mode).
  // getTransactions will filter nodes/links to watchlist addresses client-side.
  async function fetchWatchlistGraph() {
    // Derive addresses from watchedKeysRef (preferred) with fallback to items.
    const currentKeys = watchedKeysRef.current || new Set();
    const addrs = [];
    if (currentKeys.size > 0) {
      currentKeys.forEach(key => {
        const addr = key.split(':')[1];
        if (addr && /^0x[0-9a-f]{40}$/.test(addr)) addrs.push(addr);
      });
    } else {
      // Fallback: derive from items directly (handles timing edge cases)
      (items || []).forEach(it => {
        const addr = String(it.address || '').toLowerCase();
        if (/^0x[0-9a-f]{40}$/.test(addr) && !addrs.includes(addr)) addrs.push(addr);
      });
    }
    console.log('[watchlist] fetchWatchlistGraph keys:', currentKeys.size, 'addrs:', addrs);
    // Store in ref so getTransactions can filter by these addresses.
    watchlistAddressesRef.current = addrs;
    clearNodePositions();
    await fetchEthTransactions();
  }

  // When linksDataMode changes on /links (user toggled All/Stories), reload graph.
  // We track the previous value so we only act on actual user-driven changes,
  // not on the initial mount where the organic graph effect already handles loading.
  const prevLinksDataModeRef = useRef('all');
  useEffect(() => {
    if (!location.pathname.startsWith('/graphs')) return;
    const prev = prevLinksDataModeRef.current;
    prevLinksDataModeRef.current = linksDataMode;
    // Skip if nothing changed (initial mount)
    if (prev === linksDataMode) return;
    if (linksDataMode === 'stories') {
      // Fetch story addresses, then re-run the normal transaction fetch so
      // getTransactions can filter nodes/links to story addresses only.
      storyAddressesRef.current = [];
      setStoryAddresses([]);
      fetchStoryAddresses().then(() => {
        clearNodePositions();
        fetchEthTransactions().catch(() => {});
      });
    } else if (linksDataMode === 'watchlist') {
      // Fetch transactions for all watchlisted addresses and build the graph.
      storyAddressesRef.current = [];
      setStoryAddresses([]);
      fetchWatchlistGraph().catch(() => {});
    } else {
      // 'all' mode: clear story/watchlist state and reload organically
      storyAddressesRef.current = [];
      setStoryAddresses([]);
      watchlistAddressesRef.current = [];
      clearNodePositions();
      fetchEthTransactions().catch(() => {});
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [linksDataMode]);

  // Issue 2: When tokenView changes to price/volatility/marketcap on /graphs,
  // fetch price-history data for the nodelist without touching the graph.
  // When switching back to 'graphs', restore the cached tx token list.
  // On /price and /token, skip — the paged list or loadPriceMode handles it.
  useEffect(() => {
    if (!location.pathname.startsWith('/graphs')) return;
    if (tokenView === 'price' || tokenView === 'volatility' || tokenView === 'marketcap') {
      getTokenListWithHistoryAllRanges(dataSource).then((tokens) => {
        if (tokens && tokens.length > 0) {
          setTokenList(tokens);
        }
      }).catch(() => {});
    } else if (tokenView === 'graphs') {
      // Restore the transaction-derived token list if we have one cached.
      if (linksTransactionTokenListRef.current && linksTransactionTokenListRef.current.length > 0) {
        setTokenList(linksTransactionTokenListRef.current);
      }
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tokenView, location.pathname]);


  const handleCategoriesCancel = () => {
    setCategoriesOpen(false);
  };

  function fetchBscTransactions() {
    setGraphData({ ...graphData });
    setDataSource(BSCSCAN);
    getTransactions(BSCSCAN, '', true);
  }

  // Start or stop the timer
  const toggleTimer = () => {
    setIsTourRunning(false);
    if (intervalBscId || intervalEthId) {
      stopTimer();
    }
    else {
      startTimer();
    }
  };

  function stopTimer() {
    stopBscTimer();
    stopEthTimer();
  };

  function startTimer() {
    (dataSource === ETHERSCAN) ? startEthTimer() : startBscTimer();
  };

  const onEthTimer = async () => {

    await fetchEthTransactions();
    layoutManager.handleDistributeSphereAll(graphData);
  };

  const startEthTimer = () => {
    stopBscTimer();
    stopEthTimer();
    fetchEthTransactions();   
    if (!intervalEthId) {
      const id = setInterval(onEthTimer, 300000);
      setIntervalEthId(id);
    }
  };

  const stopEthTimer = () => {
    clearInterval(intervalEthId);
    setIntervalEthId(null);
  };
  
  const startBscTimer = () => {
    stopBscTimer();
    stopEthTimer();
    fetchBscTransactions();
    if (!intervalBscId) {
      const id = setInterval(fetchBscTransactions, 30000);
      setIntervalBscId(id);
    }
  };

  const stopBscTimer = () => {
    clearInterval(intervalBscId);
    setIntervalBscId(null);
  };
  
  const parseAndLoadPcapCsvDataImpl = async (csvData) => {
    return new Promise((resolve, reject) => {
      try {
        try {
          if (typeof window !== 'undefined') {
            window.__E3D_PCAP_RENDER_READY__ = false;
          }
        } catch (e) {
        }
        try {
          pcapCsvTextRef.current = typeof csvData === 'string' ? csvData : String(csvData || '');
        } catch (e) {
        }
        const preview = String(csvData || '').slice(0, 240);
        console.log('[PCAP][demo] parseAndLoadPcapCsvData: bytes=', String(csvData || '').length, 'preview=', preview);
      } catch (e) {
      }

      Papa.parse(csvData, {
        header: true,
        complete: async (results) => {
          try {
            setDataSource(PCAP);
            const jsonData = results.data;

            try {
              const conv = buildPcapConversationsFromRows(jsonData);
              setPcapConversations(conv);
            } catch (e) {
            }
            try {
              const fields = results && results.meta && Array.isArray(results.meta.fields) ? results.meta.fields : null;
              console.log('[PCAP][demo] Papa.parse fields=', fields);
            } catch (e) {
            }
            try {
              if (typeof window !== 'undefined' && window.__DEBUG_PCAP_PORTS__) {
                const first = Array.isArray(jsonData) && jsonData.length ? jsonData[0] : null;
                const keys = first ? Object.keys(first) : [];
                const cp = first && (first['Client Port'] ?? first['client_port'] ?? first['ClientPort']);
                const sp = first && (first['Server Port'] ?? first['server_port'] ?? first['ServerPort']);
                console.log('[PCAP][ports][Papa.parse] first row', { keys, clientPort: cp, serverPort: sp, first });
              }
            } catch (e) {
            }
            console.log('[PCAP][demo] Papa.parse complete: rows=', Array.isArray(jsonData) ? jsonData.length : 0);
            const graphData = csvToGraphData(jsonData);
            console.log('[PCAP][demo] csvToGraphData: nodes=', (graphData && graphData.nodes ? graphData.nodes.length : 0), 'links=', (graphData && graphData.links ? graphData.links.length : 0));
            let classified = classifyGraphNodes(graphData);
            console.log('[PCAP][demo] classifyGraphNodes: nodes=', (classified && classified.nodes ? classified.nodes.length : 0), 'links=', (classified && classified.links ? classified.links.length : 0));

            try {
              const nn = classified && Array.isArray(classified.nodes) ? classified.nodes.length : 0;
              const ll = classified && Array.isArray(classified.links) ? classified.links.length : 0;
              // Large PCAP graphs can overwhelm WebGL (context loss) and crash the renderer.
              // Auto-switch to a lighter view to keep the app responsive.
              if (nn > 9000 || ll > 20000) {
                setSnackbarSeverity('warning');
                setSnackbarMessage(`PCAP graph is very large (nodes=${nn}, links=${ll}). Switching to a lighter view (2D + Group + Collapsed links) to avoid WebGL errors.`);
                setSnackbarOpen(true);
                try { setMode3D(false); } catch (e) {}
                try { setPcapGroupNamesEnabledAndApply(true); } catch (e) {}
                try { setPcapGroupIpsEnabledAndApply(true); } catch (e) {}
                try { setPcapLinkStyleAndApply('collapsed_straight'); } catch (e) {}
              }
            } catch (e) {
            }

            try {
              const isValidIpv4 = (s) => {
                const raw = String(s || '').trim();
                if (!raw) return false;
                if (!/^\d{1,3}(?:\.\d{1,3}){3}$/.test(raw)) return false;
                const parts = raw.split('.');
                if (parts.length !== 4) return false;
                for (let i = 0; i < 4; i += 1) {
                  const n = parseInt(parts[i], 10);
                  if (!Number.isFinite(n) || n < 0 || n > 255) return false;
                }
                return true;
              };

              const ips = (classified && classified.nodes ? classified.nodes : [])
                .map((n) => (n && n.id ? String(n.id) : ''))
                .filter((id) => isValidIpv4(id));
              if (ips.length) {
                setPcapNamesLoading(true);
                const pcapIconsDebugEnabled = (() => {
                  try {
                    if (typeof window === 'undefined') return false;
                    if (window.__DEBUG_PCAP_ICONS__) return true;
                    try {
                      const v = window.localStorage ? window.localStorage.getItem('__DEBUG_PCAP_ICONS__') : null;
                      return String(v || '') === '1';
                    } catch (e) {
                      return false;
                    }
                  } catch (e) {
                    return false;
                  }
                })();
                try {
                  if (pcapIconsDebugEnabled) {
                    console.log('[PCAP][icons] pcapNamesBatch request ips=', ips.length, 'sample=', ips.slice(0, 12));
                  }
                } catch (e) {
                }
                const debugParam = (() => {
                  try {
                    return pcapIconsDebugEnabled ? '?debug=1' : '';
                  } catch (e) {
                    return '';
                  }
                })();
                const resp = await axios.post(`${SERVER_NAME}/pcapNamesBatch${debugParam}`, { ips }, { withCredentials: true });
                const items = resp && resp.data && Array.isArray(resp.data.items) ? resp.data.items : [];
                const nameMap = new Map();
                const iconMap = new Map();
                items.forEach((it) => {
                  const ip = it && it.ip ? String(it.ip) : '';
                  if (!ip) return;
                  const name = it && it.name ? String(it.name) : '';
                  if (name) nameMap.set(ip, name);

                  let icon = it && it.icon ? String(it.icon).trim() : '';
                  if (icon && icon.startsWith('/pcapIcon')) {
                    try {
                      const base = String(SERVER_NAME || '').replace(/\/$/, '');
                      icon = base ? `${base}${icon}` : icon;
                    } catch (e) {
                    }
                  }
                  if (icon) iconMap.set(ip, icon);
                });

                try {
                  if (pcapIconsDebugEnabled) {
                    const iconSamples = [];
                    for (const v of iconMap.values()) {
                      iconSamples.push(v);
                      if (iconSamples.length >= 8) break;
                    }
                    console.log(
                      '[PCAP][icons] pcapNamesBatch response items=',
                      items.length,
                      'nameMap=',
                      nameMap.size,
                      'iconMap=',
                      iconMap.size,
                      'iconSamples=',
                      iconSamples
                    );
                  }
                } catch (e) {
                }

                if (nameMap.size || iconMap.size) {
                  classified = {
                    ...classified,
                    nodes: (classified.nodes || []).map((n) => {
                      const id = n && n.id ? String(n.id) : '';
                      const name = id ? nameMap.get(id) : null;
                      const icon = id ? iconMap.get(id) : null;
                      if (!name && !icon) return n;
                      return {
                        ...n,
                        ...(name ? { label: name, symbol: name } : null),
                        ...(icon ? { icon } : null),
                      };
                    })
                  };

                  try {
                    if (pcapIconsDebugEnabled) {
                      const nodesArr = classified && Array.isArray(classified.nodes) ? classified.nodes : [];
                      let withIcon = 0;
                      for (let i = 0; i < nodesArr.length; i += 1) {
                        const n = nodesArr[i];
                        if (n && n.icon) withIcon += 1;
                      }
                      console.log('[PCAP][icons] after apply: nodes=', nodesArr.length, 'nodesWithIcon=', withIcon);
                    }
                  } catch (e) {
                  }
                }
              }
            } catch (e) {
            } finally {
              setPcapNamesLoading(false);
            }

            try {
              const macRegex = /^([0-9A-Fa-f]{2}([:-])){5}[0-9A-Fa-f]{2}$/;
              const macs = (classified && classified.nodes ? classified.nodes : [])
                .map((n) => (n && n.id ? String(n.id) : ''))
                .filter((id) => macRegex.test(String(id || '').trim()));
              if (macs.length) {
                const resp = await axios.post(`${SERVER_NAME}/pcapOuiBatch`, { macs }, { withCredentials: true });
                const items = resp && resp.data && Array.isArray(resp.data.items) ? resp.data.items : [];
                const map = new Map();
                items.forEach((it) => {
                  const prefix = it && it.prefix ? String(it.prefix).toUpperCase() : '';
                  const org = it && it.org ? String(it.org) : '';
                  if (prefix && org) map.set(prefix, org);
                });
                if (map.size) {
                  classified = {
                    ...classified,
                    nodes: (classified.nodes || []).map((n) => {
                      const id = n && n.id ? String(n.id).trim() : '';
                      if (!id || !macRegex.test(id)) return n;
                      const key = id.replace(/[^0-9A-Fa-f]/g, '').toUpperCase().slice(0, 6);
                      const org = key ? map.get(key) : null;
                      if (!org) return n;
                      return { ...n, label: org, symbol: org };
                    })
                  };
                }
              }
            } catch (e) {
            }

            pcapBaseGraphRef.current = classified;
            recomputePcapGraphAndTokens(classified, {
              groupNamesOn: (dataSource === PCAP && isMobile) ? true : !!pcapGroupNamesEnabled,
              groupIpsOn: !!pcapGroupIpsEnabled,
              useNames: !!showNames,
            });

            console.log('[PCAP][demo] recomputePcapGraphAndTokens dispatched');
            try {
              if (typeof window !== 'undefined') {
                requestAnimationFrame(() => {
                  requestAnimationFrame(() => {
                    window.__E3D_PCAP_RENDER_READY__ = true;
                  });
                });
              }
            } catch (e) {
            }
            resolve();
          } catch (e) {
            reject(e);
          }
        },
        error: (error) => {
          console.error('[PCAP][demo] Papa.parse error:', error);
          reject(error);
        }
      });
    });
  };
  
  function formatShortAddress(address) {
    if (address && address.length > 8) {
      const start = address.substring(0, 6); // '0x' + first 4 characters
      const end = address.substring(address.length - 4); // last 4 characters
      return `${start}…${end}`; // Using the ellipsis character directly
    }
    return address;
  }
 
/*
  useEffect(() => {
    function findHighestLinkCount(linkCounts) {
      let maxCount = 0;
      let savedNodeID = null;
      // Iterate over the entries in the linkCount map
      for (let [nodeId, count] of linkCounts.entries()) {
        if (count > maxCount) {
          // Update maxCount and activeNodeId if the current count is the highest
          maxCount = count;
          savedNodeID = nodeId;
        }
      }
  
      return savedNodeID;
    }

    if (graphData.nodes && graphData.nodes.length && activeNodeId === null) {
      const nodeId = graphData.nodes[0].id; // findHighestLinkCount(linkCount);
      handleNodeClick(dataSource, graphData, graphRef, nodeId, false);
      if (graphData.links.length) {
        const linkId = graphData.links[0].tx;
        handleLinkClick(dataSource, graphData, graphRef, linkId, false);
      }
    }  
  }, [graphData]);
*/

  function removeSubstrings(str, substrings) {
    substrings.forEach(substring => {
      str = str.replace(substring, '');
    });
    return str;
  }

  // Helper function to safely parse JSON and return null if invalid
  const safeParseJSON = (jsonString) => {
    try {
      return JSON.parse(jsonString);
    } catch (e) {
      return null;
    }
  };
  
  function createFilteredVolumeChartData(txData) {
    const timestampCounts = {};
    let minTimestamp = Infinity;
    let maxTimestamp = -Infinity;

    // Filter transactions and process timestamps
    const transactions = txData.filter(tx => String(tx.txType) === '0');
    transactions.forEach(tx => {
        const timestamp = convertUTCToLocalAsTimestamp(tx.timestamp);
        // Update min and max timestamps
        const timestampValue = new Date(timestamp).getTime();
        if (timestampValue < minTimestamp) minTimestamp = timestampValue;
        if (timestampValue > maxTimestamp) maxTimestamp = timestampValue;

        // Track individual timestamp counts (for reference or additional processing)
        if (timestampCounts[timestamp]) {
            timestampCounts[timestamp] += 1;
        } else {
            timestampCounts[timestamp] = 1;
        }
    });

    // Create bins
    const binCounts = {};
    const numBins = 10;
    const range = maxTimestamp - minTimestamp;
    const binSize = range / numBins;
    let i = 0;

    // Assign counts to bins
    transactions.forEach((tx, i) => {
      const timestamp = convertUTCToLocalAsTimestamp(tx.timestamp);
      //console.log(i + '   ' + timestamp);
      i++;

      const timestampValue = new Date(timestamp).getTime();

      // Check if timestampValue is not a number (invalid date)
      if (isNaN(timestampValue)) {
          console.log(`Invalid timestamp detected at index ${i}: ${timestamp}`);
      } else {
          // Calculate bin index
          const binIndex = Math.floor((timestampValue - minTimestamp) / binSize);
          const dateValue = minTimestamp + binIndex * binSize;

          // Range check - although technically redundant as we control the range via binIndex
          if (dateValue < minTimestamp || dateValue >= maxTimestamp) {
              //console.log(`Date value out of range at index ${i}: ${new Date(dateValue).toISOString()}`);
          } else {
              // Construct bin key
              let binKey;
              try {
                  binKey = `${new Date(dateValue).toISOString()}`;
              } catch (error) {
                  console.log(`Error constructing date for binKey at index ${i}: ${error}`);
              }

              // Increment the count in the appropriate bin
              if (binCounts[binKey]) {
                  binCounts[binKey] += 1;
              } else {
                  binCounts[binKey] = 1;
              }
          }
      }
    });

    return binCounts;
}


function createTokenList(tokens, tokenType, dataSourceParam, addAllAddresses=false) {
  const newTokens = [];
  const dataSource2 = dataSourceParam;

  const normalizeChain = (chain) => {
    const raw = String(chain || '').trim().toUpperCase();
    if (!raw) return 'ETH';
    if (raw === 'ETHEREUM') return 'ETH';
    if (raw === 'BINANCE' || raw === 'BINANCE SMART CHAIN') return 'BSC';
    return raw;
  };

  const hashColorHex = (str) => {
    const s = String(str || '');
    let h = 2166136261;
    for (let i = 0; i < s.length; i += 1) {
      h ^= s.charCodeAt(i);
      h = Math.imul(h, 16777619);
    }
    const hue = ((h >>> 0) % 360);
    return `hsl(${hue}, 75%, 55%)`;
  };

  const makeDotIconDataUri = (id) => {
    try {
      const fill = hashColorHex(id);
      const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><circle cx="11" cy="11" r="9" fill="${fill}" stroke="rgba(255,255,255,0.25)" stroke-width="1"/></svg>`;
      return `data:image/svg+xml;base64,${btoa(svg)}`;
    } catch (e) {
      return genericNodeIcon;
    }
  };

  tokens.forEach(tx => {
    let icon = "";
    const name  = tx.name ? tx.name : tx.label;
    let shortName = name && name !== `null` ? name : formatShortAddress(tx.to);
    const address = (dataSource2 === PCAP)
      ? (tx.id != null ? String(tx.id) : String(name || ''))
      : (tx.address ? tx.address.toLowerCase() : (tx.id) ? tx.id.toLowerCase() : name);

    if (dataSource2 === PCAP) {
      const display = tx && tx.displayId ? String(tx.displayId) : '';
      let pcapIcon = '';
      try {
        if (tx && tx.icon) {
          const cand = String(tx.icon).trim();
          if (cand) pcapIcon = cand;
        }
      } catch (e) {
      }
      newTokens.push({
        icon: pcapIcon || makeDotIconDataUri(address),
        id: address,
        label: display || shortName,
        color: tx && tx.color ? tx.color : hashColorHex(address),
        sentBytes: tx.sentBytes,
        receivedBytes: tx.receivedBytes,
        totalBytes: tx.totalBytes,
      });
    }
    else {
      const iconRaw = tx && tx.icon != null ? String(tx.icon).trim() : '';
      const iconLower = iconRaw.toLowerCase ? iconRaw.toLowerCase() : iconRaw;
      if (iconRaw && iconRaw.startsWith("{")) {
        const iconData = safeParseJSON(iconRaw);
        icon = iconData && iconData.image ? iconData.image : '';
        if (iconData && iconData.name) shortName = iconData.name;
      }
      else if (iconRaw && iconRaw.startsWith("data:image/svg+xml;base64,")) {
        icon = iconRaw;
      } 
      else if (iconRaw && iconLower !== 'null' && iconLower !== 'undefined' && iconLower !== '""') {
        icon = iconRaw;
      }
      else {
        // Only use generic icons if nothing else is available
        icon = tx.name && tx.name.includes('.eth') ? genericUserIcon : (tx.name) ? genericTokenIcon : "";
      }
      
      // Store original icon to prevent loss during processing
      const originalIcon = icon;

      if (!shortName || shortName === `null` || shortName === `undefined` || shortName === ``) {
        shortName = 'Unknown';
      }

      // Define the substrings to remove
      const substringsToRemove = ['.eth', '.nft'];
      shortName = removeSubstrings(shortName, substringsToRemove);
    
      if (address.includes('.')) {
          const tokenId = address.split('.')[1];
          if (!shortName.includes(tokenId)) {
            shortName += " (#" + tokenId + ")";
          }
      }

      let addAddress = addAllAddresses ? true : (shortName.startsWith('0x') || shortName === 'Unknown') ? false : true;

      if (tokenType === 'NFT' && !tx.count && !address.includes('.')) {
        addAddress = false;;
      }

      if (addAddress) {
        const price = (!tx.priceUSD || tx.priceUSD < 0 || tx.priceUSD > 80000) ? 0 : tx.priceUSD;
        const count = (tx.count) ? tx.count : 0;
        const symbol = (tx.symbol) ? tx.symbol : "";
        const likes = (tx.likes) ? tx.likes : 0;
        
        // Check for price history fields from our new API endpoint
        const current_price = tx.current_price || tx.priceUSD; // Use current_price if available
        const normalizedPrice = (!current_price || current_price < 0 || current_price > 80000) ? 0 : current_price;

        newTokens.push({
          id: address,
          label: shortName,
          symbol: symbol,
          icon: icon,
          originalIcon: originalIcon, // Store the original icon
          nodeType: 'token', // Explicitly mark as token
          price: normalizedPrice, // Use normalized price value
          marketCap: tx.marketCapUSD,
          supply: tx.supply,
          circulatingSupply: tx.circulatingSupply,
          totalSupply: tx.totalSupply,
          fdvUSD: tx.fdvUSD,
          priceSourceLiquidityUSD: tx.priceSourceLiquidityUSD || tx.liquidityUSD,
          fragilityScore: tx.fragilityScore,
          anomalyFlags: tx.anomalyFlags,
          liquidityUSD: tx.liquidityUSD,
          effectiveLiquidityUSD: tx.effectiveLiquidityUSD,
          volume24hUSD: tx.volume24hUSD,
          poolQuality: tx.poolQuality,
          version: tx.version,
          count: count,
          likes: likes,
          chain: normalizeChain(tx.chain || (dataSource2 === PCAP ? 'PCAP' : 'ETH')),
          priceSourceType: tx.priceSourceType,
          priceSourceDex: tx.priceSourceDex,
          priceSourcePool: tx.priceSourcePool,
          priceSourceQuoteToken: tx.priceSourceQuoteToken,
          priceConfidence: tx.priceConfidence,
          volume: tx.volume, // Sparkline data for Txs column
          priceTrend: tx.priceTrend,
          volumeTrend: tx.volumeTrend,
          linkCount: tx.linkCount,
          // Add price history fields if they exist
          price_change_percent: tx.price_change_percent,
          price_change_direction: tx.price_change_direction,
          historical_price: tx.historical_price,
          storyCount: tx.storyCount,
          thesisCount: tx.thesisCount,
        });
      }
    }
  });

  return newTokens;
}

/**
 * Classifies graph nodes into three categories:
 * - 'token': Nodes with icons (representing tokens)
 * - 'connected_user': Users connected to at least one token
 * - 'isolated_user': Users only connected to other users or not connected at all
 * 
 * This classification enables filtering the graph to show:
 * 1. All nodes (default)
 * 2. Only tokens and their connected users (no user-to-user-only connections)
 * 3. Only user-to-user connections
 * 
 * @param {Object} graphData - Object containing nodes and links arrays
 * @returns {Object} - The updated graphData object with nodeType field added to each node
 */
function classifyGraphNodes(graphData) {
  if (!graphData || !graphData.nodes || !graphData.links) {
    console.error('Invalid graph data provided to classifyGraphNodes');
    return graphData;
  }
  
  // Create a deep copy to avoid modifying the original data
  const newGraphData = {
    nodes: JSON.parse(JSON.stringify(graphData.nodes)),
    links: [...graphData.links]
  };
  
  // Step 1: Identify tokens (nodes with icons)
  const tokenIds = new Set();
  newGraphData.nodes.forEach(node => {
    if (node.icon) {
      tokenIds.add(node.id);
      // Preserve the original icon if it exists
      if (!node.originalIcon) {
        node.originalIcon = node.icon;
      } else {
        // Restore original icon if it was replaced
        node.icon = node.originalIcon;
      }
      // Mark as token
      node.nodeType = 'token';
    }
  });
  
  // Step 2: Identify users connected to tokens
  const connectedUserIds = new Set();
  newGraphData.links.forEach(link => {
    // If this link connects a user to a token
    if (tokenIds.has(link.source) && !tokenIds.has(link.target)) {
      connectedUserIds.add(link.target);
    } else if (tokenIds.has(link.target) && !tokenIds.has(link.source)) {
      connectedUserIds.add(link.source);
    }
  });
  
  // Step 3: Classify all remaining nodes
  newGraphData.nodes.forEach(node => {
    if (!node.nodeType) { // Skip nodes already classified
      if (connectedUserIds.has(node.id)) {
        node.nodeType = 'connected_user';
      } else {
        node.nodeType = 'isolated_user';
      }
    }
  });
  
  return newGraphData;
}       
   

const addTokenToGraphData = (nodeId) => {
  try {
    console.log("addTokenToGraphData");
    if (nodeId === null || nodeId === "") {
      return;
    }
  
    const isFirst = (graphData.nodes.find(node => node.id === nodeId)) ? false : true;
    if (isFirst) {
      setGraphData((prevData) => {
        console.log(`addTokenToGraphData::SetGraphData begin...`);

        const newNodes = [...prevData.nodes];
        const newLinks = [...prevData.links];

        const id = nodeId.toLowerCase();
        let tokenEntry = tokenList.find(token => token.id.toLowerCase() === id);
        let icon = tokenEntry.icon;
        let name = tokenEntry.label;
        let shortName = name && name !== `null` ? name : formatShortAddress(id);

        if (icon && icon.startsWith("{")) {
          const iconData = safeParseJSON(icon);
          icon = iconData.image;
          shortName = iconData.name;
        }
        else if (icon && icon.startsWith("data:image/svg+xml;base64,")) {
          shortName = "NFT";
        } 
        else if (icon && icon.length) {
          // do nothing
        }
        else
        {
          icon = name && name.includes('.eth') ? genericUserIcon : (name) ? genericTokenIcon : "";
        }

        newNodes.push({
          id: id,
          label: shortName,
          group: 2,
          events: 0,
          color: 0x32CD32,   // lime green
          value: 0,
          icon: icon,
          x: 0,
          y: 0,
          z: 0,
          fx: 0,
          fy: 0,
          fz: 0,
        });
        
        // Only apply classification if not in token view mode
        if (typeof filterToken !== 'undefined' && filterToken !== null && !organicLayout) {
          return { nodes: newNodes, links: newLinks };
        } else {
          // Classify nodes before returning for other views
          return classifyGraphNodes({ nodes: newNodes, links: newLinks });
        }
      });
    }

    console.log(`addTokenToGraphData::SetGraphData end.`);

  } catch (error) {
      console.error("Error fetching transactions from backend:", error);
  }
};

  const getCurrentNodeIcon  = () => {

    if (!graphData || !graphData.nodes || !graphData.nodes.length) {
      return futLogoIcon200;
    }

    const node = (filterNFT) ? graphData.nodes[currentNodeIndex] : tokenList[currentNodeIndex];
    

    if (!node) {  
      return futLogoIcon200;
    }

    return node.icon;
  };

  const getCurrentNode  = () => {
    if (!graphData || !graphData.nodes || !graphData.nodes.length) {
      return null;
    }

    const node = (filterNFT) ? graphData.nodes[currentNodeIndex] : tokenList[currentNodeIndex];
    
    return node;
  };

  const toggleViewGraph  = () => {
    const viewGraph2 = !viewGraph;
    setViewGraph(viewGraph2);
    if (!viewGraph2) {
      stopCameraSpin();
    }
  };

  const getTokenList = async (dataSourceParam, search, setIt, tokenType, userID, categoriesOverride, getTransactionsRunId = null) => {
    const fetchWhichList = (filterNFT || (search && search.includes('0x'))) ? 'fetchNFTsDB' : 'fetchTokensDB';
    const url = SERVER_NAME + '/' + fetchWhichList;

    let params = "";
    if (allLikesFilter) {
      if (params.length) { params += ","; }
      params += "AllLikesFilter";
    }

    if (myLikesFilter) {
      if (params.length) { params += ","; }
      params += "MyLikesFilter";
    }

    const axiosParams = {
      dataSource: dataSourceParam,
      search: search,
      params: params,
      userID: userID
    };

    // On the /graphs route we only need icons for ~300-400 graph nodes.
    // Limit to the top 2000 tokens by price so the query runs in <1s instead
    // of fetching all 16K+ tokens from EthNames (which takes 6-10 seconds).
    if (
      !search &&
      fetchWhichList === 'fetchTokensDB' &&
      location.pathname.startsWith('/graphs')
    ) {
      axiosParams.limit = 2000;
    }

    // Only send categories when querying tokens (not NFTs) in chain view
    const categoriesToSend =
      typeof categoriesOverride !== 'undefined' ? categoriesOverride : selectedCategories;
    if (
      fetchWhichList === 'fetchTokensDB' &&
      tokenView === 'chain' &&
      categoriesToSend &&
      categoriesToSend.length
    ) {
      axiosParams.categories = categoriesToSend.join(',');
    }

    const fetchTokensStartedAt = performance.now();
    const transactionRunPrefix = getTransactionsRunId !== null ? `[getTransactions #${getTransactionsRunId}] ` : '';
    console.log(`${transactionRunPrefix}[fetchTokensDB] start`, {
      dataSource: dataSourceParam,
      search,
      tokenType,
      pathname: location.pathname,
    });
    let responseTokens;
    try {
      responseTokens = await axios.get(url, { params: axiosParams });
      console.log(`${transactionRunPrefix}[fetchTokensDB] finished in ${Math.round(performance.now() - fetchTokensStartedAt)}ms`, {
        count: Array.isArray(responseTokens.data) ? responseTokens.data.length : 0,
      });
    } catch (error) {
      console.log(`${transactionRunPrefix}[fetchTokensDB] failed in ${Math.round(performance.now() - fetchTokensStartedAt)}ms`, error);
      throw error;
    }

    // If we got nothing try anytime
    if (responseTokens.data === null || responseTokens.data.length === 0) {
      return;
    }

    let tokenData2 = responseTokens.data;
    // Preserve the historical safety cap for non-chain modes, but allow the
    // chain-only view to display the full set of tokens returned from the DB.
    //if (tokenView !== 'chain' && tokenData2.length >= 10000) {
    //  tokenData2 = tokenData2.slice(0, 10000);
    //}
    const tokens = createTokenList(tokenData2, tokenType, dataSourceParam);

    // Always cache on /links so switching back from Price/Volatility/MktCap
    // to Transactions has a valid list to restore, regardless of setIt.
    if (location.pathname.startsWith('/graphs') && tokens && tokens.length > 0) {
      linksTransactionTokenListRef.current = tokens;
    }

    if (setIt) {
      setTokenList(tokens);
      setIsDataReady(true);
    }

    return tokens;
  };

  // Fetch token list together with price-change history for all cached ranges.
  // This is used by the /price route so we can show 6H/12H/24H
  // percentage changes in the price list.
  const getTokenListWithHistoryAllRangesImpl = async (dataSourceParam, options = {}) => {
    //if (hasLoadedInitialPriceHistory) return;

    const shouldSetTokenList = options && options.setTokenList === false ? false : true;

    const url = SERVER_NAME + '/fetchTokenPricesWithHistoryAllRanges';

    try {
      const response = await axios.get(url, {
        params: {
          dataSource: dataSourceParam,
        },
        withCredentials: true,
      });

      const payload = response.data;
      const rawTokens = (payload && Array.isArray(payload.rows))
        ? payload.rows
        : (Array.isArray(payload) ? payload : []);

      // Preserve the per-interval changes from the raw response, keyed by address
      const changesByAddress = new Map();
      rawTokens.forEach((t) => {
        const addr = (t.address || t.id || '').toLowerCase();
        if (!addr) return;
        if (t.changes) {
          changesByAddress.set(addr, t.changes);
        }
      });

      // Normalize tokens using the same pipeline as other token lists
      const normalizedTokens = createTokenList(rawTokens, 'Token', dataSourceParam);

      // Merge changes back into the normalized tokens
      const mergedTokens = normalizedTokens.map((t) => {
        const addr = (t.id || '').toLowerCase();
        const changes = changesByAddress.get(addr);
        return changes ? { ...t, changes } : t;
      });

      //await fetchEthTransactions();
      if (shouldSetTokenList) {
        setTokenList(mergedTokens);
      }
      hasLoadedInitialPriceHistory = true;
      return mergedTokens;
    } catch (error) {
      console.error('Error fetching token list with history for all ranges:', error);
      return [];
    }
  };

  // Load initial price history data when BubblesView is first shown.
  // On /price the paged fetchPriceListPage already handles token loading,
  // so skip the expensive unpaged fetch here.
  useEffect(() => {
    const isPriceRoute = location.pathname.startsWith('/price');
    if (isPriceRoute) return; // paged list handles /price
    if (!props.showBubblesView) return;

    setIsDataReady(false);
    setHasPriceHistoryData(false);
    setTokenList([]);

    console.log('BubblesView: Loading initial all-range price history meta list');

    // Fetch the all-range meta token list (includes per-range changes)
    getTokenListWithHistoryAllRanges(dataSource, { setTokenList: true })
      .then(tokens => {
        if (tokens && tokens.length > 0) {
          console.log(`Received ${tokens.length} tokens from meta price history cache`);
          setTokenList(tokens);

          // NEW: synthesize minimal graphData for /bubbles
          const bubbleNodes = tokens.map(t => {
            const rawIcon = (t && (t.icon || t.icon2)) ? String(t.icon || t.icon2).trim() : '';
            const v = rawIcon.toLowerCase ? rawIcon.toLowerCase() : rawIcon;
            const safeIcon = (!rawIcon || v === 'null' || v === 'undefined' || v === '""') ? genericTokenIcon : rawIcon;
            return {
              id: t.id,
              label: t.label || t.name || (t.id && t.id.substring(0, 8)) || '',
              symbol: t.symbol || '',
              icon: safeIcon,
              type: 'token',
              volume: [],
            };
          });

          setGraphData({ nodes: bubbleNodes, links: [] });

          setIsDataReady(true);
          setHasPriceHistoryData(true);
        } else {
          console.warn('No meta price history data received');
          setIsDataReady(true);
          setHasPriceHistoryData(false);
        }
      })
      .catch(error => {
        console.error('Error fetching initial meta price history data:', error);
        setIsDataReady(true);
        setHasPriceHistoryData(false);
      });
  }, [props.showBubblesView, location.pathname, userID]);

  /**
   * Fetches token data with price history comparison for a specific historical timestamp
   * @param {number} dataSourceParam - The data source (ETHERSCAN or other)
   * @param {string} search - Optional search string
   * @param {number} historicalTimestamp - Unix timestamp for historical price comparison
   * @param {string} userID - Optional user ID for personalized data
   * @returns {Promise<Array>} - Array of token objects with price history data
   */
  const getTokenPriceHistory = async (dataSourceParam, search = "", historicalTimestamp, userID = "") => {
    const url = SERVER_NAME + '/fetchTokenPricesWithHistory';

    let params = "";
    if (allLikesFilter) {
      if (params.length) { params += ","; }
      params += "AllLikesFilter";
    }

    if (myLikesFilter) {
      if (params.length) { params += ","; }
      params += "MyLikesFilter";
    }

    const responseTokens = await axios.get(url, {
      params: {
        dataSource: dataSourceParam,
        search: search,
        params: params,
        userID: userID,
        historicalTimestamp: historicalTimestamp
      },
    });

    // If we got nothing, return empty array
    if (responseTokens.data === null || responseTokens.data.length === 0) {
      return [];
    }

    // Process the token data before returning it
    // We don't need to run it through createTokenList since it already has the price info
    // and we want to preserve the price_change_percent and price_change_direction fields
    return responseTokens.data;
  };


  async function enrichNodeFromIPFS(node) {
    if (node.icon?.startsWith('ipfs://')) {
      // Convert ipfs:// to https://ipfs.io/ipfs/
      node.icon = node.icon.replace('ipfs://', 'https://ipfs.io/ipfs/');
      return;
    }
  
    if (
      node.label === '' &&
      node.icon?.startsWith('https://ipfs.io/ipfs/') &&
      !node.icon.endsWith('.png')
    ) {
      const ipfsHash = node.icon.split('ipfs/')[1];
      const ipfsUrl = `https://ipfs.io/ipfs/${ipfsHash}`;
  
      try {
        const response = await fetch(ipfsUrl);
        const data = await response.json();
  
        if (data.name) {
          node.label = data.name;
        }
        if (data.image) {
          // If image is an IPFS URL, convert it
          if (data.image.startsWith('ipfs://')) {
            node.icon = data.image.replace('ipfs://', 'https://ipfs.io/ipfs/');
          } else {
            node.icon = data.image;
          }
        }
      } catch (error) {
        console.error('Error fetching IPFS metadata:', error);
      }
    }
  }
  
  // Function to ensure tokens have their proper icons
  const ensureTokenIcons = (nodes) => {
    // Check if we have tokenList data available
    if (tokenList && tokenList.length > 0) {
      // For each node, try to find a matching token in tokenList
      nodes.forEach(node => {
        if (node.icon === genericTokenIcon || !node.icon) {
          // Try to find this token in the tokenList
          const tokenMatch = tokenList.find(token => token.id === node.id);
          if (tokenMatch && tokenMatch.icon && tokenMatch.icon !== genericTokenIcon) {
            // Use the icon from tokenList
            console.log(`Updating icon for ${node.id} from tokenList`);
            node.icon = tokenMatch.icon;
            node.originalIcon = tokenMatch.icon;
          }
        }
      });
    }
    return nodes;
  };

  // Get transactions from the database
  // if latest, or the time range is 0, get the latest
  async function getTransactions(dataSourceParam, search, latest, newStartDate, newEndDate, userID, txDataOverride)
  {
    try {
      const getTransactionsRunId = ++getTransactionsRunIdRef.current;
      console.log(`[getTransactions #${getTransactionsRunId}] begin`);

      setIsLoading(true);
      
      // Special handling for token view - prioritize colorful icons
      const isTokenView = filterToken && !organicLayout;

      // Replace the Etherscan API call with a call to your backend endpoint
      let limit = 5000;
      if (maxTransactions !== "") {
        let userLimit = parseInt(maxTransactions);
        if (userLimit > 0 && userLimit <= 1000000) {
          limit = userLimit;
        }
      }

        // Preserve existing positions
      const existingPositions = new Map();
      if (graphData.nodes && graphData.nodes.length) {
        graphData.nodes.forEach(node => {
          existingPositions.set(node.id, { x: node.x, y: node.y, z: node.z });
        });
      }

      let startDate = newStartDate ? newStartDate : (latest) ? 0 : dateRange.startDate;
      let endDate = newEndDate ? newEndDate : (latest) ? 0 : rangeInterval;
      const hasExplicitTimeRange = Number(newStartDate) > 0 && Number(newEndDate) > 0;
      
      // we can use params like this: a,b,c,d

    
      let params = "";
      // Note: userTransactions controls client-side node rendering (wallet nodes),
      // but we do NOT send "Users" to the backend — the default cache is correct
      // for the /graphs view and has the proper txType + icon filters applied.

      // always add users. decide whether to use them in the app
      //let params = "Users";

      // If caller explicitly passed 0/0 and we are on a specific links/token
      // address route (e.g. /links/0x..., /token/0x...), use a 1-week window
      // ending at "now" so deep dives have enough context.
      /*
      if (!search) {
        const pathForTx = (location && typeof location.pathname === 'string') ? location.pathname : '';
        if (newStartDate === 0 && newEndDate === 0 && pathForTx) {
          const segs = pathForTx.split('/').filter(Boolean); // ['links','0x...'] or ['token','0x...']
          if (segs.length >= 2 && (segs[0] === 'links' || segs[0] === 'token') && segs[1].startsWith('0x')) {
            const nowSec = Math.floor(Date.now() / 1000);
            endDate = nowSec;
            startDate = nowSec - 7 * 24 * 60 * 60; // last 7 days
          }
        }
      }

      // For explicit search queries, always restrict the backend window to the
      // last 24 hours from "now" so address/token searches are focused on
      // recent activity regardless of the current UI range.
      /*
      if (search && search !== "") {
        const nowSec = Math.floor(Date.now() / 1000);
        endDate = nowSec;
        startDate = nowSec - 24 * 60 * 60; // last 24 hours
      }
      */

      if (!useTime && (!search || search === "") && !hasExplicitTimeRange) {
        startDate = 0;
        endDate = 0;
        if (params.length) { params += ","; }
        params += "IgnoreTime";
      }
      

      if (filterNFTOnly) {
        if (params.length) { params += ","; }
        params += "FilterNFT";
      }
      
      if (filterNewOnly) {
        if (params.length) { params += ","; }
        params += "FilterNewOnly";
      }

      /*
      if (filterToken) {
        if (params.length) { params += ","; }
        params += "FilterToken";
      }
      */
    
      if (filterValue) {
        if (params.length) { params += ","; }
        params += "FilterValue";
      }

      if (allLikesFilter) {
        if (params.length) { params += ","; }
        params += "AllLikesFilter";
      }

      if (myLikesFilter) {
        if (params.length) { params += ","; }
        params += "MyLikesFilter";
      }

      if (!search || search === "") {
        search = searchText;
      }

      if (search && search.startsWith("0x")) {
        // Historically we ignore time for direct address searches, but when the
        // user explicitly selected a date/time range (e.g. via /links picker),
        // we should honor it.
        const shouldIgnoreTimeForSearch = !(
          location &&
          location.pathname &&
          location.pathname.startsWith('/graphs') &&
          hasExplicitTimeRange
        );
        if (shouldIgnoreTimeForSearch) {
          if (params.length) { params += ","; }
          params += "IgnoreTime";
        }
      }

      let tokens;

      if ((!filterNFTOnly && !filterNewOnly) && (!search || search == "")) {
        const tokenType = filterNFT ? 'NFT' : 'Token';

        // On /graphs, the token list is helpful for icon enrichment but not
        // required to render the initial graph. Defer that fetch so the graph
        // can start loading immediately, then reconcile the metadata in the
        // background.
        const shouldDeferTokenList = location.pathname.startsWith('/graphs');

        // On the /price route, we already load a specialized token list with
        // all-range price history. Avoid overwriting that tokenList here; we
        // only need this call to compute the E3D token price.
        const setItForThisCall = !location.pathname.startsWith('/price');

        if (shouldDeferTokenList) {
          if (tokenList && tokenList.length) {
            const e3dToken = tokenList.find(token => token.id === "0x6488861b401f427d13b6619c77c297366bcf6386");
            if (e3dToken) {
              setE3dPrice(e3dToken.price);
            }
          } else {
            void getTokenList(dataSourceParam, "", setItForThisCall, tokenType, userID, undefined, getTransactionsRunId)
              .then((backgroundTokens) => {
                if (!backgroundTokens || getTransactionsRunIdRef.current !== getTransactionsRunId) {
                  return;
                }
                const e3dToken = backgroundTokens.find(token => token.id === "0x6488861b401f427d13b6619c77c297366bcf6386");
                if (e3dToken) {
                  setE3dPrice(e3dToken.price);
                }
              })
              .catch((error) => {
                console.error('[getTransactions] background token list fetch failed:', error);
              });
          }
        } else {
          tokens = await getTokenList(dataSourceParam, "", setItForThisCall, tokenType, userID, undefined, getTransactionsRunId);

          if (tokens && tokens.length) {
            const e3dToken = tokens.find(token => token.id === "0x6488861b401f427d13b6619c77c297366bcf6386");
            if (e3dToken) {
              setE3dPrice(e3dToken.price);
            }
          }
        }
      }

      let response;
      let txData;

      if (txDataOverride && Array.isArray(txDataOverride)) {
        txData = txDataOverride;
      } else if (!filterNFT) {
        const fetchTransactionsStartedAt = performance.now();
        console.log(`[getTransactions #${getTransactionsRunId}] [fetchTransactionsDB] start`, {
          dataSource: dataSourceParam,
          limit,
          startTime: startDate,
          endTime: endDate,
          search,
          pathname: location.pathname,
        });
        try {
          response = await axios.get(`${SERVER_NAME}/fetchTransactionsDB/`, {
            params: {
              dataSource: dataSourceParam,
              limit: limit,
              startTime: startDate,
              endTime: endDate,
              search: search,
              params: params,
              userID: userID
            },
          });
          console.log(`[getTransactions #${getTransactionsRunId}] [fetchTransactionsDB] finished in ${Math.round(performance.now() - fetchTransactionsStartedAt)}ms`, {
            count: Array.isArray(response.data) ? response.data.length : 0,
          });
        } catch (error) {
          console.log(`[getTransactions #${getTransactionsRunId}] [fetchTransactionsDB] failed in ${Math.round(performance.now() - fetchTransactionsStartedAt)}ms`, error);
          throw error;
        }
        txData = response.data;
      }
      else {
        txData = tokens;
      }

      if (!txData || txData.length == 0) {
        const emptyGraph = { nodes: [], links: [] };
        setLinkCount(new Map());
        setTransactions([]);
        setGraphData(emptyGraph);
        setIsDataReady(true);
        setIsLoading(false);
        setIsFirstLoad(false);
        return emptyGraph;
      }

      if (isMobile && organicLayout) {
        txData.sort((a, b) => {
          if (a.toIcon !== '' && b.toIcon === '') {
            return -1;
          }
          if (a.toIcon === '' && b.toIcon !== '') {
            return 1;
          }
          return 0;
        });
        
        let sliceSize = 2000;
        if (maxNodes > 0) {
          sliceSize = maxNodes;
        }
        // take slice 
        if (txData.length > sliceSize) {
          txData = txData.slice(0, sliceSize);
        }
      }

      if (!isMobile) {
        const filteredChartData = createFilteredVolumeChartData(txData);
        setChartData(filteredChartData);
      }

      // Step 1: Find the smallest and largest timestamps
      let minTimestamp = Infinity;
      let maxTimestamp = -Infinity;

      txData.forEach(tx => {
        const timestamp = convertUTCToLocalAsTimestamp(tx.timestamp);
        if (timestamp < minTimestamp) minTimestamp = timestamp;
        if (timestamp > maxTimestamp) maxTimestamp = timestamp;
      });

      // For /links without an address, always rely on the backend cached
      // window and then apply the selected time-range (1M/5M/10M) purely on
      // the client by trimming txData to a trailing window. If
      // rangeSelectedOverrideRef has been set by a recent interval change,
      // prefer that value for this run so we don't use a stale selection.
      if (
        !txDataOverride &&
        location.pathname.startsWith('/graphs') &&
        !hasLinksAddress &&
        !isLinksHistoricalRangeActive &&
        Number.isFinite(maxTimestamp) &&
        Number.isFinite(minTimestamp) &&
        (!search || search == "")
      ) {
        const effectiveRange = rangeSelectedOverrideRef.current || rangeSelected;
        rangeSelectedOverrideRef.current = null;
        let windowMinutes = 0;
        if (effectiveRange === '1M') windowMinutes = 1;
        else if (effectiveRange === '2M') windowMinutes = 2;
        else if (effectiveRange === '5M') windowMinutes = 5;
        else if (effectiveRange === '10M') windowMinutes = 10;

        if (windowMinutes > 0) {
          const cutoff = maxTimestamp - windowMinutes * 60;
          txData = txData.filter(tx => {
            const ts = convertUTCToLocalAsTimestamp(tx.timestamp);
            return ts >= cutoff;
          });

          // Recompute min/max based on the trimmed set so downstream
          // consumers see the effective window.
          minTimestamp = Infinity;
          maxTimestamp = -Infinity;
          txData.forEach(tx => {
            const ts = convertUTCToLocalAsTimestamp(tx.timestamp);
            if (ts < minTimestamp) minTimestamp = ts;
            if (ts > maxTimestamp) maxTimestamp = ts;
          });
        }
      }

      if (minTimestamp !== Infinity && maxTimestamp !== -Infinity) {
        console.debug('getTransactions window:', {
          txCount: txData.length,
          minTimestamp,
          maxTimestamp,
          minLocal: new Date(minTimestamp * 1000).toISOString(),
          maxLocal: new Date(maxTimestamp * 1000).toISOString(),
        });
      } else {
        console.debug('getTransactions window: no timestamps found', {
          txCount: txData.length,
        });
      }

      setDateRange({ startDate: minTimestamp, endDate: maxTimestamp });

      // Step 2: Normalize the timestamps and initialize volume arrays
      const range2 = maxTimestamp - minTimestamp;

      const nodeVolumes = new Map();
      
      // Step 3: Update the volume arrays
      txData.forEach(tx => {
        if (!nodeVolumes.has(tx.from)) {
          nodeVolumes.set(tx.from, new Array(sparkLength).fill(0));
        }
        if (!nodeVolumes.has(tx.to)) {
          nodeVolumes.set(tx.to, new Array(sparkLength).fill(0));
        }
      });
      
      // Step 3: Update the volume arrays
      //txData.filter(tx => (tx.txType != '1' && tx.txType != '2')).forEach(tx => {
      txData.forEach(tx => {
        const normalizedIndex = Math.floor(((convertUTCToLocalAsTimestamp(tx.timestamp) - minTimestamp) / range2) * sparkLength - 1); 
        // Increment the 'from' node's volume
        nodeVolumes.get(tx.from)[normalizedIndex]++;
        // Increment the 'to' node's volume
        nodeVolumes.get(tx.to)[normalizedIndex]++;
      });

      const linkCount = new Map();
      const newNodes = [];
      const newLinks = [];
      const newTransactions = [];

      let maxValueTracker = 0;

      txData.forEach(tx => {
        const from = tx.from;
        const to = tx.to;
        const hash = tx.txHash;

        if (from != null && to != null && hash != null) {      
          let toIcon = "";
          let shortTo = tx.toName && tx.toName !== `null` ? tx.toName : formatShortAddress(to);

          if (tx.toIcon && tx.toIcon.startsWith("{")) {
            const toIconData = safeParseJSON(tx.toIcon);
            toIcon = toIconData.image;
            shortTo = toIconData.name;
          }
          else if (tx.toIcon && tx.toIcon.startsWith("data:image/svg+xml;base64,")) {
            toIcon = tx.toIcon;
            shortTo = "NFT";
          } 
          else if (tx.toIcon && tx.toIcon.length) {
            toIcon = tx.toIcon;
          }
          else
          {
            toIcon = tx.toName && tx.toName.includes('.eth') ? genericUserIcon : (tx.toName) ? genericTokenIcon : "";
          }

          let fromIcon = "";
          let shortFrom = tx.fromName && tx.fromName !== `null` ? tx.fromName : formatShortAddress(from);

          if (tx.fromIcon && tx.fromIcon.startsWith("{")) {
            const fromIconData = safeParseJSON(tx.fromIcon);
            fromIcon = fromIconData.image;
            shortFrom = fromIconData.name;
          }
          else if (tx.fromIcon && tx.fromIcon.startsWith("data:image/svg+xml;base64,")) {
            fromIcon = tx.fromIcon;
            shortFrom = "NFT";
          } 
          else if (tx.fromIcon && tx.fromIcon.length) {
            fromIcon = tx.fromIcon;
          }
          else
          {
            fromIcon = tx.fromName && tx.fromName.includes('.eth') ? genericUserIcon : (tx.fromName) ? genericTokenIcon : "";
          }

          // Define the substrings to remove
          const substringsToRemove = ['.eth', '.nft'];
          shortTo = removeSubstrings(shortTo, substringsToRemove);
          shortFrom = removeSubstrings(shortFrom, substringsToRemove);

          const txTo = to;
          if (txTo.includes('.')) {
              const tokenId = txTo.split('.')[1];
              if (!shortTo.includes(tokenId)) {
                shortTo += " (#" + tokenId + ")";
              }
          }

          const txFrom = from;
          if (txFrom.includes('.')) {
              const tokenId = txFrom.split('.')[1];
              if (!shortFrom.includes(tokenId)) {
                shortFrom += " (#" + tokenId + ")";
              }
          } 
          
          const fromIsToken = shortFrom.startsWith('0x') ? false : true;
          const fromAddress = from;
          const fromIsFirst = newNodes.some(node => node.id === fromAddress) ? false : true;
          if (fromAddress && fromAddress.length && (userTransactions || fromIsToken) && fromIsFirst) {
            //const price = tx[`fromPriceUSD`];
            if (organicLayout) {
              newNodes.push({
                id: fromAddress,
                label: shortFrom,
                group: 1,
                events: 0,
                color: 0x1E90FF,   // dodger blue
                value: 0,
                icon: fromIcon,
                volume: nodeVolumes.get(tx.from),
                symbol: tx.fromSymbol,
                //price: price,
                //cap: tx[`fromCapUSD`],
              });
            }
            else {
              newNodes.push({
                id: fromAddress,
                label: shortFrom,
                group: 1,
                events: 0,
                color: 0x1E90FF,   // dodger blue
                value: 0,
                icon: fromIcon,
                x: 0,
                y: 0,
                z: 0,
                fx: 0,
                fy: 0,
                fz: 0,
                volume: nodeVolumes.get(fromAddress),
                symbol: tx.fromSymbol,
                //price: price,
                //cap: tx[`fromCapUSD`],
              });
            }
          }
      
          const toIsToken = shortTo.startsWith('0x') ? false : true;
          const toAddress = to;
          const toIsFirst = newNodes.some(node => node.id === toAddress) ? false : true;
          if (toAddress && toAddress.length && (userTransactions || toIsToken) && toIsFirst) {
              //const price = tx[`toPriceUSD`];
            if (organicLayout) {
              newNodes.push({
                id: toAddress,
                label: shortTo,
                group: 2,
                events: 0,
                color: 0x32CD32,   // lime green
                value: 0,
                icon: toIcon,
                volume: nodeVolumes.get(toAddress),
                symbol: tx.toSymbol,
              });
            }
            else {
              //console.log(`addTokenToGraphData::SetGraphData begin...`);
              const nodeExists = newNodes.some(node => node.id === toAddress);

              if (!nodeExists) {
                // Check if the address is properly formatted (starts with 0x and has expected length)
                const isFormattedAddress = toAddress && toAddress.startsWith('0x') && toAddress.length >= 42;
                if (isFormattedAddress) {
                  newNodes.push({
                    id: toAddress,
                    label: shortTo,
                    group: 2,
                    events: 0,
                    color: 0x32CD32,   // lime green
                    value: 0,
                    icon: toIcon,
                    x: 0,
                    y: 0,
                    z: 0,
                    fx: 0,
                    fy: 0,
                    fz: 0,
                    volume: nodeVolumes.get(to),
                    symbol: tx.toSymbol,
                    //price: price,
                    //cap: tx[`toCapUSD`],
                  });
                } else {
                  newNodes.push({
                    id: toAddress,
                    label: shortTo,
                    group: 2,
                    events: 0,
                    color: 0x32CD32,   // lime green
                    value: 0,
                    icon: toIcon,
                    x: 0,
                    y: 0,
                    z: 0,
                    fx: 0,
                    fy: 0,
                    fz: 0,
                    volume: nodeVolumes.get(to),
                    symbol: tx.toSymbol,
                    //price: price,
                    //cap: tx[`toCapUSD`],
                  });
                }
              }
            }
          }
      
          const etherValueWei = tx.value;
          const etherGasWei = tx.gasLimit;
          const txType = tx.txType;

          if (toAddress && fromAddress && toAddress.length && fromAddress.length) {
            if ((toIsToken && fromIsToken) || userTransactions) {
              newLinks.push({
                txType: txType,
                timestamp: tx.timestamp,
                blockNumber: tx.blockNumber,
                tx: hash,
                source: fromAddress,
                target: toAddress,
                fromIcon: fromIcon,
                toIcon: toIcon,
                gasLimit: etherGasWei,
                value: etherValueWei,
                gasUsed: tx.gasUsed,
                gasPrice: tx.gasPrice
              });
            }

            if (tx.txType !== 0) {
              newTransactions.push({
                txType: txType,
                timestamp: tx.timestamp,
                blockNumber: tx.blockNumber,
                tx: hash,
                source: fromAddress,
                target: toAddress,
                fromIcon: fromIcon,
                toIcon: toIcon,
                gasLimit: etherGasWei,
                value: etherValueWei,
                gasUsed: tx.gasUsed,
                gasPrice: tx.gasPrice
              });
            }
          }

          if (fromAddress && fromAddress.length) {
            linkCount.set(fromAddress, (linkCount.get(fromAddress) || 0) + 1);
          }

          if (toAddress && toAddress.length) {
            linkCount.set(toAddress, (linkCount.get(toAddress) || 0) + 1);
          }

          if (etherValueWei > maxValueTracker) {
            maxValueTracker = etherValueWei;
          }

        }
      });        

      if (filterNFTOnly || filterNewOnly) {
        const tokens = createTokenList(newNodes, 'Token', dataSourceParam);
        setTokenList(tokens);
      }
        
      // Skip position merge when a fresh simulation was requested (mode/range switch).
      // Merging old positions — especially fx/fy/fz which pin nodes — would prevent
      // the force simulation from running organically from scratch.
      if (existingPositions.size && !stripNodePositionsNextRenderRef.current) {
        // Before finalizing newNodes, merge in existing positions
        newNodes.forEach(node => {
          if (existingPositions.has(node.id)) {
            const { x, y, z } = existingPositions.get(node.id);
            node.x = x;
            node.y = y;
            node.z = z;
            node.fx = x;
            node.fy = y;
            node.fz = z;
          }
          else {
            node.x = node.x || 0;
            node.y = node.y || 0;
            node.z = node.z || 0;
          }
        });
      }

      newLinks.sort((a, b) => a.timestamp - b.timestamp);
      newNodes.sort((a, b) => {
        if (a.label > b.label) {
            return -1;
        }
        if (a.label < b.label) {
            return 1;
        }
        return 0;
      });

      // In Stories mode on /links, filter nodes and links to only those
      // involving story addresses so the graph shows story-relevant activity.
      if (location.pathname.startsWith('/graphs') && linksDataModeRef.current === 'stories') {
        const storySet = new Set((storyAddressesRef.current || []).map(a => String(a).toLowerCase()));
        if (storySet.size > 0) {
          // Keep only links where at least one endpoint is a story address
          const filteredLinks = newLinks.filter(link => {
            const src = String(link.source || '').toLowerCase();
            const tgt = String(link.target || '').toLowerCase();
            return storySet.has(src) || storySet.has(tgt);
          });
          // Keep only nodes that appear in the filtered links
          const linkedIds = new Set();
          filteredLinks.forEach(link => {
            linkedIds.add(String(link.source || '').toLowerCase());
            linkedIds.add(String(link.target || '').toLowerCase());
          });
          const filteredNodes = newNodes.filter(n => linkedIds.has(String(n.id || '').toLowerCase()));
          newLinks.length = 0;
          filteredLinks.forEach(l => newLinks.push(l));
          newNodes.length = 0;
          filteredNodes.forEach(n => newNodes.push(n));
          // Recompute linkCount for filtered nodes
          linkCount.clear();
          filteredLinks.forEach(link => {
            const src = String(link.source || '').toLowerCase();
            const tgt = String(link.target || '').toLowerCase();
            linkCount.set(src, (linkCount.get(src) || 0) + 1);
            linkCount.set(tgt, (linkCount.get(tgt) || 0) + 1);
          });
        }
      }

      // In Watchlist mode on /graphs, filter nodes and links to only those
      // involving watchlisted addresses.
      if (location.pathname.startsWith('/graphs') && linksDataModeRef.current === 'watchlist') {
        const watchSet = new Set((watchlistAddressesRef.current || []).map(a => String(a).toLowerCase()));
        if (watchSet.size > 0) {
          // Watchlist mode should show ONLY the watchlisted addresses themselves.
          // Do not include neighbor nodes.
          const filteredNodes = newNodes.filter(n => watchSet.has(String(n.id || '').toLowerCase()));
          const filteredLinks = newLinks.filter(link => {
            const src = String(link.source || '').toLowerCase();
            const tgt = String(link.target || '').toLowerCase();
            return watchSet.has(src) && watchSet.has(tgt);
          });
          newLinks.length = 0;
          filteredLinks.forEach(l => newLinks.push(l));
          newNodes.length = 0;
          filteredNodes.forEach(n => newNodes.push(n));
          linkCount.clear();
          filteredLinks.forEach(link => {
            const src = String(link.source || '').toLowerCase();
            const tgt = String(link.target || '').toLowerCase();
            linkCount.set(src, (linkCount.get(src) || 0) + 1);
            linkCount.set(tgt, (linkCount.get(tgt) || 0) + 1);
          });

          // Sync the token list UI to the watchlist-filtered nodes so /links
          // doesn't continue displaying the full DB token list.
          try {
            const watchTokenList = createTokenList(filteredNodes, 'Token', dataSourceParam);
            if (watchTokenList && watchTokenList.length >= 0) {
              setTokenList(watchTokenList);
            }
          } catch (e) {
          }
        }
      }

      setLinkCount(linkCount);
      setTransactions(newTransactions)
      setIsDataReady(true);

      // First set link counts
      newNodes.forEach(node => {
        node.linkCount = linkCount.get(node.id) || 0;
      });

      setTokenData(null);
      layoutManager.saveOriginalLocations(graphData.nodes);

      const enhancedNodes = ensureTokenIcons(newNodes);
      let finalNodes = enhancedNodes;
      // If a mode/range switch requested fresh positions, strip x/y/z so the
      // force simulation starts from scratch instead of reusing stale positions.
      if (stripNodePositionsNextRenderRef.current) {
        stripNodePositionsNextRenderRef.current = false;
        finalNodes = enhancedNodes.map((n) => {
          if (!n) return n;
          const { x: _x, y: _y, z: _z, vx: _vx, vy: _vy, vz: _vz, ...rest } = n;
          return rest;
        });
      }
      const newGraphData = { nodes: finalNodes, links: newLinks };
      const classifiedGraphData = classifyGraphNodes(newGraphData);
      setGraphData(classifiedGraphData);

      // For token view, ensure icons are properly updated
      if (filterToken && !organicLayout && tokenList.length > 0) {
        // Use setTimeout to ensure this happens after graph data is set
        setTimeout(() => fixTokenGraphIcons(), 100);
      }

      setIsLoading(false);
      setIsFirstLoad(false);
      console.log(`SetGraphData end.`);

      // IPFS enrichment is intentionally skipped on /graphs because rewriting
      // graph state after the first render can retrigger the force layout and
      // break the connected structure. The faster first paint is preserved by
      // deferring the token-list fetch above.
      if (!location.pathname.startsWith('/graphs')) {
        void (async () => {
          try {
            console.log('Starting IPFS enrichment for nodes...');
            const ipfsNodes = finalNodes.map((node) => (node ? { ...node } : node));
            for (const node of ipfsNodes) {
              await enrichNodeFromIPFS(node);
            }
            console.log('IPFS enrichment complete for all nodes');

            if (getTransactionsRunIdRef.current !== getTransactionsRunId) {
              return;
            }

            const enrichedGraphData = classifyGraphNodes({ nodes: ipfsNodes, links: newLinks });
            setGraphData(enrichedGraphData);
          } catch (error) {
            console.error('Error during background IPFS enrichment:', error);
          }
        })();
      }

      // On /links, cache the graph-node-derived token list so it can be
      // restored when the user switches back to Transactions mode from
      // Price/Volatility/MktCap. Do NOT call setTokenList here — the tokenList
      // is already set correctly by getTokenList() earlier in this function.
      if (location.pathname.startsWith('/graphs') && finalNodes && finalNodes.length > 0) {
        const txTokenList = createTokenList(finalNodes, 'Token', dataSourceParam);
        if (txTokenList && txTokenList.length > 0) {
          linksTransactionTokenListRef.current = txTokenList;
        }
      }

      console.log(`[getTransactions #${getTransactionsRunId}] end`);
      return classifiedGraphData;

    } catch (error) {
      console.error("Error fetching transactions from backend:", error);

      // Ensure the UI does not spin forever on errors or timeouts. Surface a
      // clean "No data" state by marking data as ready and setting an empty
      // graph, which triggers the existing isDataReady && !nodes.length check.
      const emptyGraph = { nodes: [], links: [] };
      setLinkCount(new Map());
      setTransactions([]);
      setGraphData(emptyGraph);
      setIsDataReady(true);
      setIsLoading(false);
      setIsFirstLoad(false);
      return emptyGraph;
    }
  }

 
  const [searchTrigger, setSearchTrigger] = useState(false);

  // Debug helper: track how tokenView and viewGraph evolve across route
  // changes so we can reason about /links vs /token behavior in terms of
  // committed React state rather than transient values inside effects.
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.log('Route state:', {
      path: location.pathname,
      tokenView,
      viewGraph,
      filterToken,
      filterNFT,
    });
  }, [location.pathname, tokenView, viewGraph, filterToken, filterNFT]);

  useEffect(() => {
    if (isMobile) {
      setSpinCamera(false);
    }
  }, [isMobile]);
  
  // The layoutManager will automatically receive the current graphViewMode through its constructor
  // and props passed to GraphLayoutPanel

  useEffect(() => {
    if (searchTrigger) {
      setSearchTrigger(false);
      handleSearchFromDialogCallback();
    }
  }, [searchTrigger]);

  
  const handleSearchFromDialog = (searchTextParam) => {
    setShowSearchDialog(false);
    if (location.pathname.startsWith('/price')) {
      const raw = String(searchTextParam || '').trim();
      if (priceSearchDebounceRef.current) clearTimeout(priceSearchDebounceRef.current);
      setPriceSearchText(raw);
      resetAndLoadPriceList({ sortBy: priceListSortBy, sortDir: priceListSortDir, searchOverride: raw });
    } else {
      handleSearchFromDialogCallback(searchTextParam);
    }
  }

  const handleSearchFromDialogCallback = (searchOverride) => { 
    const searchTextLower = String((typeof searchOverride === 'string' ? searchOverride : searchText) || '').toLowerCase();
    console.log('Searching for:', searchTextLower);

    const isIPv4Query = /^\d{1,3}(?:\.\d{1,3}){3}$/.test(searchTextLower);
    const isIPv6Query = /^[0-9a-f:]+$/.test(searchTextLower) && searchTextLower.includes(':');
    const isPcapExactQuery = dataSource === PCAP && (isIPv4Query || isIPv6Query);

    const zoomToFoundNode = (nodeId) => {
      try {
        if (!graphRef || !graphRef.current) return;
        suppressAutoFitUntilRef.current = Date.now() + 2500;
        const gd = typeof graphRef.current.graphData === 'function' ? graphRef.current.graphData() : null;
        const nodes = gd && Array.isArray(gd.nodes) ? gd.nodes : (graphData && Array.isArray(graphData.nodes) ? graphData.nodes : []);
        const node = (nodes || []).find((n) => n && n.id === nodeId);
        if (!node) return;

        if (is3DMode && typeof graphRef.current.cameraPosition === 'function') {
          // Smaller distRatio => closer zoom.
          const distRatio = 0.75;
          graphRef.current.cameraPosition(
            { x: node.x * distRatio, y: node.y * distRatio, z: node.z * distRatio },
            node,
            450
          );
          return;
        }

        if (typeof graphRef.current.centerAt === 'function') {
          graphRef.current.centerAt(node.x, node.y, 350);
        }
        if (typeof graphRef.current.zoom === 'function') {
          graphRef.current.zoom(20, 350);
        }
      } catch (e) {
      }
    };

    if (!nodeListRef.current) {
      console.log('No rows available');
      return;
    }

    // Get the sorted rows from NodeLists
    const sortedRows = nodeListRef.current.getSortedRows();
    if (!sortedRows || !sortedRows.length) {
      console.log('No rows available');
      return;
    }

    // Find current index in sorted rows
    const currentIndex = activeNodeId ? sortedRows.findIndex(row => row.original.id === activeNodeId) : -1;
    const startIndex = currentIndex === -1 ? 0 : currentIndex;
    console.log('Starting search from index:', startIndex);

    // Search function that checks if a token matches the search criteria
    const matchesSearch = (row) => {
      const token = row.original;
      const idLower = token && token.id ? String(token.id).toLowerCase() : '';
      // For hex addresses, require exact match
      if (searchTextLower.startsWith('0x')) {
        return idLower === searchTextLower;
      }
      
      // For text search, check if any part matches
      const label = token.label ? token.label.toLowerCase() : '';
      const symbol = token.symbol ? token.symbol.toLowerCase() : '';
      // PCAP: search should match either the friendly name (label) OR the raw
      // address/ip (id), since there is no backend DB search.
      if (dataSource === PCAP) {
        if (isPcapExactQuery) {
          return idLower === searchTextLower || label === searchTextLower || symbol === searchTextLower;
        }
        return idLower.includes(searchTextLower) || label.includes(searchTextLower) || symbol.includes(searchTextLower);
      }
      
      // Check if search term appears anywhere in the label or symbol
      return label.includes(searchTextLower) || symbol.includes(searchTextLower);
    };

    const handleFoundNode = (nodeId, tokenType) => {
      // First update the graph (this might trigger re-renders)
      // In PCAP mode, avoid handleNodeClick camera animations (moveToNode)
      // which can override the explicit search zoom.
      handleNodeClick(dataSource, graphData, graphRef, nodeId, dataSource === PCAP ? false : true, tokenType);
      
      // Then after the graph update, set active node and scroll
      requestAnimationFrame(() => {
        setActiveNodeId(nodeId);
        if (nodeListRef.current) {
          nodeListRef.current.scrollToActiveNode(nodeId);
        }
        zoomToFoundNode(nodeId);
      });
    };

    // First, search from current position to end
    for (let i = startIndex + 1; i < sortedRows.length; i++) {
      if (matchesSearch(sortedRows[i])) {
        const tokenType = filterNFT ? 'NFT' : 'Token';
        handleFoundNode(sortedRows[i].original.id, tokenType);
        return;
      }
    }

    // If not found after current position, search from beginning up to current position
    for (let i = 0; i <= startIndex; i++) {
      if (matchesSearch(sortedRows[i])) {
        const tokenType = filterNFT ? 'NFT' : 'Token';
        handleFoundNode(sortedRows[i].original.id, tokenType);
        return;
      }
    }

    console.log('No matches found');
  };

  const restoreOriginalGraph = () => {
    if (originalGraphData) {
      setGraphData(originalGraphData);
      setOriginalGraphData(null);
    }
  };

  const parseCSVData = (file, graphData) => {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const contents = e.target.result;

        // Parsing the CSV data
        Papa.parse(contents, {
          header: true,
          dynamicTyping: true,
          complete: (results) => {
            const newData = csvToGraphData(results.data, graphData);
            resolve(newData);
          },
        });
      };
      reader.readAsText(file);
    });
  };


  const loadCSVData = useCallback(async () => {
    const response = await fetch(fileUrl);
    const text = await response.text();

    return new Promise((resolve) => {
      Papa.parse(text, {
        header: true,
        dynamicTyping: true,
        complete: (results) => {
          resolve(results.data);
        },
      });
    });
  }, [fileUrl]);

  useEffect(() => {
    const fetchData = async () => {
      resetGraph();
      setIsLoading(true);
      const csvData = await loadCSVData();
      const graphData = csvToGraphData(csvData);
      setGraphData(classifyGraphNodes(graphData));
      setIsLoading(false);
    };
    if (fileUrl != null) {
      fetchData();
    }
  }, [loadCSVData]);


  const csvToGraphData = (csvData, existingData = { nodes: [], links: [] }) => {
    const nodesSet = new Set(existingData.nodes.map((n) => n.id));
    const nodes = [...existingData.nodes];
    const links = [...existingData.links];
    const linkCount = new Map();
    const linkMap = new Map();
    const neighborMap = new Map();
    let pcapPortsDebugCount = 0;

    const macRegex = /^([0-9A-Fa-f]{2}([:-])){5}[0-9A-Fa-f]{2}$/;

    csvData.forEach((row) => {
      const clientAddr = getField(row, ['Client Addr', 'src', 'Src', 'source', 'Source']);
      const serverAddr = getField(row, ['Server Addr', 'dst', 'Dst', 'target', 'Target']);
      if (clientAddr && serverAddr) {
        const clientMacRaw = getField(row, ['Client MAC', 'client_mac', 'ClientMac', 'src mac', 'Src MAC', 'src_mac']);
        const serverMacRaw = getField(row, ['Server MAC', 'server_mac', 'ServerMac', 'dst mac', 'Dst MAC', 'dst_mac']);
        const clientMac = clientMacRaw != null ? String(clientMacRaw).trim() : '';
        const serverMac = serverMacRaw != null ? String(serverMacRaw).trim() : '';
        const clientPortRaw = getField(row, ['Client Port', 'client_port', 'ClientPort', 'src port', 'Src Port', 'src_port']);
        const serverPortRaw = getField(row, ['Server Port', 'server_port', 'ServerPort', 'dst port', 'Dst Port', 'dst_port']);
        const clientPort = toPortString(clientPortRaw);
        const serverPort = toPortString(serverPortRaw);
        const clientBytes = toNumber(getField(row, ['Client Bytes', 'tx bytes', 'tx_bytes', 'Tx Bytes', 'TX Bytes', 'tx']));
        const serverBytes = toNumber(getField(row, ['Server Bytes', 'rx bytes', 'rx_bytes', 'Rx Bytes', 'RX Bytes', 'rx']));

        let totalBytes = clientBytes + serverBytes;
        if (isNaN(totalBytes)) {
          totalBytes = toNumber(getField(row, ['Bytes', 'bytes']));
        }
        const clientEvents = getField(row, ['Events', 'events']);

        if (!nodesSet.has(clientAddr)) {
          let clientColor = mapData.has(clientAddr) ? mapData.get(clientAddr).color : 0x1E90FF; // Dodger Blue
          if (mapData.has(clientAddr) && mapData.get(clientAddr).trust === "Untrusted") {
            clientColor = 0xFF6347; // Tomato
          }
          nodes.push({ 
            id: clientAddr, 
            label: clientAddr, 
            symbol: clientAddr,
            color: clientColor, 
            events: clientEvents, 
            sentBytes: clientBytes, 
            receivedBytes: serverBytes, 
            totalBytes: totalBytes, 
            linkCount: 1
          });
          nodesSet.add(clientAddr);
        }
        else {
          const node = nodes.find(n => n.id === clientAddr);
          node.sentBytes += clientBytes;
          node.receivedBytes += serverBytes;
          node.totalBytes += totalBytes;
          node.linkCount = (node.linkCount || 0) + 1;
        }

        if (!nodesSet.has(serverAddr)) {
          let serverColor = mapData.has(serverAddr) ? mapData.get(serverAddr).color : 0x32CD32; // Lime Green
          if (mapData.has(serverAddr) && mapData.get(serverAddr).trust === "Untrusted") {
            serverColor = 0xFF4500; // Orange Red
          }
          nodes.push({ 
            id: serverAddr, 
            label: serverAddr, 
            symbol: serverAddr,
            color: serverColor, 
            events: 0, 
            sentBytes: serverBytes, 
            receivedBytes: clientBytes, 
            totalBytes: totalBytes,
            linkCount: 1 
          });
          nodesSet.add(serverAddr);
        }
        else {
          const node = nodes.find(n => n.id === serverAddr);
          node.sentBytes += serverBytes;
          node.receivedBytes += clientBytes;
          node.totalBytes += totalBytes;
          node.linkCount = (node.linkCount || 0) + 1;
        }

        const addMacNode = (mac) => {
          const m = String(mac || '').trim();
          if (!m || !macRegex.test(m)) return;
          if (nodesSet.has(m)) return;
          nodes.push({
            id: m,
            label: m,
            symbol: m,
            color: 0x999999,
            events: 0,
            sentBytes: 0,
            receivedBytes: 0,
            totalBytes: 0,
            linkCount: 0,
            metaType: 'pcap_mac',
          });
          nodesSet.add(m);
        };

        const linkMacToIp = (mac, ip) => {
          const m = String(mac || '').trim();
          const i = String(ip || '').trim();
          if (!m || !i) return;
          if (!macRegex.test(m)) return;
          // Avoid creating MAC↔MAC helper links when the endpoint itself is a MAC (L2 rows).
          if (macRegex.test(i)) return;
          const key = `${m}↔${i}`;
          const existing = linkMap.get(key);
          if (existing) {
            existing.packets = (existing.packets || 0) + Math.floor(toNumber(getField(row, ['Packets', 'packets'])));
          } else {
            const linkObj = {
              id: `mac:${m}->ip:${i}`,
              source: m,
              target: i,
              value: 0,
              gas: 0,
              metaType: 'pcap_mac',
              pcapDir: 'mac',
              packets: Math.floor(toNumber(getField(row, ['Packets', 'packets']))),
              curvature: 0,
            };
            linkMap.set(key, linkObj);
            links.push(linkObj);
          }
          if (!neighborMap.has(m)) neighborMap.set(m, new Set());
          if (!neighborMap.has(i)) neighborMap.set(i, new Set());
          neighborMap.get(m).add(i);
          neighborMap.get(i).add(m);
        };

        addMacNode(clientMac);
        addMacNode(serverMac);
        if (clientMac) linkMacToIp(clientMac, clientAddr);
        if (serverMac) linkMacToIp(serverMac, serverAddr);

        const protocol = getField(row, ['Protocol', 'protocol']) || '';
        const portsRaw = getField(row, ['Ports', 'ports']);
        const portsRawStr = (portsRaw === null || typeof portsRaw === 'undefined') ? '' : String(portsRaw).trim();
        // Some generators include a Ports column but fill it with placeholders like "-:-".
        // In that case we should prefer the actual Client/Server Port columns.
        const isPlaceholderPorts = !portsRawStr || portsRawStr === '-:-' || portsRawStr === ':-' || portsRawStr === '-:' || portsRawStr === 'n/a';
        const ports = isPlaceholderPorts ? `${clientPort}:${serverPort}` : portsRawStr;

        try {
          if (typeof window !== 'undefined' && window.__DEBUG_PCAP_PORTS__ && pcapPortsDebugCount < 1) {
            pcapPortsDebugCount += 1;
            console.log('[PCAP][ports][csvToGraphData] row sample', {
              keys: row ? Object.keys(row).slice(0, 25) : [],
              clientAddr,
              serverAddr,
              clientPortRaw,
              serverPortRaw,
              clientPort,
              serverPort,
              portsRawStr,
              ports,
            });
          }
        } catch (e) {
        }
        const startTime = toNumber(getField(row, ['Start Time', 'start_time', 'start', 'timestamp']));
        const duration = toNumber(getField(row, ['Duration', 'duration']));
        const packets = Math.floor(toNumber(getField(row, ['Packets', 'packets'])));

        const a = String(clientAddr);
        const b = String(serverAddr);
        const ordered = [a, b].sort();
        const minId = ordered[0];
        const baseCurv = 0.25;
        const curvatureAB = (a === minId) ? baseCurv : -baseCurv;
        const curvatureBA = -curvatureAB;

        const pushDirected = (src, dst, bytes, curv, dir, fromMac, toMac) => {
          const safeBytes = Number(bytes) || 0;
          const safePackets = Number(packets) || 0;
          if (!(safeBytes > 0) && !(safePackets > 0)) return;
          const dirKey = `${src}→${dst}`;
          const linkId = `${src}->${dst}:${dir}`;
          const existing = linkMap.get(dirKey);
          if (existing) {
            existing.value += safeBytes;
            if (!existing.protocol && protocol) existing.protocol = protocol;
            if (ports) {
              const prevPorts = existing.ports == null ? '' : String(existing.ports).trim();
              const prevIsPlaceholder = !prevPorts || prevPorts === '-:-' || prevPorts === ':-' || prevPorts === '-:' || prevPorts === 'n/a';
              if (!existing.ports || prevIsPlaceholder) existing.ports = ports;
            }
            if (safePackets) existing.packets = (existing.packets || 0) + safePackets;
            if (startTime && duration) existing.duration = Math.max(existing.duration || 0, duration);

            if (fromMac && (!existing.fromMac || existing.fromMac === '-' || existing.fromMac === '')) {
              existing.fromMac = String(fromMac);
            }
            if (toMac && (!existing.toMac || existing.toMac === '-' || existing.toMac === '')) {
              existing.toMac = String(toMac);
            }

            if (clientPort !== '-' || serverPort !== '-') {
              if (!existing.pcapFlows) existing.pcapFlows = {};
              const pKey = `${clientPort || ''}:${serverPort || ''}`;
              const prev = existing.pcapFlows[pKey] || { clientPort, serverPort, clientBytes: 0, serverBytes: 0, packets: 0 };
              if (dir === 'tx') {
                prev.clientBytes += safeBytes;
              } else {
                prev.serverBytes += safeBytes;
              }
              prev.packets += safePackets;
              existing.pcapFlows[pKey] = prev;
            }
          } else {
            const linkObj = {
              id: linkId,
              timestamp: startTime,
              source: src,
              target: dst,
              value: safeBytes,
              gas: 0,
              protocol: protocol,
              ports: ports,
              duration: duration,
              packets: safePackets,
              metaType: 'pcap',
              curvature: curv,
              pcapDir: dir,
            };

            if (clientPort !== '-' || serverPort !== '-') {
              linkObj.pcapFlows = {};
              const pKey = `${clientPort || ''}:${serverPort || ''}`;
              const init = { clientPort, serverPort, clientBytes: 0, serverBytes: 0, packets: safePackets };
              if (dir === 'tx') {
                init.clientBytes = safeBytes;
              } else {
                init.serverBytes = safeBytes;
              }
              linkObj.pcapFlows[pKey] = init;
            }

            linkMap.set(dirKey, linkObj);
            links.push(linkObj);
          }

          if (!neighborMap.has(src)) neighborMap.set(src, new Set());
          if (!neighborMap.has(dst)) neighborMap.set(dst, new Set());
          neighborMap.get(src).add(dst);
          neighborMap.get(dst).add(src);
        };

        // Emit one directed link per direction so A->B and B->A can be curved apart.
        // Attach MACs so the detailed conversations list can show L2 identity.
        pushDirected(a, b, clientBytes, curvatureAB, 'tx', clientMac, serverMac);
        pushDirected(b, a, serverBytes, curvatureBA, 'rx', serverMac, clientMac);
      }
    });

    // Update node linkCount to reflect unique neighbors (degree), regardless of direction.
    nodes.forEach((n) => {
      const id = n && n.id ? String(n.id) : '';
      const set = neighborMap.get(id);
      if (set && set.size >= 0) {
        n.linkCount = set.size;
      }
    });
 
    setIsFirstLoad(false);
    setLinkCount(linkCount);
    return { nodes, links };
  };

  const loadDemoFile = async () => {
    const response = await fetch(`${process.env.PUBLIC_URL}/ExpertFlowStatisticsBigGraph.csv`);
    const blob = await response.blob();
    const url = URL.createObjectURL(blob);
    setIsLoading(true);
    setFileUrl(url);
    setIsLoading(false);
  };

  const processFile = async (file) => {
    setIsLoading(true);
    const newData = await parseCSVData(file, graphData);
    setGraphData(classifyGraphNodes(newData));
    setIsLoading(false);
  };


  const handleFileChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      setGraphData({ nodes: [], links: [] });
      setFileUrl(null);
      processFile(file);
    }
  };

  const handleNameTableChange = async (event) => {
    const file = event.target.files[0];
    if (file) {
      processNameTableFile(file);
    }
  };

  const processNameTableFile = async (file) => {
    const reader = new FileReader();
    reader.onload = function(e) {
        const content = e.target.result;
        try {
            const jsonData = JSON.parse(content);
            const map = createMapFromJson(jsonData);
            setMapData(map);
        } catch (error) {
            console.error('Error parsing JSON:', error);
        }
    };
    reader.readAsText(file);
  };

  const createMapFromJson = (jsonData) => {
      const map = new Map();
      jsonData.names.forEach(item => {
          map.set(item.entry, { 
              entryType: item.entryType,
              name: item.name,
              group: item.group,
              modified: item.modified,
              used: item.used,
              color: item.color,
              nodeType: item.nodeType,
              source: item.source,
              trust: item.trust
          });
      });
      return map;
  };


  const handleBackgroundClick = () => {
    stopCameraSpin();
    handleCloseTokenInfo();
  };

  const handleZoom = () => {
    stopCameraSpin();
  };

  
  function isConnected(nodeId, targetNodeId, links) {
    return links.some(link => (link.source === nodeId && link.target === targetNodeId) || 
      (link.target === nodeId && link.source === targetNodeId));
  }
  

  const handleKeyPress = (event) => {
    // Don't steal focus / fight with Material-UI dialogs while the user is typing.
    try {
      const tag = event && event.target && event.target.tagName ? String(event.target.tagName).toLowerCase() : '';
      const isEditable = tag === 'input' || tag === 'textarea' || tag === 'select' || (event && event.target && event.target.isContentEditable);
      // If the user is typing into an editable control, never run global hotkeys
      // (except Escape which we use for zoom out).
      if (isEditable && event.key !== 'Escape') return;
    } catch (e) {
    }

    if (event.key === 'Escape') { // Check if the ESC key is pressed
      layoutManager.handleZoomOut();
    }
    stopCameraSpin();
  };
  
  useEffect(() => {
    document.addEventListener('keydown', handleKeyPress);
  
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [graphData]); // Include graphData in the dependency array
  
  // Use useEffect to add event listeners after component mounts
  useEffect(() => {
    // Ensure the ref is set
    if (graphRef.current) {
        const handleMouseDown = (event) => {
            console.log('Mouse down', event);
            stopCameraSpin();
            // You can add state logic here to track dragging
        };

        // Add event listeners
        const graphContainer = graphContainerRef.current;
        if (!graphContainer) return;
      
        const container = graphRef.current; // Directly to the container
        graphContainer.addEventListener('mousedown', handleMouseDown);
  
        // Cleanup function to remove event listeners
        return () => {
          graphContainer.removeEventListener('mousedown', handleMouseDown);
        };
    }
  }, [graphRef]); // Re-run if graphRef changes


  const hasUsablePositions = (data) => {
    if (!data || !Array.isArray(data.nodes) || !data.nodes.length) return false;

    const nodes = data.nodes;
    const withPos = nodes.filter(
      (n) => n && n.x != null && n.y != null
    );

    // Consider positions usable if at least half the nodes have x/y
    return withPos.length >= nodes.length / 2;
  };


  function runInitialLayoutIfReady({ force = false } = {}) {
    if (
      hasInitialLayoutApplied ||
      !graphRef?.current ||
      !graphData ||
      !Array.isArray(graphData.nodes) ||
      !graphData.nodes.length ||
      !isLoaded ||
      !layoutManager ||
      !viewGraph
    ) {
      return;
    }

    const isLinksRoute = location && location.pathname && location.pathname.startsWith('/graphs');

    if (isLinksRoute) {
      //layoutManager.handleExpandGraph(graphData, 1);
      //layoutManager.autoFit(graphData, 1.0);
    }

    setHasInitialLayoutApplied(true);
    setIsFirstEngineStop(false);
  }

/*
  useEffect(() => {
    if (
      hasInitialLayoutApplied ||
      !graphRef?.current ||
      !graphData ||
      !Array.isArray(graphData.nodes) ||
      !graphData.nodes.length ||
      !isLoaded ||
      !viewGraph
    ) {
      return;
    }

    // Let the force simulation run for a short period so the layout
    // stabilizes a bit before we apply the double expand + autofit.
    const timeoutId = setTimeout(() => {
      runInitialLayoutIfReady();
    }, 2000); // ms

    return () => clearTimeout(timeoutId);
  }, [graphData, isLoaded, graphRef, searchText, hasInitialLayoutApplied, hasLinksAddress]);
*/

  const handleEngineStop = () => {
    try {
      if (typeof window !== 'undefined' && typeof window.__E3D_NOTIFY_ENGINE_STOP__ === 'function') {
        window.__E3D_NOTIFY_ENGINE_STOP__();
      }
    } catch (e) {
    }

    // In practice the initial layout now runs as soon as the graph is ready
    // via runInitialLayoutIfReady(). Treat onEngineStop as a late fallback
    // in case the engine settles after data changes.
    if (!isFirstEngineStop) return;
    const isLinksRoute = location && location.pathname && location.pathname.startsWith('/graphs');

    
    if (isLinksRoute) {
      runInitialLayoutIfReady({ force: true });
    }
  };

  const handleNodeDragEnd = (node) => {
    try {
      const sel = pcapSelectedLinkKeys;
      if (sel && sel.size) {
        const members = dragSelectedGroupRef.current && dragSelectedGroupRef.current.members;
        if (members && typeof members.forEach === 'function') {
          members.forEach((_, id) => {
            const nid = String(id || '');
            if (!nid) return;
            let cur = null;
            try {
              const ref = graphRef && graphRef.current;
              const gd = ref && typeof ref.graphData === 'function' ? ref.graphData() : null;
              const nodesArr = gd && Array.isArray(gd.nodes) ? gd.nodes : null;
              if (nodesArr) cur = nodesArr.find((n) => n && String(n.id) === nid) || null;
            } catch (e2) {
            }
            if (!cur) {
              cur = (graphDataRef && graphDataRef.current && Array.isArray(graphDataRef.current.nodes))
                ? graphDataRef.current.nodes.find((n) => n && String(n.id) === nid)
                : null;
            }
            if (!cur) return;
            cur.fx = cur.x;
            cur.fy = cur.y;
            cur.fz = cur.z;
          });
        }
      }
    } catch (e) {
    }

    node.fx = node.x;
    node.fy = node.y;
    node.fz = node.z;
    if (dragSelectedGroupRef.current) {
      dragSelectedGroupRef.current.anchorId = null;
      dragSelectedGroupRef.current.members = null;
    }
  };

  const handleNodeDrag = (node) => {
    try {
      const sel = pcapSelectedLinkKeys;
      if (sel && sel.size) {
        const normalizeEndpointId = (v) => {
          try {
            if (v == null) return '';
            if (typeof v === 'object') {
              const raw = v.id ?? v._id ?? v.address;
              return raw != null ? String(raw) : '';
            }
            return String(v);
          } catch (e) {
            return '';
          }
        };
        const makePairKey = (a, b) => {
          const ordered = [String(a || ''), String(b || '')].sort();
          return `${ordered[0]}↔${ordered[1]}`;
        };

        // Build member ids from the *currently rendered* links that are selected.
        // This avoids mismatches between selection keys and node ids in grouped mode.
        const memberIds = new Set();
        try {
          const ref = graphRef && graphRef.current;
          const gd = ref && typeof ref.graphData === 'function' ? ref.graphData() : null;
          const linksArr = gd && Array.isArray(gd.links) ? gd.links : null;
          if (linksArr) {
            for (let i = 0; i < linksArr.length; i += 1) {
              const l = linksArr[i];
              if (!l || l.metaType !== 'pcap') continue;
              const s = normalizeEndpointId(l.source);
              const t = normalizeEndpointId(l.target);
              if (!s || !t) continue;
              const key = makePairKey(s, t);
              if (!sel.has(key)) continue;
              memberIds.add(String(s));
              memberIds.add(String(t));
            }
          }
        } catch (e2) {
        }

        // Fallback: if we couldn't find selected links, fall back to parsing keys.
        if (!memberIds.size) {
          sel.forEach((k) => {
            const raw = k != null ? String(k) : '';
            if (!raw) return;
            const parts = raw.split('↔');
            if (parts.length !== 2) return;
            const a = String(parts[0] || '').trim();
            const b = String(parts[1] || '').trim();
            if (a) memberIds.add(a);
            if (b) memberIds.add(b);
          });
        }

        const anchorId = node && node.id != null ? String(node.id) : '';
        const dragState = dragSelectedGroupRef.current || { anchorId: null, members: null };
        if (anchorId && (dragState.anchorId !== anchorId || !dragState.members)) {
          const members = new Map();
          const ax = Number(node.x) || 0;
          const ay = Number(node.y) || 0;
          const az = Number(node.z) || 0;
          let renderedNodesArr = null;
          try {
            const ref = graphRef && graphRef.current;
            const gd = ref && typeof ref.graphData === 'function' ? ref.graphData() : null;
            renderedNodesArr = gd && Array.isArray(gd.nodes) ? gd.nodes : null;
          } catch (e2) {
            renderedNodesArr = null;
          }
          memberIds.forEach((id) => {
            const nid = String(id || '');
            if (!nid) return;
            let cur = null;
            if (renderedNodesArr) cur = renderedNodesArr.find((n) => n && String(n.id) === nid) || null;
            if (!cur) {
              cur = (graphDataRef && graphDataRef.current && Array.isArray(graphDataRef.current.nodes))
                ? graphDataRef.current.nodes.find((n) => n && String(n.id) === nid)
                : null;
            }
            if (!cur) return;
            const cx = Number(cur.x) || 0;
            const cy = Number(cur.y) || 0;
            const cz = Number(cur.z) || 0;
            members.set(nid, { dx: cx - ax, dy: cy - ay, dz: cz - az });
          });
          dragSelectedGroupRef.current = { anchorId, members };
        }

        const active = dragSelectedGroupRef.current;
        if (active && active.members && active.anchorId === anchorId) {
          node.fx = node.x;
          node.fy = node.y;
          node.fz = node.z;
          const ax = Number(node.x) || 0;
          const ay = Number(node.y) || 0;
          const az = Number(node.z) || 0;
          let renderedNodesArr = null;
          try {
            const ref = graphRef && graphRef.current;
            const gd = ref && typeof ref.graphData === 'function' ? ref.graphData() : null;
            renderedNodesArr = gd && Array.isArray(gd.nodes) ? gd.nodes : null;
          } catch (e2) {
            renderedNodesArr = null;
          }
          active.members.forEach((off, nid) => {
            let cur = null;
            const targetId = String(nid);
            if (renderedNodesArr) cur = renderedNodesArr.find((n) => n && String(n.id) === targetId) || null;
            if (!cur) {
              cur = (graphDataRef && graphDataRef.current && Array.isArray(graphDataRef.current.nodes))
                ? graphDataRef.current.nodes.find((n) => n && String(n.id) === targetId)
                : null;
            }
            if (!cur) return;
            const dx = off && Number.isFinite(off.dx) ? off.dx : 0;
            const dy = off && Number.isFinite(off.dy) ? off.dy : 0;
            const dz = off && Number.isFinite(off.dz) ? off.dz : 0;
            const nx = ax + dx;
            const ny = ay + dy;
            const nz = az + dz;
            cur.x = nx;
            cur.y = ny;
            cur.z = nz;
            cur.fx = nx;
            cur.fy = ny;
            cur.fz = nz;
          });
          try {
            const ref = graphRef && graphRef.current;
            if (ref && typeof ref.refresh === 'function') ref.refresh();
          } catch (e2) {
          }
          return;
        }
      }
    } catch (e) {
    }

    node.fx = node.x;
    node.fy = node.y;
    node.fz = node.z;
  };

  const handleSimulationToggle = () => {
    setPauseSimulation(!PauseSimulation);
  
    if (simulationRef.current) {
      if (!PauseSimulation) {
        // Start the simulation
        simulationRef.current.alphaTarget(0.1).restart();
      } else {
        // Stop the simulation
        simulationRef.current.stop();
      }
    }
  };

  useEffect(() => {
    if (viewGraph && graphRef && graphRef.current) {
      // Create and configure the simulation
      simulationRef.current = graphRef.current.d3Force('charge');
    }
  }, []);

  
  const handleClick = (event, { node, link }) => {
    if (node) {
      if (node.link) {
        window.open(node.link, '_blank');
      } 
      else {
        layoutManager.zoomToNode(node);
      }
    } else if (link) {
      if (link.link) {
        window.open(link.link, '_blank');
      }
    } else {
      if (simulationRef.current) {
        setPauseSimulation(true);
        simulationRef.current.stop();
      }
    }
  };

  async function load() {
    handleOrientationChange();
    //await fetchEthTransactions();
  }

  useEffect(() => {
    if (!showHomePage && !isLoaded && (filterNFT != null) && (filterToken != null) && rate != null && dataSource != PCAP) { 
      load();
    }
  }, [rate, filterNFT, filterToken, showHomePage]);

  useEffect(() => {
    if (filterNFT) {
      console.log('filterNFT is true');
      // Run your code that depends on filterNFT being true
    }
  }, [filterNFT]);

  // Special effect to handle E3D NFT Marketplace loading
  useEffect(() => {
    if (showE3DMarketplace) {
      console.log('E3D NFT Marketplace view activated');
      // Force data reload for marketplace
      isLoaded = false;
      setIsDataReady(false);
      
      // The marketplace requires NFT data, ensure it's set properly
      setFilterNFT(true);
      setFilterToken(false);
      
      // Trigger data loading if needed
      if (!isLoaded && rate != null && dataSource != PCAP) {
        console.log('Loading marketplace data');
        load();
      }
    }
  }, [showE3DMarketplace, dataSource, rate]);
  
  // Special effect to handle Custom NFT Marketplace loading
  useEffect(() => {
    if (showCustomNFTMarketplace) {
      console.log('Custom NFT Marketplace view activated');
      // Force data reload for marketplace
      isLoaded = false;
      setIsDataReady(false);
      
      // The marketplace requires NFT data, ensure it's set properly
      setFilterNFT(true);
      setFilterToken(false);
      
      // Trigger data loading if needed
      if (!isLoaded && rate != null && dataSource != PCAP) {
        console.log('Loading Custom NFT marketplace data');
        load();
      }
    }
  }, [showCustomNFTMarketplace, dataSource, rate]);
  
   // Special effect to handle Custom NFT Dialog loading
   useEffect(() => {
    if (showCustomNFTDialog) {
      console.log('Custom NFT Dialog view activated');
      // Force data reload for custom NFT Dialog
      isLoaded = false;
      setIsDataReady(false);
      
      // The custom NFT Dialog requires NFT data, ensure it's set properly
      setFilterNFT(true);
      setFilterToken(false);
      
      // Trigger data loading if needed
      if (!isLoaded && rate != null && dataSource != PCAP) {
        console.log('Loading custom NFT Dialog data');
        load();
      }
    }
  }, [showCustomNFTDialog, dataSource, rate]);

  // Special effect to handle NFT Explorer loading
  useEffect(() => {
    // Only run this when filterNFT is true, viewGraph is false, and we're not in either marketplace
    // This combination indicates we're in the NFT Explorer view (/nft)
    if (filterNFT && !viewGraph && !showE3DMarketplace && !showCustomNFTMarketplace && !showHomePage) {
      console.log('NFT Explorer view activated');
      
      // Force data reload for NFT Explorer
      isLoaded = false;
      
      // Make sure the token list is properly loaded
      const loadNFTData = async () => {
        try {
          // Reset token list first
          setTokenList([]);
          setIsDataReady(false);
          
          // Explicitly load NFT token list for the explorer view
          if (rate != null && dataSource != PCAP) {
            console.log('Loading NFT Explorer data');
            await getTokenList(true, 'NFT', dataSource);
            console.log('NFT data loaded successfully');
            
            // Ensure data is ready to display
            setIsDataReady(true);
          }
        } catch (error) {
          console.error('Error loading NFT data:', error);
          // Even on error, set isDataReady to avoid frozen UI
          setIsDataReady(true);
        }
      };
      
      // Call the async function to load data
      loadNFTData();
    }
  }, [filterNFT, viewGraph, showE3DMarketplace, showCustomNFTMarketplace, showHomePage, dataSource, rate]);

  useEffect(() => {
    if (!showHomePage && !isLoaded && graphData.nodes.length && viewGraph) {
      isLoaded = true;
    }

  }, [graphData, isLoaded]); // Empty dependency array



  const openIntervalInputRef = React.createRef();
  const openFileInputRef = React.createRef();
  const addFileInputRef = React.createRef();
  const openPcapRef = React.createRef();
  const openNameTableInputRef = React.createRef();

  const [anchorInterval, setAnchorInterval] = React.useState(null);
  const [anchorOpenSaveAs, setAnchorOpenSaveAs] = React.useState(null);
  const [anchorOpen, setAnchorOpen] = React.useState(null);
  const [anchorSave, setAnchorSave] = React.useState(null);
  const [anchorView, setAnchorView] = React.useState(null);
  const [chartAnchorEl, setChartAnchorEl] = useState(null);
  const [viewModeAnchorEl, setViewModeAnchorEl] = useState(null);
  const [modalAnchorEl, setModalAnchorEl] = useState(null);
  const [contractAnchorEl, setContractAnchorEl] = useState(null);
  
  // Add missing anchor state variables
  const [anchorEl, setAnchorEl] = useState(null);
  const [anchorElAdvanced, setAnchorElAdvanced] = useState(null);
  const [anchorEth, setAnchorEth] = useState(null);

  const handleMenuClickEl = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuCloseEl = () => {
    setAnchorEl(null);
  };

  const handleAdvancedMenuClickEl = (event) => {
    setAnchorElAdvanced(event.currentTarget);
  };

  const handleAdvancedMenuCloseEl = () => {
    setAnchorElAdvanced(null);
  };
  
  // Add missing list menu handler
  const handleClickListMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuItemClick = (action) => () => {
    action();
    handleMenuCloseEl();
  };

  const handleAdvancedMenuItemClick = (action) => () => {
    action();
    handleAdvancedMenuCloseEl();
    handleMenuCloseEl(); 
  };

  const handleOpenInterval = (event) => {
    setAnchorInterval(event.currentTarget);
  };

  const handleCloseInterval = () => {
    setAnchorInterval(null);
  };

  const handleOpenOpen = (event) => {
    setAnchorOpen(event.currentTarget);
  };

  const handleCloseOpen = () => {
    setAnchorOpen(null);
  };

  const handleFileMenuClickAction = (action) => () => {
    action();
    handleCloseOpen();
  };

  const handleOpenSaveAs = (event) => {
    setAnchorOpenSaveAs(event.currentTarget);
  };

  const handleCloseSaveAs = () => {
    setAnchorOpenSaveAs(null);
  };

  const handleOpenSave = (event) => {
    setAnchorSave(event.currentTarget);
  };

  const handleCloseSave = () => {
    setAnchorSave(null);
  };

  const handleOpenView = (event) => {
    setAnchorView(event.currentTarget);
  };

  const handleCloseView = () => {
    setAnchorView(null);
  };

  const handleMenuItemViewClick = (action) => () => {
    action();
    handleCloseView();
  };

  const handleOpenEth = (event) => {
    setAnchorEth(event.currentTarget);
  };

  const handleCloseEth = () => {
    setAnchorEth(null);
  };

  const handleIntervalSelection = async(action) => {
    try {
      if (location.pathname.startsWith('/graphs')) {
        const allowed = Array.isArray(allowedLinksIntervals) ? allowedLinksIntervals : [allowedLinksInterval];
        if (!allowed.includes(action)) {
          if (!isAuthenticated) {
            if (window.navigateToSignup) {
              window.navigateToSignup();
            } else {
              navigate('/signup');
            }
            return;
          }

          openUpgradeDialog();
          return;
        }

        linksIntervalTouchedRef.current = true;
      }

      rangeSelectedOverrideRef.current = action;
      setRangeSelected(action);

      const totalMinutes = (() => {
        if (action.includes('M')) return parseInt(action.split('M')[0], 10) || 0;
        if (action.includes('H')) return (parseInt(action.split('H')[0], 10) || 0) * 60;
        if (action.includes('D')) return (parseInt(action.split('D')[0], 10) || 0) * 24 * 60;
        return 0;
      })();

      // Standard time range calculation
      const endTimeUTC = new Date();
      const startTimeUTC = new Date(endTimeUTC.getTime() - (totalMinutes * 60 * 1000));

      // If in BubblesView, fetch token price history with the appropriate time comparison
      if (props.showBubblesView) {
        try {
          // Mark data as not ready before fetching
          setIsDataReady(false);
          // Reset price history flag
          setHasPriceHistoryData(false);

          // Clear the tokenList to prevent old data from showing
          setTokenList([]);

          console.log(`BubblesView: Fetching price history with interval ${action} (${totalMinutes} minutes)`);

          // Convert current time and interval to timestamps
          const currentTimestamp = Math.floor(Date.now() / 1000);
          const historicalTimestamp = currentTimestamp - (totalMinutes * 60);

          // Fetch token data with historical price comparison
          const priceHistoryData = await getTokenPriceHistory(dataSource, "", historicalTimestamp, userID);

          if (priceHistoryData && priceHistoryData.length > 0) {
            console.log(`Received ${priceHistoryData.length} tokens with price history`);

            // Process through createTokenList to ensure proper structure
            const processedTokens = createTokenList(priceHistoryData, 'token', dataSource);
            console.log(`Processed ${processedTokens.length} tokens with price history`);

            // Update the token list with the processed data
            setTokenList(processedTokens);

            // Set flag to indicate we have price history data
            setHasPriceHistoryData(true);
          } else {
            console.warn('No price history data received');
            setHasPriceHistoryData(false);
          }

          // Always mark data as ready after processing
          setIsDataReady(true);
        } catch (error) {
          console.error("Error fetching price history data:", error);
          // Ensure we mark data as ready even in case of errors to avoid UI getting stuck
          setIsDataReady(true);
          setHasPriceHistoryData(false);
        }
      } else {
        // For the /token route in price-list modes, changing the interval should
        // only update which change column we emphasize, not re-fetch
        // transactions. Keep the original transaction-based behavior only when
        // tokenView is 'transactions'.
        if (location.pathname.startsWith('/token') && tokenView !== 'links') {
          return;
        }

        // If we arrived in /links via a prefetched forensics snapshot from the
        // Stories page, skip the initial reset+fetch entirely so the prefetched
        // graph remains visible. Use a one-shot flag to avoid interfering with
        // later manual range changes.
        if (
          typeof window !== 'undefined' &&
          window.prefetchedForensicsWasUsed &&
          location.pathname.startsWith('/graphs')
        ) {
          window.prefetchedForensicsWasUsed = false;
          return;
        }

        // If /links is showing a snapshot loaded from /timeseries, never
        // override it with a live getTransactions() refresh.
        try {
          if (
            location.pathname.startsWith('/graphs') &&
            typeof window !== 'undefined' &&
            window.__E3D_ACTIVE_SNAPSHOT_URL__
          ) {
            return;
          }
        } catch (e) {
        }

        // In /graphs view with no specific address, always rely on the backend
        // cached window (latest=true with no explicit time bounds) and apply
        // the selected time-range filter on the client.
        if (location.pathname.startsWith('/graphs') && !hasLinksAddress) {
          setUserTransactions(true);
          // Clear stale node positions so the force simulation starts fresh on range change.
          clearNodePositions();
          resetGraph();
          await getTransactions(ETHERSCAN, '', true, undefined, undefined, userID);
        } else {
          // For /graphs views that *do* have a specific address, if we already
          // have a populated graph (from a prefetched snapshot or previous
          // load), skip this initial reset+fetch. This protects against
          // StrictMode double-invocation and ensures the prefetched graph is
          // preserved.
          if (
            location.pathname.startsWith('/graphs') &&
            hasLinksAddress &&
            graphData &&
            Array.isArray(graphData.nodes) &&
            graphData.nodes.length > 0 &&
            isDataReady
          ) {
            if (typeof window !== 'undefined') {
              window.prefetchedForensicsWasUsed = false;
            }
            return;
          }

          // Original behavior for other views: pass explicit start/end bounds.
          resetGraph();
          await getTransactions(ETHERSCAN, '', true, startTimeUTC, endTimeUTC, userID);
        }
        //setTrigger4(true);
      }
    } catch (e) {
    }
  };


  const handleMenuClick = async(action) => {
    handleCloseOpen();
    handleCloseSave();
    handleCloseView();
    handleCloseEth();
    handleCloseSaveAs();
    switch (action) {
      case 'loadEth':
        fetchEthTransactions();
        break;
      case 'startTimer':
        startTimer();
        break;
      case 'startEth':
        startEthTimer();
        break;
      case 'stopEth':
        stopEthTimer();
        break;      
      case 'loadBsc':
        fetchBscTransactions();
        break;
      case 'startBsc':
        startBscTimer();
        break;
      case 'stopBsc':
        stopBscTimer();
        break;      
      case 'demo':
        loadDemoFile();
        break;
      case 'openCSV':
        if (openFileInputRef.current) openFileInputRef.current.click();
        break;
      case 'addCSV':
        if (addFileInputRef.current) addFileInputRef.current.click();
        break;
      case 'openPCAP':
        if (openPcapRef.current) openPcapRef.current.click();
        break;
      case 'openNameTable':
        if (openNameTableInputRef.current) openNameTableInputRef.current.click();
        break;
      case 'reset':
        resetGraph();
        break;
      case 'refresh':
        setIsTourRunning(false);
        if (dataSource === PCAP) {
          // PCAP is a local file. "Refresh/Search" should never hit the backend
          // DB; instead, just run the local NodeList search.
          handleSearchFromDialogCallback();
          break;
        }
        resetGraph();
        await getTransactions(dataSource,searchText,true);
        break;
      case 'saveCSV':
        downloadCsvWithHash(graphDataToCsv(graphData, tokenList), "graphData.csv");
        break;
      case 'saveJPG':
        downloadImageJPG(graphRef);
        break;
      case 'savePNG':
        downloadImagePNG(graphRef);
        break;
      case 'savePDF':
        downloadPDF(graphRef);
        break;
      case 'spin':
        toggleCameraSpin();
        break;
      case 'zoomOut':
        layoutManager.handleZoomOut();
        break;
      case 'showAll':
        restoreOriginalGraph();
        break;
      case 'toggleLabels':
        setShowText(!showText);
        break;
      case 'toggleList':
        setShowPanel(!showPanel);
        //Cookies.set('showPanel', showPanel, { expires: 7 }); // Expires in 7 days
        break;
      case 'toggleBottom':
        setShowBottom((prev) => {
          const next = !prev;
          try {
            if (dataSource === PCAP && window && window.localStorage) {
              window.localStorage.setItem('pcapShowBottom', next ? 'true' : 'false');
            }
          } catch (e) {
          }
          return next;
        });
        break;
      case 'toggle3D':
        setIs3DMode(!is3DMode);
        break;
      case 'toggleSim':
        handleSimulationToggle();
        break;
      default:
        break;
    }
  };

  const [theta, setTheta] = useState(0); // Initialize theta
  const [phi, setPhi] = useState(Math.PI / 2); // Initialize phi

  const handleEvent = (event) => {
    if (event.pointerType != "mouse") {
      stopCameraSpin();
    }

    if (viewGraph && graphRef.current) {
      const zoomStep = .2; // Define the zoom step
  
      if (is3DMode) {
        // Periodically reset angles to align with the current camera position
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          rotateCamera({ horizontal: event.key === 'ArrowLeft' ? 0.05 : -0.05 });
        } else if (event.shiftKey && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
          const cameraPosition = graphRef.current.cameraPosition();
          const zoomChange = event.key === 'ArrowUp' ? -zoomStep * cameraPosition.z : zoomStep * cameraPosition.z;
          graphRef.current.cameraPosition({ z: cameraPosition.z + zoomChange }, undefined, 100);
        } else if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
          rotateCamera({ vertical: event.key === 'ArrowUp' ? 0.05 : -0.05 });
        }
      } else {
        const currentZoom = graphRef.current.zoom();

        if (event.shiftKey && (event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
          const currentZoom = graphRef.current.zoom();
          const newZoom = event.key === 'ArrowUp' ? currentZoom * (1 - zoomStep) : currentZoom * (1 + zoomStep);
          graphRef.current.zoom(newZoom, 100);
        } else if ((event.key === 'ArrowUp' || event.key === 'ArrowDown')) {
          // Zoom in/out 
          graphRef.current.zoom(event.key === 'ArrowUp' ? currentZoom + zoomStep : currentZoom - zoomStep, 100);
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          // Translate left/right for 2D
          const translateStep = 30; // Define the translation step (in pixels)
          const direction = event.key === 'ArrowLeft' ? -1 : 1;
          const currentTranslate = graphRef.current.centerAt();
          graphRef.current.centerAt(currentTranslate.x + direction * translateStep, currentTranslate.y, 100);
        }
      }
    }
  };  

  const rotateCamera = (rotationAngle) => {
    // Camera rotation only works in 3D mode
    if (!is3DMode || !graphRef.current || !graphRef.current.cameraPosition) {
      return;
    }
    
    const currentCameraPosition = graphRef.current.cameraPosition();
    const { x, y, z } = currentCameraPosition;

    // Calculate the current distance from the center
    const distance = Math.sqrt(x * x + y * y + z * z);

    // Calculate initial spherical coordinates
    let theta = Math.atan2(x, z);
    let phi = Math.acos(y / distance);

    // Adjust theta and phi
    if (rotationAngle.horizontal) {
      theta += rotationAngle.horizontal;
    }
    if (rotationAngle.vertical) {
      // Limit the vertical rotation to avoid flipping
      phi = Math.max(0.1, Math.min(Math.PI - 0.1, phi + rotationAngle.vertical));
    }
 
    // Convert back to Cartesian coordinates
    const newX = distance * Math.sin(phi) * Math.sin(theta);
    const newY = distance * Math.cos(phi);
    const newZ = distance * Math.sin(phi) * Math.cos(theta);

    graphRef.current.cameraPosition({ x: newX, y: newY, z: newZ }, { x: 0, y: 0, z: 0 });
  };
    
  function startCameraSpin() {
    stopCameraSpin();

    // Camera spin only works in 3D mode
    if (!is3DMode 
      || !spinSpeed 
      || (spinCamera && cameraSpinIntervalRef.current) 
      || !graphRef 
      || !graphRef.current
      || !graphRef.current.cameraPosition) {
      return;
    }
    
    // If a spin interval is already running for any reason, clear it first
    // so we never have multiple competing timers.
    if (cameraSpinIntervalRef.current) {
      clearInterval(cameraSpinIntervalRef.current);
      cameraSpinIntervalRef.current = 0;
    }

    // Set both local state and global tracker
    setSpinCamera(true);
    window._tempSpinState = true;

    const id = setInterval(() => {
      if (!graphRef || !graphRef.current || !graphRef.current.cameraPosition) {
        return;
      }

      const current = graphRef.current.cameraPosition();
      const dx = current.x;
      const dz = current.z;
      const distance = Math.sqrt(dx * dx + dz * dz) || 1;
      let angle = Math.atan2(dx, dz);

      const delta = Math.PI / 1000;
      angle += delta;

      const newX = distance * Math.sin(angle);
      const newZ = distance * Math.cos(angle);

      graphRef.current.cameraPosition(
        { x: newX, y: current.y, z: newZ },
        { x: 0, y: 0, z: 0 }
      );

      // In 3D chain mode, also very slowly rotate each chain's token nodes
      // around its own center, by mutating the React graphData nodes in
      // place. This avoids extra React renders and gives a subtle planets
      // effect.
      const latestGraphData = graphDataRef.current;
      if (
        is3DMode &&
        tokenView === 'chain' &&
        layoutMode === 'sphere' &&
        latestGraphData &&
        latestGraphData.nodes &&
        latestGraphData.nodes.length
      ) {
        const nodes = latestGraphData.nodes;
        const tokensByChain = new Map();

        nodes.forEach(node => {
          if (node && node.nodeType === 'token' && node.chain) {
            const key = String(node.chain).toUpperCase();
            if (!tokensByChain.has(key)) {
              tokensByChain.set(key, []);
            }
            tokensByChain.get(key).push(node);
          }
        });

        const spinDirections = {
          ETH: 1,
          ARB: 1,
          OPT: 1,
          POL: 1,
          BSC: -1,
          AVAX: -1,
        };

        tokensByChain.forEach((nodesForChain, chainKey) => {
          if (!nodesForChain.length) return;

          const dir = spinDirections[chainKey] ?? 1;
          const chainDelta = dir * (Math.PI / 600); // faster per-tick rotation (about 4x)

          let cx = 0, cy = 0, cz = 0;
          nodesForChain.forEach(n => {
            cx += n.x || 0;
            cy += n.y || 0;
            cz += n.z || 0;
          });
          cx /= nodesForChain.length;
          cy /= nodesForChain.length;
          cz /= nodesForChain.length;

          nodesForChain.forEach(n => {
            const ox = (n.x ?? cx) - cx;
            const oz = (n.z ?? cz) - cz;
            const r = Math.sqrt(ox * ox + oz * oz) || 0;
            if (!r) return;

            let a = Math.atan2(ox, oz) + chainDelta;
            const rx = r * Math.sin(a);
            const rz = r * Math.cos(a);

            n.x = cx + rx;
            n.z = cz + rz;
            n.fx = n.x;
            n.fy = n.y;
            n.fz = n.z;
          });
        });

        // Keep the internal force simulation warm while spinning so
        // per-sphere rotations remain visible.
        if (graphRef.current && typeof graphRef.current.d3ReheatSimulation === 'function') {
          graphRef.current.d3ReheatSimulation();
        }
      }
  
    }, spinSpeed);
    cameraSpinIntervalRef.current = id;
  }

  const stopCameraSpinImpl = useCallback(() => {
    // Update both local state and global tracker
    setSpinCamera(false);
    window._tempSpinState = false;
    
    if (cameraSpinIntervalRef.current) {
      clearInterval(cameraSpinIntervalRef.current);
      cameraSpinIntervalRef.current = 0;
    }
  }, []);

  useEffect(() => {
    stopCameraSpinImplRef.current = stopCameraSpinImpl;
  }, [stopCameraSpinImpl]);

  
  function toggleCameraSpin() {
    // Do not allow manual camera spin toggling while the tour is running.
    if (isTourRunning) {
      return;
    }

    const spinCameraNew = !spinCamera;
    setSpinCamera(!spinCamera);
    (spinCameraNew) ? startCameraSpin() : stopCameraSpin();
  }


  const layoutManager = useMemo(() => new GraphLayoutManager({
    mode3D,
    setMode3D,
    is3DMode,
    viewMode: graphViewMode,
    globalDistance,
    globalSize,
    dataSource,
    pcapGroupEnabled,
    setGraphData,
    activeNodeId,
    spinCamera,
    startCameraSpin,
    stopCameraSpin,
    graphRef,
    tokenView,
    layoutMode,
    setLayoutMode,
    resetGraph,
    setGraphInstanceKey,
  }), [mode3D, setMode3D, is3DMode, globalDistance, activeNodeId, setGraphData, graphData, spinCamera, startCameraSpin, stopCameraSpin, graphViewMode, tokenView, layoutMode, dataSource, pcapGroupEnabled]);

  useEffect(() => {
    layoutManagerRef.current = layoutManager;
    // Also expose globally for debugging/automation
    try {
      if (typeof window !== 'undefined') {
        window.__E3D_LAYOUT_MANAGER__ = layoutManager;
      }
    } catch (e) {}
  }, [layoutManager]);

  // Live mode polling: every 10 seconds fetch transactions for a rolling
  // 10-minute window and rebuild the graph from that slice. This reuses the
  // existing getTransactions pipeline so all normal graph behavior applies.
  useEffect(() => {
    if (!isLiveMode) {
      if (liveIntervalRef.current) {
        clearInterval(liveIntervalRef.current);
        liveIntervalRef.current = null;
      }
      liveStartRef.current = null;
      liveLastRefreshRef.current = null;
      return;
    }

    // Ensure we are using time-based filtering while in live mode.
    if (!useTime) {
      setUseTime(true);
    }

    const pollIntervalMs = 60000; // 60 seconds, matches 1-minute timestamp granularity
    const windowSeconds = 60; // 1 minute rolling window

    const TEN_MINUTES_MS = 10 * 60 * 1000;

    // Record the moment Live was (re)enabled so we can enforce wall-clock
    // limits and premium refresh behavior.
    if (!liveStartRef.current) {
      liveStartRef.current = Date.now();
    }
    if (!liveLastRefreshRef.current) {
      liveLastRefreshRef.current = Date.now();
    }

    const runPoll = async () => {
      try {
        const nowMs = Date.now();
        const nowSec = Math.floor(nowMs / 1000);

        const startedAt = liveStartRef.current || nowMs;
        const lastRefreshAt = liveLastRefreshRef.current || startedAt;
        const elapsedMs = nowMs - startedAt;
        const sinceRefreshMs = nowMs - lastRefreshAt;

        // For non-premium users (not authenticated), stop Live entirely
        // after 10 minutes of wall-clock time.
        if (!isAuthenticated && elapsedMs >= TEN_MINUTES_MS) {
          console.info('Live mode: non-premium 10-minute limit reached, stopping Live.');
          if (liveIntervalRef.current) {
            clearInterval(liveIntervalRef.current);
            liveIntervalRef.current = null;
          }
          liveStartRef.current = null;
          liveLastRefreshRef.current = null;
          setIsLiveMode(false);
          return;
        }

        // For authenticated (premium) users, keep Live running but perform a
        // full getTransactions refresh every 10 minutes to rebase the graph.
        if (isAuthenticated && sinceRefreshMs >= TEN_MINUTES_MS) {
          try {
            console.info('Live mode: premium 10-minute refresh via getTransactions().');
            await getTransactions(dataSource, '', false, dateRange.startDate, dateRange.endDate, userID);
          } catch (refreshErr) {
            console.error('Live mode premium refresh error:', refreshErr);
          } finally {
            liveLastRefreshRef.current = nowMs;
            // Reset the contiguous slice tracking so we resume from "now".
            setLiveLastEndTime(null);
          }
        }

        // Use contiguous 1-minute slices: each new poll starts right after
        // the previous slice ended to avoid gaps. On the very first run
        // (when liveLastEndTime is null), fall back to a backward-looking
        // window ending at now.
        let startSec;
        let endSec;

        if (liveLastEndTime != null) {
          startSec = liveLastEndTime + 1;
          endSec = startSec + windowSeconds;
        } else {
          startSec = nowSec - windowSeconds;
          endSec = nowSec;
        }

        // Stop camera spin and any running tour when live updates are
        // driving the graph.
        stopCameraSpin();
        if (isTourRunning) {
          setIsTourRunning(false);
        }

        // Build params similar to getTransactions, but scoped for Live.
        let params = '';
        if (userTransactions) {
          if (params.length) { params += ','; }
          params += 'Users';
        }
        if (filterNFTOnly) {
          if (params.length) { params += ','; }
          params += 'FilterNFT';
        }
        if (filterNewOnly) {
          if (params.length) { params += ','; }
          params += 'FilterNewOnly';
        }
        if (filterValue) {
          if (params.length) { params += ','; }
          params += 'FilterValue';
        }
        if (allLikesFilter) {
          if (params.length) { params += ','; }
          params += 'AllLikesFilter';
        }
        if (myLikesFilter) {
          if (params.length) { params += ','; }
          params += 'MyLikesFilter';
        }

        let limit = 5000;
        if (maxTransactions !== '') {
          const userLimit = parseInt(maxTransactions);
          if (userLimit > 0 && userLimit <= 1000000) {
            limit = userLimit;
          }
        }

        // Fetch recent transactions directly from the backend.
        let txData = [];
        if (!filterNFT) {
          const response = await axios.get(`${SERVER_NAME}/fetchTransactionsDB/`, {
            params: {
              dataSource,
              limit,
              startTime: startSec,
              endTime: endSec,
              search: '',
              params,
              userID,
            },
          });
          txData = response.data || [];
        }

        if (!txData.length) {
          setLiveLastEndTime(endSec);
          return;
        }

        // Build simple per-node volume arrays focused on the latest bucket.
        const nodeVolumes = new Map();
        txData.forEach(tx => {
          const fromAddress = tx.from;
          const toAddress = tx.to;
          if (fromAddress) {
            if (!nodeVolumes.has(fromAddress)) {
              nodeVolumes.set(fromAddress, new Array(sparkLength).fill(0));
            }
            const vol = nodeVolumes.get(fromAddress);
            vol[vol.length - 1]++;
          }
          if (toAddress) {
            if (!nodeVolumes.has(toAddress)) {
              nodeVolumes.set(toAddress, new Array(sparkLength).fill(0));
            }
            const vol = nodeVolumes.get(toAddress);
            vol[vol.length - 1]++;
          }
        });

        const existingGraph = graphDataRef.current || { nodes: [], links: [] };
        const existingNodesById = new Map();
        const existingTxHashes = new Set();

        (existingGraph.nodes || []).forEach(n => {
          if (n && n.id) {
            existingNodesById.set(n.id, n);
          }
        });
        (existingGraph.links || []).forEach(l => {
          if (l && l.tx) {
            existingTxHashes.add(l.tx);
          }
        });

        const newNodesBatch = [];
        const newLinksBatch = [];

        // Debug: window of txData used for this Live poll.
        let liveMinTs = Infinity;
        let liveMaxTs = -Infinity;

        txData.forEach(tx => {
          if (tx.from != null && tx.to != null && tx.txHash != null) {
            const txHash = tx.txHash;

            // Skip links we already have, so repeated polls don't duplicate.
            if (existingTxHashes.has(txHash)) {
              return;
            }
            existingTxHashes.add(txHash);

            let toIcon = '';
            let shortTo = tx.toName && tx.toName !== `null` ? tx.toName : formatShortAddress(tx.to);

            if (tx.toIcon && tx.toIcon.startsWith('{')) {
              const toIconData = safeParseJSON(tx.toIcon);
              toIcon = toIconData.image;
              shortTo = toIconData.name;
            } else if (tx.toIcon && tx.toIcon.startsWith('data:image/svg+xml;base64,')) {
              toIcon = tx.toIcon;
              shortTo = 'NFT';
            } else if (tx.toIcon && tx.toIcon.length) {
              toIcon = tx.toIcon;
            } else {
              toIcon = tx.toName && tx.toName.includes('.eth') ? genericUserIcon : (tx.toName ? genericTokenIcon : '');
            }

            let fromIcon = '';
            let shortFrom = tx.fromName && tx.fromName !== `null` ? tx.fromName : formatShortAddress(tx.from);

            if (tx.fromIcon && tx.fromIcon.startsWith('{')) {
              const fromIconData = safeParseJSON(tx.fromIcon);
              fromIcon = fromIconData.image;
              shortFrom = fromIconData.name;
            } else if (tx.fromIcon && tx.fromIcon.startsWith('data:image/svg+xml;base64,')) {
              fromIcon = tx.fromIcon;
              shortFrom = 'NFT';
            } else if (tx.fromIcon && tx.fromIcon.length) {
              fromIcon = tx.fromIcon;
            } else {
              fromIcon = tx.fromName && tx.fromName.includes('.eth') ? genericUserIcon : (tx.fromName ? genericTokenIcon : '');
            }

            const substringsToRemove = ['.eth', '.nft'];
            shortTo = removeSubstrings(shortTo, substringsToRemove);
            shortFrom = removeSubstrings(shortFrom, substringsToRemove);

            const txTo = tx.to;
            if (txTo && txTo.includes('.')) {
              const tokenId = txTo.split('.')[1];
              if (!shortTo.includes(tokenId)) {
                shortTo += " (#" + tokenId + ")";
              }
            }

            const txFrom = tx.from;
            if (txFrom && txFrom.includes('.')) {
              const tokenId = txFrom.split('.')[1];
              if (!shortFrom.includes(tokenId)) {
                shortFrom += " (#" + tokenId + ")";
              }
            }

            const fromAddress = tx.from;
            const toAddress = tx.to;

            // Track min/max timestamps at the transaction level.
            let txTs = tx.timestamp;
            if (typeof txTs !== 'number') {
              txTs = convertUTCToLocalAsTimestamp(txTs);
            }
            if (txTs < liveMinTs) liveMinTs = txTs;
            if (txTs > liveMaxTs) liveMaxTs = txTs;

            const fromIsToken = shortFrom.startsWith('0x') ? false : true;
            const toIsToken = shortTo.startsWith('0x') ? false : true;

            if (fromAddress && fromAddress.length && (userTransactions || fromIsToken) && !existingNodesById.has(fromAddress)) {
              const vol = nodeVolumes.get(fromAddress) || new Array(sparkLength).fill(0);

              // If the counterparty already exists, seed this node near that
              // neighbor so new nodes don't all spawn at the origin.
              const neighbor = existingNodesById.get(toAddress);
              const seeded = neighbor && typeof neighbor.x === 'number' && typeof neighbor.y === 'number';

              const newNode = {
                id: fromAddress,
                label: shortFrom,
                group: 1,
                events: 0,
                color: 0x1E90FF,
                value: 0,
                icon: fromIcon,
                volume: vol,
                symbol: tx.fromSymbol,
              };

              if (seeded) {
                const jitter = 5;
                newNode.x = neighbor.x + (Math.random() - 0.5) * jitter;
                newNode.y = neighbor.y + (Math.random() - 0.5) * jitter;
                newNode.z = (neighbor.z || 0) + (Math.random() - 0.5) * jitter;
                newNode.fx = newNode.x;
                newNode.fy = newNode.y;
                newNode.fz = newNode.z;
              }
              existingNodesById.set(fromAddress, newNode);
              newNodesBatch.push(newNode);
            }

            if (toAddress && toAddress.length && (userTransactions || toIsToken) && !existingNodesById.has(toAddress)) {
              const vol = nodeVolumes.get(toAddress) || new Array(sparkLength).fill(0);

              const neighbor = existingNodesById.get(fromAddress);
              const seeded = neighbor && typeof neighbor.x === 'number' && typeof neighbor.y === 'number';

              const newNode = {
                id: toAddress,
                label: shortTo,
                group: 2,
                events: 0,
                color: 0x32CD32,
                value: 0,
                icon: toIcon,
                volume: vol,
                symbol: tx.toSymbol,
              };

              if (seeded) {
                const jitter = 5;
                newNode.x = neighbor.x + (Math.random() - 0.5) * jitter;
                newNode.y = neighbor.y + (Math.random() - 0.5) * jitter;
                newNode.z = (neighbor.z || 0) + (Math.random() - 0.5) * jitter;
                newNode.fx = newNode.x;
                newNode.fy = newNode.y;
                newNode.fz = newNode.z;
              }
              existingNodesById.set(toAddress, newNode);
              newNodesBatch.push(newNode);
            }

            const etherValueWei = tx.value;
            const etherGasWei = tx.gasLimit;
            const txType = tx.txType;

            if (toAddress && fromAddress && toAddress.length && fromAddress.length) {
              if ((toIsToken && fromIsToken) || userTransactions) {
                newLinksBatch.push({
                  txType,
                  timestamp: tx.timestamp,
                  blockNumber: tx.blockNumber,
                  tx: txHash,
                  source: fromAddress,
                  target: toAddress,
                  fromIcon,
                  toIcon,
                  gasLimit: etherGasWei,
                  value: etherValueWei,
                  gasUsed: tx.gasUsed,
                  gasPrice: tx.gasPrice,
                  appearedAt: Date.now() / 1000,
                });
              }
            }
          }
        });

        if (liveMinTs !== Infinity && liveMaxTs !== -Infinity) {
          console.debug('Live runPoll txData window:', {
            txCount: txData.length,
            liveMinTs,
            liveMaxTs,
            liveMinLocal: new Date(liveMinTs * 1000).toISOString(),
            liveMaxLocal: new Date(liveMaxTs * 1000).toISOString(),
          });
        } else {
          console.debug('Live runPoll txData window: no timestamps found', {
            txCount: txData.length,
          });
        }

        // Merge new links with existing. We'll compute the rolling window
        // relative to the newest timestamp present in the data, not the
        // browser wall-clock time, to avoid over-pruning when the backend
        // serves older or cached slices.
        const mergedLinks = [
          ...(existingGraph.links || []),
          ...newLinksBatch,
        ];

        // Find the maximum timestamp across all merged links.
        let maxTs = -Infinity;
        mergedLinks.forEach(l => {
          if (!l || !l.timestamp) return;
          let ts = l.timestamp;
          if (typeof ts !== 'number') {
            ts = convertUTCToLocalAsTimestamp(ts);
          }
          if (ts > maxTs) maxTs = ts;
        });

        // If we couldn't determine any timestamps, keep everything.
        if (maxTs === -Infinity) {
          maxTs = 0;
        }

        const cutoffSec = maxTs - 1200; // 20 minutes before latest tx we have
        const prunedLinks = mergedLinks.filter(l => {
          if (!l || !l.timestamp) return true;

          // Normalize timestamp to numeric seconds so comparison is valid.
          let ts = l.timestamp;
          if (typeof ts !== 'number') {
            ts = convertUTCToLocalAsTimestamp(ts);
          }

          return ts >= cutoffSec;
        });

        console.debug('Live runPoll after time prune:', {
          existingNodeCount: (existingGraph.nodes || []).length,
          existingLinkCount: (existingGraph.links || []).length,
          newNodesBatchCount: newNodesBatch.length,
          newLinksBatchCount: newLinksBatch.length,
          mergedLinkCount: mergedLinks.length,
          prunedLinkCount: prunedLinks.length,
          cutoffSec,
          cutoffLocal: new Date(cutoffSec * 1000).toISOString(),
        });

        // Helper to normalize a link endpoint (which may be a string ID or
        // a node object) into a stable node id string.
        const getNodeId = (endpoint) => {
          if (!endpoint) return null;
          if (typeof endpoint === 'string') return endpoint;
          if (typeof endpoint === 'object' && endpoint.id) return endpoint.id;
          return null;
        };

        // Determine which nodes are still active based on remaining links.
        const activeNodeIds = new Set();
        prunedLinks.forEach(l => {
          if (!l) return;
          const sourceId = getNodeId(l.source);
          const targetId = getNodeId(l.target);
          if (sourceId) activeNodeIds.add(sourceId);
          if (targetId) activeNodeIds.add(targetId);
        });

        // Merge new nodes into existing, then prune to active only.
        const mergedNodes = [
          ...(existingGraph.nodes || []),
          ...newNodesBatch,
        ];

        const prunedNodes = mergedNodes.filter(n => n && activeNodeIds.has(n.id));

        // As an extra safety pass, drop any links whose endpoints are no
        // longer present in the pruned node set. This guarantees there are
        // no dangling links referencing removed nodes.
        const finalNodeIds = new Set(prunedNodes.map(n => n.id));
        const finalLinks = prunedLinks.filter(l => {
          if (!l) return false;
          const sourceId = getNodeId(l.source);
          const targetId = getNodeId(l.target);
          return !!sourceId && !!targetId && finalNodeIds.has(sourceId) && finalNodeIds.has(targetId);
        });

        // Rebuild linkCount for the final graph.
        const newLinkCount = new Map();
        finalLinks.forEach(l => {
          if (!l) return;
          if (l.source) {
            newLinkCount.set(l.source, (newLinkCount.get(l.source) || 0) + 1);
          }
          if (l.target) {
            newLinkCount.set(l.target, (newLinkCount.get(l.target) || 0) + 1);
          }
        });
        setLinkCount(newLinkCount);

        // Keep a parallel transactions list based on the final links.
        const newTransactions = finalLinks.map(l => {
          const sourceId = getNodeId(l.source);
          const targetId = getNodeId(l.target);

          return {
            txType: l.txType,
            timestamp: l.timestamp,
            blockNumber: l.blockNumber,
            tx: l.tx,
            source: sourceId,
            target: targetId,
            fromIcon: l.fromIcon,
            toIcon: l.toIcon,
            gasLimit: l.gasLimit,
            value: l.value,
            gasUsed: l.gasUsed,
            gasPrice: l.gasPrice,
          };
        });
        setTransactions(newTransactions);

        const liveGraph = { nodes: prunedNodes, links: finalLinks };
        const classified = classifyGraphNodes(liveGraph);
        const enhancedNodes = ensureTokenIcons(classified.nodes || []);
        const finalGraph = { nodes: enhancedNodes, links: classified.links || [] };
        setGraphData(finalGraph);

        setLiveLastEndTime(endSec);
      } catch (e) {
        console.error('Live mode polling error:', e);
      }
    };

    // Kick off immediately, then on interval.
    runPoll();
    liveIntervalRef.current = setInterval(runPoll, pollIntervalMs);

    return () => {
      if (liveIntervalRef.current) {
        clearInterval(liveIntervalRef.current);
        liveIntervalRef.current = null;
      }
    };
  }, [isLiveMode, dataSource, userID, useTime, isTourRunning, stopCameraSpin, isAuthenticated, dateRange]);

  // Stories LIVE mode: when on /links in Stories mode with Live enabled,
  // refresh story addresses every 60 seconds then re-run the normal transaction
  // fetch (getTransactions filters to story addresses internally).
  useEffect(() => {
    if (!isLiveMode || !location.pathname.startsWith('/graphs') || linksDataMode !== 'stories') {
      if (storiesLiveIntervalRef.current) {
        clearInterval(storiesLiveIntervalRef.current);
        storiesLiveIntervalRef.current = null;
      }
      return;
    }

    const runStoriesPoll = async () => {
      try {
        await fetchStoryAddresses();
        await fetchEthTransactions();
      } catch (e) {
        console.error('Stories Live poll error:', e);
      }
    };

    storiesLiveIntervalRef.current = setInterval(runStoriesPoll, 60000);
    return () => {
      if (storiesLiveIntervalRef.current) {
        clearInterval(storiesLiveIntervalRef.current);
        storiesLiveIntervalRef.current = null;
      }
    };
  }, [isLiveMode, linksDataMode, location.pathname]);

  
  const handleTouchStart = (event) => {
    if (event.touches.length === 2) { // Check if two fingers are placed on the screen
      stopCameraSpin();  
    }
  };

  const onPointer = (e) => {
    // Any pointer interaction (mouse drag, touch, pen) inside the graph
    // container should immediately stop the camera spin so it doesn't
    // fight with user panning/zooming.
    stopCameraSpin();
  };

  const graphContainerRef = useRef(null);
  const tokenContainerRef = useRef(null);
  const containerRef = useRef(null);

  useEffect(() => {
    const graphContainer = graphContainerRef.current;
    if (!graphContainer) return;
  
    graphContainer.addEventListener('touchstart', handleTouchStart);
    graphContainer.addEventListener('pointerdown', onPointer);
    graphContainer.addEventListener('pointermove', onPointer);
    graphContainer.addEventListener('pointerup', onPointer);
    graphContainer.addEventListener('keydown', handleEvent);
    graphContainer.addEventListener('click', handleEvent);
  
    return () => {
      graphContainer.removeEventListener('touchstart', handleTouchStart);
      graphContainer.removeEventListener('pointerdown', onPointer);
      graphContainer.removeEventListener('pointermove', onPointer);
      graphContainer.removeEventListener('pointerup', onPointer);
      graphContainer.removeEventListener('keydown', handleEvent);
      graphContainer.removeEventListener('click', handleEvent);
    };
  }, []);

  const [timeRange, setTimeRange] = useState([20, 80]); // Example range values
  const sparklineData = [5, 10, 5, 20, 8, 15, 10, 25, 20, 30, 45]; // Example data

  // Handler for the slider
  const onSliderChange = (value) => {
    setTimeRange(value);
    // Additional logic to update your graph based on the slider's range
  };

 
  useEffect(() => {
    if (viewGraph && graphRef && graphRef.current) {
      // Access the force simulation and stop it
      const forceSim = graphRef.current.d3Force('simulation');
      if (forceSim) {
        setTimeout(() => forceSim.stop(), 100); // Stop the simulation after a brief period
      }
    }
  }, []);
  
  

  const timeIntervals = ['30s', '1m', '5m', '10m', '30m', '1h'];

  const TimeButton = ({ label, onClick }) => {
    return (
      <Button className={classes.linkButtonStyle} onClick={() => onClick(label)}>
        {label}
      </Button>
    );
  };

  // Handler for when the text field changes
  const handleMaxTransactionsChange = (event) => {
    setMaxTransactions(event.target.value);
  };

  
  // Ref to store the interval ID
  const intervalRef = useRef(null);

  // Function to be called on interval
  const goToNextNode = () => {
    setCurrentNodeIndex((currentIndex) => {
      let nextIndex = currentIndex;
      let foundNodeWithIcon = false;
      let arrowDown = false;
  
      do {
        nextIndex = (nextIndex + 1) % graphDataRef.current.nodes.length;

        if (filterNFT && nextIndex == graphDataRef.current.nodes.length - 1) {
          nextIndex = 0;
          arrowDown = true;
          // simulate an ArrowDown key press
          var event = new KeyboardEvent('keydown', {'key':'ArrowDown'});
          document.dispatchEvent(event);
          break;
        }

        if (graphDataRef.current.nodes[nextIndex].icon) {
          foundNodeWithIcon = true;
          break;
        }
  
        // If we reached the end, loop back to the start
        if (nextIndex === tokenList.length - 1) {
          setIsTourRunning(false)
          nextIndex = -1; // This will be incremented to 0 by the loop
        }
        
      } while (nextIndex !== currentIndex);
  
      if (arrowDown) {
        return nextIndex;
      }

      // If a node with an icon is found, move the camera and trigger the
      // normal node-click behavior so the list selection and token info
      // window stay in sync with the tour.
      if (foundNodeWithIcon) {
        const node = graphDataRef.current.nodes[nextIndex];
        moveToNode(graphDataRef.current, graphRef, node);
        handleNodeClick(dataSource, graphDataRef.current, graphRef, node.id, true);
      }
  
      return nextIndex;
    });
  };
  

  // Effect to handle the starting and stopping of the tour
  useEffect(() => {
    if (isTourRunning) {
      // Start the interval
      intervalRef.current = setInterval(goToNextNode, (viewGraph) ? tourSpeedGraph : tourSpeedList);
    } else {
      // Clear the interval if it's running
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    }

    // Cleanup interval on component unmount
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
      }
    };
  }, [isTourRunning]);

  // Start or stop the tour
  const toggleTour = () => {
      if (!isTourRunning) {
        // Starting the tour: stop any existing camera spin so it doesn't
        // fight with the automatic tour movement.
        stopCameraSpin();
        goToNextNode();
      }
      setIsTourRunning(!isTourRunning);
  };

  const goToPreviousTimeRange = () => {
      setIsTourRunning(false); // Stop the tour
      const newStartDate = dateRange.startDate - 300; //(dateRange.endDate - dateRange.startDate);
      const newEndDate = dateRange.startDate - 1;
      //the global state won't be set for the fetch call, so we have to pass the new dates in
      setDateRange( newStartDate, newEndDate);
      resetGraph();
      getTransactions( dataSource, null, false, newStartDate, newEndDate );
  };

  const goToNextTimeRange = () => {
      setIsTourRunning(false); // Stop the tour
      const newStartDate = dateRange.endDate + 300; //1;
      const newEndDate = newStartDate + 300; // dateRange.endDate + (dateRange.endDate - dateRange.startDate);
      //the global state won't be set for the fetch call, so we have to pass the new dates in
      setDateRange( newStartDate, newEndDate);
      resetGraph();
      getTransactions( dataSource, null, false, newStartDate, newEndDate );
  };

  const goToPreviousNode = () => {
      stopCameraSpin();
      setIsTourRunning(false); // Stop the tour
    
      setCurrentNodeIndex((currentIndex) => {
        let prevNodeIndex = currentIndex === 0 ? graphData.nodes.length - 1 : currentIndex - 1;
    
        while (!tokenList[prevNodeIndex].icon) {
          prevNodeIndex = prevNodeIndex === 0 ? graphData.nodes.length - 1 : prevNodeIndex - 1;
          if (prevNodeIndex === currentIndex) break; // Break if a full loop is completed
        }
    
        if (tokenList[prevNodeIndex].icon) {
            moveToNode(graphData, graphRef, graphData.nodes[prevNodeIndex]);
        }
    
        return prevNodeIndex;
      });
  };
  
  const goToNextNodeManually = () => {
      stopCameraSpin();
      setIsTourRunning(false); // Stop the tour
    
      setCurrentNodeIndex((currentIndex) => {
        let nextNodeIndex = (currentIndex + 1) % graphData.nodes.length;
    
        while (!graphData.nodes[nextNodeIndex].icon) {
          nextNodeIndex = (nextNodeIndex + 1) % tokenList.length;
          if (nextNodeIndex === currentIndex) break; // Break if a full loop is completed
        }
    
        if (graphData.nodes[nextNodeIndex].icon) {
          handleNodeClick(dataSource, graphData, graphRef, graphData.nodes[nextNodeIndex].id, true);
        }
    
        return nextNodeIndex;
      });
  };


  function moveToNode(graphData, graphRef, node) {
    if (node) {
      if (viewGraph && graphRef.current) {
        // Calculate the distance you want to stop in front of the node
        const stopDistance = 800; // Distance from the node to stop at

        // Assuming the camera is above the graph looking down, we might only need to adjust z
        const finalPosition = { x: node.x, y: node.y, z: node.z - stopDistance };

        // First, turn to face the destination node immediately, might not be necessary if you're going to set lookAt in the next step anyway
        graphRef.current.cameraPosition(undefined, { x: node.x, y: node.y, z: node.z }, 1000);

        // After a delay (to allow the camera to turn), fly towards the node and adjust to look at it directly
        setTimeout(() => {
          // Move the camera to the final position and ensure it's looking at the node
          graphRef.current.cameraPosition(finalPosition, { x: node.x, y: node.y, z: node.z }, 2500); // Takes 2.5 seconds to fly
        }, 1000); // Delay to ensure the camera has turned
      }
      else {
        if (imgRefs[currentNodeIndex].current) {
          imgRefs[currentNodeIndex].current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }); // Scroll image into view
        }
        setImageKey(Date.now());
      } 
    }
  }

  // saveIconToAddress
  const saveIconToAddress = async(dataSource, address,icon) => {
    try {
      const response = await axios.get(`${SERVER_NAME}/saveIconToAddress/`, {
        params: {
          dataSource: dataSource,
          address: address,
          icon: icon,
        },
      });
    } catch (error) {
      console.error('Error saving token info:', error);
    }
  }

  const filterOnCurrentNode = async () => {
    if (!activeNodeId) return;
    let nodeId = activeNodeId.split('.')[0] || activeNodeId;
    setSearchText(nodeId);
  };
  
  const gotoEtherscan = async () => {
    if (!activeNodeId) return;
    const nodeId = activeNodeId.split('.')[0] || activeNodeId;
    const url = (filterNFT) ? `https://etherscan.io/token/${nodeId}#inventory` : `https://etherscan.io/address/${nodeId}`
    window.open(url, '_blank');
  };

  const [trigger4, setTrigger4] = useState(0);

  useEffect(() => {
      if (trigger4 == false) return;
      setTrigger4(0);
      
      // Only perform graph operations when not in BubblesView mode
      if (!props.showBubblesView) {
          layoutManager.handleDistributeAll(graphData);
          //setTimeout(() => graphRef.current.zoomToFit(), 1000);
          if (graphRef.current) {
              // Don't override user/search-initiated zoom.
              if (Date.now() >= (suppressAutoFitUntilRef.current || 0)) {
                graphRef.current.zoomToFit(1000, 80);
              }
          }
      }
  }, [trigger4, props.showBubblesView]);

  const [trigger3, setTrigger3] = useState(0);

  useEffect(() => {
      if (trigger3 === 0) return;
      setTrigger3(0);
      
      // Skip node operations in BubblesView mode
      if (!props.showBubblesView) {
        const node = graphData.nodes.find(n => n.id === activeNodeId);
        if (node) {
          handleNodeClick(dataSource, graphData, graphRef, activeNodeId, true);
        }
      }
  }, [trigger3, isDataReady, props.showBubblesView]);

  const [trigger2, setTrigger2] = useState(0);

  useEffect(() => {
      if (trigger2 === 0) return;
      setTrigger2(0);
      
      // Skip layout operations in BubblesView mode
      if (!props.showBubblesView) {
        layoutManager.handleDistributeAll(graphData);
        setTrigger3(trigger3 + 1);
      }
  }, [graphData, trigger2, isDataReady, props.showBubblesView]);

  const [trigger, setTrigger] = useState(0);

  useEffect(() => {
      if (trigger == 0) return;
      setTrigger(0);
      
      // Skip token operations in BubblesView mode
      if (!props.showBubblesView) {
        addTokenToGraphData(activeNodeId);
        setTrigger2(trigger2 + 1);
      }
  }, [trigger, props.showBubblesView]);

  
  const handleNodeClick = useCallback(async (dataSource, graphData, graphRef, nodeId, zoom, tokenType) => {
    // For all view modes, including bubbles view, we need to set activeNodeId
    setActiveNodeId(nodeId);

    const pathNow = (() => {
      try {
        if (location && typeof location.pathname === 'string') return location.pathname;
      } catch (e) {
      }
      try {
        if (typeof window !== 'undefined' && window.location && typeof window.location.pathname === 'string') return window.location.pathname;
      } catch (e2) {
      }
      return '';
    })();
    const isLinksPath = String(pathNow || '').startsWith('/graphs');
    const isPricePath = String(pathNow || '').startsWith('/price');
    const nodeIdRaw = nodeId != null ? String(nodeId).trim() : '';
    const nodeIdLower = nodeIdRaw.toLowerCase();
    const isHexAddress = nodeIdLower.startsWith('0x');

    if (isPricePath && tokenType !== 'NFT' && isHexAddress) {
      navigate(`/token/${encodeURIComponent(nodeIdRaw)}`);
      return;
    }

    const findNodeById = (nodes) => {
      try {
        if (!Array.isArray(nodes) || !nodeIdRaw) return null;
        const exact = nodes.find((n) => n && String(n.id || '').trim() === nodeIdRaw);
        if (exact) return exact;
        if (!isHexAddress) return null;
        return nodes.find((n) => n && String(n.id || '').trim().toLowerCase() === nodeIdLower) || null;
      } catch (e) {
        return null;
      }
    };
    
    // Skip certain operations if node is already active or if in bubbles view.
    // When zoom=true (NodeList click) always proceed so the camera always flies
    // to the node even if it is already the active selection.
    if (!props.showBubblesView && !zoom) {
      if (activeNodeId == nodeId) return;
      
      if (!viewGraph && filterNFT && imgRefs.length && imgRefs.length >= currentNodeIndex && imgRefs[currentNodeIndex].current) {
        imgRefs[currentNodeIndex].current.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' }); // Scroll image into view
        setImageKey(Date.now());
        //return;
      }
    }

    if (filterNFT || tokenType == 'NFT') {
      tokenType = 'NFT';
      const address = nodeId.split('.')[0];
      if (!address.length) { return; }
      setChartData(null);
      const tokens = await getTokenList(dataSource, address, false, tokenType, userID);
      setGraphData(classifyGraphNodes({ nodes: tokens, links: [] }));
      setImageKey(Date.now());
      setCurrentNodeIndex(0);
      nodeId = address;
      if (nodeListRef && nodeListRef.current) {
        nodeListRef.current.scrollToActiveNode(nodeId);
      }
      setActiveNodeId(nodeId);

      setLike('none');
      const nftCollectionNode = tokenList.find(t => t.id === nodeId);
      if (nftCollectionNode) {
        const vote = nftCollectionNode.likes > 0 ? 'like' : 'none';
        setLike(vote);
      }

      return;
    }

    //if (!graphRef.current) return;

    let node = (!viewGraph)
      ? (tokenList.find((t) => t && String(t.id || '').trim() === nodeIdRaw) || (isHexAddress ? tokenList.find((t) => t && String(t.id || '').trim().toLowerCase() === nodeIdLower) : null))
      : findNodeById(graphData && graphData.nodes ? graphData.nodes : []);

    if (node && node.id != null) {
      const canonicalId = String(node.id).trim();
      if (canonicalId && canonicalId !== nodeIdRaw) {
        nodeId = canonicalId;
        setActiveNodeId(canonicalId);
      }
    }
    
    // Only use nodeListRef if not in bubbles view and ref exists
    if (!props.showBubblesView && nodeListRef && nodeListRef.current) {
      nodeListRef.current.scrollToActiveNode(nodeId);
    }
    
    // Fix for token icons: When clicking on a token in the list, update its icon in the graph
    if (!filterNFT && filterToken && tokenList && tokenList.length > 0) {
      // Find the token in the tokenList
      const tokenMatch = tokenList.find(token => token.id === nodeId);
      if (tokenMatch && tokenMatch.icon && node && (node.icon === genericTokenIcon || !node.icon)) {
        // Update the node's icon with the token icon from the list
        node.icon = tokenMatch.icon;
        // Also update the graph data with this icon so it persists
        setGraphData(prevGraphData => {
          const updatedNodes = [...prevGraphData.nodes];
          const nodeIndex = updatedNodes.findIndex(n => n.id === nodeId);
          if (nodeIndex >= 0) {
            updatedNodes[nodeIndex].icon = tokenMatch.icon;
          }
          return {...prevGraphData, nodes: updatedNodes};
        });
      }
    }

    if (!node) {
      if (!isLinksPath) {
        if (viewGraph) {
          setTrigger(prevTrigger => prevTrigger + 1);
        }

        if (!isMobile) {
          await getTransactions(dataSource, nodeId, true);
        }
      }

      return;
    }

    if (node) {
      // Only attempt to move camera in graph view, not in bubbles view
      if (!props.showBubblesView && zoom && viewGraph && graphRef.current) {
        stopCameraSpin();
        moveToNode(graphData, graphRef, node);  
      }
      
      setActiveNodeName(node.label);
      const tokenEntry = tokenList.find(t => t.id === nodeId);
      if (tokenEntry) {
        setCurrentNodeIndex(tokenList.indexOf(tokenEntry));
      }
    } 

    const shouldFetchTokenInfo = Boolean(showChart || (!viewGraph && (filterToken || (() => {
      try {
        const p = (typeof window !== 'undefined' && window.location && typeof window.location.pathname === 'string')
          ? window.location.pathname
          : '';
        return p.startsWith('/price');
      } catch (e) {
        return false;
      }
    })())));
    if (shouldFetchTokenInfo) {
      const tokenAddress = nodeId;
      const chain = (node && node.chain) ? String(node.chain).toUpperCase() : 'ETH';
      // In PCAP mode, node ids are often IPs/MACs. Don't call token metadata endpoints for those.
      const isIPv4 = /^\d{1,3}(?:\.\d{1,3}){3}$/.test(String(tokenAddress || '').trim());
      const looksLikeMacOrIpv6 = String(tokenAddress || '').includes(':');
      if (dataSource === PCAP || chain === 'PCAP' || isIPv4 || looksLikeMacOrIpv6) {
        return;
      }
      const serverUrl = `${SERVER_NAME}/getTokenInfoJson?chain=${encodeURIComponent(chain)}&address=${encodeURIComponent(tokenAddress)}`;

      try {
        const response = await fetch(serverUrl);
        const data = await response.json();
        if (data) {
          setTokenData((data && data.description && data.description.en) ? data : null);

          if (node && node.icon === genericTokenIcon && data && data.image && data.image.large) {
            saveIconToAddress(dataSource, tokenAddress, data.image.large);
            node.icon = data.image.large;
          }
        }
      } catch (error) {
        console.error('Error fetching token info JSON:', error);
      }
    }
  }, [dataSource, graphData, graphRef, navigate, props.showBubblesView, viewGraph]);
  
  const handleLinkClick = async (dataSource, graphData, graphRef, linkId, zoom) => {
    const link = graphData.links.find(n => n.tx === linkId);
    if (!link || !graphRef.current) return;

    const node = graphData.nodes.find(n => n.id === link.target.id);
    if (!node) return;
  
    if (zoom) {
      stopCameraSpin();
      moveToNode(graphData, graphRef, node);
    }
    setActiveLinkId(linkId);
   
    const tokenAddress = node.id;
    const chain = (node && node.chain) ? String(node.chain).toUpperCase() : 'ETH';
    const serverUrl = `${SERVER_NAME}/getTokenInfoJson?chain=${encodeURIComponent(chain)}&address=${encodeURIComponent(tokenAddress)}`;
  
    try {
      const response = await fetch(serverUrl);
      const data = await response.json();

      setTokenData((data && data.description) ? data : null);

      if (node.icon === genericTokenIcon && data && data.contract_address && data.image && data.image.large) {
        saveIconToAddress(dataSource, data.contract_address, data.image.large);
        node.icon = data.image.large;
      }
    } catch (error) {
      console.error('Error fetching token info:', error);
    }
  };
  
  useEffect(() => {
    if (filterNFT && isDataReady && tokenList.length > 0) {
  
      // we might already have a node id passed in with the url (eg /nft/0x1234...)
      let nodeId = defaultNodeId;
      let zoom = true;

      if (!nodeId) {
        if (filterNFT) {
          const tokens = tokenList.sort((a, b) => {
            // Check if the first character of each label is a number
            const aIsNumber = !isNaN(a.label[0]);
            const bIsNumber = !isNaN(b.label[0]);
        
            // If a starts with a letter and b starts with a number, a comes first
            if (!aIsNumber && bIsNumber) {
                return -1;
            }
        
            // If a starts with a number and b starts with a letter, b comes first
            if (aIsNumber && !bIsNumber) {
                return 1;
            }
        
            // If both start with a letter or both start with a number, compare as usual
            return a.label.localeCompare(b.label);
          });

          nodeId = tokens[0].id;
        } else if (filterToken) {
          const tokens = tokenList.sort((a, b) => b.price - a.price);
          nodeId = tokens[0].id;
          zoom = false;
        }
      }

      if (nodeId) {
        setTimeout(() => {
          setActiveNodeId(nodeId);
          const tokenType = filterNFT ? 'NFT' : 'Token';
          handleNodeClick(dataSource, graphData, graphRef, nodeId, zoom, tokenType);
        }, 2000);
      }
    }
  }, [isDataReady]);


  // Called by GraphComponent when a node is clicked in /links Stories mode.
  // If the node is a story address, show the story popover instead of the
  // normal token info panel.
  const handleStoryNodeClick = useCallback((nodeId, screenX, screenY) => {
    const key = String(nodeId || '').toLowerCase();
    const stories = storyNodeMapRef.current.get(key);
    if (stories && stories.length > 0) {
      setStoryPopover({ nodeId, stories, x: screenX, y: screenY });
      return true; // consumed — caller should skip normal handleNodeClick
    }
    return false;
  }, []);

  const loadView = async () => {
    if (filterNFT) {
      await getTokenList(dataSource, "", true);
    }

    if (filterToken) {
      getTransactions(dataSource,'',true);
      startCameraSpin();
    }
  }
 
  useEffect(() => {
    if (reload) {
      loadView();
      setReload(false);
    }
  }, [reload]);


  const getActiveTokenPrice = async () => {
    const token = tokenList.find(t => t.id === activeNodeId);
    if (token && token.price) {
      return token.price;
    }
    return 0;
  }

  const getActiveTokenUniswapVersion = async () => {
    const token = tokenList.find(t => t.id === activeNodeId);
    if (token && token.version) {
      console.log('getActiveTokenUniswapVersion.  activeNodeId: ', activeNodeId, ' token.version: ', token.version);
      return token.version;
    }
    return 0;
  }

  useEffect(() => {
    if (isAuthenticated && activeNodeId) {
      //console.log('call fetchTokenPrice.  activeNodeId: ', activeNodeId);

      const fetchTokenPrice = async () => {
        const price = await getActiveTokenPrice();
        setTokenPrice(price);
      };

      const fetchTokenUniswapVersion = async () => {
        const uniswapVersion = await getActiveTokenUniswapVersion();
        setTokenUniswapVersion(uniswapVersion);
      };

      fetchTokenPrice();
      fetchTokenUniswapVersion();
    }
  }, [activeNodeId]);


  if (isFirstOrient) {
    setIsFirstOrient(false);
    handleOrientationChange();
  }

  const optionsPopupClose = async (save, subscribeNewsletterParam) => {
    setShowOptionsPopup(false);

    if (save && subscribeNewsletterParam !== undefined) {
      try {
        console.log('Updating newsletter subscription status to:', subscribeNewsletterParam);
        const response = await axios.post(`${SERVER_NAME}/subscribeNewsletter`, {
          username: username,
          subscribeNewsletter: subscribeNewsletterParam,
        }, { withCredentials: true });
        
        if (response.status === 200) {
          // Show a temporary success message
          const subscriptionStatus = subscribeNewsletterParam ? 'subscribed' : 'unsubscribed';
          const message = `Successfully ${subscriptionStatus} from the newsletter`;
          setSnackbarMessage(message);
          setSnackbarOpen(true);
          console.log(message);
        }
      } catch (error) {
        console.error('Error updating newsletter subscription:', error);
        setSnackbarMessage('Error updating your newsletter preferences');
        setSnackbarOpen(true);
      }
    }
  }


  function SearchField({ initialSearchText, onSearchTextChange, handleSearch, commitOnEnterOnly = false, rightAdornment = null }) {
    const [searchFieldText, setSearchFieldText] = useState(initialSearchText);
    const inputRef = useRef();
    const [recentFilesAnchorEl, setRecentFilesAnchorEl] = useState(null);
    const [recentFilesItems, setRecentFilesItems] = useState([]);
    const [recentFilesLoading, setRecentFilesLoading] = useState(false);

    const openPcapUrlViaJob = async (rawUrl) => {
      const raw = String(rawUrl || '').trim();
      if (!raw) return;

      let prevUrl = '';
      try {
        if (typeof window !== 'undefined') {
          prevUrl = window.__E3D_PCAP_LAST_URL__ ? String(window.__E3D_PCAP_LAST_URL__) : '';
        }
      } catch (e) {
      }

      try {
        if (typeof setShowOpenPcapButton === 'function') setShowOpenPcapButton(false);
      } catch (e) {
      }

      // Note: We used to clear graphData and remount when reopening the same URL,
      // but this causes WebGL context loss. The ForceGraph component handles data
      // updates correctly without needing a full remount.
      if (prevUrl && prevUrl === raw) {
        try { pcapBaseGraphRef.current = null; } catch (e) {}
      }

      setIsLoading(true);
      setProgressVisible(true);
      try { setProgress(0); } catch (e) {}

      // Save progress state immediately so it persists across component remounts
      try {
        if (typeof window !== 'undefined') {
          window.__E3D_PCAP_RENDER_READY__ = false;
          window.__E3D_PCAP_LAST_URL__ = raw;
          window.__E3D_PCAP_PROGRESS_VISIBLE__ = true;
          window.__E3D_PCAP_PROGRESS__ = 0;
          window.__E3D_PCAP_SHOW_OPEN_BUTTON__ = false;
        }
      } catch (e) {
      }

      try {
        const createResp = await axios.post(`${SERVER_NAME}/openPcapUrlJob`, { url: raw }, { withCredentials: false });
        const jobId = createResp && createResp.data && createResp.data.jobId ? String(createResp.data.jobId) : '';
        if (!jobId) throw new Error('Failed to start job');

        const startedAt = Date.now();
        const maxWaitMs = 30 * 60 * 1000;
        let lastProgress = 0;

        while (true) {
          if ((Date.now() - startedAt) > maxWaitMs) throw new Error('Timed out waiting for job');

          const statusResp = await axios.get(`${SERVER_NAME}/openPcapUrlJob/${encodeURIComponent(jobId)}/status`, { withCredentials: false });
          const phase = statusResp && statusResp.data && statusResp.data.phase ? String(statusResp.data.phase) : '';
          const errMsg = statusResp && statusResp.data && statusResp.data.error ? String(statusResp.data.error) : '';
          const percent = statusResp && statusResp.data && statusResp.data.download && statusResp.data.download.percent != null
            ? Number(statusResp.data.download.percent)
            : null;

          if (phase === 'error') throw new Error(errMsg || 'Job failed');
          if (phase === 'done') {
            try {
              setProgress(100);
              if (typeof window !== 'undefined') {
                window.__E3D_PCAP_PROGRESS__ = 100;
              }
            } catch (e) {}
            break;
          }

          let p = lastProgress;
          if (phase === 'downloading') {
            if (percent != null && Number.isFinite(percent)) {
              p = Math.max(p, Math.min(80, Math.round((percent / 100) * 80)));
            } else {
              p = Math.max(p, 5);
            }
          } else if (phase === 'converting') {
            p = Math.max(p, 90);
          } else {
            p = Math.max(p, 1);
          }
          lastProgress = p;
          try {
            setProgress(p);
            // Save to window immediately so it persists across remounts
            if (typeof window !== 'undefined') {
              window.__E3D_PCAP_PROGRESS__ = p;
            }
          } catch (e) {}

          await new Promise((r) => setTimeout(r, 1000));
        }

        const resultResp = await axios.get(`${SERVER_NAME}/openPcapUrlJob/${encodeURIComponent(jobId)}/result`, { withCredentials: false, responseType: 'text' });
        const csvText = resultResp && typeof resultResp.data === 'string' ? resultResp.data : '';
        if (!csvText) throw new Error('Failed to open URL: empty response');

        if (typeof parseAndLoadPcapCsvData === 'function') {
          await parseAndLoadPcapCsvData(csvText);
        }

        try { setDataSource(PCAP); } catch (e) {}
        try { setOrganicLayout(true); } catch (e) {}
        try { setViewGraph(true); } catch (e) {}
        try { setShowPanel(true); } catch (e) {}
        try { setIsDataReady(true); } catch (e) {}

        try {
          if (typeof setShowOpenPcapButton === 'function') setShowOpenPcapButton(false);
        } catch (e) {
        }

        try {
          await axios.post(`${SERVER_NAME}/recentFiles`, { path: raw }, { withCredentials: true });
        } catch (e) {
        }
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message)
          ? String(e.response.data.message)
          : (e && e.message ? String(e.message) : 'Failed to open URL');
        console.log(e);
        if (typeof setSnackbarSeverity === 'function') setSnackbarSeverity('error');
        if (typeof setSnackbarMessage === 'function') setSnackbarMessage(msg);
        if (typeof setSnackbarOpen === 'function') setSnackbarOpen(true);
      } finally {
        try {
          setProgressVisible(false);
          setIsLoading(false);
          setIsDataReady(true);
          // Clear the gallery loading flag
          if (typeof window !== 'undefined') {
            window.__E3D_PCAP_IS_LOADING_FROM_GALLERY__ = false;
          }
        } catch (e2) {
        }
      }
    };

    useEffect(() => {
      try {
        try {
          if (typeof window !== 'undefined') {
            window.__E3D_OPEN_PCAP_URL_VIA_JOB__ = openPcapUrlViaJob;
          }
        } catch (e) {
        }
        if (!inputRef || !inputRef.current || typeof inputRef.current.focus !== 'function') return;
        const dialogOpen = typeof document !== 'undefined' && !!document.querySelector('.MuiDialog-root');
        const activeTag = document && document.activeElement && document.activeElement.tagName
          ? String(document.activeElement.tagName).toLowerCase()
          : '';
        const activeIsEditable = activeTag === 'input' || activeTag === 'textarea' || activeTag === 'select' || (document && document.activeElement && document.activeElement.isContentEditable);
        if (dialogOpen || activeIsEditable) return;
        inputRef.current.focus();
      } catch (e) {
      }
    }, []);

    useEffect(() => {
      setSearchFieldText(initialSearchText);
    }, [initialSearchText]);
    
    const handleChange = (event) => {
      const value = event.target.value;
      setSearchFieldText(value);
      if (!commitOnEnterOnly) {
        onSearchTextChange(value);
      }
    };
    const handlePaste = (event) => {
      event.preventDefault();
      const pastedText = (event.clipboardData || window.clipboardData).getData('text');
      setSearchFieldText(pastedText);
      if (!commitOnEnterOnly) {
        onSearchTextChange(pastedText);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === 'Enter') {
        const raw = (searchFieldText || '').trim();

        const looksLikeUrl = /^https?:\/\//i.test(raw) || /^ipfs:\/\//i.test(raw);

        if (location.pathname.startsWith('/price')) {
          setPriceSearchText(raw);
          resetAndLoadPriceList({ sortBy: priceListSortBy, sortDir: priceListSortDir, searchOverride: raw });
          if (inputRef.current) {
            inputRef.current.focus();
          }
          return;
        }

        // PCAP is a local file: Enter should never trigger backend queries.
        // Instead, just search the currently displayed NodeList rows (match on
        // label or id) and zoom/select that node in the graph.
        if (dataSource === PCAP) {
          if (looksLikeUrl) {
            (async () => {
              await openPcapUrlViaJob(raw);
            })();
          } else if (raw) {
            handleSearchFromDialogCallback(raw);
          }
          if (inputRef.current) {
            inputRef.current.focus();
          }
          return;
        }

        // If the user entered a 0x-prefixed address, treat Enter as a
        // direct navigation gesture to the links view instead of running
        // the generic search. This matches the manual /links/<address>
        // deep-link behavior.
        if (raw) {
          if (raw.startsWith('0x')) {
            // Use the existing goTo helper so navigation semantics (like
            // _t cache-busting) stay consistent.
            goTo(`/links/${encodeURIComponent(raw)}`);
            return;
          }

          getTransactions(dataSource,raw,true);
        }

        //handleSearch(raw);
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }
    };

    const fetchRecentFiles = async () => {
      try {
        setRecentFilesLoading(true);
        const resp = await axios.get(`${SERVER_NAME}/recentFiles`, { withCredentials: true });
        const items = resp && resp.data && Array.isArray(resp.data.items) ? resp.data.items : [];
        const cleaned = items
          .map((it) => ({
            path: it && it.path ? String(it.path) : '',
            timestamp: it && it.timestamp ? it.timestamp : null,
          }))
          .filter((it) => !!it.path);
        setRecentFilesItems(cleaned);
      } catch (e) {
        setRecentFilesItems([]);
      } finally {
        setRecentFilesLoading(false);
      }
    };

    const handleOpenRecentFiles = async (event) => {
      try {
        setRecentFilesAnchorEl(event.currentTarget);
        await fetchRecentFiles();
      } catch (e) {
      }
    };

    const handleCloseRecentFiles = () => {
      setRecentFilesAnchorEl(null);
    };

    const handleRecentFileSelect = async (path) => {
      let didStartLoading = false;
      try {
        const raw = String(path || '').trim();
        if (!raw) return;

        // Show selection in the input.
        setSearchFieldText(raw);
        onSearchTextChange(raw);

        const looksLikeUrl = /^https?:\/\//i.test(raw) || /^ipfs:\/\//i.test(raw);
        if (!looksLikeUrl) return;

        didStartLoading = true;
        await openPcapUrlViaJob(raw);
      } catch (e) {
        const msg = (e && e.response && e.response.data && e.response.data.message)
          ? String(e.response.data.message)
          : (e && e.message ? String(e.message) : 'Failed to open URL');
        if (typeof setSnackbarSeverity === 'function') setSnackbarSeverity('error');
        if (typeof setSnackbarMessage === 'function') setSnackbarMessage(msg);
        if (typeof setSnackbarOpen === 'function') setSnackbarOpen(true);
      } finally {
        if (didStartLoading) {
          try {
            setProgressVisible(false);
            setIsLoading(false);
            setIsDataReady(true);
          } catch (e2) {
          }
        }
      }
    };

    return (
      <div style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', minWidth: 0 }}>
        {rightAdornment && (
          <div style={{ flex: '0 0 auto', display: 'flex', alignItems: 'center' }}>
            {rightAdornment}
          </div>
        )}
        <TextField
          fullWidth
          inputRef={inputRef}
          value={searchFieldText}
          onChange={handleChange}
          onPaste={handlePaste}
          className={classes.searchField}
          style={{ flex: 1, minWidth: 0 }}
          variant="outlined"
          size="small"
          onKeyDown={handleKeyDown}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon style={{ color: 'white' }} />
              </InputAdornment>
            ),
            endAdornment: (
              <InputAdornment position="end">
                {!isMobile && (
                  <div>
                    <Tooltip title="Recent PCAP/CSV">
                      <IconButton
                        onClick={handleOpenRecentFiles}
                        className={classes.iconButtonStyle}
                        edge="end"
                        size="small"
                      >
                        <FaChevronRight style={{ transform: 'rotate(90deg)' }} />
                      </IconButton>
                    </Tooltip>
                    <Menu
                      anchorEl={recentFilesAnchorEl}
                      keepMounted
                      open={Boolean(recentFilesAnchorEl)}
                      onClose={handleCloseRecentFiles}
                    >
                      {recentFilesLoading && (
                        <MenuItem disabled>Loading…</MenuItem>
                      )}
                      {!recentFilesLoading && (!recentFilesItems || !recentFilesItems.length) && (
                        <MenuItem disabled>No recent files</MenuItem>
                      )}
                      {!recentFilesLoading && recentFilesItems && recentFilesItems.map((it) => (
                        <MenuItem
                          key={it.path}
                          onClick={async () => {
                            handleCloseRecentFiles();
                            await handleRecentFileSelect(it.path);
                          }}
                        >
                          {it.path}
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                )}
                {(dataSource === PCAP && progressVisible) && (
                  <div style={{ display: 'flex', alignItems: 'center', marginRight: 8 }}>
                    <CircularProgress size={14} style={{ color: 'rgba(255,255,255,0.75)' }} />
                  </div>
                )}
                {searchFieldText.length && (
                  <div>
                    <IconButton
                      aria-label="clear text"
                      onClick={() => {
                        setSearchFieldText('');
                        if (location.pathname.startsWith('/price')) {
                          setPriceSearchText('');
                          resetAndLoadPriceList({ sortBy: priceListSortBy, sortDir: priceListSortDir, searchOverride: '' });
                        } else {
                          onSearchTextChange('');
                        }
                      }}
                      className={classes.iconButtonStyle}
                      edge="end"
                      size="small"
                    >
                      <ClearIcon style={{ color: 'white' }} />
                    </IconButton>
                    {!location.pathname.startsWith('/price') && (
                      <Tooltip title="Guide">
                        <IconButton onClick={() => handleMenuClick('guide')} className={classes.iconButtonStyle} edge="end" size="small">
                          <FaBook />
                        </IconButton>
                      </Tooltip>
                    )}
                  </div>
                )}
              </InputAdornment>
            ),
          }}
        />
        {!location.pathname.startsWith('/price') && (
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Tooltip title="Search / Reload">
              <IconButton onClick={() => handleMenuClick('refresh')} className={classes.iconButtonStyle} edge="end" size="small">
                <FaRedo />
              </IconButton>
            </Tooltip>
            {!isMobile && (
              <div>
                <Tooltip title="Paste current selection">
                  <IconButton onClick={() => filterOnCurrentNode()} className={classes.iconButtonStyle} edge="end" size="small">
                    <FaPaste /> 
                  </IconButton>
                </Tooltip>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
  
  const PortfolioFilterMenu = ({ setPortfolioFilter }) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null);
  
    const handleOpenMenu = (event) => {
      setAnchorEl(event.currentTarget);
    };
  
    const handleCloseMenu = () => {
      setAnchorEl(null);
    };
  
    const handleFilterChange = (filter) => {
      setPortfolioFilter(filter);
      handleCloseMenu();
    };
  
    return (
      <>
        <Tooltip title="Portfolio Filter">
          <IconButton onClick={handleOpenMenu} className={classes.iconButtonStyle}>
            <FaFilter />
          </IconButton>
        </Tooltip>
  
        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleCloseMenu}
        >
          <MenuItem onClick={() => handleFilterChange("")}>Main Portfolio</MenuItem>
          <MenuItem onClick={() => handleFilterChange("/alllikes")}>All Likes</MenuItem>
          <MenuItem onClick={() => handleFilterChange("/mylikes")}>My Likes</MenuItem>
        </Menu>
      </>
    );
  };
  


  const [like, setLike] = useState('');

  async function vote(choice) {
    if (!userID) {
        console.log('User ID not set');
        setShowLogin(true);
        return;
    }

    const tokenNode = getCurrentNode();
    if (!tokenNode) {
        return;
    }

    console.log(`vote() currentNodeIndex: ${currentNodeIndex} choice:`, choice);

    const address = tokenNode.id;
    const collectionAddress = address.split('.')[0];
    const view = (filterNFT) ? 'nft' : 'token';

    
    try {
      console.log('call /getVote address: ', address);
      const response1 = await axios.get(`${SERVER_NAME}/getVote`, {
        params: {
          userId: userID,
          tokenAddress: address
        }
      });

      // ignore choice parameter for now since we do not have an unlike. the like button is a toggle
      choice = (response1.data === 'like') ? 'none' : 'like';
      setLike(choice);
    } catch (error) {            
      console.error('vote error:', error);
      const message = (error.response && error.response.data) ? error.response.data.message : error;
      console.error(message);
      alert(message);
      return;
    }

    // update the likes count in the graphData
    tokenNode.likes = (choice === 'like') ? tokenNode.likes + 1 : tokenNode.likes - 1;

    // update the likes count in the tokenList
    if (filterNFT) {
      const collectionNode = tokenList.find(token => token.id === collectionAddress);
      if (collectionNode) {
        collectionNode.likes = (choice === 'like') ? collectionNode.likes + 1 : collectionNode.likes - 1;
      }
    }

    setTokenList([...tokenList]);

    let response;
    try {
        console.log('call /vote address:', address, ' choice:', choice);
        await axios.post(`${SERVER_NAME}/vote`, {
            view: view,
            userId: userID, 
            tokenAddress: address,
            vote: choice,
        });

        // if the token is an NFT collection then call /vote again to vote for the collection

        if (address.includes('.')) {
          console.log('call /vote collectionAddress:', collectionAddress, ' choice:', choice);
          await axios.post(`${SERVER_NAME}/vote`, {
            view: view,
            userId: userID, 
            tokenAddress: collectionAddress,
            vote: choice,
          });
        }
    } catch (error) {            
        console.error('vote error:', error);
        const message = (error.response && error.response.data) ? error.response.data.message : error;
        console.error(message);
        alert(message);
        return;
    }

    setCurrentNodeIndex(currentNodeIndex);
  }

  async function getVote() {
      const nftNode = getCurrentNode();
      const address = nftNode.id.split('.')[0];
      const collectionNode = tokenList.find(token => token.id === address);
      //console.log('getVote() address:', address, ' collectionNode:', collectionNode);
      const like = (collectionNode && collectionNode.likes > 0) ? 'like' : 'none';
      setLike(like);
      //console.log('getVote() like:', like);
      return like;

    /*
      //setCurrentNode(node);
      const address = node.id;
      let response;
      try {
          response = await axios.get(`${SERVER_NAME}/getVote`, {
              params: {
                  userId: userID, // replace with actual user ID
                  tokenAddress: address,
              },
          });
      } catch (error) {
          console.error('getVotes error:', error);
          const message = (error.response && error.response.data) ? error.response.data.message : error;
          console.error(message);
          alert(message);
          return;
      }
      const like = response.data;
      return like;
     */
  }

  useEffect(() => {
      const node = getCurrentNode();
      if (userID !== '' && node) {
        getVote();
      }
  }, [graphData, currentNodeIndex, like, userID, getCurrentNode]); // Add the variable that represents the current image to the dependency array

 /*
  // Load initial price history data when BubblesView is first shown
  useEffect(() => {
    // Only act when BubblesView is actually visible
    if (!props.showBubblesView) {
      return;
    }

    // Wait until we know the userID (to avoid firing before auth settles)
    if (!userID) {
      console.log('BubblesView: Waiting for userID before loading initial price history');
      return;
    }

    // If we've already kicked off the initial load, don't start another
    if (hasLoadedInitialPriceHistory) {
      console.log('BubblesView: Initial price history already loaded (guard), skipping');
      return;
    }

    // Extra safety: if we already have price-history data in state, bail out
    if (hasPriceHistoryData && tokenList && tokenList.length > 0) {
      console.log('BubblesView: Price history data already present in state, skipping initial fetch');
      hasLoadedInitialPriceHistory = true;
      return;
    }

    // Set data as not ready while we fetch the meta list
    setIsDataReady(false);
    setHasPriceHistoryData(false);
    setTokenList([]);

    console.log('BubblesView: Loading initial all-range price history meta list');

    // Flip the guard BEFORE firing the request so Strict Mode can't trigger duplicates
    hasLoadedInitialPriceHistory = true;
    console.log('BubblesView: Marked initial meta price history as loading (guard set to true)');

    // Fetch the all-range meta token list (includes per-range changes)
    getTokenListWithHistoryAllRanges(dataSource)
      .then(tokens => {
        if (tokens && tokens.length > 0) {
          console.log(`Received ${tokens.length} tokens from meta price history cache`);
          setTokenList(tokens);
          setIsDataReady(true);
          setHasPriceHistoryData(true);
        } else {
          console.warn('No meta price history data received');
          setIsDataReady(true);
          setHasPriceHistoryData(false);
        }
      })
      .catch(error => {
        console.error('Error fetching initial meta price history data:', error);
        setIsDataReady(true);
        setHasPriceHistoryData(false);
      });
  }, [props.showBubblesView, userID]);
*/

  const renderBubblesView = () => {
    // When the Google ad banner is visible (user not logged in), we pass a
    // simple flag into BubblesView so it can position its bottom bar above
    // the ad banner.
    const showAdBanner = !HIDE_GOOGLE_ADS_BANNER && !debugHideBanner && !isAuthenticated && localStorage.getItem('isAuthenticated') !== 'true';

    return (
      <div style={{ width: '100vw', height: '100vh', overflow: 'hidden', position: 'relative', backgroundColor: '#000' }}>
        <BubblesView
          tokenList={memoizedTokenList}
          dimensions={dimensions}
          handleNodeClick={handleNodeClick}
          dataSource={memoizedDataSource}
          graphData={memoizedGraphData}
          handleMenuClick={handleMenuClick}
          handleIntervalSelection={handleIntervalSelection}
          rangeSelected={rangeSelected}
          isDataReady={isDataReady}
          hasPriceHistoryData={hasPriceHistoryData} // Pass the flag indicating we have price history data
          isMobile={isMobile}
          showAdvancedToolbar={showAdvancedToolbar}
          hasAdBanner={showAdBanner}
        />
        
        {/* Desktop overlay TokenInfoComponent when bottom panel is closed.
            Fill the graph view area and center the panel within it so the
            dialog is positioned relative to the ForceGraph, not the whole
            app window. */}
        {(!isMobile && !showBottom && tokenData) && (
          <div style={{
            position: 'absolute',
            inset: 0,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 2000,
            pointerEvents: 'none',
          }}>
            <div style={{
              maxHeight: '80vh',
              maxWidth: '90vw',
              backgroundColor: 'rgba(0,0,0,0.9)',
              borderRadius: '10px',
              overflow: 'auto',
              pointerEvents: 'auto',
            }}>
              <TokenInfoComponent 
                data={tokenData} 
                onClose={handleCloseTokenInfo} 
                isMobile={isMobile} 
                isPortrait={isPortrait}
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  // If showBubblesView is true, render the BubblesView layout instead of the normal app
  if (props.showBubblesView) {
    return renderBubblesView();
  }

  // Otherwise, render the normal AppContent
  return (
    <div >
      {/* Quick Price Chart Dialog */}
      <Dialog open={!!quickChartToken} onClose={() => setQuickChartToken(null)} maxWidth="md" fullWidth
        PaperProps={{ style: { background: '#0d1117', border: '1px solid rgba(100,120,200,0.3)', borderRadius: 10 } }}>
        <DialogTitle style={{ color: '#e5e7ff', fontSize: 14, paddingBottom: 4, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <span>{quickChartToken ? `${quickChartToken.name || quickChartToken.symbol || 'Token'} — ${priceTrendIntervalSelected || '30D'} Trend` : ''}</span>
          <IconButton onClick={() => setQuickChartToken(null)} size="small" style={{ color: '#666' }}>
            <FaTimes />
          </IconButton>
        </DialogTitle>
        <DialogContent style={{ paddingTop: 4 }}>
          <QuickPriceChart token={quickChartToken} selectedPriceTrendInterval={priceTrendIntervalSelected} />
        </DialogContent>
      </Dialog>
      {showMintNFTDialog && (
        <MintNFTDialog
          open={showMintNFTDialog} 
          onClose={() => setShowMintNFTDialog(false)} 
          setShowMintNFTDialog={setShowMintNFTDialog}
          userAddress={userAddress}
          graphRef={graphRef}
          nodes={memoizedGraphData.nodes}
        />
      )}

      {showCustomNFTDialog && (
        <CustomNFTDialog 
          open={showCustomNFTDialog} 
          onClose={() => setShowCustomNFTDialog(false)} 
          setShowCustomNFTDialog={setShowCustomNFTDialog}
          userAddress={userAddress}
        />
      )}

      {showMintPcapNFTDialog && (
        <MintPcapNFTDialog
          open={showMintPcapNFTDialog}
          onClose={() => setShowMintPcapNFTDialog(false)}
          setShowMintPcapNFTDialog={setShowMintPcapNFTDialog}
          userAddress={userAddress}
          graphRef={graphRef}
          graphData={(graphDataRef && graphDataRef.current) ? graphDataRef.current : graphData}
          pcapCsvText={pcapCsvTextRef.current}
        />
      )}

      {showConnectWalletToMintDialog && (
        <Dialog
          open={showConnectWalletToMintDialog}
          onClose={() => setShowConnectWalletToMintDialog(false)}
          maxWidth="xs"
          PaperProps={{
            style: {
              backgroundColor: '#1b1f2a',
              color: '#f5f7ff',
            },
          }}
        >
          <DialogTitle disableTypography>
            <Typography variant="h6" style={{ color: '#f5f7ff' }}>
              Connect Wallet
            </Typography>
          </DialogTitle>
          <DialogContent>
            <Typography variant="body2" style={{ color: '#f5f7ff' }}>
              Please connect a wallet to mint the network graph.
            </Typography>
            <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10, marginTop: 16 }}>
              <Button
                variant="outlined"
                onClick={() => setShowConnectWalletToMintDialog(false)}
                style={{ color: '#f5f7ff', borderColor: 'rgba(245, 247, 255, 0.6)' }}
              >
                Cancel
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={async () => {
                  try {
                    await connectWallet();
                    setShowConnectWalletToMintDialog(false);
                    setShowMintPcapNFTDialog(true);
                  } catch (e) {
                  }
                }}
                style={{ backgroundColor: '#4fc3f7', color: '#fff' }}
              >
                Connect Wallet
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      )}

      {(() => {
        const path = location && location.pathname ? String(location.pathname) : '';
        const isPcapRoute = path === '/pcap';
        const isFlowRoute = path.startsWith('/flows');

        // If we leave /pcap while the "Select File / Load Demo" overlay is showing,
        // ensure it can't keep rendering on other routes.
        try {
          if (!isPcapRoute && showOpenPcapButton) setShowOpenPcapButton(false);
        } catch (e) {
        }

        return (
          <>
            {isPcapRoute && (
              <PcapView
                showOpenPcapButton={showOpenPcapButton}
                demoPcapLoading={demoPcapLoading}
                onSelectFile={() => handleMenuClick('openPCAP')}
                openPcapRef={openPcapRef}
                serverName={SERVER_NAME}
                parseAndLoadPcapCsvData={parseAndLoadPcapCsvData}
                pcapBaseGraphRef={pcapBaseGraphRef}
                setShowOpenPcapButton={setShowOpenPcapButton}
                setDemoPcapLoading={setDemoPcapLoading}
                setIsDataReady={setIsDataReady}
                setGraphData={setGraphData}
                setIsLoading={setIsLoading}
                setProgressVisible={setProgressVisible}
                setProgress={setProgress}
                onEngineStop={handleEngineStop}
                setSnackbarOpen={setSnackbarOpen}
                setSnackbarMessage={setSnackbarMessage}
                setSnackbarSeverity={setSnackbarSeverity}
              />
            )}

            {isFlowRoute && (
              <FlowView
                showOpenFlowButton={showOpenFlowButton}
                flowLoading={flowLoading}
                serverName={SERVER_NAME}
                parseAndLoadPcapCsvData={parseAndLoadPcapCsvData}
                setShowOpenFlowButton={setShowOpenFlowButton}
                setFlowLoading={setFlowLoading}
                setIsDataReady={setIsDataReady}
                setGraphData={setGraphData}
                onEngineStop={handleEngineStop}
                setSnackbarOpen={setSnackbarOpen}
                setSnackbarMessage={setSnackbarMessage}
                setSnackbarSeverity={setSnackbarSeverity}
              />
            )}
          </>
        );
      })()}
      {showCookieDialog && (
        <CookieConsentDialog
          onClose={handleDeclineCookies}
          onAccept={handleAcceptCookies}
        />
      )}
      {showAboutDialog && (
        <AboutDialog
          onClose={() => setShowAboutDialog(false)}
        />
      )}
      {showLogin && (
        <LoginDialog
            open={true}
            onClose={() => setShowLogin(false)}
            setShowSignup={setShowSignup}
          />
      )}
      <LogoutConfirmDialog
          open={showLogoutConfirm} 
          onLogout={handleLogout}
          onClose={() => setShowLogoutConfirm(false)}
        />
      {membersOnlyEnabled && showMembersOnly && (
        <MembersOnlyDialog
            onSignup={() => {setShowMembersOnly(false); setShowSignup(true)}}
            onClose={() => setShowMembersOnly(false)}
            onLogin={() => {setShowMembersOnly(false); setShowLogin(true)}}
          />
      )}
      {showVerifyEmailCode && (
        <VerifyEmailCodeDialog  
            username={username} 
            onSignup={handleVerifyEmailCode}
            onClose={() => setShowVerifyEmailCode(false)}
          />
      )}
      {showSaveMapDialog && (
        <SaveMapDialog
            open={showSaveMapDialog}
            onSave={saveMap}
            onClose={() => setShowSaveMapDialog(false)}
          />
      )}
      {showLoadMapDialog && (
        <LoadMapDialog
            open={showLoadMapDialog}
            maps={maps}
            onLoad={openMap}
            onClose={() => setShowLoadMapDialog(false)}
          />
      )}
      {showSearchDialog && (
        <SearchDialog
          searchTextParam={searchText}
          setSearchTextParam={setSearchText}
          open={showSearchDialog}
          onSearch={handleSearchFromDialog}
          onClose={() => setShowSearchDialog(false)}
        />
      )}
      {showOptionsPopup && (
        <OptionsPopup 
          open={showOptionsPopup} 
          onClose={optionsPopupClose} 
          tourSpeedGraph={tourSpeedGraph} 
          setTourSpeedGraph={setTourSpeedGraph} 
          tourSpeedList={tourSpeedList} 
          setTourSpeedList={setTourSpeedList} 
          spinSpeed={spinSpeed} 
          setSpinSpeed={setSpinSpeed}
          useAspectRatio={useAspectRatio} 
          setUseAspectRatio={setUseAspectRatio} 
          imageSize={imageSize} 
          setImageSize={setImageSize} 
          resetCookieConsent={resetCookieConsent} 
          setResetCookieConsent={setResetCookieConsent}
          subscribeNewsletter={subscribeNewsletter}
          setSubscribeNewsletter={setSubscribeNewsletter}
      />
      )}
      {/* Newsletter is now displayed inline in the main content area */}
      <input
        type="file"
        ref={openFileInputRef}
        onChange={handleFileChange}
        accept=".csv"
        style={{ display: 'none' }}
      />
      <input
        type="file"
        ref={openNameTableInputRef}
        onChange={handleNameTableChange}
        accept=".json"
        style={{ display: 'none' }}
      />
      {/* Conditional rendering based on current view */}
      {showHomePage ? (
        /* HomePage content */
        <HomePage
          setShowHomePage={setShowHomePage}
          setShowShortcutPage={setShowShortcutPage}
          setShowSignup={setShowSignup}
          setShowLogin={setShowLogin}
          showLogin={showLogin} 
          username={username}
          handleLogin={handleLogin}
          isAuthenticated={isAuthenticated}
          showLogoutConfirm={showLogoutConfirm}
          setShowLogoutConfirm={setShowLogoutConfirm}
          handleLogout={handleLogout}
          showE3DMarketplaceParam={showE3DMarketplace}
          showCustomNFTMarketplace={showCustomNFTMarketplace}
          setShowCustomNFTMarketplace={setShowCustomNFTMarketplace}
          showNewsletter={showNewsletter}
          setShowSwapDialog={debugSetShowSwapDialog}
          setShowStakeDialog={debugSetShowStakeDialog}
          subscribeNewsletter={subscribeNewsletter}
          setSubscribeNewsletter={setSubscribeNewsletter}
          tourSpeedGraph={tourSpeedGraph}
          setTourSpeedGraph={setTourSpeedGraph}
          tourSpeedList={tourSpeedList}
          setTourSpeedList={setTourSpeedList}
          spinSpeed={spinSpeed}
          setSpinSpeed={setSpinSpeed}
          imageSize={imageSize}
          setImageSize={setImageSize}
          useAspectRatio={useAspectRatio}
          setUseAspectRatio={setUseAspectRatio}
          resetCookieConsent={resetCookieConsent}
          setResetCookieConsent={setResetCookieConsent}
          showCustomNFTDialog={showCustomNFTDialog}
          setShowCustomNFTDialog={setShowCustomNFTDialog}
          userAddress={userAddress}
        />
      ) : showNewsletter || location.pathname === '/news' ? (
        /* Newsletter */
        <div style={{ width: '100%', height: '100%', padding: '20px' }}>
          <NewsletterContent refreshKey={1} /> {/* Fixed value to prevent constant refreshing */}
        </div>
      ) : (
      /* Main app content */
      <>
      <div style={{ display: 'flex', flexDirection: 'column', width: '100%', overflow: 'hidden' }}>
      {location.pathname.startsWith('/graphs') && (
        <div id="linksHeroBanner" style={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: 10,
          flexWrap: 'nowrap',
          padding: '5px 14px 5px',
          background: 'radial-gradient(circle at 18% 50%, rgba(77,121,255,0.25), rgba(10,14,30,0.97))',
          borderBottom: '1px solid rgba(77,121,255,0.30)',
          boxSizing: 'border-box',
          flexShrink: 0,
          overflow: 'hidden',
          minWidth: 0,
        }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 10, minWidth: 0, overflow: 'hidden' }}>
            <div style={{
              fontSize: '1.0rem',
              fontWeight: 900,
              letterSpacing: -0.3,
              color: '#e5e7ff',
              textShadow: '0 0 12px rgba(77,121,255,0.5)',
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}>
              Evidence Graph
            </div>
            <div style={{ fontSize: 11, color: '#9ea4d8', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
              Live 3D transaction graph — Organic Galaxy is the primary layout. Other layouts are supplementary.
            </div>
          </div>
          <div style={{ display: 'flex', gap: 6, alignItems: 'center', flexShrink: 0, marginLeft: 8 }}>
            <button
              onClick={() => navigate('/transactions-guide')}
              style={{
                background: '#4d79ff',
                color: '#fff',
                border: 'none',
                borderRadius: 8,
                padding: '4px 12px',
                fontWeight: 800,
                fontSize: 12,
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                fontFamily: 'inherit',
              }}
            >
              Guide
            </button>
            <button
              onClick={() => navigate('/transactions-use-cases')}
              style={{
                background: 'transparent',
                color: '#cfd3ff',
                border: '1px solid rgba(255,255,255,0.20)',
                borderRadius: 8,
                padding: '4px 12px',
                fontWeight: 700,
                fontSize: 12,
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                fontFamily: 'inherit',
              }}
            >
              Use Cases
            </button>
          </div>
        </div>
      )}
      <div id="topContainer" className={classes.topContainer}>
        <div className={classes.leftAlignedContainer}>
          {!isMobile && (
            <div style={{ flex: 1, minWidth: 0 }}>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
                <SearchField
                  initialSearchText={location.pathname.startsWith('/price') ? priceSearchText : searchText}
                  onSearchTextChange={(val) => {
                    if (location.pathname.startsWith('/price')) {
                      // 300ms debounce for price page
                      if (priceSearchDebounceRef.current) clearTimeout(priceSearchDebounceRef.current);
                      priceSearchDebounceRef.current = setTimeout(() => {
                        const raw = String(val || '').trim();
                        setPriceSearchText(raw);
                        resetAndLoadPriceList({ sortBy: priceListSortBy, sortDir: priceListSortDir, searchOverride: raw });
                      }, 300);
                    } else {
                      setSearchText(val);
                    }
                  }}
                  handleSearch={handleSearchFromDialog}
                  commitOnEnterOnly={false}
                  placeholder="Search by name, symbol, or address…"
                  rightAdornment={location.pathname.startsWith('/price') ? (
                    <Button
                      variant="outlined"
                      color="inherit"
                      onClick={() => navigate('/price-guide')}
                      style={{
                        textTransform: 'none',
                        minWidth: 0,
                        paddingLeft: 18,
                        paddingRight: 18,
                        paddingTop: 0,
                        paddingBottom: 0,
                        border: 'none',
                        borderRadius: 16,
                        color: '#fff',
                        background: 'linear-gradient(180deg, #5b82ff 0%, #4d79ff 100%)',
                        lineHeight: '34px',
                        minHeight: 34,
                        height: 34,
                        whiteSpace: 'nowrap',
                        boxShadow: '0 10px 18px rgba(77,121,255,0.28), inset 0 -2px 0 rgba(0,0,0,0.18)',
                        fontWeight: 800,
                        fontSize: 16,
                        letterSpacing: 0.2,
                        display: 'inline-flex',
                        alignItems: 'center',
                      }}
                    >
                      Guide
                    </Button>
                  ) : null}
                />
                {location.pathname.startsWith('/price') && (() => {
                  const activeFilterCount = [
                    priceSelectedCategories.length > 0,
                    watchlistOnly,
                    Object.values(priceScreener).filter((v) => v !== '' && v != null && v !== false).length,
                  ].filter(Boolean).length;
                  return (
                  <>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 10, alignItems: 'center' }}>
                    {[{ label: 'All', value: ALL_CHAINS }, { label: 'ETH', value: ETHERSCAN }, { label: 'BSC', value: BSCSCAN }, { label: 'SOL', value: SOLANA }].map(({ label, value }) => (
                      <button
                        key={label}
                        onClick={() => { setPriceDataSource(value); }}
                        style={{
                          background: priceDataSource === value ? 'rgba(255,255,255,0.18)' : 'transparent',
                          border: '1px solid',
                          borderColor: priceDataSource === value ? 'rgba(255,255,255,0.5)' : 'rgba(255,255,255,0.2)',
                          borderRadius: 12,
                          color: priceDataSource === value ? '#fff' : 'rgba(255,255,255,0.5)',
                          fontWeight: priceDataSource === value ? 700 : 400,
                          fontSize: 12,
                          padding: '2px 10px',
                          cursor: 'pointer',
                        }}
                      >
                        {label}
                      </button>
                    ))}
                    <span className={classes.listTextStyle} style={{ minWidth: 90 }}>{`Tokens: ${(priceListTotal || 0).toLocaleString()}`}</span>
                    <Tooltip title={activeFilterCount > 0 ? `Reset to defaults (${activeFilterCount} active)` : 'Reset to defaults'}>
                      <span>
                        <IconButton size="small" onClick={resetPriceToolbarSettings} style={{ color: activeFilterCount > 0 ? '#ffb74d' : '#888', padding: 4 }}>
                          <ClearIcon style={{ fontSize: 16 }} />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <Tooltip title={priceExportBusy ? 'Exporting…' : 'Export CSV'}>
                      <span>
                        <IconButton size="small" onClick={exportPriceListCsv} disabled={priceExportBusy} style={{ color: priceExportBusy ? '#555' : '#888', padding: 4 }}>
                          <FaFileExport style={{ fontSize: 14 }} />
                        </IconButton>
                      </span>
                    </Tooltip>
                    <label className={classes.listTextStyle} style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}>
                      <input
                        type="checkbox"
                        checked={!!watchlistOnly}
                        onChange={(e) => {
                          const v = !!(e && e.target && e.target.checked);
                          try { setWatchlistOnly(v); } catch (err) {}
                        }}
                      />
                      Watchlist Only
                    </label>
                    <>
                      <Button
                        color="inherit"
                        aria-controls="price-category-menu"
                        aria-haspopup="true"
                        onClick={(event) => setPriceCategoryAnchorEl(event.currentTarget)}
                        style={{
                          textTransform: 'none',
                          minWidth: 0,
                          paddingTop: 2,
                          paddingBottom: 2,
                          marginLeft: 0,
                          borderColor: 'rgba(255,255,255,0.35)',
                          color: '#fff',
                          background: 'rgba(0,0,0,0.35)',
                          lineHeight: '16px',
                          minHeight: 0,
                        }}
                        variant="outlined"
                      >
                        {priceCategoryButtonLabel}
                      </Button>
                      <Menu
                        id="price-category-menu"
                        anchorEl={priceCategoryAnchorEl}
                        keepMounted
                        open={Boolean(priceCategoryAnchorEl)}
                        onClose={() => setPriceCategoryAnchorEl(null)}
                        PaperProps={priceMenuPaperProps}
                        MenuListProps={{
                          ...priceMenuListProps,
                          style: {
                            ...priceMenuListProps.style,
                            maxHeight: '68vh',
                            overflowY: 'auto',
                          },
                        }}
                      >
                        {(allCategories || []).map((cat) => {
                          const checked = priceSelectedCategories.includes(cat);
                          return (
                            <MenuItem
                              key={cat}
                              onClick={() => {
                                setPriceSelectedCategories((prev) => {
                                  const has = prev.includes(cat);
                                  return has ? prev.filter((v) => v !== cat) : prev.concat(cat);
                                });
                              }}
                              style={priceMenuItemStyle}
                            >
                              <input type="checkbox" readOnly checked={checked} style={{ marginRight: 8 }} />
                              {cat}
                            </MenuItem>
                          );
                        })}
                      </Menu>
                    </>
                    <>
                      <Button
                        color="inherit"
                        aria-controls="price-trend-menu-inline"
                        aria-haspopup="true"
                        onClick={(event) => setPriceTrendAnchorEl(event.currentTarget)}
                        style={{
                          textTransform: 'none',
                          minWidth: 0,
                          paddingTop: 2,
                          paddingBottom: 2,
                          marginLeft: 0,
                          borderColor: 'rgba(255,255,255,0.35)',
                          color: '#fff',
                          background: 'rgba(0,0,0,0.35)',
                          lineHeight: '16px',
                          minHeight: 0,
                        }}
                        variant="outlined"
                      >
                        {priceTrendButtonLabel}
                      </Button>
                      <Menu
                        id="price-trend-menu-inline"
                        anchorEl={priceTrendAnchorEl}
                        keepMounted
                        open={Boolean(priceTrendAnchorEl)}
                        onClose={() => setPriceTrendAnchorEl(null)}
                        PaperProps={priceMenuPaperProps}
                        MenuListProps={priceMenuListProps}
                      >
                        {PRICE_CHANGE_INTERVAL_OPTIONS.map((k) => {
                          const checked = priceTrendIntervalSelected === k;
                          return (
                            <MenuItem
                              key={k}
                              onClick={() => {
                                setPriceTrendIntervalSelected(k);
                                setPriceTrendAnchorEl(null);
                              }}
                              style={priceMenuItemStyle}
                            >
                              <input type="radio" readOnly checked={checked} style={{ marginRight: 8 }} />
                              {k}
                            </MenuItem>
                          );
                        })}
                      </Menu>
                    </>
                    <>
                      <Button
                        color="inherit"
                        aria-controls="price-change-menu-inline"
                        aria-haspopup="true"
                        onClick={(event) => setPriceChangeAnchorEl(event.currentTarget)}
                        style={{
                          textTransform: 'none',
                          minWidth: 0,
                          paddingTop: 2,
                          paddingBottom: 2,
                          marginLeft: 0,
                          borderColor: 'rgba(255,255,255,0.35)',
                          color: '#fff',
                          background: 'rgba(0,0,0,0.35)',
                          lineHeight: '16px',
                          minHeight: 0,
                        }}
                        variant="outlined"
                      >
                        {`% Columns (${priceSelectedChangeIntervals.length})`}
                      </Button>
                      <Menu
                        id="price-change-menu-inline"
                        anchorEl={priceChangeAnchorEl}
                        keepMounted
                        open={Boolean(priceChangeAnchorEl)}
                        onClose={() => setPriceChangeAnchorEl(null)}
                        PaperProps={priceMenuPaperProps}
                        MenuListProps={priceMenuListProps}
                      >
                        {PRICE_CHANGE_INTERVAL_OPTIONS.map((k) => {
                          const checked = priceSelectedChangeIntervals.includes(k);
                          return (
                            <MenuItem
                              key={k}
                              onClick={() => {
                                setPriceSelectedChangeIntervals((prev) => {
                                  const has = prev.includes(k);
                                  const next = has ? prev.filter((v) => v !== k) : prev.concat(k);
                                  if (next.length) setPriceChangeIntervalSelected(k);
                                  return next;
                                });
                              }}
                              style={priceMenuItemStyle}
                            >
                              <input type="checkbox" readOnly checked={checked} style={{ marginRight: 8 }} />
                              {`${k} %`}
                            </MenuItem>
                          );
                        })}
                      </Menu>
                    </>
                    <>
                      <Button
                        color="inherit"
                        aria-controls="price-columns-menu-inline"
                        aria-haspopup="true"
                        onClick={(event) => setPriceColumnsAnchorEl(event.currentTarget)}
                        style={{
                          textTransform: 'none',
                          minWidth: 0,
                          paddingTop: 2,
                          paddingBottom: 2,
                          marginLeft: 0,
                          borderColor: 'rgba(255,255,255,0.35)',
                          color: '#fff',
                          background: 'rgba(0,0,0,0.35)',
                          lineHeight: '16px',
                          minHeight: 0,
                        }}
                        variant="outlined"
                      >
                        {`Columns (${priceVisibleColumnCount})`}
                      </Button>
                      <Menu
                        id="price-columns-menu-inline"
                        anchorEl={priceColumnsAnchorEl}
                        keepMounted
                        open={Boolean(priceColumnsAnchorEl)}
                        onClose={() => setPriceColumnsAnchorEl(null)}
                        PaperProps={priceMenuPaperProps}
                        MenuListProps={priceMenuListProps}
                      >
                        {PRICE_COLUMN_VISIBILITY_OPTIONS.map((opt) => {
                          const checked = !priceHiddenColumns.includes(opt.id);
                          return (
                            <MenuItem
                              key={opt.id}
                              onClick={() => {
                                setPriceHiddenColumns((prev) => {
                                  const has = prev.includes(opt.id);
                                  return has ? prev.filter((v) => v !== opt.id) : prev.concat(opt.id);
                                });
                              }}
                              style={priceMenuItemStyle}
                            >
                              <input type="checkbox" readOnly checked={checked} style={{ marginRight: 8 }} />
                              {opt.label}
                            </MenuItem>
                          );
                        })}
                      </Menu>
                    </>
                    <Button
                      color="inherit"
                      onClick={() => setPriceScreenerOpen((v) => !v)}
                      style={{
                        textTransform: 'none',
                        minWidth: 0,
                        paddingTop: 2,
                        paddingBottom: 2,
                        paddingLeft: 8,
                        paddingRight: 8,
                        marginLeft: 0,
                        borderColor: priceScreenerOpen ? 'rgba(100,180,255,0.8)' : 'rgba(255,255,255,0.35)',
                        color: priceScreenerOpen ? '#64b4ff' : '#fff',
                        background: priceScreenerOpen ? 'rgba(30,60,100,0.5)' : 'rgba(0,0,0,0.35)',
                        lineHeight: '16px',
                        minHeight: 0,
                      }}
                      variant="outlined"
                    >
                      {`Screener${screenerHasActiveFilters ? ` (${screenerActiveFilterCount})` : ''}${screenerHasActiveFilters ? ' ●' : ''}`}
                    </Button>
                    <Button
                      color="inherit"
                      onClick={() => setShowSectorView((v) => !v)}
                      style={{
                        textTransform: 'none',
                        minWidth: 0,
                        paddingTop: 2,
                        paddingBottom: 2,
                        paddingLeft: 8,
                        paddingRight: 8,
                        marginLeft: 0,
                        borderColor: showSectorView ? 'rgba(100,180,255,0.8)' : 'rgba(255,255,255,0.35)',
                        color: showSectorView ? '#64b4ff' : '#fff',
                        background: showSectorView ? 'rgba(30,60,100,0.5)' : 'rgba(0,0,0,0.35)',
                        lineHeight: '16px',
                        minHeight: 0,
                      }}
                      variant="outlined"
                    >
                      Sectors
                    </Button>
                  </div>

                  {priceScreenerOpen && (() => { const inputStyle = {
                      background: 'rgba(255,255,255,0.08)',
                      border: '1px solid rgba(255,255,255,0.2)',
                      borderRadius: 4,
                      color: '#fff',
                      fontSize: 11,
                      padding: '2px 6px',
                      width: 80,
                      outline: 'none',
                    };
                    const screenerTextStyle = {
                      color: '#fff',
                      fontSize: 11,
                      whiteSpace: 'nowrap',
                      padding: 0,
                      margin: 0,
                      lineHeight: '1',
                    };
                    const hasActiveFilters = screenerHasActiveFilters;
                    const screenerCheckbox = (key, label) => (
                      <label className={classes.listTextStyle} style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer', ...screenerTextStyle }}>
                        <input
                          type="checkbox"
                          checked={!!priceScreener[key]}
                          onChange={(e) => {
                            const checked = !!(e && e.target && e.target.checked);
                            setPriceScreener((prev) => ({ ...prev, [key]: checked }));
                          }}
                        />
                        {label}
                      </label>
                    );
                    const rangeGroup = (label, minKey, maxKey) => (
                      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                        <span className={classes.listTextStyle} style={screenerTextStyle}>{label}</span>
                        <input
                          style={inputStyle}
                          placeholder="min"
                          value={priceScreener[minKey] || ''}
                          onChange={(e) => setPriceScreener((prev) => ({ ...prev, [minKey]: e.target.value }))}
                          onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
                        />
                        <span style={{ color: '#666', fontSize: 11 }}>–</span>
                        <input
                          style={inputStyle}
                          placeholder="max"
                          value={priceScreener[maxKey] || ''}
                          onChange={(e) => setPriceScreener((prev) => ({ ...prev, [maxKey]: e.target.value }))}
                          onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
                        />
                      </div>
                    );
                    return (
                      <div style={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 8,
                        padding: '8px 10px',
                        marginTop: 4,
                        background: 'rgba(255,255,255,0.04)',
                        border: '1px solid rgba(255,255,255,0.1)',
                        borderRadius: 6,
                      }}>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: 12, alignItems: 'center' }}>
                        {screenerCheckbox('includeNoCirc', 'Empty Circ Supply')}
                        {screenerCheckbox('emptyFdv', 'Empty FDV')}
                        {screenerCheckbox('emptyLiquidity', 'Empty Liquidity')}
                        {screenerCheckbox('emptyVolume24h', 'Empty Vol 24H')}
                        {screenerCheckbox('emptyEffectiveLiquidity', 'Empty Eff. Liq')}
                        {rangeGroup('MCap', 'minMktCap', 'maxMktCap')}
                        {rangeGroup('Liquidity', 'minLiquidity', 'maxLiquidity')}
                        {rangeGroup('Uniswap 24H Vol', 'minVolume24h', 'maxVolume24h')}
                        {rangeGroup('Price', 'minPrice', 'maxPrice')}
                        {rangeGroup('24H%', 'minChange24h', 'maxChange24h')}
                        <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                          <span className={classes.listTextStyle} style={screenerTextStyle}>FDV min</span>
                          <input
                            style={inputStyle}
                            placeholder="min"
                            value={priceScreener.minFdv || ''}
                            onChange={(e) => setPriceScreener((prev) => ({ ...prev, minFdv: e.target.value }))}
                            onKeyDown={(e) => { if (e.key === 'Enter') e.target.blur(); }}
                          />
                        </div>
                        <span style={{ color: '#555', fontSize: 10 }}>Accepts: 1M, 500K, 1B</span>
                        {hasActiveFilters && priceListTotal != null && (
                          <span style={{ color: '#64b4ff', fontSize: 11, fontWeight: 600 }}>
                            {`Tokens: ${priceListTotal.toLocaleString()}`}
                          </span>
                        )}
                        <Button
                          color="inherit"
                          onClick={() => setPriceScreener({})}
                          style={{ textTransform: 'none', fontSize: 11, padding: '1px 8px', border: '1px solid rgba(255,255,255,0.2)', color: '#aaa', background: 'transparent', borderRadius: 4, cursor: 'pointer', height: 22 }}
                          variant="outlined"
                        >
                          Clear All
                        </Button>
                      </div>
                      {/* ── Screener presets ── */}
                      <div style={{ display: 'flex', alignItems: 'center', gap: 6, flexWrap: 'wrap', borderTop: '1px solid rgba(255,255,255,0.07)', paddingTop: 6 }}>
                        <span style={{ color: '#9ea4d8', fontSize: 11 }}>Presets:</span>
                        {screenerPresets.length > 0 && (
                          <select
                            defaultValue=""
                            onChange={(e) => {
                              const preset = screenerPresets.find((p) => p.name === e.target.value);
                              if (preset) {
                                setPriceScreener({ ...preset.params });
                                setPriceSelectedCategories(preset.categories || []);
                              }
                              e.target.value = '';
                            }}
                            style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 4, color: '#cfd6ff', fontSize: 11, padding: '1px 4px', cursor: 'pointer', height: 22 }}
                          >
                            <option value="" disabled>Load preset…</option>
                            {screenerPresets.map((p) => (
                              <option key={p.name} value={p.name}>{p.name}</option>
                            ))}
                          </select>
                        )}
                        {screenerPresetSaving ? (
                          <input
                            autoFocus
                            type="text"
                            placeholder="Preset name…"
                            value={screenerPresetName}
                            onChange={(e) => setScreenerPresetName(e.target.value)}
                            onKeyDown={(e) => {
                              if (e.key === 'Enter' && screenerPresetName.trim()) {
                                const name = screenerPresetName.trim();
                                setScreenerPresets((prev) => [{ name, createdAt: new Date().toISOString(), params: { ...priceScreener }, categories: [...priceSelectedCategories] }, ...prev.filter((p) => p.name !== name)]);
                                setScreenerPresetName('');
                                setScreenerPresetSaving(false);
                              }
                              if (e.key === 'Escape') { setScreenerPresetSaving(false); setScreenerPresetName(''); }
                            }}
                            onBlur={() => { setScreenerPresetSaving(false); setScreenerPresetName(''); }}
                            style={{ background: 'rgba(255,255,255,0.08)', border: '1px solid rgba(100,160,255,0.5)', borderRadius: 4, color: '#fff', fontSize: 11, padding: '1px 6px', outline: 'none', width: 110, height: 20 }}
                          />
                        ) : (
                          <button
                            onClick={() => setScreenerPresetSaving(true)}
                            style={{ background: 'transparent', border: '1px solid rgba(255,255,255,0.2)', borderRadius: 4, color: '#aaa', fontSize: 11, padding: '1px 8px', cursor: 'pointer', height: 22 }}
                          >
                            Save as…
                          </button>
                        )}
                        {screenerPresets.length > 0 && (
                          <div style={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                            {screenerPresets.map((p) => (
                              <button
                                key={p.name}
                                onClick={() => setScreenerPresets((prev) => prev.filter((x) => x.name !== p.name))}
                                title={`Delete preset "${p.name}"`}
                                style={{ background: 'transparent', border: 'none', color: '#555', fontSize: 10, cursor: 'pointer', padding: '0 2px' }}
                              >
                                ✕{p.name}
                              </button>
                            ))}
                          </div>
                        )}
                      </div>
                      </div>
                    );
                  })()}
                  </>
                  );
                })()}
              </div>
            </div>
          )}

          
          {isMobile && (
            <>
              <Tooltip title="Search">
                <IconButton onClick={() => setShowSearchDialog(true)} className={classes.iconButtonStyle}>
                  <FaSearch />
                </IconButton>
              </Tooltip>
            </>
          )}

        {!location.pathname.startsWith('/price') && (dataSource !== PCAP) && (
          <Tooltip title={filterToken ? "I like this Token" : "I like this NFT Collection"}>
            <IconButton onClick={() => vote('like')} className={classes.iconButtonStyle}>
                <FaHeart color={(like === 'like') ? "white" : "transparent"} stroke="white" strokeWidth="0.6em" />
            </IconButton>
          </Tooltip>
        )}

          {!location.pathname.startsWith('/price') && viewGraph && showAdvanced && (
            <div style={{display: 'flex'}}>
              <Tooltip title={`File Menu`}>
                <IconButton onClick={handleOpenOpen} className={classes.iconButtonStyle}>
                  <FaSave/>
                </IconButton>
              </Tooltip>
              <Menu 
                anchorEl={anchorOpen}
                keepMounted
                open={Boolean(anchorOpen)}
                onClose={handleCloseOpen}
              >
                <MenuItem key="mintNFT" onClick={handleFileMenuClickAction(() => setShowMintNFTDialog(true))}>
                  <FaCoins style={{ marginRight: '8px' }} />
                  Mint E3D Graph NFT
                </MenuItem>
                <MenuItem key="customNFT" onClick={handleFileMenuClickAction(() => setShowCustomNFTDialog(true))}>
                  <FaCoins style={{ marginRight: '8px' }} />
                  Create Custom NFT
                </MenuItem>
                <MenuItem key="mapDialog" onClick={handleFileMenuClickAction(() => setShowSaveMapDialog(true))}>
                  <FaSave style={{ marginRight: '8px' }} />
                  Save Graph Coordinates
                </MenuItem>
                <MenuItem onClick={handleFileMenuClickAction(() => selectMap())}>
                  <FaFileExport style={{ marginRight: '8px' }} />
                  Load Graph Coordinates
                </MenuItem>
                <div className={classes.rightBtnGroup}>
                  {organicLayout && (
                    <>
                      <Button
                        color="inherit"
                        aria-controls="view-mode-menu"
                        aria-haspopup="true"
                        onClick={(event) => setViewModeAnchorEl(event.currentTarget)}
                      >
                        View Mode: {graphViewMode === 'all' ? 'All Nodes' : 
                                  graphViewMode === 'token_connected' ? 'Tokens & Connected Users' : 
                                  graphViewMode === 'users_only' ? 'Users Only' : 
                                  'Tokens Only'}
                      </Button>
                      <Menu
                        id="view-mode-menu"
                        anchorEl={viewModeAnchorEl}
                        keepMounted
                        open={Boolean(viewModeAnchorEl)}
                        onClose={() => setViewModeAnchorEl(null)}
                      >
                        <MenuItem onClick={() => { setGraphViewMode('all'); setViewModeAnchorEl(null); }}>All Nodes</MenuItem>
                        <MenuItem onClick={() => { setGraphViewMode('token_connected'); setViewModeAnchorEl(null); }}>Tokens & Connected Users</MenuItem>
                        <MenuItem onClick={() => { setGraphViewMode('users_only'); setViewModeAnchorEl(null); }}>Users Only</MenuItem>
                        <MenuItem onClick={() => { setGraphViewMode('tokens_only'); setViewModeAnchorEl(null); }}>Tokens Only</MenuItem>
                      </Menu>
                    </>
                  )}
                  <Button color="inherit" aria-controls="recent-graph-menu" aria-haspopup="true" 
                      onClick={handleClickListMenu}>
                  {`Recent ${dataSource}`} 
                  </Button>
                  <MenuItem
                    aria-controls="save-menu"
                    aria-haspopup="true"
                    onClick={handleOpenSaveAs}
                  >
                    <FaSave style={{ marginRight: '8px' }} />
                    Save Graph as...
                    <FaChevronRight style={{ marginLeft: 'auto' }} />
                  </MenuItem>
                </div>
                <Menu
                  anchorEl={anchorOpenSaveAs}
                  keepMounted
                  open={Boolean(anchorOpenSaveAs)}
                  onClose={handleCloseSaveAs}
                >
                  <MenuItem onClick={() => handleMenuClick('saveCSV')}>Save as CSV</MenuItem>
                  <MenuItem onClick={() => handleMenuClick('saveJPG')}>Save as JPEG</MenuItem>
                  <MenuItem onClick={() => handleMenuClick('savePNG')}>Save as PNG</MenuItem>
                  <MenuItem onClick={() => handleMenuClick('savePDF')}>Save as PDF</MenuItem>
                </Menu>

                {!isMobile && (
                  <MenuItem onClick={() => handleMenuClick('openPCAP')}>
                    <FaNetworkWired style={{ marginRight: '8px' }} />
                    Open PCAP File
                  </MenuItem>
                )}

                <MenuItem onClick={() =>  window.open('e3d_doc.html', '_blank')}>
                  <FaQuestionCircle style={{ marginRight: '8px' }} />
                  Documentation
                </MenuItem>

              </Menu>

            </div>
          )}

          {!location.pathname.startsWith('/price') && (
            <Tooltip title="View Menu">
              <IconButton onClick={handleMenuClickEl} className={classes.iconButtonStyle}>
                <FaEye />
              </IconButton>
            </Tooltip>
          )}

          {isMobile &&
            isPortrait &&
            ((location && location.pathname && location.pathname.startsWith('/price')) ||
              (location && location.pathname && location.pathname.startsWith('/token') && tokenView === 'price')) && (
            <>
              <Button
                variant="outlined"
                color="inherit"
                aria-controls="price-trend-menu"
                aria-haspopup="true"
                onClick={(event) => setPriceTrendAnchorEl(event.currentTarget)}
                style={{
                  textTransform: 'none',
                  minWidth: 0,
                  paddingLeft: 8,
                  paddingRight: 8,
                  paddingTop: 2,
                  paddingBottom: 2,
                  marginLeft: 6,
                  borderColor: 'rgba(255,255,255,0.35)',
                  color: '#fff',
                  background: 'rgba(0,0,0,0.35)',
                  lineHeight: '16px',
                  minHeight: 0,
                }}
              >
                {priceTrendButtonLabel}
              </Button>
              <Menu
                id="price-trend-menu"
                anchorEl={priceTrendAnchorEl}
                keepMounted
                open={Boolean(priceTrendAnchorEl)}
                onClose={() => setPriceTrendAnchorEl(null)}
              >
                {PRICE_CHANGE_INTERVAL_OPTIONS.map((k) => {
                  const checked = priceTrendIntervalSelected === k;
                  return (
                    <MenuItem
                      key={k}
                      onClick={() => {
                        setPriceTrendIntervalSelected(k);
                        setPriceTrendAnchorEl(null);
                      }}
                    >
                      <input type="radio" readOnly checked={checked} style={{ marginRight: 8 }} />
                      {k}
                    </MenuItem>
                  );
                })}
              </Menu>
              <Button
                variant="outlined"
                color="inherit"
                aria-controls="price-change-menu"
                aria-haspopup="true"
                onClick={(event) => setPriceChangeAnchorEl(event.currentTarget)}
                style={{
                  textTransform: 'none',
                  minWidth: 0,
                  paddingLeft: 8,
                  paddingRight: 8,
                  paddingTop: 2,
                  paddingBottom: 2,
                  marginLeft: 6,
                  borderColor: 'rgba(255,255,255,0.35)',
                  color: '#fff',
                  background: 'rgba(0,0,0,0.35)',
                  lineHeight: '16px',
                  minHeight: 0,
                }}
              >
                {`% Columns (${priceSelectedChangeIntervals.length})`}
              </Button>
              <Menu
                id="price-change-menu"
                anchorEl={priceChangeAnchorEl}
                keepMounted
                open={Boolean(priceChangeAnchorEl)}
                onClose={() => setPriceChangeAnchorEl(null)}
              >
                {PRICE_CHANGE_INTERVAL_OPTIONS.map((k) => {
                  const checked = priceSelectedChangeIntervals.includes(k);
                  return (
                    <MenuItem
                      key={k}
                      onClick={() => {
                        setPriceSelectedChangeIntervals((prev) => {
                          const has = prev.includes(k);
                          const next = has ? prev.filter((v) => v !== k) : prev.concat(k);
                          if (next.length) {
                            const preferred = has ? (next.includes(priceChangeIntervalSelected) ? priceChangeIntervalSelected : next[next.length - 1]) : k;
                            setPriceChangeIntervalSelected(preferred);
                          }
                          return next;
                        });
                      }}
                    >
                      <input type="checkbox" readOnly checked={checked} style={{ marginRight: 8 }} />
                      {`${k} %`}
                    </MenuItem>
                  );
                })}
              </Menu>
              <Button
                variant="outlined"
                color="inherit"
                aria-controls="price-columns-menu"
                aria-haspopup="true"
                onClick={(event) => setPriceColumnsAnchorEl(event.currentTarget)}
                style={{
                  textTransform: 'none',
                  minWidth: 0,
                  paddingLeft: 8,
                  paddingRight: 8,
                  paddingTop: 2,
                  paddingBottom: 2,
                  marginLeft: 6,
                  borderColor: 'rgba(255,255,255,0.35)',
                  color: '#fff',
                  background: 'rgba(0,0,0,0.35)',
                  lineHeight: '16px',
                  minHeight: 0,
                }}
              >
                {`Columns (${priceVisibleColumnCount})`}
              </Button>
              <Menu
                id="price-columns-menu"
                anchorEl={priceColumnsAnchorEl}
                keepMounted
                open={Boolean(priceColumnsAnchorEl)}
                onClose={() => setPriceColumnsAnchorEl(null)}
              >
                {PRICE_COLUMN_VISIBILITY_OPTIONS.map((opt) => {
                  const checked = !priceHiddenColumns.includes(opt.id);
                  return (
                    <MenuItem
                      key={opt.id}
                      onClick={() => {
                        setPriceHiddenColumns((prev) => {
                          const has = prev.includes(opt.id);
                          return has ? prev.filter((v) => v !== opt.id) : prev.concat(opt.id);
                        });
                      }}
                    >
                      <input type="checkbox" readOnly checked={checked} style={{ marginRight: 8 }} />
                      {opt.label}
                    </MenuItem>
                  );
                })}
              </Menu>
              <Button
                variant="outlined"
                color="inherit"
                onClick={resetPriceToolbarSettings}
                style={{
                  textTransform: 'none',
                  minWidth: 0,
                  paddingLeft: 8,
                  paddingRight: 8,
                  paddingTop: 2,
                  paddingBottom: 2,
                  marginLeft: 6,
                  borderColor: 'rgba(255,255,255,0.35)',
                  color: '#fff',
                  background: 'rgba(0,0,0,0.35)',
                  lineHeight: '16px',
                  minHeight: 0,
                }}
              >
                Reset
              </Button>
            </>
          )}
          <Menu
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleMenuCloseEl}
          >
 
            <MenuItem key="etherscan" onClick={handleMenuItemClick(gotoEtherscan)}>
              <img src={etherscanLogo} alt='Etherscan' style={{ width: 24, height: 24, marginRight: 8 }} />
              Etherscan
            </MenuItem>
            {viewGraph && [
 
              <MenuItem key="clearGraph" onClick={handleMenuItemClick(resetGraph)}>
                <FaTimes style={{ marginRight: 8 }} />
                Clear the graph
              </MenuItem>
            ]}
            {(viewGraph && showAdvanced) && (
              <MenuItem key="advancedOptions" onClick={handleAdvancedMenuClickEl}>
                Advanced Options
                <FaChevronRight style={{ marginLeft: 'auto' }} />
              </MenuItem>
            )}
          </Menu>

          {showAdvanced && (
            <Menu
              anchorEl={anchorElAdvanced}
              keepMounted
              open={Boolean(anchorElAdvanced)}
              onClose={handleAdvancedMenuCloseEl}
            >
              {viewGraph && [
                <MenuItem key="useTime" onClick={handleAdvancedMenuItemClick(() => setUseTime(!useTime))}>
                  <FaClock style={{ marginRight: 8 }} />
                  Use time in the search
                </MenuItem>,
                <MenuItem key="autoRefresh" onClick={handleAdvancedMenuItemClick(toggleTimer)}>
                  <FaHourglassHalf style={{ marginRight: 8 }} />
                  {intervalEthId || intervalBscId ? 'Stop Auto Refresh' : 'Start Auto Refresh'}
                </MenuItem>,
                <MenuItem key="toggleLabels" onClick={handleAdvancedMenuItemClick(() => handleMenuClick('toggleLabels'))}>
                  <FaFont style={{ marginRight: 8 }} />
                  {showText ? "Hide Labels" : "Show Labels"}
                </MenuItem>,
                <MenuItem key="showChart" onClick={handleAdvancedMenuItemClick(() => setShowChart(!showChart))}>
                  <FaChartBar style={{ marginRight: 8 }} />
                  {showChart ? "Hide the transactions chart" : "Show the transactions chart"}
                </MenuItem>,
                <MenuItem key="showAdvancedToolbar" onClick={handleAdvancedMenuItemClick(() => setShowAdvancedToolbar(!showAdvancedToolbar))}>
                  <FaTools style={{ marginRight: 8 }} />
                  {showAdvancedToolbar ? "Hide advanced toolbar" : "Show advanced toolbar"}
                </MenuItem>,
                <MenuItem key="resetDefaults" onClick={handleAdvancedMenuItemClick(() => resetLocalStorage())}>
                  <FaRedo style={{ marginRight: 8 }} />
                  Reset to defaults
                </MenuItem>,
              ]}
            </Menu>
          )}

          {!location.pathname.startsWith('/price') && (!isMobile || dataSource === PCAP) && (
            <div>
              {(!isMobile && dataSource !== PCAP) && (
                <PortfolioFilterMenu setPortfolioFilter={setPortfolioFilter} />
              )}

              <Tooltip title={spinCamera ? "Stop Spinning" : "Start Spinning"}>
                <IconButton
                  onClick={handleMenuItemClick(() => handleMenuClick('spin'))}
                  className={classes.iconButtonStyle}
                  disabled={isTourRunning}
                >
                  <FaSync />
                </IconButton>
              </Tooltip>

              {(!isMobile && dataSource !== PCAP) && (
                <Tooltip title={isTourRunning ? "Stop Tour" : "Start Tour"}>
                  <IconButton
                    onClick={handleMenuItemClick(toggleTour)}
                    className={classes.iconButtonStyle}
                  >
                    <FaBus />
                  </IconButton>
                </Tooltip>
              )}
            </div>
          )}

          {!location.pathname.startsWith('/price') && viewGraph && (!isMobile || dataSource === PCAP) && (
            (dataSource === PCAP) ? (
              null
            ) : (
              <Tooltip title="Mint Graph NFT">
                <IconButton
                  onClick={handleMenuItemClick(() => setShowMintNFTDialog(true))}
                  className={classes.iconButtonStyle}
                >
                  <FaSignature style={{ color: '#ffd700' }} />
                </IconButton>
              </Tooltip>
            )
          )}

          {!location.pathname.startsWith('/price') && viewGraph && (!isMobile || dataSource === PCAP) && (
            <Tooltip title={showGraphToolbar ? 'Hide graph toolbar' : 'Show graph toolbar'}>
              <IconButton
                onClick={handleMenuItemClick(() => setShowGraphToolbar((prev) => !prev))}
                className={classes.iconButtonStyle}
              >
                <FaCog />
              </IconButton>
            </Tooltip>
          )}
        </div>

        <div className={classes.rightAlignedContainer}>
          {!location.pathname.startsWith('/price') && viewGraph && (!isMobile || !isPortrait) && (
            <Tooltip title="Toggle Token Name List View">
              <IconButton onClick={() => handleMenuClick('toggleList')} className={classes.iconButtonStyle}>
                <FaBars />
              </IconButton>
            </Tooltip>
          )}
        </div>
      </div>

      {(viewGraph && dataSource === PCAP && isMobile && isPortrait) && (
        <div
          style={{
            position: 'fixed',
            left: 10,
            bottom: 10,
            zIndex: 2600,
          }}
        >
          <Tooltip title={showBottom ? 'Hide node list' : 'Show node list'}>
            <IconButton
              onClick={() => setShowBottom((prev) => !prev)}
              className={classes.iconButtonStyle}
              style={{
                background: 'rgba(0,0,0,0.35)',
                border: '1px solid rgba(255,255,255,0.25)',
              }}
              size="small"
            >
              <FaBars />
            </IconButton>
          </Tooltip>
        </div>
      )}

      {(isLoading || pcapNamesLoading) && !isLiveMode && !showOpenPcapButton && !demoPcapLoading && !showMintNFTDialog && !showCustomNFTDialog && !showMintPcapNFTDialog && <Spinner />}

      <div id="container" ref={containerRef} tabIndex="-1" className={classes.container}>
        {viewGraph && (
          <GraphLayoutPanel 
            isMobile={isMobile} 
            layoutManager={layoutManager} 
            graphData={graphData} 
            mode3D={mode3D} 
            is3DMode={is3DMode} 
            setIs3DMode={setIs3DMode}
            viewMode={graphViewMode}
          />
        )}

          {viewGraph && (
            <div>
              {isFirstLoad && <div className={classes.spacepacketText}><Spinner/></div>}
            </div>
          )}
    

          {(((viewGraph && filterToken)) || filterNFT) && (
            <div width={dimensions.width} height={dimensions.height} className={classes.graphContainer}>
              {viewGraph && (isDataReady || (
                location.pathname.startsWith('/graphs') &&
                memoizedGraphData &&
                Array.isArray(memoizedGraphData.nodes) &&
                memoizedGraphData.nodes.length > 0
              )) && (

                <div
                  key={graphKey}
                  id="graphContainer"
                  ref={graphContainerRef}
                  tabIndex="-1"
                  width={dimensions.width}
                  height={dimensions.height}
                  className={classes.graphContainer}
                  style={{ position: 'relative' }}
                >
                  {(viewGraph && showGraphToolbar) && (
                    <div
                      style={{
                        ...(graphToolbarOrientation === 'vertical'
                          ? {
                            position: 'absolute',
                            top: 12,
                            left: 12,
                            transform: 'none',
                            zIndex: 2400,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'stretch',
                            gap: 6,
                            padding: '6px 10px',
                            background: 'rgba(0,0,0,0.55)',
                            border: '1px solid rgba(255,255,255,0.25)',
                            borderRadius: 8,
                            maxWidth: 260,
                          }
                          : {
                        position: 'absolute',
                        top: 12,
                        left: (dataSource === PCAP && isMobile && isPortrait) ? 12 : '50%',
                        transform: (dataSource === PCAP && isMobile && isPortrait) ? 'none' : 'translateX(-50%)',
                        zIndex: 2400,
                        display: 'flex',
                        flexDirection: (dataSource === PCAP && isMobile && isPortrait) ? 'column' : 'row',
                        alignItems: (dataSource === PCAP && isMobile && isPortrait) ? 'stretch' : 'center',
                        gap: (dataSource === PCAP && isMobile && isPortrait) ? 6 : 10,
                        padding: '6px 10px',
                        background: 'rgba(0,0,0,0.55)',
                        border: '1px solid rgba(255,255,255,0.25)',
                        borderRadius: 8,
                        maxWidth: (dataSource === PCAP && isMobile && isPortrait) ? '92vw' : undefined,
                          })
                      }}
                    >
                      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: 6 }}>
                        <Tooltip title="Close toolbar">
                          <IconButton
                            onClick={() => setShowGraphToolbar(false)}
                            className={classes.iconButtonStyle}
                            size="small"
                            style={{ padding: 4, backgroundColor: 'rgba(255,255,255,0.06)' }}
                          >
                            <FaTimes />
                          </IconButton>
                        </Tooltip>

                        <Tooltip title={graphToolbarOrientation === 'vertical' ? 'Toolbar: left (click for top)' : 'Toolbar: top (click for left)'}>
                          <IconButton
                            onClick={() => setGraphToolbarOrientation((prev) => (prev === 'vertical' ? 'horizontal' : 'vertical'))}
                            className={classes.iconButtonStyle}
                            size="small"
                            style={{ padding: 4, backgroundColor: 'rgba(255,255,255,0.06)' }}
                          >
                            {graphToolbarOrientation === 'vertical' ? <FaArrowsAltH /> : <FaArrowsAltV />}
                          </IconButton>
                        </Tooltip>
                      </div>

                      {location.pathname.startsWith('/graphs') && (
                        <>
                          <div style={{ width: 1, alignSelf: 'stretch', background: 'rgba(255,255,255,0.18)' }} />
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.85)' }}>Story overlay:</div>
                            <Tooltip title={linksStoryOverlayEnabled ? 'Hide story overlay' : 'Show story overlay'}>
                              <div
                                style={{
                                  padding: 1,
                                  borderRadius: 5,
                                  border: `1px solid ${linksStoryOverlayEnabled ? 'rgba(0,255,0,0.95)' : 'rgba(255,255,255,0.25)'}`,
                                  background: linksStoryOverlayEnabled ? 'rgba(0,255,0,0.10)' : 'rgba(255,255,255,0.05)',
                                  transform: 'scale(0.9)',
                                  transformOrigin: 'left center',
                                }}
                              >
                                <Switch
                                  checked={linksStoryOverlayEnabled}
                                  onChange={(e) => setLinksStoryOverlayEnabled(!!e.target.checked)}
                                  size="small"
                                  color="default"
                                />
                              </div>
                            </Tooltip>
                          </div>
                        </>
                      )}

                      {(dataSource === PCAP) && (
                        <>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.85)' }}>Links:</div>
                            <Tooltip title="Collapsed (single straight line per pair)">
                              <IconButton
                                onClick={() => setPcapLinkStyleAndApply('collapsed_straight')}
                                className={classes.iconButtonStyle}
                                size="small"
                                style={{
                                  padding: 4,
                                  border: pcapLinkStyle === 'collapsed_straight' ? '2px solid #00ff00' : '2px solid transparent',
                                  backgroundColor: 'rgba(255,255,255,0.06)'
                                }}
                              >
                                <FaMinus />
                              </IconButton>
                            </Tooltip>
                            <Tooltip title="Split (two curved directional links: tx/rx)">
                              <IconButton
                                onClick={() => setPcapLinkStyleAndApply('split_curved')}
                                className={classes.iconButtonStyle}
                                size="small"
                                style={{
                                  padding: 4,
                                  border: pcapLinkStyle === 'split_curved' ? '2px solid #00ff00' : '2px solid transparent',
                                  backgroundColor: 'rgba(255,255,255,0.06)'
                                }}
                              >
                                <FaCircleNotch />
                              </IconButton>
                            </Tooltip>
                          </div>

                          <div style={{ width: 1, alignSelf: 'stretch', background: 'rgba(255,255,255,0.18)' }} />
                        </>
                      )}

                      {(dataSource === PCAP) && (
                        null
                      )}

                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.85)' }}>Names:</div>
                        <Tooltip title={showNames ? 'Show addresses' : 'Show names'}>
                          <div
                            style={{
                              padding: 1,
                              borderRadius: 5,
                              border: `1px solid ${showNames ? 'rgba(0,255,0,0.95)' : 'rgba(255,255,255,0.25)'}`,
                              background: showNames ? 'rgba(0,255,0,0.10)' : 'rgba(255,255,255,0.05)',
                              transform: 'scale(0.9)',
                              transformOrigin: 'left center',
                            }}
                          >
                            <Switch
                              checked={showNames}
                              onChange={(e) => setShowNames(!!e.target.checked)}
                              size="small"
                              color="default"
                            />
                          </div>
                        </Tooltip>
                        {(dataSource === PCAP && pcapNamesLoading) && (
                          <div style={{ display: 'flex', alignItems: 'center' }}>
                            <CircularProgress size={14} style={{ color: 'rgba(255,255,255,0.75)' }} />
                          </div>
                        )}
                      </div>

                      {(dataSource === PCAP) && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.85)' }}>MAC:</div>
                          <Tooltip title={pcapShowMac ? 'Hide MAC addresses' : 'Show MAC addresses'}>
                            <div
                              style={{
                                padding: 1,
                                borderRadius: 5,
                                border: `1px solid ${pcapShowMac ? 'rgba(0,255,0,0.95)' : 'rgba(255,255,255,0.25)'}`,
                                background: pcapShowMac ? 'rgba(0,255,0,0.10)' : 'rgba(255,255,255,0.05)',
                                transform: 'scale(0.9)',
                                transformOrigin: 'left center',
                              }}
                            >
                              <Switch
                                checked={pcapShowMac}
                                onChange={(e) => setPcapShowMacAndApply(!!e.target.checked)}
                                size="small"
                                color="default"
                              />
                            </div>
                          </Tooltip>
                        </div>
                      )}

                      {(dataSource === PCAP) && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.85)' }}>OUI:</div>
                          <Tooltip title={pcapShowOui ? 'Hide OUI vendor names' : 'Show OUI vendor names'}>
                            <div
                              style={{
                                padding: 1,
                                borderRadius: 5,
                                border: `1px solid ${pcapShowOui ? 'rgba(0,255,0,0.95)' : 'rgba(255,255,255,0.25)'}`,
                                background: pcapShowOui ? 'rgba(0,255,0,0.10)' : 'rgba(255,255,255,0.05)',
                                transform: 'scale(0.9)',
                                transformOrigin: 'left center',
                              }}
                            >
                              <Switch
                                checked={pcapShowOui}
                                onChange={(e) => setPcapShowOuiAndApply(!!e.target.checked)}
                                size="small"
                                color="default"
                              />
                            </div>
                          </Tooltip>
                        </div>
                      )}

                      <div style={{ width: 1, alignSelf: 'stretch', background: 'rgba(255,255,255,0.18)' }} />

                      {(dataSource === PCAP) ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.85)' }}>Labels:</div>
                          <Tooltip title={pcapShowLabels ? 'Hide labels' : 'Show labels'}>
                            <div
                              style={{
                                padding: 1,
                                borderRadius: 5,
                                border: `1px solid ${pcapShowLabels ? 'rgba(0,255,0,0.95)' : 'rgba(255,255,255,0.25)'}`,
                                background: pcapShowLabels ? 'rgba(0,255,0,0.10)' : 'rgba(255,255,255,0.05)',
                                transform: 'scale(0.9)',
                                transformOrigin: 'left center',
                              }}
                            >
                              <Switch
                                checked={pcapShowLabels}
                                onChange={(e) => setPcapShowLabels(!!e.target.checked)}
                                size="small"
                                color="default"
                              />
                            </div>
                          </Tooltip>
                          <div style={{ width: 40, paddingTop: 2 }}>
                            <Slider
                              value={pcapLabelSize}
                              min={2}
                              max={20}
                              step={1}
                              onChange={(e, v) => setPcapLabelSize(Number(v) || 0)}
                            />
                          </div>
                        </div>
                      ) : (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.85)' }}>Token Labels:</div>
                            <Tooltip title={showText ? 'Hide token labels' : 'Show token labels'}>
                              <div
                                style={{
                                  padding: 1,
                                  borderRadius: 5,
                                  border: `1px solid ${showText ? 'rgba(0,255,0,0.95)' : 'rgba(255,255,255,0.25)'}`,
                                  background: showText ? 'rgba(0,255,0,0.10)' : 'rgba(255,255,255,0.05)',
                                  transform: 'scale(0.9)',
                                  transformOrigin: 'left center',
                                }}
                              >
                                <Switch
                                  checked={showText}
                                  onChange={(e) => setShowText(!!e.target.checked)}
                                  size="small"
                                  color="default"
                                />
                              </div>
                            </Tooltip>
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.85)' }}>Address Labels:</div>
                            <Tooltip title={showAddressLabels ? 'Hide address labels' : 'Show address labels'}>
                              <div
                                style={{
                                  padding: 1,
                                  borderRadius: 5,
                                  border: `1px solid ${showAddressLabels ? 'rgba(0,255,0,0.95)' : 'rgba(255,255,255,0.25)'}`,
                                  background: showAddressLabels ? 'rgba(0,255,0,0.10)' : 'rgba(255,255,255,0.05)',
                                  transform: 'scale(0.9)',
                                  transformOrigin: 'left center',
                                }}
                              >
                                <Switch
                                  checked={showAddressLabels}
                                  onChange={(e) => setShowAddressLabels(!!e.target.checked)}
                                  size="small"
                                  color="default"
                                />
                              </div>
                            </Tooltip>
                          </div>

                          <div style={{ width: 40, paddingTop: 2 }}>
                            <Slider
                              value={labelSize ?? 3}
                              min={2}
                              max={20}
                              step={1}
                              onChange={(e, v) => setLabelSize(Number(v) || 0)}
                            />
                          </div>
                        </div>
                      )}

                      <Tooltip title={hiddenNodeIds && hiddenNodeIds.size ? 'Unhide all nodes' : 'No hidden nodes'}>
                        <span>
                          <IconButton
                            onClick={unhideAllNodes}
                            className={classes.iconButtonStyle}
                            size="small"
                            disabled={!(hiddenNodeIds && hiddenNodeIds.size)}
                            style={{
                              padding: 4,
                              opacity: (hiddenNodeIds && hiddenNodeIds.size) ? 1 : 0.35,
                            }}
                          >
                            <FaRedo />
                          </IconButton>
                        </span>
                      </Tooltip>

                      {(dataSource === PCAP) && (
                        <div
                          style={{
                            display: 'flex',
                            flexDirection: graphToolbarOrientation === 'vertical' ? 'column' : 'row',
                            alignItems: graphToolbarOrientation === 'vertical' ? 'stretch' : 'center',
                            gap: 8,
                          }}
                        >
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.85)' }}>Group All Names:</div>
                            <Tooltip title={(pcapMobileForceGroupNames || pcapGroupNamesEnabled) ? 'Don\'t group by name' : 'Group nodes with the same resolved name'}>
                              <div
                                style={{
                                  padding: 1,
                                  borderRadius: 5,
                                  border: `1px solid ${(pcapMobileForceGroupNames || pcapGroupNamesEnabled) ? 'rgba(0,255,0,0.95)' : 'rgba(255,255,255,0.25)'}`,
                                  background: (pcapMobileForceGroupNames || pcapGroupNamesEnabled) ? 'rgba(0,255,0,0.10)' : 'rgba(255,255,255,0.05)',
                                  transform: 'scale(0.9)',
                                  transformOrigin: 'left center',
                                }}
                              >
                                <Switch
                                  checked={pcapMobileForceGroupNames ? true : pcapGroupNamesEnabled}
                                  onChange={(e) => setPcapGroupNamesEnabledAndApply(!!e.target.checked)}
                                  disabled={pcapMobileForceGroupNames}
                                  size="small"
                                  color="default"
                                />
                              </div>
                            </Tooltip>
                          </div>

                          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                            <div style={{ fontSize: 10, color: 'rgba(255,255,255,0.85)' }}>Group All IPs:</div>
                            <Tooltip title={pcapGroupIpsEnabled ? 'Don\'t group identical IP nodes' : 'Group nodes that share the same IP'}>
                              <div
                                style={{
                                  padding: 1,
                                  borderRadius: 5,
                                  border: `1px solid ${pcapGroupIpsEnabled ? 'rgba(0,255,0,0.95)' : 'rgba(255,255,255,0.25)'}`,
                                  background: pcapGroupIpsEnabled ? 'rgba(0,255,0,0.10)' : 'rgba(255,255,255,0.05)',
                                  transform: 'scale(0.9)',
                                  transformOrigin: 'left center',
                                }}
                              >
                                <Switch
                                  checked={pcapGroupIpsEnabled}
                                  onChange={(e) => setPcapGroupIpsEnabledAndApply(!!e.target.checked)}
                                  size="small"
                                  color="default"
                                />
                              </div>
                            </Tooltip>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  <div className={classes.forceGraphComponent}>
                    {/* Only show the GraphViewModeSelector in organic layout (user graph) mode */}
                    {(organicLayout && dataSource !== PCAP) && (
                      <GraphViewModeSelector
                        viewMode={graphViewMode}
                        onViewModeChange={setGraphViewMode}
                      />
                    )}

                    {/* Don't render GraphComponent until we have data for PCAP to prevent WebGL context loss from remounting with empty data */}
                    {(dataSource !== PCAP || (graphData && graphData.nodes && graphData.nodes.length > 0)) && (
                    <GraphComponent
                      key={graphInstanceKey}
                      isMobile={isMobile}
                      is3DMode={is3DMode}
                      graphData={organicLayout ? filterGraphDataByViewMode(memoizedGraphData, graphViewMode) : memoizedGraphData}
                      graphRef={graphRef}
                      hiddenNodeIds={hiddenNodeIds}
                      handleBackgroundClick={handleBackgroundClick}
                      handleNodeDragEnd={handleNodeDragEnd}
                      handleNodeDrag={handleNodeDrag}
                      handleEngineStop={handleEngineStop}
                      handleZoom={layoutManager.handleZoom}
                      handleClick={handleClick}
                      handleNodeRightClick={handleNodeRightClick}
                      handleNodeDoubleClick={handleNodeDoubleClick}
                      dataSource={dataSource}
                      filterNFT={filterNFT}
                      maxValue={maxValue}
                      imageSize={imageSize}
                      stopCameraSpin={stopCameraSpin}
                      startCameraSpin={startCameraSpin}
                      setActiveLinkId={setActiveLinkId}
                      handleNodeClick={handleNodeClick}
                      showText={showText}
                      showAddressLabels={showAddressLabels}
                      showNames={showNames}
                      width={dimensions.width}
                      height={dimensions.height}
                      showChainLabels={location.pathname.startsWith('/token') && tokenView === 'chain'}
                      spinOnMount={dataSource === PCAP ? false : !(location.pathname.startsWith('/token') && tokenView === 'chain')}
                      currentView={currentView}
                      pcapLinkStyle={pcapLinkStyle}
                      pcapShowLabels={pcapShowLabels}
                      pcapLabelSize={pcapLabelSize}
                      pcapGroupEnabled={pcapGroupEnabled}
                      labelSize={labelSize}
                      pcapSelectedLinkKeys={pcapSelectedLinkKeys}
                      linksDataMode={linksDataMode}
                      storyNodeMap={linksDataMode === 'stories' ? storyNodeMapRef.current : null}
                      onStoryNodeClick={linksDataMode === 'stories' ? handleStoryNodeClick : null}
                      storyOverlayEnabled={location.pathname.startsWith('/graphs') ? linksStoryOverlayEnabled : false}
                      storyOverlayMap={location.pathname.startsWith('/graphs') && linksStoryOverlayEnabled ? storyOverlayMap : null}
                      watchedKeys={location.pathname.startsWith('/graphs') ? watchedKeys : null}
                    />
                    )}

                  </div>

                  {(((isLoading && !isLiveMode) || isCounterpartyLoading)) && !filterNFT && (
                    <div
                      style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 2500,
                        pointerEvents: 'none',
                        background: 'radial-gradient(circle at center, rgba(0,0,0,0.5), rgba(0,0,0,0.0))',
                      }}
                    >
                      <div style={{ pointerEvents: 'auto' }}>
                        <Spinner />
                      </div>
                    </div>
                  )}

                  {/* Desktop overlay TokenInfoComponent when bottom panel is closed.
                      Center within the graph container so it aligns with the
                      ForceGraph viewport, not the whole window. */}
                  {(!isMobile && !showBottom && viewGraph && tokenData) && (
                    <div
                      style={{
                        position: 'absolute',
                        inset: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 2000,
                        pointerEvents: 'none',
                        padding: '0 8px',
                      }}
                    >
                      <div
                        style={{
                          maxHeight: '80vh',
                          maxWidth: '90vw',
                          backgroundColor: 'rgba(0,0,0,0.9)',
                          borderRadius: '10px',
                          overflow: 'auto',
                          pointerEvents: 'auto',
                        }}
                      >
                        <TokenInfoComponent
                          data={tokenData}
                          onClose={handleCloseTokenInfo}
                          isMobile={isMobile}
                          isPortrait={isPortrait}
                        />
                      </div>
                    </div>
                  )}

                  {/*}
                  {(!isMobile && showChart && chartData) && (<FutcoChart rawData={chartData} showList={showBottom} onClose={handleCloseChart}/>)}
                  {*/}
                </div>
              )}
              
              {!viewGraph && isDataReady && (
                <TokenContainer 
                  imageKey={imageKey} 
                  tokenContainerRef={tokenContainerRef} 
                  dimensions={dimensions} 
                  getCurrentNodeIcon={getCurrentNodeIcon} 
                  getCurrentNode={getCurrentNode} 
                  futLogoIcon200={futLogoIcon200} 
                  graphData={graphData} 
                  currentNodeIndex={currentNodeIndex} 
                  setCurrentNodeIndex={setCurrentNodeIndex} 
                  setImageKey={setImageKey} 
                  imgRefs={imgRefs} 
                  goToPreviousNode={goToPreviousNode} 
                  goToNextNodeManually={goToNextNodeManually} 
                  filterNFT={filterNFT}
                  filterToken={filterToken}
                  showChart={showChart}
                  tokenData={tokenData}
                  handleCloseTokenInfo={handleCloseTokenInfo}
                  isMobile={isMobile}
                  isPortrait={isPortrait}
                  setIsTourRunning={setIsTourRunning}
                  useAspectRatio={useAspectRatio}
                  userID={userID}
                  setShowLogin={setShowLogin}
                  vote={vote}
                />
              )}

              {/* Desktop overlay TokenInfoComponent for list views like /price.
                  When we're not in graph mode and tokenData is set, show the
                  same token details panel as a centered modal above the list.
                  This ensures selecting a token in the /price view can surface
                  full token info even though there is no graph visible. */}
              {(!isMobile && !viewGraph && tokenData) && (
                <div
                  style={{
                    position: 'fixed',
                    inset: 0,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 2100,
                    pointerEvents: 'none',
                    padding: '0 8px',
                  }}
                >
                  <div
                    style={{
                      maxHeight: '80vh',
                      maxWidth: '90vw',
                      backgroundColor: 'rgba(0,0,0,0.9)',
                      borderRadius: '10px',
                      overflow: 'auto',
                      pointerEvents: 'auto',
                    }}
                  >
                    <TokenInfoComponent
                      data={tokenData}
                      onClose={handleCloseTokenInfo}
                      isMobile={isMobile}
                      isPortrait={isPortrait}
                    />
                  </div>
                </div>
              )}

              {isDataReady && !memoizedGraphData.nodes.length && (
                <div>
                  No data
                </div>
              )}
            </div>
          )}

          {((viewGraph || filterNFT) && showPanel && memoizedGraphData.nodes.length) && (
            <div id="panelContainer" className={classes.panelContainer}>
              <NodeList
                ref={nodeListRef}
                graphData={memoizedGraphData}
                graphRef={memoizedGraphRef}
                dataSource={dataSource}
                hiddenNodeIds={hiddenNodeIds}
                onToggleNodeHidden={toggleHiddenNodeId}
                onVisibleCountChange={setNodeListVisibleCount}
                linkCount={linkCount}
                getTransactions={getTransactions}
                handleNodeClick={handleNodeClick}
                activeNodeId={activeNodeId}
                stopCameraSpin={stopCameraSpin}
                isMobile={isMobile}
                isPortrait={isPortrait}
                tokenType={location.pathname.startsWith('/nft') ? "NFT" : "Token"}
                tokenList={memoizedTokenList}
                viewGraph={viewGraph}
                rangeSelected={rangeSelected}
                organicLayout={organicLayout}
                tokenView={tokenView}
                showNames={showNames}
                pcapShowMac={pcapShowMac}
                showAddressNodes={showAllAddressesInLinksDetail}
                filterAddresses={linksDataMode === 'watchlist'
                    ? watchlistAddressesRef.current
                    : null}
                storyAddresses={linksDataMode === 'watchlist'
                    ? watchlistAddressesRef.current
                    : null}
                storyOverlayMap={location.pathname.startsWith('/graphs') && linksStoryOverlayEnabled ? storyOverlayMap : null}
                selectedPriceChangeInterval={priceChangeIntervalSelected}
                selectedPriceChangeIntervals={priceSelectedChangeIntervals}
                selectedPriceTrendInterval={priceTrendIntervalSelected}
                onSelectPriceChangeInterval={(k) => setPriceChangeIntervalSelected(k)}
                onSelectPriceTrendInterval={(k) => setPriceTrendIntervalSelected(k)}
                showTokenViewToggle={(location.pathname.startsWith('/graphs') || location.pathname.startsWith('/token')) && filterToken}
                includeChainOption={location.pathname.startsWith('/token')}
                onTokenViewChange={(mode) => {
                  setTokenView(mode);
                  if (!location.pathname.startsWith('/graphs')) {
                    isLoaded = false;
                    setViewGraph(true);
                    setTokenViewTrigger(t => t + 1);
                  }
                }}
                onOpenCategories={() => setCategoriesOpen(true)}
                categoriesCount={selectedCategories.length}
                serverPagingEnabled={location.pathname.startsWith('/price')}
                serverSortBy={priceListSortBy}
                serverSortDir={priceListSortDir}
                onServerSortChange={handlePriceServerSortChange}
                onLoadMore={loadMorePriceList}
                priceListBusy={priceListBusy}
              />

            </div>
          )}
        
      </div>

      {storyPopover && (
        <div
          style={{ position: 'fixed', inset: 0, zIndex: 3100 }}
          onClick={() => setStoryPopover(null)}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              position: 'absolute',
              top: Math.min(storyPopover.y, window.innerHeight - 320),
              left: Math.min(storyPopover.x, window.innerWidth - 340),
              width: 320,
              maxHeight: 400,
              overflowY: 'auto',
              backgroundColor: 'rgba(10,14,30,0.97)',
              border: '1px solid rgba(255,179,0,0.6)',
              borderRadius: 8,
              padding: '12px 14px',
              color: '#fff',
              fontSize: 12,
              boxShadow: '0 4px 24px rgba(0,0,0,0.7)',
            }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
              <span style={{ fontSize: 10, color: '#888', fontFamily: 'monospace' }}>
                {String(storyPopover.nodeId || '').slice(0, 10)}…{String(storyPopover.nodeId || '').slice(-4)}
              </span>
              <span
                style={{ cursor: 'pointer', color: '#888', fontSize: 14, lineHeight: 1 }}
                onClick={() => setStoryPopover(null)}
              >✕</span>
            </div>
            {storyPopover.stories.map((s, i) => {
              const firstSentence = s.subtitle
                ? String(s.subtitle).split(/[.!?]/)[0].trim()
                : '';
              const storyUrl = `/stories?id=${s.id}`;
              const linksUrl = `/links?address=${storyPopover.nodeId}`;
              return (
                <div
                  key={s.id || i}
                  style={{
                    marginBottom: i < storyPopover.stories.length - 1 ? 12 : 0,
                    paddingBottom: i < storyPopover.stories.length - 1 ? 12 : 0,
                    borderBottom: i < storyPopover.stories.length - 1 ? '1px solid rgba(255,255,255,0.08)' : 'none',
                    textAlign: 'left',
                  }}
                >
                  {s.story_type && (
                    <span style={{
                      display: 'inline-block',
                      backgroundColor: 'rgba(255,179,0,0.2)',
                      color: '#ffb300',
                      border: '1px solid rgba(255,179,0,0.5)',
                      borderRadius: 3,
                      padding: '1px 5px',
                      fontSize: 10,
                      fontWeight: 700,
                      marginBottom: 4,
                      textTransform: 'uppercase',
                      letterSpacing: '0.05em',
                    }}>
                      {s.story_type}
                    </span>
                  )}
                  <div style={{ fontWeight: 600, fontSize: 13, marginBottom: 3, lineHeight: 1.3, textAlign: 'left' }}>
                    {s.title || '(untitled)'}
                  </div>
                  {s.score != null && (
                    <div style={{ color: '#aaa', fontSize: 11, marginBottom: 4, textAlign: 'left' }}>
                      Score: {s.score}
                    </div>
                  )}
                  {firstSentence && (
                    <div style={{ color: '#ccc', fontSize: 11, marginBottom: 6, lineHeight: 1.4, textAlign: 'left' }}>
                      {firstSentence}.
                    </div>
                  )}
                  <div style={{ display: 'flex', gap: 8 }}>
                    <a
                      href={storyUrl}
                      style={{
                        color: '#4d79ff',
                        fontSize: 11,
                        textDecoration: 'none',
                        border: '1px solid rgba(77,121,255,0.4)',
                        borderRadius: 3,
                        padding: '2px 7px',
                      }}
                      onClick={() => setStoryPopover(null)}
                    >
                      View Story →
                    </a>
                    <a
                      href={linksUrl}
                      style={{
                        color: '#aaa',
                        fontSize: 11,
                        textDecoration: 'none',
                        border: '1px solid rgba(255,255,255,0.15)',
                        borderRadius: 3,
                        padding: '2px 7px',
                      }}
                      onClick={() => setStoryPopover(null)}
                    >
                      Open in All mode
                    </a>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}

      {nodeContextMenu && (
        <div
          style={{
            position: 'fixed',
            inset: 0,
            zIndex: 3000,
          }}
          onClick={() => { setNodeContextMenu(null); setShowTopSubmenu(false); }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div
            style={{
              position: 'absolute',
              top: nodeContextMenu.mouseY,
              left: nodeContextMenu.mouseX,
              backgroundColor: '#111',
              border: '1px solid #444',
              padding: '4px 0',
              color: '#fff',
              fontSize: 12,
              minWidth: 140,
              textAlign: 'left',
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div
              style={{
                padding: '4px 12px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                textAlign: 'left',
              }}
              onClick={handleHideFromContextMenu}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              Hide
            </div>
            <div
              style={{
                padding: '4px 12px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                textAlign: 'left',
              }}
              onClick={handleShowNeighborsFromContextMenu}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              Show neighbors
            </div>
            <div
              style={{
                padding: '4px 12px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                textAlign: 'left',
              }}
              onClick={handleHideNeighborsFromContextMenu}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              Hide neighbors
            </div>
            <div
              style={{
                padding: '4px 12px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                textAlign: 'left',
              }}
              onClick={handleHideNonNeighborsFromContextMenu}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              Hide non-neighbors
            </div>
            <div
              style={{
                padding: '4px 12px',
                cursor: (hiddenNodeIds && hiddenNodeIds.size) ? 'pointer' : 'default',
                whiteSpace: 'nowrap',
                textAlign: 'left',
                opacity: (hiddenNodeIds && hiddenNodeIds.size) ? 1 : 0.4,
              }}
              onClick={() => {
                if (!(hiddenNodeIds && hiddenNodeIds.size)) return;
                handleUnhideAllFromContextMenu();
              }}
              onMouseEnter={(e) => {
                if (!(hiddenNodeIds && hiddenNodeIds.size)) return;
                e.currentTarget.style.backgroundColor = '#222';
              }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              Unhide all
            </div>
            {(() => {
              const isPcapView = !!(location && typeof location.pathname === 'string' && location.pathname.startsWith('/pcap'));
              if (!isPcapView) {
                return (
                  <>
                    <div
                      style={{
                        padding: '4px 12px',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                      }}
                      onClick={handleFollowFromContextMenu}
                      onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                    >
                      Follow Here
                    </div>
                    <div
                      style={{
                        padding: '4px 12px',
                        cursor: 'pointer',
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                      }}
                      onClick={handleFollowNewFromContextMenu}
                      onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                    >
                      Follow New
                    </div>
                  </>
                );
              }

              return (
                <div
                  style={{
                    padding: '4px 12px',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    textAlign: 'left',
                  }}
                  onClick={handleEditNameTableFromContextMenu}
                  onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                >
                  Edit Nametable
                </div>
              );
            })()}
            <div
              style={{
                padding: '4px 12px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                textAlign: 'left',
              }}
              onClick={handleCopyAddressFromContextMenu}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              Copy Address
            </div>

            {(() => {
              const pathname = location && typeof location.pathname === 'string' ? location.pathname : '';
              if (!pathname.startsWith('/graphs')) return null;
              if (!linksStoryOverlayEnabled) return null;
              const n = nodeContextMenu && nodeContextMenu.node ? nodeContextMenu.node : null;
              const id = n && n.id != null ? String(n.id).trim().toLowerCase() : '';
              if (!id) return null;
              const stories = storyOverlayMapRef.current && storyOverlayMapRef.current.get ? storyOverlayMapRef.current.get(id) : null;
              if (!stories || !stories.length) return null;
              const s = stories[0];
              if (!s || !s.id) return null;
              return (
                <div
                  style={{
                    padding: '4px 12px',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    textAlign: 'left',
                  }}
                  onClick={() => {
                    setNodeContextMenu(null);
                    goTo(`/stories?storyId=${encodeURIComponent(String(s.id))}`);
                  }}
                  onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                >
                  View story
                </div>
              );
            })()}

            {(() => {
              const pathname = location && typeof location.pathname === 'string' ? location.pathname : '';
              const isPcapOrFlowsView = !!(pathname && (pathname.startsWith('/pcap') || pathname.startsWith('/flows')));
              if (!isPcapOrFlowsView) return null;
              const n = nodeContextMenu && nodeContextMenu.node ? nodeContextMenu.node : null;
              const id = n && n.id != null ? String(n.id).trim() : '';
              const label = n && n.label != null ? String(n.label).trim() : '';
              if (!id) return null;
              const macRegex = /^([0-9A-Fa-f]{2}([:-])){5}[0-9A-Fa-f]{2}$/;
              if (macRegex.test(id) || macRegex.test(label)) return null;
              const rawIdForMenu = (id && id.startsWith('ip:')) ? id.slice('ip:'.length) : ((id && id.startsWith('name:')) ? id.slice('name:'.length) : id);
              const rawIpForMenu = extractIpv4(rawIdForMenu) || extractIpv4(label);
              const labelKey = String(label || '').trim().toLowerCase();
              const idKey = String(rawIdForMenu || '').trim().toLowerCase();
              const isEffectivelyUnnamedLabel = (lk, ik) => {
                const v = String(lk || '').trim();
                if (!v) return true;
                if (v === String(ik || '').trim()) return true;
                if (v === '-') return true;
                if (v === 'n/a') return true;
                if (v === 'na') return true;
                if (v === 'unknown') return true;
                return false;
              };
              const hasMeaningfulName = !!(labelKey && !isEffectivelyUnnamedLabel(labelKey, idKey) && labelKey !== idKey && !isIpv4(label));

              const alreadyGroupedByName = !!(id && id.startsWith('name:')) || (hasMeaningfulName && pcapManualGroupNameKeys && pcapManualGroupNameKeys.has(labelKey));
              const ipOctet = rawIpForMenu ? (String(rawIpForMenu).split('.')[0] || '') : '';
              const isIpBucketNode = !!(id && id.startsWith('ip:') && String(rawIdForMenu).includes('/8'));
              const alreadyGroupedByIp = !!(isIpBucketNode || (ipOctet && pcapManualGroupIpFirstOctets && pcapManualGroupIpFirstOctets.has(ipOctet)));
              const groupEnabled = hasMeaningfulName ? !alreadyGroupedByName : (rawIpForMenu ? !alreadyGroupedByIp : true);

              const title = hasMeaningfulName
                ? `Group ${label} Addresses`
                : (rawIpForMenu
                  ? (() => {
                    const firstOctet = ipOctet;
                    if (!firstOctet) return 'Group Same Addresses';
                    return `Group ${firstOctet}.0.0.0/8 Addresses`;
                  })()
                  : 'Group Same Addresses');
              return (
                <div
                  style={{
                    padding: '4px 12px',
                    cursor: groupEnabled ? 'pointer' : 'default',
                    whiteSpace: 'nowrap',
                    textAlign: 'left',
                    opacity: groupEnabled ? 1 : 0.35,
                  }}
                  onClick={() => { if (groupEnabled) handleGroupThisFromContextMenu(); }}
                  onMouseEnter={(e) => { if (groupEnabled) e.currentTarget.style.backgroundColor = '#222'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                >
                  {title}
                </div>
              );
            })()}

            {(() => {
              const pathname = location && typeof location.pathname === 'string' ? location.pathname : '';
              const isPcapOrFlowsView = !!(pathname && (pathname.startsWith('/pcap') || pathname.startsWith('/flows')));
              if (!isPcapOrFlowsView) return null;
              return (
                <div
                  style={{
                    padding: '4px 12px',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    textAlign: 'left',
                  }}
                  onClick={handleGroupAllFromContextMenu}
                  onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                >
                  Group All
                </div>
              );
            })()}

            {(() => {
              const pathname = location && typeof location.pathname === 'string' ? location.pathname : '';
              const isPcapOrFlowsView = !!(pathname && (pathname.startsWith('/pcap') || pathname.startsWith('/flows')));
              if (!isPcapOrFlowsView) return null;
              const n = nodeContextMenu && nodeContextMenu.node ? nodeContextMenu.node : null;
              const id = n && n.id != null ? String(n.id).trim() : '';
              if (!id) return null;
              const anyManual = !!((pcapManualGroupNameKeys && pcapManualGroupNameKeys.size) || (pcapManualGroupIpFirstOctets && pcapManualGroupIpFirstOctets.size));
              const labelKey = String((n && n.label != null ? n.label : '') || '').trim().toLowerCase();

              let ungroupThisEnabled = false;
              let ungroupThisVisible = false;
              if (id.startsWith('name:')) {
                ungroupThisVisible = true;
                const key = id.slice('name:'.length).trim().toLowerCase();
                ungroupThisEnabled = !!(key && pcapManualGroupNameKeys && pcapManualGroupNameKeys.has(key));
              } else if (id.startsWith('ip:')) {
                ungroupThisVisible = true;
                const rest = id.slice('ip:'.length).trim();
                const oct = (rest && rest.includes('/8')) ? (rest.split('.')[0] || '') : '';
                ungroupThisEnabled = !!(oct && pcapManualGroupIpFirstOctets && pcapManualGroupIpFirstOctets.has(oct));
              }

              if (!anyManual) return null;
              const ungroupAllEnabled = true;

              return (
                <>
                  {ungroupThisVisible ? (
                    <div
                      style={{
                        padding: '4px 12px',
                        cursor: ungroupThisEnabled ? 'pointer' : 'default',
                        whiteSpace: 'nowrap',
                        textAlign: 'left',
                        opacity: ungroupThisEnabled ? 1 : 0.35,
                      }}
                      onClick={() => { if (ungroupThisEnabled) handleUngroupThisFromContextMenu(); }}
                      onMouseEnter={(e) => { if (ungroupThisEnabled) e.currentTarget.style.backgroundColor = '#222'; }}
                      onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                    >
                      Ungroup Item
                    </div>
                  ) : null}
                  <div
                    style={{
                      padding: '4px 12px',
                      cursor: ungroupAllEnabled ? 'pointer' : 'default',
                      whiteSpace: 'nowrap',
                      textAlign: 'left',
                      opacity: ungroupAllEnabled ? 1 : 0.35,
                    }}
                    onClick={() => { if (ungroupAllEnabled) handleUngroupAllFromContextMenu(); }}
                    onMouseEnter={(e) => { if (ungroupAllEnabled) e.currentTarget.style.backgroundColor = '#222'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                  >
                    Ungroup All
                  </div>
                </>
              );
            })()}
            {(() => {
              const pathname = location && typeof location.pathname === 'string' ? location.pathname : '';
              const isPcapOrFlowsView = !!(pathname && (pathname.startsWith('/pcap') || pathname.startsWith('/flows')));
              if (!isPcapOrFlowsView) return null;
              const topNOptions = [50, 100, 200, 500, 1000, 'All'];
              return (
                <div
                  style={{ position: 'relative' }}
                  onMouseEnter={() => setShowTopSubmenu(true)}
                  onMouseLeave={() => setShowTopSubmenu(false)}
                >
                  <div
                    style={{
                      padding: '4px 12px',
                      cursor: 'pointer',
                      whiteSpace: 'nowrap',
                      textAlign: 'left',
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                    }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                  >
                    <span>Show Top{pcapShowTopN !== 'All' ? ` (${pcapShowTopN})` : ''}</span>
                    <span style={{ marginLeft: 8 }}>&#9656;</span>
                  </div>
                  {showTopSubmenu && (
                    <div
                      style={{
                        position: 'absolute',
                        top: 0,
                        left: '100%',
                        backgroundColor: '#111',
                        border: '1px solid #444',
                        padding: '4px 0',
                        minWidth: 80,
                      }}
                    >
                      {topNOptions.map((n) => (
                        <div
                          key={String(n)}
                          style={{
                            padding: '4px 12px',
                            cursor: 'pointer',
                            whiteSpace: 'nowrap',
                            textAlign: 'left',
                            fontWeight: pcapShowTopN === n ? 700 : 400,
                          }}
                          onClick={() => handleSetPcapShowTopN(n)}
                          onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
                          onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                        >
                          {n}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              );
            })()}
            <div
              style={{
                padding: '4px 12px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                textAlign: 'left',
              }}
              onClick={handleSelectNeighborsFromContextMenu}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              Select neighbors
            </div>
            <div
              style={{
                padding: '4px 12px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                textAlign: 'left',
              }}
              onClick={handleUnselectNeighborsFromContextMenu}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              Unselect neighbors
            </div>
            <div
              style={{
                padding: '4px 12px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
                textAlign: 'left',
              }}
              onClick={handleUnselectAllFromContextMenu}
              onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
              onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
            >
              Unselect all
            </div>
            {(() => {
              const isPcapView = !!(location && typeof location.pathname === 'string' && location.pathname.startsWith('/pcap'));
              if (isPcapView) return null;
              const id = nodeContextMenu && nodeContextMenu.node ? nodeContextMenu.node.id : null;
              const addr = normalizeAddress(id);
              if (!addr) return null;
              return (
                <div
                  style={{
                    padding: '4px 12px',
                    cursor: 'pointer',
                    whiteSpace: 'nowrap',
                    textAlign: 'left',
                  }}
                  onClick={handleEditNameTableFromContextMenu}
                  onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = '#222'; }}
                  onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = 'transparent'; }}
                >
                  Edit Nametable
                </div>
              );
            })()}
          </div>
        </div>
      )}

      <NameTableDialog
        open={showNameTableDialog}
        onClose={() => setShowNameTableDialog(false)}
        address={(String(nameTableChain || 'ETH').toUpperCase() === 'PCAP')
          ? (nameTableNode && nameTableNode.id ? String(nameTableNode.id) : '')
          : (normalizeAddress(nameTableNode && nameTableNode.id) || '')}
        label={nameTableLabel}
        onLabelChange={(v) => setNameTableLabel(v)}
        iconUrl={nameTableIconUrl}
        onIconUrlChange={(v) => setNameTableIconUrl(v)}
        onUploadFileChange={(file) => {
          try {
            if (!file) {
              setNameTableUploadFile(null);
              return;
            }
            const name = String(file.name || '').toLowerCase();
            const extOk = /\.(png|jpe?g|gif|webp|svg)$/.test(name);
            const type = String(file.type || '').toLowerCase();
            const typeOk = (
              type === 'image/png' ||
              type === 'image/jpeg' ||
              type === 'image/gif' ||
              type === 'image/webp' ||
              type === 'image/svg+xml'
            );
            if (!extOk && !typeOk) {
              setNameTableError('Unsupported image type. Please use PNG, JPG, GIF, WEBP, or SVG.');
              setNameTableUploadFile(null);
              return;
            }
            setNameTableError('');
            setNameTableUploadFile(file);
          } catch (e) {
            setNameTableError('Unsupported image type. Please use PNG, JPG, GIF, WEBP, or SVG.');
            setNameTableUploadFile(null);
          }
        }}
        error={nameTableError}
        saving={nameTableSaving}
        onSave={() => {
          try {
            if (!isAuthenticated) {
              setNameTableError('Please create an account or log in to save nametable entries');
            }
          } catch (e) {
            setNameTableError('Please create an account or log in to save nametable entries');
          }
          handleSaveNameTable();
        }}
        canSave={!!isAuthenticated}
      />

      {(() => {
        const isPriceListRoute = !viewGraph && filterToken && location.pathname.startsWith('/price');
        return ((isPriceListRoute || memoizedGraphData.nodes.length) && ((!viewGraph && filterToken) || (showBottom && isMobile && isPortrait))) && (
          <div
            id="linkContainer"
            className={classes.linkContainer}
            style={{ position: 'relative' }}
          >
            {(!isMobile && !viewGraph && filterToken && tokenData) && (
              <div
                style={{
                  position: 'absolute',
                  inset: 0,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 2100,
                  pointerEvents: 'none',
                  padding: '0 8px',
                }}
              >
                <div
                  style={{
                    maxHeight: '80vh',
                    maxWidth: '90vw',
                    backgroundColor: 'rgba(0,0,0,0.9)',
                    borderRadius: '10px',
                    overflow: 'auto',
                    pointerEvents: 'auto',
                  }}
                >
                  <TokenInfoComponent
                    data={tokenData}
                    onClose={handleCloseTokenInfo}
                    isMobile={isMobile}
                    isPortrait={isPortrait}
                  />
                </div>
              </div>
            )}
            {!viewGraph && filterToken && showSectorView ? (() => {
                const tokens = memoizedTokenList || [];
                const sectorMap = {};
                tokens.forEach((t) => {
                  const cats = Array.isArray(t.categories) ? t.categories : (t.category ? [t.category] : ['Other']);
                  cats.forEach((cat) => {
                    if (!cat) return;
                    if (!sectorMap[cat]) sectorMap[cat] = [];
                    sectorMap[cat].push(t);
                  });
                });
                const get24h = (t) => {
                  const e = t.changes && (t.changes['24H'] || t.changes['24h']);
                  return e && e.percent !== undefined && e.percent !== null ? parseFloat(e.percent) : NaN;
                };
                const rows = Object.entries(sectorMap).map(([cat, toks]) => {
                  const changes = toks.map(get24h).filter(Number.isFinite);
                  const avg24h = changes.length ? changes.reduce((a, b) => a + b, 0) / changes.length : null;
                  const sorted = [...changes].sort((a, b) => a - b);
                  const mid = Math.floor(sorted.length / 2);
                  const median24h = sorted.length ? (sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid]) : null;
                  const topMover = toks.reduce((best, t) => {
                    const c = get24h(t); const bc = best ? get24h(best) : -Infinity;
                    return (Number.isFinite(c) && (!Number.isFinite(bc) || c > bc)) ? t : best;
                  }, null);
                  const worstMover = toks.reduce((worst, t) => {
                    const c = get24h(t); const wc = worst ? get24h(worst) : Infinity;
                    return (Number.isFinite(c) && (!Number.isFinite(wc) || c < wc)) ? t : worst;
                  }, null);
                  return { cat, count: toks.length, avg24h, median24h, topMover, worstMover };
                }).sort((a, b) => (b.avg24h || 0) - (a.avg24h || 0));
                const fmtPct = (v) => v === null ? '—' : `${v > 0 ? '+' : ''}${v.toFixed(1)}%`;
                const pctColor = (v) => v === null ? '#888' : v > 0 ? '#00e676' : v < 0 ? '#ff5252' : '#888';
                return (
                  <div style={{ padding: '8px 12px', overflowY: 'auto', maxHeight: 'calc(100vh - 200px)' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12, color: '#ccc' }}>
                      <thead>
                        <tr style={{ borderBottom: '1px solid rgba(255,255,255,0.12)', color: '#9ea4d8', textAlign: 'left' }}>
                          {['Category', 'Tokens', 'Avg 24H%', 'Median 24H%', 'Top Mover', 'Worst Mover'].map((h) => (
                            <th key={h} style={{ padding: '6px 8px', fontWeight: 700, fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.4 }}>{h}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {rows.map(({ cat, count, avg24h, median24h, topMover, worstMover }) => (
                          <tr
                            key={cat}
                            style={{ borderBottom: '1px solid rgba(255,255,255,0.06)', cursor: 'pointer' }}
                            onClick={() => {
                              setPriceSelectedCategories([cat]);
                              setShowSectorView(false);
                            }}
                          >
                            <td style={{ padding: '5px 8px', fontWeight: 600, color: '#e5e7ff' }}>{cat}</td>
                            <td style={{ padding: '5px 8px', color: '#888' }}>{count}</td>
                            <td style={{ padding: '5px 8px', color: pctColor(avg24h), fontWeight: 600 }}>{fmtPct(avg24h)}</td>
                            <td style={{ padding: '5px 8px', color: pctColor(median24h) }}>{fmtPct(median24h)}</td>
                            <td style={{ padding: '5px 8px', color: '#00e676' }}>{topMover ? `${topMover.symbol || topMover.name || '?'} ${fmtPct(get24h(topMover))}` : '—'}</td>
                            <td style={{ padding: '5px 8px', color: '#ff5252' }}>{worstMover ? `${worstMover.symbol || worstMover.name || '?'} ${fmtPct(get24h(worstMover))}` : '—'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                );
              })() : !viewGraph && filterToken && showBubblesMode ? (
                <BubblesView
                  tokenList={memoizedTokenList}
                  dimensions={dimensions}
                  handleNodeClick={handleNodeClick}
                  dataSource={memoizedDataSource}
                  graphData={memoizedGraphData}
                />
              ) : (
                <NodeList
                  ref={nodeListRef}
                  graphData={memoizedGraphData}
                  graphRef={memoizedGraphRef}
                  dataSource={memoizedDataSource}
                  hiddenNodeIds={hiddenNodeIds}
                  onToggleNodeHidden={toggleHiddenNodeId}
                  linkCount={linkCount}
                  getTransactions={getTransactions}
                  handleNodeClick={handleNodeClick}
                  stopCameraSpin={stopCameraSpin}
                  isMobile={isMobile}
                  isPortrait={isPortrait}
                  tokenType={location.pathname.startsWith('/nft') ? "NFT" : "Token"}
                  tokenList={memoizedTokenList}
                  viewGraph={viewGraph}
                  rangeSelected={rangeSelected}
                  organicLayout={organicLayout}
                  showPriceColumns={true}
                  priceHiddenColumns={priceHiddenColumns}
                  tokenView={tokenView}
                  showNames={showNames}
                  selectedPriceChangeInterval={priceChangeIntervalSelected}
                  selectedPriceChangeIntervals={priceSelectedChangeIntervals}
                  selectedPriceTrendInterval={priceTrendIntervalSelected}
                  onSelectPriceChangeInterval={(k) => setPriceChangeIntervalSelected(k)}
                  showTokenViewToggle={(location.pathname.startsWith('/graphs') || location.pathname.startsWith('/token')) && filterToken}
                  includeChainOption={location.pathname.startsWith('/token')}
                  onTokenViewChange={(mode) => {
                    setTokenView(mode);
                    if (!location.pathname.startsWith('/graphs')) {
                      isLoaded = false;
                      setViewGraph(true);
                      setTokenViewTrigger(t => t + 1);
                    }
                  }}
                  onOpenCategories={() => setCategoriesOpen(true)}
                  categoriesCount={selectedCategories.length}
                  showChainColumn={location.pathname.startsWith('/price') && !(isMobile && isPortrait)}
                  serverPagingEnabled={location.pathname.startsWith('/price')}
                  serverSortBy={priceListSortBy}
                  serverSortDir={priceListSortDir}
                  onServerSortChange={handlePriceServerSortChange}
                  onLoadMore={loadMorePriceList}
                  priceListBusy={priceListBusy}
                  onSparklineClick={(token) => setQuickChartToken(token)}
                />
              )}
            </div>
        );
      })()}

      {(filterToken && showChart && tokenData && isMobile) && (
        <TokenInfoComponent data={tokenData} onClose={handleCloseTokenInfo} isMobile={isMobile} isPortrait={isPortrait}/>
      )}

      {(showBottom && isDataReady && memoizedGraphData.nodes.length && !isMobile) && (
        <div id="infoContainer" className={classes.linkContainer}>
          {(filterToken && showChart && tokenData && !isMobile) ? (
            <TokenInfoComponent data={tokenData} onClose={handleCloseTokenInfo} isMobile={isMobile} isPortrait={isPortrait}/>
          ) : (
            <div id="linkContainer" className={classes.linkContainer}>
                { (dataSource === PCAP) 
                  ? <LinkListPCAP 
                      graphData={graphData} 
                      conversations={pcapConversations}
                      graphRef={graphRef} 
                      mapData={mapData} 
                      pcapMacOuiByMac={pcapMacOuiByMac}
                      stopCameraSpin={stopCameraSpin} 
                      handleNodeClick={handleNodeClick}
                      onSelectConversation={(fromId, toId) => {
                        try {
                          const a = fromId != null ? String(fromId).trim() : '';
                          const b = toId != null ? String(toId).trim() : '';
                          if (a && b) {
                            const ordered = [a, b].sort();
                            const k = `${ordered[0]}↔${ordered[1]}`;
                            setPcapSelectedLinkKeysManual((prev) => {
                              const next = new Set(prev);
                              next.add(k);
                              return next;
                            });
                          }
                        } catch (e) {
                        }
                        handleNodeClick(PCAP, graphDataRef.current || graphData, graphRef, fromId, true);
                      }}
                      handleLinkClick={handleLinkClick}
                      activeLinkId={activeLinkId}
                      showNames={showNames}
                      pcapShowMac={pcapShowMac}
                      pcapShowOui={pcapShowOui}
                    /> 
                  : <LinkList 
                      graphData={graphData} 
                      graphRef={graphRef} 
                      dataSource={dataSource} 
                      rate={rate} 
                      stopCameraSpin={stopCameraSpin} 
                      handleNodeClick={handleNodeClick}
                      handleLinkClick={handleLinkClick}
                      activeLinkId={activeLinkId}
                      activeNodeId={activeNodeId}
                      transactions={transactions}
                    />  
                } 
            </div>
          )}
        </div>
      )}  
      
      {!filterNFT && !location.pathname.startsWith('/price') && !showOpenPcapButton && (
        <div id="bottomContainer" className={`${classes.bottomContainer} ${!HIDE_GOOGLE_ADS_BANNER && !debugHideBanner && !isAuthenticated && localStorage.getItem('isAuthenticated') !== 'true' ? classes.bottomContainerWithAd : ''}`}> 
          {!isMobile && (
            <Tooltip title="Toggle Transaction List View">
              <Button onClick={() => handleMenuClick('toggleBottom')} className={classes.burgerButtonStyle}>
                <FaBars className={classes.burgerButtonStyle}/> 
              </Button>
            </Tooltip>
          )}

          {(viewGraph || location.pathname.startsWith('/bubbles')) && (
            /* Show toolbar if: not in PCAP mode OR progress is visible OR we're on token page */
            <div className={`${classes.toolbarContainer} ${(viewGraph && showAdvancedToolbar && (dataSource !== PCAP || progressVisible || location.pathname.startsWith('/token') || location.pathname.startsWith('/bubbles'))) ? '' : classes.hidden}`}>
              <div className={classes.advancedToolbar}>
                {/* Range Selector - Hide in PCAP mode */}
                <div className={classes.toolbarSection}>
                  <div className={classes.intervalToolbar}>
                    {/* Only show time range buttons when appropriate for the current view/mode */}
                    {(() => {
                      let intervals = null;

                      if (location.pathname.startsWith('/token')) {
                        if (tokenView === 'volatility') {
                          // Match the price-change intervals used in the NodeList
                          intervals = ['30M', '6H', '12H', '24H'];
                        } else if (tokenView === 'links') {
                          // In /token links mode, keep the full set of ranges.
                          intervals = ['1M', '2M', '10M', '30M', '1H', '2H', '4H'];
                        } else {
                          // Price mode: hide time range buttons
                          intervals = null;
                        }
                      } else if (location.pathname.startsWith('/graphs')) {
                        // Both All and Stories modes use the same 1M, 2M, 5M, 10M windows.
                        intervals = ['1M', '2M', '5M', '10M'];
                      } else if (dataSource !== PCAP || location.pathname.startsWith('/bubbles')) {
                        intervals = ['1M', '10M', '30M', '1H', '2H', '4H'];
                      }

                      return (
                        <>
                          {intervals && intervals.map((interval) => (
                            (() => {
                              const allowed = Array.isArray(allowedLinksIntervals) ? allowedLinksIntervals : [allowedLinksInterval];
                              const isLinksIntervalLocked = location.pathname.startsWith('/graphs') && !allowed.includes(interval);
                              const isDisabled = isLiveMode || isLinksIntervalLocked || (location.pathname.startsWith('/graphs') && isLinksHistoricalRangeActive);
                              const lockedStyle = isLinksIntervalLocked ? { opacity: 0.35, cursor: 'not-allowed' } : undefined;
                              return (
                                <button
                                  key={interval}
                                  className={`${classes.intervalButton} ${rangeSelected === interval ? classes.selected : ''}`}
                                  onClick={() => handleIntervalSelection(interval)}
                                  disabled={isDisabled}
                                  style={(isLiveMode || (location.pathname.startsWith('/graphs') && isLinksHistoricalRangeActive)) ? { opacity: 0.4, cursor: 'default' } : lockedStyle}
                                >
                                  {interval}
                                </button>
                              );
                            })()
                          ))}

                          {location.pathname.startsWith('/graphs') && (
                            <>
                              <IconButton
                                size="small"
                                title="Shift window backward"
                                onClick={(e) => {
                                  if (!isAuthenticated) {
                                    setLinksSignInAnchorEl(e.currentTarget);
                                    return;
                                  }

                                  const nowSec = Math.floor(Date.now() / 1000);
                                  const currentStart = (dateRange2 && dateRange2.startDate) ? Number(dateRange2.startDate) : 0;
                                  const currentEnd = (dateRange2 && dateRange2.endDate) ? Number(dateRange2.endDate) : 0;

                                  const windowMinutes = (() => {
                                    if (rangeSelected === '1M') return 1;
                                    if (rangeSelected === '2M') return 2;
                                    if (rangeSelected === '5M') return 5;
                                    if (rangeSelected === '10M') return 10;
                                    return 0;
                                  })();

                                  let baseStartSec = 0;
                                  let baseEndSec = 0;
                                  if (isLinksHistoricalRangeActive && currentStart > 0 && currentEnd > 0) {
                                    baseStartSec = currentStart;
                                    baseEndSec = currentEnd;
                                  } else {
                                    const durSec = windowMinutes > 0 ? windowMinutes * 60 : 0;
                                    if (!durSec) return;
                                    baseEndSec = nowSec;
                                    baseStartSec = nowSec - durSec;
                                  }

                                  const durationSec = Math.max(1, baseEndSec - baseStartSec);
                                  const nextStartSec = baseStartSec - durationSec;
                                  const nextEndSec = baseEndSec - durationSec;

                                  const startIso = new Date(nextStartSec * 1000).toISOString();
                                  const endIso = new Date(nextEndSec * 1000).toISOString();

                                  try {
                                    if (typeof window !== 'undefined' && window.sessionStorage) {
                                      window.sessionStorage.setItem('e3d_date_range', JSON.stringify({ start: startIso, end: endIso }));
                                    }
                                  } catch (e2) {
                                  }

                                  const nextRange2 = { startDate: nextStartSec, endDate: nextEndSec };
                                  setLinksRangeUpgradeMsg('');
                                  setLinksIsoDateRange({ start: startIso, end: endIso });
                                  setDateRange2(nextRange2);
                                  setUseTime(true);
                                  setIsLiveMode(false);
                                  clearNodePositions();
                                  resetGraph();
                                  fetchEthTransactions(nextRange2).catch(() => {});
                                }}
                                style={{
                                  padding: 6,
                                  marginLeft: 8,
                                  color: '#cfd3ff',
                                  border: '1px solid transparent',
                                  borderRadius: 10,
                                }}
                              >
                                <span style={{ fontSize: 14, lineHeight: 1 }}>◀</span>
                              </IconButton>

                              <IconButton
                                size="small"
                                title="Shift window forward"
                                onClick={(e) => {
                                  if (!isAuthenticated) {
                                    setLinksSignInAnchorEl(e.currentTarget);
                                    return;
                                  }

                                  const nowSec = Math.floor(Date.now() / 1000);
                                  const currentStart = (dateRange2 && dateRange2.startDate) ? Number(dateRange2.startDate) : 0;
                                  const currentEnd = (dateRange2 && dateRange2.endDate) ? Number(dateRange2.endDate) : 0;

                                  const windowMinutes = (() => {
                                    if (rangeSelected === '1M') return 1;
                                    if (rangeSelected === '2M') return 2;
                                    if (rangeSelected === '5M') return 5;
                                    if (rangeSelected === '10M') return 10;
                                    return 0;
                                  })();

                                  let baseStartSec = 0;
                                  let baseEndSec = 0;
                                  if (isLinksHistoricalRangeActive && currentStart > 0 && currentEnd > 0) {
                                    baseStartSec = currentStart;
                                    baseEndSec = currentEnd;
                                  } else {
                                    const durSec = windowMinutes > 0 ? windowMinutes * 60 : 0;
                                    if (!durSec) return;
                                    baseEndSec = nowSec;
                                    baseStartSec = nowSec - durSec;
                                  }

                                  const durationSec = Math.max(1, baseEndSec - baseStartSec);
                                  let nextStartSec = baseStartSec + durationSec;
                                  let nextEndSec = baseEndSec + durationSec;

                                  // Clamp to now so the window doesn't drift into the future.
                                  if (nextEndSec > nowSec) {
                                    nextEndSec = nowSec;
                                    nextStartSec = nowSec - durationSec;
                                  }

                                  const startIso = new Date(nextStartSec * 1000).toISOString();
                                  const endIso = new Date(nextEndSec * 1000).toISOString();

                                  try {
                                    if (typeof window !== 'undefined' && window.sessionStorage) {
                                      window.sessionStorage.setItem('e3d_date_range', JSON.stringify({ start: startIso, end: endIso }));
                                    }
                                  } catch (e2) {
                                  }

                                  const nextRange2 = { startDate: nextStartSec, endDate: nextEndSec };
                                  setLinksRangeUpgradeMsg('');
                                  setLinksIsoDateRange({ start: startIso, end: endIso });
                                  setDateRange2(nextRange2);
                                  setUseTime(true);
                                  setIsLiveMode(false);
                                  clearNodePositions();
                                  resetGraph();
                                  fetchEthTransactions(nextRange2).catch(() => {});
                                }}
                                style={{
                                  padding: 6,
                                  marginLeft: 4,
                                  color: '#cfd3ff',
                                  border: '1px solid transparent',
                                  borderRadius: 10,
                                }}
                              >
                                <span style={{ fontSize: 14, lineHeight: 1 }}>▶</span>
                              </IconButton>

                              <IconButton
                                size="small"
                                title={isLinksHistoricalRangeActive ? 'Date range: ON' : 'Date range'}
                                onClick={(e) => {
                                  if (!isAuthenticated) {
                                    setLinksSignInAnchorEl(e.currentTarget);
                                    return;
                                  }
                                  setLinksDateRangeAnchorEl(e.currentTarget);
                                }}
                                style={{
                                  padding: 6,
                                  marginLeft: 8,
                                  color: isLinksHistoricalRangeActive ? '#ffffff' : '#cfd3ff',
                                  border: isLinksHistoricalRangeActive ? '1px solid rgba(158, 196, 255, 0.9)' : '1px solid transparent',
                                  borderRadius: 10,
                                }}
                              >
                                <span style={{ fontSize: 16, lineHeight: 1 }}>📅</span>
                              </IconButton>

                              {isLinksHistoricalRangeActive && linksIsoDateRange && (
                                <div style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginLeft: 6, color: '#cfd3ff', fontSize: 11 }}>
                                  <span>📅 {formatRangeLabel(linksIsoDateRange.start, linksIsoDateRange.end)}</span>
                                  <IconButton
                                    size="small"
                                    title="Clear date range"
                                    onClick={() => {
                                      clearLinksDateRange();
                                      setIsLiveMode(false);
                                      clearNodePositions();
                                      resetGraph();
                                      fetchEthTransactions().catch(() => {});
                                    }}
                                    style={{ padding: 2, color: '#cfd3ff' }}
                                  >
                                    <span style={{ fontSize: 14, lineHeight: 1 }}>✕</span>
                                  </IconButton>
                                </div>
                              )}

                              <Popover
                                open={!!linksSignInAnchorEl}
                                anchorEl={linksSignInAnchorEl}
                                onClose={() => setLinksSignInAnchorEl(null)}
                                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                PaperProps={{
                                  style: {
                                    background: 'rgba(10,14,30,0.98)',
                                    border: '1px solid rgba(77, 121, 255, 0.35)',
                                    borderRadius: 12,
                                    padding: 10,
                                    color: '#e5e7ff',
                                    maxWidth: 280,
                                  },
                                }}
                              >
                                <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
                                  <div style={{ fontSize: 12, color: '#cfd3ff', lineHeight: 1.35 }}>
                                    Sign in to search historical data
                                  </div>
                                  <Button
                                    variant="contained"
                                    size="small"
                                    onClick={() => {
                                      setLinksSignInAnchorEl(null);
                                      setShowLogin(true);
                                    }}
                                    style={{ textTransform: 'none' }}
                                  >
                                    Sign in →
                                  </Button>
                                </div>
                              </Popover>

                              <DateRangePickerPopover
                                open={!!linksDateRangeAnchorEl}
                                anchorEl={linksDateRangeAnchorEl}
                                onClose={() => setLinksDateRangeAnchorEl(null)}
                                maxLookbackDays={linksMaxLookbackDays}
                                maxRangeMinutes={10}
                                minIso={earliestEthTxIso}
                                value={linksIsoDateRange}
                                allowFutureEnd
                                onApply={(range) => {
                                  const sMs = Date.parse(range && range.start ? range.start : '');
                                  let eMs = Date.parse(range && range.end ? range.end : '');
                                  if (!Number.isFinite(sMs) || !Number.isFinite(eMs) || sMs <= 0 || eMs <= 0) return;

                                  if (eMs < sMs) eMs = sMs;

                                  const limitMs = 10 * 60 * 1000;
                                  if (eMs - sMs > limitMs) eMs = sMs + limitMs;

                                  const startIso = new Date(sMs).toISOString();
                                  const endIso = new Date(eMs).toISOString();

                                  try {
                                    if (typeof window !== 'undefined' && window.sessionStorage) {
                                      window.sessionStorage.setItem('e3d_date_range', JSON.stringify({ start: startIso, end: endIso }));
                                    }
                                  } catch (e) {
                                  }

                                  const sSec = Math.floor(sMs / 1000);
                                  const eSec = Math.floor(eMs / 1000);
                                  setLinksRangeUpgradeMsg('');
                                  setLinksIsoDateRange({ start: startIso, end: endIso });
                                  const nextRange2 = { startDate: sSec, endDate: eSec };
                                  setDateRange2(nextRange2);
                                  setUseTime(true);
                                  setIsLiveMode(false);
                                  clearNodePositions();
                                  resetGraph();
                                  fetchEthTransactions(nextRange2).catch(() => {});
                                }}
                                onClear={() => {
                                  clearLinksDateRange();
                                  const nextRange2 = { startDate: 0, endDate: 0 };
                                  setDateRange2(nextRange2);
                                  setIsLiveMode(false);
                                  clearNodePositions();
                                  resetGraph();
                                  fetchEthTransactions(nextRange2).catch(() => {});
                                }}
                                disableLast30={!isPremiumPlus}
                                onAttemptLast30={() => {
                                  if (!isPremiumPlus) setLinksRangeUpgradeMsg('Upgrade to Premium for 30-day lookback');
                                }}
                                upgradeMessage={linksRangeUpgradeMsg}
                                onDismissUpgradeMessage={() => setLinksRangeUpgradeMsg('')}
                              />
                            </>
                          )}


                          {location.pathname.startsWith('/graphs') && (
                            <div style={{ display: 'inline-flex', alignItems: 'center', marginLeft: 12, gap: 4 }}>
                              <span style={{ fontSize: 11, color: '#cfd3ff' }}>Min links:</span>
                              <select
                                value={minLinks}
                                onChange={(e) => setMinLinks(parseInt(e.target.value, 10) || 1)}
                                style={{
                                  backgroundColor: 'rgba(10,14,30,0.9)',
                                  color: '#cfd3ff',
                                  borderRadius: 4,
                                  border: '1px solid rgba(77,121,255,0.6)',
                                  fontSize: 11,
                                  padding: '2px 6px',
                                }}
                              >
                                {[0, 1, 2, 3, 4, 5, 10, 20].map((val) => (
                                  <option key={val} value={val}>
                                    {val}
                                  </option>
                                ))}
                              </select>
                            </div>
                          )}
                        </>
                      );
                    })()}
                    
                    {/* Progress Bar - Always show when needed, regardless of mode */}
                    {(() => {
                      if (progressVisible) {
                        console.log('[ProgressBar] Rendering:', { progressVisible, progress, dataSource });
                      }
                      return progressVisible && (
                        <div className={`${classes.inlineProgressBarContainer} ${dataSource === PCAP ? classes.pcapProgressBar : ''}`}>
                          <div className={classes.progressBar} style={{ width: `${progress}%` }} />
                          {progress === 100 && <span className={classes.progressComplete}>✓</span>}
                        </div>
                      );
                    })()}

                    {/* Live mode toggle - recording-style indicator */}
                    {dataSource !== PCAP && (
                      <div style={{ display: 'flex', alignItems: 'center', marginLeft: 12 }}>
                        <button
                          type="button"
                          onClick={() => {
                            if (location.pathname.startsWith('/graphs') && isLinksHistoricalRangeActive) return;
                            toggleLiveMode();
                          }}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 4,
                            background: 'transparent',
                            border: 'none',
                            cursor: 'pointer',
                            color: '#f44336',
                            fontSize: 11,
                            fontWeight: 700,
                            letterSpacing: '0.08em',
                            textTransform: 'uppercase',
                            opacity: (location.pathname.startsWith('/graphs') && isLinksHistoricalRangeActive) ? 0.35 : 1,
                          }}
                          title={(location.pathname.startsWith('/graphs') && isLinksHistoricalRangeActive)
                            ? 'LIVE mode unavailable during historical view'
                            : (isLiveMode ? 'Live: streaming last 10 minutes (click to stop)' : 'Enable Live mode: stream last 10 minutes with 10s updates')}
                        >
                          <span className={isLiveMode ? classes.liveDotActive : classes.liveDot} />
                          <span>LIVE</span>
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>   
            </div>
          )}

          {/* All / Stories / Watchlist data-mode toggle – only on /graphs */}
          {location.pathname.startsWith('/graphs') && (
            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 8 }}>
              <div
                style={{
                  display: 'flex',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  backgroundColor: 'rgba(0,0,0,0.7)',
                  border: '1px solid #444',
                }}
              >
                {[
                  { mode: 'all',       label: 'All',       color: '#2196F3' },
                  { mode: 'watchlist', label: 'Watchlist', color: '#ffd700' },
                ].map((opt, idx, arr) => (
                  <button
                    key={opt.mode}
                    onClick={() => {
                      if (linksDataMode !== opt.mode) {
                        setLinksDataMode(opt.mode);
                      }
                    }}
                    style={{
                      padding: '4px 10px',
                      border: 'none',
                      cursor: 'pointer',
                      backgroundColor: linksDataMode === opt.mode ? opt.color : 'transparent',
                      color: linksDataMode === opt.mode && opt.mode === 'watchlist' ? '#000' : 'white',
                      fontSize: '11px',
                      fontWeight: linksDataMode === opt.mode ? 'bold' : 'normal',
                      borderRight: idx < arr.length - 1 ? '1px solid #444' : 'none',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 4,
                    }}
                  >
                    {opt.label}
                    {opt.mode === 'watchlist' && watchedKeys && watchedKeys.size > 0 && linksDataMode !== 'watchlist' && (
                      <span
                        title={`${watchedKeys.size} watchlisted address${watchedKeys.size > 1 ? 'es' : ''}`}
                        style={{
                          display: 'inline-flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          backgroundColor: '#ffd700',
                          color: '#000',
                          borderRadius: '50%',
                          width: 14,
                          height: 14,
                          fontSize: 9,
                          fontWeight: 'bold',
                          lineHeight: 1,
                        }}
                      >
                        {watchedKeys.size}
                      </span>
                    )}
                  </button>
                ))}
              </div>
            </div>
          )}

          {/* Token-view sort mode toggle: Chain | Price | Volatility | MarketCap | Transactions, plus Categories filter for chain mode */}
          {location.pathname.startsWith('/token') && filterToken && (
            <div style={{ flex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center', gap: 12 }}>
              <div
                style={{
                  display: 'flex',
                  borderRadius: '16px',
                  overflow: 'hidden',
                  backgroundColor: 'rgba(0, 0, 0, 0.7)',
                  border: '1px solid #444',
                }}
              >
                {[
                  ...(location.pathname.startsWith('/token') ? [{ mode: 'chain', label: 'Chain', color: '#9C27B0', borderRight: true }] : []),
                  { mode: 'price',      label: 'Price',      color: '#4CAF50', borderRight: true },
                  { mode: 'volatility', label: 'Volatility', color: '#F44336', borderRight: true },
                  { mode: 'marketcap',  label: 'MktCap',     color: '#FF9800', borderRight: true },
                  { mode: 'links',      label: 'Txs', color: '#2196F3', borderRight: false },
                ].map((opt) => (
                  <button
                    key={opt.mode}
                    onClick={() => {
                      setTokenView(opt.mode);
                      if (!location.pathname.startsWith('/graphs')) {
                        isLoaded = false;
                        setViewGraph(true);
                        setTokenViewTrigger(t => t + 1);
                      }
                    }}
                    style={{
                      padding: '4px 10px',
                      border: 'none',
                      cursor: 'pointer',
                      backgroundColor: tokenView === opt.mode ? opt.color : 'transparent',
                      color: 'white',
                      fontSize: '11px',
                      fontWeight: tokenView === opt.mode ? 'bold' : 'normal',
                      borderRight: opt.borderRight ? '1px solid #444' : 'none',
                    }}
                  >
                    {opt.label}
                  </button>
                ))}
              </div>

              {tokenView === 'chain' && (
                <>
                  <Button
                    variant="outlined"
                    onClick={() => setCategoriesOpen(true)}
                    style={{
                      color: 'white',
                      borderColor: '#666',
                      textTransform: 'none',
                      fontSize: '11px',
                      padding: '4px 10px',
                      height: '100%',
                    }}
                  >
                    Categories{selectedCategories.length > 0 ? ` (${selectedCategories.length})` : ''}
                  </Button>
                  <CategoriesFilterDialog
                    open={categoriesOpen}
                    onCancel={handleCategoriesCancel}
                    onApply={handleCategoriesApply}
                    allCategories={allCategories}
                    selectedCategories={selectedCategories}
                  />
                </>
              )}
            </div>
          )}

          {!location.pathname.startsWith('/price') && (
            <div className={classes.statisticsContainer}>
              <div>
                <label className={classes.statisticsLabel}>Nodes:</label>
                <span className={classes.statisticsValue}>
                  {(() => {
                    if (nodeListVisibleCount != null) {
                      return Number(nodeListVisibleCount || 0).toLocaleString();
                    }
                    return ((memoizedGraphData.nodes || []).length).toLocaleString();
                  })()}
                </span>
              </div>
              <div style={{ marginLeft: 16 }}>
                <label className={classes.statisticsLabel}>Links:</label>
                <span className={classes.statisticsValue}>
                  {((memoizedGraphData.links || []).length).toLocaleString()}
                </span>
              </div>
            </div>
          )}

          {location.pathname.startsWith('/token') && (
            <CategoriesFilterDialog
              open={categoriesOpen}
              onCancel={handleCategoriesCancel}
              onApply={handleCategoriesApply}
              allCategories={allCategories}
              selectedCategories={selectedCategories}
            />
          )}
        </div>  
      )}
    </div>
    </>
    )}
    </div>
  );
}

// Main App component that wraps the router
function App() {
  return (
    <AuthProvider>
      <WatchlistProvider>
        <GlobalNameTableController />
        <Router>
          <AppWithRouter />
        </Router>
      </WatchlistProvider>
    </AuthProvider>
  );
}

function GlobalNameTableController() {
  const { isAuthenticated } = useAuth();
  const [open, setOpen] = useState(false);
  const [node, setNode] = useState(null);
  const [label, setLabel] = useState('');
  const [iconUrl, setIconUrl] = useState('');
  const [uploadFile, setUploadFile] = useState(null);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const normalizeAddress = useCallback((addr) => {
    if (!addr) return '';
    const s = String(addr).trim().toLowerCase();
    if (!s) return '';
    if (s.startsWith('0x') && s.length === 42) return s;
    return '';
  }, []);

  const openForNode = useCallback((n) => {
    const raw = n ? (n.id || n.address || n.addr || null) : null;
    let addr = normalizeAddress(raw);
    if (!addr && raw) {
      try {
        const m = String(raw).match(/0x[0-9a-fA-F]{40}/);
        if (m && m[0]) addr = normalizeAddress(m[0]);
      } catch (e) {
      }
    }

    if (!addr) {
      try {
        console.warn('[nametable] (global) cannot open dialog: invalid address for node', { id: n && n.id, address: n && n.address });
      } catch (e) {
      }
      return;
    }

    setNode({ ...(n || {}), id: addr });
    setLabel('');
    setIconUrl('');
    setUploadFile(null);
    setError('');
    setOpen(true);
  }, [normalizeAddress]);

  const onSave = useCallback(async () => {
    try {
      if (!isAuthenticated) {
        setError('Login required to save nametable entries');
        return;
      }
      setSaving(true);
      setError('');

      const addr = normalizeAddress(node && (node.id || node.address || node.addr));
      if (!addr) {
        setError('Invalid address');
        return;
      }

      let finalIconUrl = String(iconUrl || '').trim();
      if (uploadFile) {
        const fd = new FormData();
        fd.append('image', uploadFile);
        fd.append('address', addr);
        fd.append('chain', 'ETH');
        const resp = await axios.post(`${SERVER_NAME}/user/uploadAddressIcon`, fd, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });
        finalIconUrl = resp && resp.data && resp.data.url ? String(resp.data.url) : '';
      }

      await axios.post(`${SERVER_NAME}/nametable`, {
        chain: 'ETH',
        address: addr,
        label: String(label || ''),
        iconUrl: finalIconUrl,
      });

      setOpen(false);
    } catch (e) {
      const msg = (e && e.response && e.response.data && e.response.data.message)
        ? String(e.response.data.message)
        : 'Failed to save';
      setError(msg);
    } finally {
      setSaving(false);
    }
  }, [iconUrl, isAuthenticated, label, node, normalizeAddress, uploadFile]);

  useEffect(() => {
    if (typeof window === 'undefined') return;

    try {
      window.openNameTableDialogForNode = openForNode;
    } catch (e) {
    }

    const onOpen = (evt) => {
      try {
        const n = evt && evt.detail ? evt.detail.node : null;
        if (n) openForNode(n);
      } catch (e) {
      }
    };

    try {
      window.addEventListener('open-nametable-dialog', onOpen);
    } catch (e) {
    }

    return () => {
      try {
        if (window.openNameTableDialogForNode === openForNode) {
          delete window.openNameTableDialogForNode;
        }
      } catch (e) {
      }

      try {
        window.removeEventListener('open-nametable-dialog', onOpen);
      } catch (e) {
      }
    };
  }, [openForNode]);

  return (
    <NameTableDialog
      open={open}
      onClose={() => setOpen(false)}
      address={node && (node.id || node.address || '')}
      label={label}
      onLabelChange={(v) => setLabel(v)}
      iconUrl={iconUrl}
      onIconUrlChange={(v) => setIconUrl(v)}
      onUploadFileChange={(file) => {
        try {
          if (!file) {
            setUploadFile(null);
            return;
          }
          const name = String(file.name || '').toLowerCase();
          const extOk = /\.(png|jpe?g|gif|webp|svg)$/.test(name);
          const type = String(file.type || '').toLowerCase();
          const typeOk = (
            type === 'image/png' ||
            type === 'image/jpeg' ||
            type === 'image/gif' ||
            type === 'image/webp' ||
            type === 'image/svg+xml'
          );
          if (!extOk && !typeOk) {
            setError('Unsupported image type. Please use PNG, JPG, GIF, WEBP, or SVG.');
            setUploadFile(null);
            return;
          }
          setError('');
          setUploadFile(file);
        } catch (e) {
          setError('Unsupported image type. Please use PNG, JPG, GIF, WEBP, or SVG.');
          setUploadFile(null);
        }
      }}
      error={error}
      saving={saving}
      onSave={onSave}
      canSave={!!isAuthenticated}
    />
  );
}

// AppWithRouter has access to React Router context and location
function AppWithRouter() {
  // Use location to monitor route changes
  const location = useLocation();
  const navigate = useNavigate();
  
  // The signup handler from AppContent - we need to define it here for the Routes
  const handleSignup = async (username, password, subscribeNewsletterParam) => {
    try {
      console.log('AppWithRouter handleSignup called with:', { username, subscribeNewsletterParam });
      
      // Always use /signup for all environments
      const response = await axios.post(`${SERVER_NAME}/signup`, {
        username: username,
        password: password,
        subscribeNewsletter: subscribeNewsletterParam,
      });
      
      if (response && response.data.success) {
        console.log('Registration successful, now attempting to login');
        
        // After successful registration, immediately call login to authenticate the user
        try {
          const loginResponse = await axios.post(`${SERVER_NAME}/login`, {
            email: username,  // Server expects 'email' field
            password: password
          });
          
          console.log('Auto-login after registration:', loginResponse.data);
          
          if (loginResponse.status === 200) {
            // Use AuthContext login
            login({
              username: username,
              userID: loginResponse.data.user?.userid || username
            });
            
            // Set localStorage (as backup)
            localStorage.setItem('username', username);
            localStorage.setItem('isAuthenticated', 'true');
            localStorage.setItem('userID', loginResponse.data.user?.userid || '');
            
            console.log('Auto-login successful after registration');
            return true;
          }
        } catch (loginError) {
          console.error('Auto-login after registration failed:', loginError);
          // Even if auto-login fails, registration was successful
          alert('Account created! Please log in with your credentials.');
          return true;
        }
      } else {
        console.error('Registration failed');
        return false;
      }
    } catch (error) {
      console.error('Registration error:', error);
      const message = (error.response && error.response.data) ? error.response.data.message : error;
      alert(message);
      return false;
    }
  };
  
  // Use authentication context
  const { isAuthenticated, username, userID, userAddress, login, logout, updateUserInfo, rate, tokenPrice, tokenUniswapVersion, e3dPrice } = useAuth();

  const storiesPageElement = useMemo(() => <StoriesPage />, []);
  
  // Navigation function similar to the one in AppContent
  const goTo = (path) => {
    // Add timestamp to force re-render even if path is the same
    const url = new URL(path, window.location.origin);
    url.searchParams.append('_t', Date.now());
    
    // Use navigate instead of direct window.location change
    navigate(url.pathname + url.search, {
      replace: true,
      state: { from: location.pathname }
    });
    
    console.log(`Navigation to ${path} complete`);
  };
  
  // Initialize SessionManager for persistent sessions
  useEffect(() => {
    // Initialize SessionManager with logout callback
    sessionManager.initialize(() => {
      console.log('Session expired, logging out');
      logout();
    });
    
    return () => {
      // Clean up on unmount
      sessionManager.cleanup();
    };
  }, [logout]);

  // Initialize UI state variables
  const [showLogin, setShowLogin] = useState(false);
  const [watchlistLoginNotice, setWatchlistLoginNotice] = useState('');
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [showOptionsPopup, setShowOptionsPopup] = useState(false);
  const [subscribeNewsletter, setSubscribeNewsletter] = useState(false);
  const [tourSpeedGraph, setTourSpeedGraph] = useState(6000);
  
  // This useEffect was moved to the AppContent component
  const [tourSpeedList, setTourSpeedList] = useState(2000);
  const [spinSpeed, setSpinSpeed] = useState(60);
  const [useAspectRatio, setUseAspectRatio] = useState(false);
  const [imageSize, setImageSize] = useState(100);
  const [resetCookieConsent, setResetCookieConsent] = useState(false);
  
  // Handler for closing options popup
  const optionsPopupClose = async (save, subscribeNewsletterParam) => {
    setShowOptionsPopup(false);
    
    if (save && subscribeNewsletterParam !== undefined) {
      try {
        console.log('Updating newsletter subscription status to:', subscribeNewsletterParam);
        setSubscribeNewsletter(subscribeNewsletterParam);
        // In AppWithRouter we could add actual save functionality later if needed
      } catch (error) {
        console.error('Error updating newsletter subscription:', error);
      }
    }
  };
  
  // Define the missing variables needed for E3DHeader
  const [activeNodeId, setActiveNodeId] = useState(null);
  const [activeNodeName, setActiveNodeName] = useState(null);

  const openWatchlistLoginDialog = useCallback(() => {
    try {
      if (typeof window !== 'undefined' && typeof window.globalShowLogin === 'function') {
        window.globalShowLogin(true);
        return;
      }
      if (typeof document !== 'undefined') {
        document.dispatchEvent(new Event('force-login-dialog-render'));
      }
      if (typeof window !== 'undefined' && typeof window.setGlobalShowLogin === 'function') {
        window.setGlobalShowLogin(true);
        return;
      }
    } catch (e) {
    }
    setShowLogin(true);
  }, []);

  const handleWatchlistLoginLinkClick = useCallback((e) => {
    try {
      if (e && typeof e.preventDefault === 'function') e.preventDefault();
      if (e && typeof e.stopPropagation === 'function') e.stopPropagation();
    } catch (err) {
    }
    openWatchlistLoginDialog();
  }, [openWatchlistLoginDialog]);

  const dismissWatchlistLoginNotice = useCallback(() => {
    setWatchlistLoginNotice('');
  }, []);

  useEffect(() => {
    const handleWatchlistLoginRequired = (e) => {
      try {
        const msg = e && e.detail && e.detail.message ? String(e.detail.message) : 'Login to watch tokens.';
        setWatchlistLoginNotice(msg);
      } catch (err) {
        setWatchlistLoginNotice('Login to watch tokens.');
      }
    };

    document.addEventListener('watchlist-login-required', handleWatchlistLoginRequired);
    return () => document.removeEventListener('watchlist-login-required', handleWatchlistLoginRequired);
  }, []);

  useEffect(() => {
    if (isAuthenticated && watchlistLoginNotice) {
      setWatchlistLoginNotice('');
    }
  }, [isAuthenticated, watchlistLoginNotice]);
  
  // Additional price-related functions are available from useAuth() if needed
  // But we already have the main variables destructured above
  
  // Define setUserAddress function that uses updateUserInfo to update only the address
  const setUserAddress = (address) => {
    updateUserInfo({ userAddress: address });
  };
  
  // No longer need refreshAuthenticationState as AuthContext handles this
  
  // Log auth state on route changes
  useEffect(() => {
    console.log(`Route changed: auth state - isAuthenticated: ${isAuthenticated}, userID: ${userID}, username: ${username}`);
    // Record user activity on route change to extend session
    sessionManager.recordActivity();
    // AuthContext now handles all authentication state management
  }, [location, isAuthenticated, userID, username]);
  
  // ETH price is now handled by AuthContext's fetchRate function
  
  // Price data fetching is now handled by AuthContext
  // No need for local price fetching logic
  const [showSwapDialog, setShowSwapDialog] = useState(false);
  const [showStakeDialog, setShowStakeDialog] = useState(false);
  // Changed from UpgradeDialog to SignupDialog for premium upgrades
  const [showUpgradeDialog, setShowUpgradeDialog] = useState(false);
  // Add showSignup state for account creation dialog
  const [showSignup, setShowSignup] = useState(false);
  // Debug mode to test layout without Premium Banner
  const [debugHideBanner, setDebugHideBanner] = useState(false);

  // Debug logging for dialog state changes
  const debugSetShowSwapDialog = (value) => {
    console.log('App: Setting showSwapDialog to', value);
    setShowSwapDialog(value);
  };
  
  const debugSetShowStakeDialog = (value) => {
    console.log('App: Setting showStakeDialog to', value);
    setShowStakeDialog(value);
  };

  // Monitor dialog state changes
  useEffect(() => {
    console.log('Dialog state changed - showSwapDialog:', showSwapDialog);
  }, [showSwapDialog]);

  useEffect(() => {
    console.log('Dialog state changed - showStakeDialog:', showStakeDialog);
  }, [showStakeDialog]);
  
  // Add keyboard shortcut for debug mode
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Ctrl+Shift+A to toggle debug hide banner mode
      if (e.ctrlKey && e.shiftKey && e.key === 'A') {
        setDebugHideBanner(prev => {
          const newValue = !prev;
          console.log(`Debug mode: Premium Banner ${newValue ? 'hidden' : 'visible'} (top offset: ${newValue ? '65px' : '125px'})`); 
          return newValue;
        });
      }
      
      // Ctrl+Shift+P to toggle fake premium subscription mode
      if (e.ctrlKey && e.shiftKey && e.key === 'P') {
        // Toggle fake premium mode using the utility function
        const isPremium = toggleDebugFakePremium();
        console.log(`Debug mode: Premium subscription ${isPremium ? 'ACTIVE' : 'INACTIVE'} (Test mode)`);
      }
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Global dialog management - accessible from anywhere
  useEffect(() => {
    // Create global access to dialog functions
    window.openE3DSwapDialog = () => {
      console.log('Global access: Opening Swap Dialog');
      debugSetShowSwapDialog(true);
    };
    
    window.openE3DStakeDialog = () => {
      console.log('Global access: Opening Stake Dialog');
      debugSetShowStakeDialog(true);
    };
    
    // Add global handler to preserve auth state when navigating to signup
    window.navigateToSignup = () => {
      console.log('Global handler: Preserving auth state before signup navigation');
      const currentAuth = localStorage.getItem('isAuthenticated');
      const currentUserID = localStorage.getItem('userID');
      const currentUsername = localStorage.getItem('username');
      const currentUserAddress = localStorage.getItem('userAddress');
      const walletConnected = localStorage.getItem('walletConnected');
      
      console.log('Current state before signup navigation:', { 
        currentAuth, 
        currentUserID, 
        currentUsername, 
        currentUserAddress, 
        walletConnected 
      });
      
      // Make sure we persist the state
      if (currentAuth === 'true') {
        // First update localStorage
        localStorage.setItem('isAuthenticated', 'true');
        if (currentUserID) localStorage.setItem('userID', currentUserID);
        if (currentUsername) localStorage.setItem('username', currentUsername);
        
        // EXPLICITLY preserve wallet connection state
        if (currentUserAddress) localStorage.setItem('userAddress', currentUserAddress);
        if (walletConnected) localStorage.setItem('walletConnected', walletConnected);
        
        // Then update AuthContext state
        login({
          userID: currentUserID || '',
          username: currentUsername || '',
          userAddress: currentUserAddress || ''
        });
        
        // IMPORTANT: Use a timeout to ensure auth state is updated before navigation
        setTimeout(() => {
          // Use React Router for navigation to preserve state
          navigate('/signup', { state: { 
            keepAuth: true,
            userAddress: currentUserAddress,
            walletConnected: walletConnected === 'true'
          }});
        }, 100); // Increased timeout for better state propagation
      } else {
        // If not authenticated, but still preserve wallet state if available
        if (currentUserAddress) {
          navigate('/signup', { state: { 
            userAddress: currentUserAddress,
            walletConnected: walletConnected === 'true' 
          }});
        } else {
          // No auth or wallet state
          navigate('/signup');
        }
      }
    };
    
    window.openUpgradeDialog = () => {
      console.log('Global access: Opening Upgrade Dialog');
      setShowUpgradeDialog(true);
    };
    
    // Add custom CSS to fix dialog styling
    const styleElement = document.createElement('style');
    styleElement.textContent = `
      /* Force dialog to fit exactly to content with no extra space */
      .MuiDialog-paper:not(.embedPreviewDialogPaper) {
        border: 1px solid #4d79ff !important;
        outline: 1px solid #4d79ff !important;
        height: fit-content !important;
        max-width: 450px !important;
        margin: 0 !important;
        background-color: #1f2026 !important;
      }
      /* Remove default dialog spacing/padding */
      .MuiDialogContent-root:not(.embedPreviewDialogContent) {
        padding: 0 !important;
        overflow: visible !important;
      }
      /* Center dialog and ensure it doesn't take extra space */
      .MuiDialog-container {
        align-items: center !important;
      }
      /* Target the entire dialog system to remove any additional spacing issues */
      .MuiDialog-root, .MuiBackdrop-root, .MuiDialog-container, .MuiDialog-scrollPaper {
        display: flex !important;
        align-items: center !important;
        justify-content: center !important;
      }
      /* Ensure the dialog content fits exactly with no extra space */
      .MuiDialogContent-root:not(.embedPreviewDialogContent) > div, .MuiDialogContent-root:not(.embedPreviewDialogContent) > * {
        margin-bottom: 0 !important;
        overflow: visible !important;
      }
      /* Fix potential scrolling issues */
      .MuiDialog-scrollBody {
        overflow-y: visible !important;
      }
    `;
    document.head.appendChild(styleElement);
    
    return () => {
      // Clean up on unmount
      delete window.openE3DSwapDialog;
      delete window.openE3DStakeDialog;
      document.head.removeChild(styleElement);
    };
  }, []);

  // Log authentication state whenever route changes, but avoid infinite loop
  useEffect(() => {
    // Just log the route change without triggering state updates
    const savedAuth = localStorage.getItem('isAuthenticated');
    const savedUserID = localStorage.getItem('userID');
    
    console.log(`Route changed to: ${location.pathname}`);
    
    if (savedAuth === 'true' && savedUserID) {
      console.log(`User is authenticated: ${savedUserID}`);
      // Auth state is managed by AuthContext but we log for debugging
    }
    
    // We no longer update state here to avoid the infinite loop
    // State is already initialized from localStorage on component mount
  }, [location.pathname]); // Only re-run when the actual pathname changes
  
  // Check for wallet connection ONLY on app load (runs once)
  useEffect(() => {
    const checkWalletConnection = async () => {
      // First check localStorage for saved wallet address
      const savedUserAddress = localStorage.getItem('userAddress');
      const walletDisconnected = localStorage.getItem('walletDisconnected') === 'true';
      if (walletDisconnected) {
        return;
      }
      
      // Only update if the current state is empty but we have a saved address
      if (savedUserAddress && !userAddress) {
        console.log('Restoring wallet address from localStorage:', savedUserAddress);
        // Update AuthContext with saved address
        updateUserInfo({ userAddress: savedUserAddress });
      }
      
      // Then check if MetaMask is connected but only update if different
      if (window.ethereum) {
        try {
          const accounts = await window.ethereum.request({ method: 'eth_accounts' });
          if (accounts.length > 0 && accounts[0] !== userAddress) {
            console.log('Found connected wallet:', accounts[0]);
            
            // Only update state if different from current state
            if (accounts[0] !== userAddress) {
              updateUserInfo({ userAddress: accounts[0] });
              
              // Only update AuthContext if different
              if (accounts[0] !== userAddress) {
                updateUserInfo({ userAddress: accounts[0] });
              }
              
              // Update localStorage only if different
              if (accounts[0] !== savedUserAddress) {
                localStorage.setItem('userAddress', accounts[0]);
              }
            }
          }
        } catch (error) {
          console.error('Error checking wallet connection:', error);
        }
      }
    };
    
    checkWalletConnection();
    // Note: Empty dependency array makes this effect run only once on mount
  }, []);
  
  // Listen for MetaMask account changes and update state accordingly
  useEffect(() => {
    if (window.ethereum) {
      const handleAccountsChanged = (accounts) => {
        console.log('MetaMask accounts changed:', accounts);
        
        // Record activity in SessionManager
        sessionManager.recordActivity();
        
        if (accounts.length === 0) {
          // User disconnected their wallet
          console.log('User disconnected wallet via MetaMask');
          localStorage.removeItem('userAddress');
          localStorage.removeItem('walletConnected');
          localStorage.removeItem('walletDisconnected');
          updateUserInfo({ userAddress: null });
        } else {
          // User switched to a different account
          const newAccount = accounts[0];
          console.log('New active account:', newAccount);
          localStorage.setItem('userAddress', newAccount);
          localStorage.setItem('walletConnected', 'true');
          localStorage.removeItem('walletDisconnected');
          updateUserInfo({ userAddress: newAccount });
        }
      };

      window.ethereum.on('accountsChanged', handleAccountsChanged);

      return () => {
        window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
      };
    }
  }, [updateUserInfo]);

  // Use the unified wallet connection functions from AuthContext
  const { connectWallet, disconnectWallet } = useAuth();
  
  // Function to handle wallet connect/disconnect in App.js
  const handleWalletConnect = async () => {
    console.log('handleWalletConnect called in App.js');
    
    // If wallet is connected, disconnect it
    if (userAddress) {
      console.log('Disconnecting wallet');
      disconnectWallet();
    } else {
      console.log('Connecting to MetaMask');
      try {
        await connectWallet();
      } catch (error) {
        console.error('Error connecting to MetaMask:', error);
        alert('Please install MetaMask to connect your wallet');
      }
    }
  };

  // The handleSignup function is declared at the top of the file around line ~1360
  // This function calls the /signup endpoint on the server

  // Handle login success
  const handleLogin = () => {
    console.log('Login successful - closing dialog');
    // Make sure we close the login dialog
    setShowLogin(false);
  };

  // Handle logout
  const handleLogout = () => {
    console.log('Logout confirmed, clearing auth state');
    // Use AuthContext logout which manages localStorage and state
    logout();
    setShowLogoutConfirm(false);
  };

  const MainLayout = () => {
    const location = useLocation();
    const [isPortraitMode, setIsPortraitMode] = useState(() => {
      try {
        if (typeof window === 'undefined') return false;
        return window.innerWidth < window.innerHeight;
      } catch (e) {
        return false;
      }
    });

    const [isMobileViewport, setIsMobileViewport] = useState(() => {
      try {
        if (typeof window === 'undefined') return false;
        return window.innerWidth <= 600;
      } catch (e) {
        return false;
      }
    });

    useEffect(() => {
      const onResize = () => {
        try {
          setIsPortraitMode(window.innerWidth < window.innerHeight);
          setIsMobileViewport(window.innerWidth <= 600);
        } catch (e) {
        }
      };
      try {
        window.addEventListener('resize', onResize);
        return () => window.removeEventListener('resize', onResize);
      } catch (e) {
        return () => {};
      }
    }, []);

    const onStoriesRoute = Boolean(
      location &&
      location.pathname != null &&
      (location.pathname === '/' || location.pathname.startsWith('/stories'))
    );

    const hideHeaderOnStoriesMobile = Boolean(
      isMobileViewport &&
      isPortraitMode &&
      onStoriesRoute
    );

    return (
      <>
        {!IS_PEERMAP_HOST && !hideHeaderOnStoriesMobile && (
          <E3DHeader
            isAuthenticated={isAuthenticated}
            username={username}
            setShowOptionsPopup={setShowOptionsPopup}
            setShowLogoutConfirm={setShowLogoutConfirm}
            setShowLogin={setShowLogin}
            gotoMainPage={() => goTo('/home')}
            activeNodeId={activeNodeId} 
            activeNodeName={activeNodeName} 
            ethPrice={rate} 
            tokenPrice={tokenPrice} 
            tokenUniswapVersion={tokenUniswapVersion} 
            e3dPrice={e3dPrice}
          />
        )}
        <div className="content-container"> {/* Add this wrapper */}
          <Outlet /> {/* This is where route components will render */}
        </div>
      </>
    );
  };

  return (
    <div id='appContainer' className="App" style={{ height: '100vh', maxHeight: '100vh' }}>
      {/* Premium subscription banner for non-premium users */}
      {/* Only render the Premium Banner if not in debug mode and user is not authenticated */}
      {!IS_PEERMAP_HOST && !debugHideBanner && !isAuthenticated && localStorage.getItem('isAuthenticated') !== 'true' && (
        <PremiumBanner userAddress={userAddress} isAuthenticated={isAuthenticated} userID={userID} />
      )}
      
      {/* Visual indicator when debug mode is active */}
      {debugHideBanner && (
        <div style={{ 
          backgroundColor: '#333', 
          color: '#ff5555', 
          textAlign: 'center', 
          padding: '2px', 
          fontSize: '12px', 
          fontWeight: 'bold' 
        }}>
          DEBUG MODE: Premium Banner Hidden (Ctrl+Shift+A to restore)
        </div>
      )}
      
      {/* Swap Dialog - conditionally rendered */}
      {showSwapDialog && (
        <SwapPage
          open={true} // Always open when rendered
          onClose={() => debugSetShowSwapDialog(false)}
          isDialog={true}
          walletAddress={userAddress}
          key={"swap-dialog-" + Date.now()} // Unique key to force fresh mount
        />
      )}

      {/* Stake Dialog - conditionally rendered */}
      {showStakeDialog && (
        <StakePage
          open={true} // Always open when rendered
          onClose={() => debugSetShowStakeDialog(false)}
          isDialog={true}
          walletAddress={userAddress}
          key={"stake-dialog-" + Date.now()} // Unique key to force fresh mount
        />
      )}

      {/* Premium Subscription Signup Dialog */}
      {showUpgradeDialog && (
        <SignupDialog
          open={true}
          onClose={() => setShowUpgradeDialog(false)}
          userAddress={userAddress}
          userID={userID}
          username={username}
          isAuthenticated={isAuthenticated}
        />
      )}
      
      {/* Login Dialog */}
      {showLogin && (
        <LoginDialog
          open={true}
          onClose={() => setShowLogin(false)}
          onLogin={handleLogin}
          setShowSignup={setShowSignup}
        />
      )}
      
      {/* Signup Dialog for account creation */}
      {showSignup && (
        <SignupDialog
          open={true}
          onClose={() => setShowSignup(false)}
          onSignup={handleSignup}
          username={''}
          userID={''}
          standalone={false}
          isAccountCreation={true} /* This flag specifies we want account creation mode */
          handleLogin={handleLogin} /* Pass the login handler for after successful signup */
        />
      )}

      {!!watchlistLoginNotice && (
        <div style={{
          position: 'fixed',
          left: '50%',
          bottom: '14px',
          transform: 'translateX(-50%)',
          zIndex: 5000,
          background: 'rgba(18, 24, 44, 0.96)',
          color: '#e8ecff',
          border: '1px solid rgba(77, 121, 255, 0.35)',
          borderRadius: '999px',
          padding: '10px 14px',
          boxShadow: '0 10px 30px rgba(0, 0, 0, 0.35)',
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          maxWidth: 'min(92vw, 560px)',
          fontSize: '13px',
          lineHeight: 1.35,
        }}>
          <span>{watchlistLoginNotice}</span>
          <button
            type="button"
            onClick={handleWatchlistLoginLinkClick}
            style={{
              background: 'transparent',
              border: 'none',
              color: '#7fb0ff',
              cursor: 'pointer',
              fontWeight: 700,
              padding: 0,
              textDecoration: 'underline',
            }}
          >
            login
          </button>
          <button
            type="button"
            onClick={dismissWatchlistLoginNotice}
            aria-label="Dismiss login notice"
            style={{
              background: 'transparent',
              border: 'none',
              color: '#aab3d9',
              cursor: 'pointer',
              marginLeft: '2px',
              fontSize: '18px',
              lineHeight: 1,
              padding: 0,
            }}
          >
            ×
          </button>
        </div>
      )}
      
      {/* Logout Confirmation Dialog */}
      {showLogoutConfirm && (
        <LogoutConfirmDialog
          open={true}
          onClose={() => setShowLogoutConfirm(false)}
          onLogout={handleLogout}
        />
      )}

      {/* Options Popup Dialog */}
      {showOptionsPopup && (
        <OptionsPopup 
          open={showOptionsPopup} 
          onClose={optionsPopupClose} 
          tourSpeedGraph={tourSpeedGraph} 
          setTourSpeedGraph={setTourSpeedGraph} 
          tourSpeedList={tourSpeedList} 
          setTourSpeedList={setTourSpeedList} 
          spinSpeed={spinSpeed} 
          setSpinSpeed={setSpinSpeed}
          useAspectRatio={useAspectRatio} 
          setUseAspectRatio={setUseAspectRatio} 
          imageSize={imageSize} 
          setImageSize={setImageSize} 
          resetCookieConsent={resetCookieConsent} 
          setResetCookieConsent={setResetCookieConsent}
          subscribeNewsletter={subscribeNewsletter}
          setSubscribeNewsletter={setSubscribeNewsletter}
        />
      )}

      <Routes>
        <Route path="/embed/story/:storyId" element={<StoryEmbedPage />} />
        <Route path="/pay" element={<PayPage />} />
        <Route path="/mint" element={<MintReportPage />} />
        <Route element={<MainLayout />}>
          <Route path="/" element={
            <IntelligencePage />
          } />
          <Route path="/welcome" element={
            <HomePage
              setShowHomePage={() => {}}
              setShowShortcutPage={() => {}}
              setShowSwapDialog={debugSetShowSwapDialog}
              setShowStakeDialog={debugSetShowStakeDialog}
              showCustomNFTMarketplace={false}
              setShowCustomNFTMarketplace={() => {}}
            />
          } />
          <Route path="/home" element={
            <HomePage
              setShowHomePage={() => {}}
              setShowShortcutPage={() => {}}
              setShowSwapDialog={debugSetShowSwapDialog}
              setShowStakeDialog={debugSetShowStakeDialog}
              showCustomNFTMarketplace={false}
              setShowCustomNFTMarketplace={() => {}}
            />
          } />
          <Route
            path="/dashboard"
            element={
              <Dashboard
                walletAddress={userAddress}
                isAuthenticated={isAuthenticated}
                userID={userID}
              />
            }
          />
          <Route path="/app" element={<AppContent showSwapDialog={showSwapDialog} setShowSwapDialog={debugSetShowSwapDialog} showStakeDialog={showStakeDialog} setShowStakeDialog={debugSetShowStakeDialog} debugHideBanner={debugHideBanner} />} />
          <Route path="/rwa" element={<AppContent showSwapDialog={showSwapDialog} setShowSwapDialog={debugSetShowSwapDialog} showStakeDialog={showStakeDialog} setShowStakeDialog={debugSetShowStakeDialog} debugHideBanner={debugHideBanner} />} />
          <Route path="/customnft" element={<AppContent showSwapDialog={showSwapDialog} setShowSwapDialog={debugSetShowSwapDialog} showStakeDialog={showStakeDialog} setShowStakeDialog={debugSetShowStakeDialog} debugHideBanner={debugHideBanner} />} />
          <Route path="/about" element={<HomePage setShowHomePage={() => {}} setShowShortcutPage={() => {}} setShowSwapDialog={debugSetShowSwapDialog} setShowStakeDialog={debugSetShowStakeDialog} showCustomNFTMarketplace={false} setShowCustomNFTMarketplace={() => {}} />} />
          <Route path="/token" element={<Navigate to="/links" replace />} />
          <Route path="/token/:address" element={<TokenIntelligencePage />} />
          <Route path="/token/:address/claim" element={<TokenClaimPage />} />
          <Route path="/admin/project-claims/:claimId" element={<ProjectClaimReviewPage />} />
          <Route path="/admin/project-discovery/:candidateId" element={<ProjectDiscoveryReviewPage />} />
          <Route path="/admin/project-discovery" element={<ProjectDiscoveryReviewPage />} />
          <Route path="/admin/outreach/:messageId" element={<ProjectOutreachManagerPage />} />
          <Route path="/admin/outreach" element={<ProjectOutreachManagerPage />} />
          <Route path="/tokens" element={<Navigate to="/links" replace />} />
          <Route path="/price" element={<AppContent showSwapDialog={showSwapDialog} setShowSwapDialog={debugSetShowSwapDialog} showStakeDialog={showStakeDialog} setShowStakeDialog={debugSetShowStakeDialog} debugHideBanner={debugHideBanner} />} />
          <Route path="/nft" element={<AppContent showSwapDialog={showSwapDialog} setShowSwapDialog={debugSetShowSwapDialog} showStakeDialog={showStakeDialog} setShowStakeDialog={debugSetShowStakeDialog} />} />
          <Route path="/news" element={<AppContent showSwapDialog={showSwapDialog} setShowSwapDialog={debugSetShowSwapDialog} showStakeDialog={showStakeDialog} setShowStakeDialog={debugSetShowStakeDialog} />} />
          <Route path="/news/:date" element={<AppContent showSwapDialog={showSwapDialog} setShowSwapDialog={debugSetShowSwapDialog} showStakeDialog={showStakeDialog} setShowStakeDialog={debugSetShowStakeDialog} />} />
          <Route path="/pcap" element={<AppContent showSwapDialog={showSwapDialog} setShowSwapDialog={debugSetShowSwapDialog} showStakeDialog={showStakeDialog} setShowStakeDialog={debugSetShowStakeDialog} />} />
          <Route path="/pcap/uploads" element={<PcapUploadsPage />} />
          <Route path="/pcap/details/:uploadId" element={<PcapDetailsPage />} />
          <Route path="/pcap/uploads/:uploadId" element={<PcapUploadDetailPage />} />
          <Route path="/flows" element={<AppContent showSwapDialog={showSwapDialog} setShowSwapDialog={debugSetShowSwapDialog} showStakeDialog={showStakeDialog} setShowStakeDialog={debugSetShowStakeDialog} />} />
          <Route path="/gallery" element={<PcapGallery />} />
          <Route path="/pcapgallery" element={<Navigate to="/gallery" replace />} />
          <Route path="/timeseries" element={<TimeseriesGallery />} />
          <Route path="/agents" element={<AgentsDirectoryPage openLogin={() => setShowLogin(true)} />} />
          <Route path="/agents/:tokenAddress" element={<AgentDashboardPage />} />
          <Route path="/agents-guide" element={<AgentsGuidePage />} />
          <Route path="/agents-use-cases" element={<AgentsUseCasePage />} />
          <Route path="/transactions-guide" element={<TransactionsGuidePage />} />
          <Route path="/transactions-use-cases" element={<TransactionsUseCasePage />} />
          <Route path="/api" element={<ApiKeysPage openLogin={() => setShowLogin(true)} openSignup={() => setShowSignup(true)} />} />
          <Route path="/api-guide" element={<ApiGuidePage />} />
          <Route path="/swap" element={<SwapPage walletAddress={userAddress} onWalletConnect={handleWalletConnect} />} />
          <Route path="/stake" element={<StakePage walletAddress={userAddress} onWalletConnect={handleWalletConnect} />} />
          <Route path="/bubbles" element={<AppContent showBubblesView={true} />} />
          <Route path="/graphs" element={
            <AppContent
              showSwapDialog={showSwapDialog}
              setShowSwapDialog={debugSetShowSwapDialog}
              showStakeDialog={showStakeDialog}
              setShowStakeDialog={debugSetShowStakeDialog}
              debugHideBanner={debugHideBanner}
            />
          } />
          <Route path="/graphs/graph" element={
            <AppContent
              showSwapDialog={showSwapDialog}
              setShowSwapDialog={debugSetShowSwapDialog}
              showStakeDialog={showStakeDialog}
              setShowStakeDialog={debugSetShowStakeDialog}
              debugHideBanner={debugHideBanner}
            />
          } />
          <Route path="/graphs/:address" element={
            <AppContent
              showSwapDialog={showSwapDialog}
              setShowSwapDialog={debugSetShowSwapDialog}
              showStakeDialog={showStakeDialog}
              setShowStakeDialog={debugSetShowStakeDialog}
              debugHideBanner={debugHideBanner}
            />
          } />
          <Route path="/marketplace" element={
            <E3DMarketplace 
              walletAddress={userAddress}
              onWalletConnect={handleWalletConnect}
              isAuthenticated={isAuthenticated}
              userID={userID}
            />
          } />
          <Route path="/pricing" element={<Navigate to="/signup" replace />} />
          <Route path="/signup" element={
              <SignupDialog 
                standalone={true} 
                isAuthenticated={isAuthenticated}
                onSignup={handleSignup}
                username={username}
                userAddress={userAddress}
                userID={userID}
                handleLogin={handleLogin}
              />
          } />
          <Route path="/login" element={
              <LoginDialog 
                standalone={true}
                onLogin={handleLogin}
                isAuthenticated={isAuthenticated}
              />
          } />
          <Route path="/subscribe" element={
              <AppContent showSubscription={true} />
          } />
          <Route path="/docs" element={
              <DocPage />
          } />
          <Route path="/whatsnew" element={
              <WhatsNewPage />
          } />
          <Route path="/thesis" element={
              <ThesisPage openLogin={() => setShowLogin(true)} />
          } />
          <Route path="/thesis-guide" element={
              <ThesisGuidePage />
          } />
          <Route path="/thesis-use-cases" element={
              <ThesisUseCasePage />
          } />
          <Route path="/price-reference" element={
              <PriceReferencePage />
          } />
          <Route path="/price-guide" element={
              <PriceGuidePage />
          } />
          <Route path="/price-use-cases" element={
              <PriceUseCasePage />
          } />
          <Route path="/stories" element={
              storiesPageElement
          } />
          <Route path="/stories/:storyId" element={<StoriesPageRoute />} />
          <Route path="/story-guide" element={
              <StoryGuidePage />
          } />
          <Route path="/story-reference" element={
              <StoryReferencePage />
          } />
          <Route path="/story-use-cases" element={
              <StoryUseCasePage />
          } />
          <Route path="/methodology/*" element={
              <MethodologyPage />
          } />
          <Route path="/intelligence" element={<IntelligencePage />} />
          <Route path="/macro-intelligence" element={<MacroIntelligencePage />} />
          <Route path="/maps" element={<MapsPage />} />
          <Route path="/tokenomics" element={<TokenomicsPage />} />
          <Route path="/actions" element={<ActionsPage />} />
          <Route path="/agent-verdicts" element={<AgentVerdictsPage />} />
        </Route>
      </Routes>

      <div style={{
        width: '100%',
        padding: '10px 16px',
        boxSizing: 'border-box',
        borderTop: '1px solid rgba(77,121,255,0.22)',
        background: 'rgba(6, 10, 22, 0.96)',
        color: '#d0dcff',
        fontSize: 12,
        textAlign: 'center',
      }}>
        Built on OTA v1 — <a href="/methodology" style={{ color: '#9ec4ff', fontWeight: 800, textDecoration: 'none' }}>read the paper</a>
      </div>
      
      {/* Google Ads Banner - only for non-premium users */}
      {!IS_PEERMAP_HOST && !HIDE_GOOGLE_ADS_BANNER && !debugHideBanner && !isAuthenticated && localStorage.getItem('isAuthenticated') !== 'true' && (
        <GoogleAdsBanner 
          userAddress={userAddress} 
          isAuthenticated={isAuthenticated} 
          userID={userID}
        />
      )}
    </div>
  );
}

export default App;
